/* eslint-disable prettier */
/* eslint-disable max-len */
/**
 * PT BR resource file
 */

import {
    ArcTimeLineValidationTypes,
    ArcTimelineGroups,
    Entity,
    GAComponentDocumentStatus,
    GALinkStatus,
    GARoleTypeId,
    TaskListTypes,
    actionTypes,
    activityType,
    assignmentTypes,
    bulkAssignment,
    bulkAssignmentConstants,
    clientRequestNoteTab,
    confidentialityTypes,
    filters,
    financialStatementType,
    gaRecommendationType,
    gaScopes,
    groupSummaryTabs,
    independenceActionIds,
    instructionStatus,
    instructionType,
    ipFilterType,
    ipInputType,
    linkType,
    milestoneBuildTaskIds,
    notesFilter,
    reviewNoteRoutes,
    rnhFilterTypeQuery,
    rnhQuickFilter,
    snapshotComparisonIds,
    syncStatus,
    todoListTimeframeOptions,
    trialBalanceType,
    uiViews,
    receiveInstructionSwitcherIds
} from "../util/uiconstants";

export const labels = {

    //Review notes tile 2

    reviewNoteTileGraphHeader: "Abrir notas de revisão até a data de vencimento",
    reviewNoteTileGraphHeaderAssignedToMe: "Abrir notas de revisão atribuídas a mim, por data de vencimento",
    reviewNoteTileGraphHeaderAuthoredByMe: 'Authored open notes, by due date',
    reviewNoteYAxisLabel: "Notas de revisão",
    overDueCatFirst: "Atrasado >90",
    overDueCatSecond: "Atrasado 31-90",
    overDueCatThird: "Atrasado 10-30",
    overDueCatFourth: "Atrasado <10",
    catFifth: '<10',
    catSixth: '10-30',
    catSeventh: '31-90',
    catEighth: '>90',
    noNotesAvailable: "Nenhuma nota disponível",


    //ReviewNoteTiles
    totalOpen: "Totalmente aberto",
    totalCleared: "Totalmente limpo",
    changeDueDate: "Alterar data de vencimento",
    reviewNoteHashValue: '#',

    //Rejected PSPs
    rejectedPSPsTitle: 'Rejected PSPs',
    noRejectedPSPs: 'No rejected PSPs',
    updateRejectedPSPs: 'Update rejected PSPs',

    //CRA Build Step 2 Labels
    inherentRiskTypeId: "Avaliação de risco inerente",
    controlRiskTypeId: "Avaliação de risco de controle",
    viewUnRelatedWCGWs: "Exibir WCGWs não relacionados",
    unrelatedWCGWsInstruction: "Os WCGWs listados abaixo não estão relacionados a nenhuma assertiva. Eles devem estar relacionados a pelo menos uma assertiva ou ser excluídos. Para encontrar facilmente esses WCGWs no modal 'Relacionar WCGWs as assertivas', selecione \'WCGWs não relacionados'\ no menu suspenso das SCOTs. Se o WCGW não for mais relevante ou precisar ser editado, clique no link \'Identificar WCGWs e controles'\ na página subjacente para fazer essas alterações.",
    relatedWCGWsInstruction: "Relacione os WCGWs à assertiva selecionada. Selecione uma SCOT para relacionar os WCGWs de uma SCOT específica ou selecione uma opção em Todas as SCOTs. Para obter uma lista de WCGWs que precisam ser relacionados a uma assertvia, selecione \'WCGWs não relacionados'\.",
    allScots: "Todas as SCOTs",
    allWCGWs: "Todos os WCGWs",
    unRelatedWCGWs: "WCGWs não relacionados",
    //CRA Build Step 4 Header Label
    craValue: "CRA",
    incompleteCraValue: "CRA incompleto",
    // Panel Headers
    taskCategories: "Navegação de tarefas",
    taskCategoryExecution: "Execução",
    taskList: "Lista de tarefas",
    taskDetails: "Detalhes da tarefa",
    fullScreen: "Tela Cheia",
    exitFullScreen: "Sair da tela cheia",
    defaultDropdown: "Menu Suspenso",
    status: "Status",
    language: "Idioma",
    channel: "Canal",
    header: "Cabeçalho",
    headerName: "Nome do cabeçalho",
    sectionCustomLabelLabel: "Legenda personalizada",
    sectionNamePlaceHolder: "Inserir o título de seção",
    showRelatedObjectLabel: "Mostrar objetos relacionados",
    errorBanner: "{0} Erro (s)",
    customize: "Personalize",
    customized: "Personalizado",
    custom: "Personalizar",
    description: "Descrição",
    seeDescription: "Veja a descrição",
    section: "Seção",
    entities: "Entidades",
    edit: "Editar",
    delete: "Deletar",
    collapse: "Reduzir",
    collapseAll: "Comprimir tudo",
    expand: "Expandir",
    expandAll: "Expandir tudo",
    incompleteResponse: "Resposta incompleta",
    unresolvedComments: "Comentários não resolvidos",
    saving: "Salvando…",
    tasks: "Tarefas",
    requests: "Solicitações",

    //BodyType Placeholder
    numericValuePlaceholder: "Insira o valor",

    //Modal
    addButton: "Adicionar botão",
    evidence: "Evidência",
    temporary: "Temporário",
    temporaryFiles: "Arquivos temporários",
    priorPeriod: "Período anterior",
    externaldocuments: "Documentos externos",
    eydocuments: "Documentos EY",
    clientRequestClientAnalytics: "Nome analítico",
    groupdocuments: "Documentos de grupo",
    name: "Nome",
    reason: "Razão",
    browse: "Procurar",
    uploadFile: "Fazer upload de arquivos",
    uploadDocument: "Carregar documento",
    duplicateDocumentHeader: "Um ou mais documentos com o mesmo nome já existem neste engagement (como arquivos de evidência ou temporários).",
    duplicateDocumentInstruction: "Selecione 'Substituir' para fazer upload do documento e substituir o arquivo existente ou 'Descartar' para cancelar. Se esse arquivo existente estiver em evidência, o documento será carregado na evidência. Se o arquivo existente estiver em arquivos temporários, o documento será carregado nos arquivos temporários.",
    overwriteLabel: "Substituir",
    discardLabel: "Descartar",
    discardChangesLabel: "Descartar alterações",
    note: "Nota",
    notes: "Notas",
    signOffs: "Assinaturas",
    related: "Relacionado",
    attributes: "Atributos",
    approveChanges: "Aprovar alterações",
    nodocumentsAdded: "Sem documentos disponíveis",
    noEntitiesAvailable: "Nenhuma entidade disponível",
    noDocumentsUpload: "Nenhum documento está sendo carregado",
    noSections: "Nenhuma seção disponível",
    noRequestMessage: "Não há solicitações ou tarefas externas neste engagement",
    noResultFound: "Nenhum resultado encontrado.",
    noRequestsFound: "Nenhuma solicitação encontrada",
    noTimePhasesFound: "Nenhuma fase de tempo disponível",
    noEntitiesFound: "Sem resultados",
    relatedEntities: "Entidades relacionadas",
    noClickableRelatedEntities: "As entidades relacionadas não podem ser editadas nesta tarefa",
    taskByEntityLabel: "Tarefas por entidade",
    relEntityLabel: "Entidade",
    singleEntity: "{0} entidade",
    multipleEntity: "{0} entidades",
    engagementDeliveryLabel: "Tarefas por engagement",
    onlyShowRelEntities: "Mostrar apenas as entidades relacionadas",
    engDeliveryDescription: "Esta tarefa está associada a todas as entidades do engagement.",
    relEntitiesDescription: "Visualize entidades relacionadas à tarefa. As entidades relacionadas só podem ser editadas para tarefas OSP e OST.",
    relEntitiesPSTorPSPDesc: "Visualize entidades relacionadas à tarefa. As entidades relacionadas não podem ser editadas para tarefas PST e PSP.",
    warningRelMsg: "A tarefa deve estar relacionada a uma ou mais entidades. Para tornar o engagement da tarefa abrangente, altere a Tarefa por entidade.",
    reldetailDescription: "Por padrão, as tarefas OSP e OST abrangem todo o engagement e estão relacionadas a todas as entidades. As tarefas podem ser relacionadas a uma ou mais entidades habilitando Tarefas por entidade.",
    results: "resultados",
    searchPlaceholder: "Procurar",
    searchDocPlaceholder: "Pesquisar documento",
    searchCanvasForms: "Pesquisar formulários do Canvas",
    searchControlForms: "Pesquisar SCOTs",
    canvasFormListDescription: "Selecione um Formulário do Canvas na lista abaixo para visualizar relatórios relacionados ao Formulário do Canvas.",
    controlFormListDescription: "Selecione uma SCOT para ver seus formulários de controle relacionados.",
    object: "Objeto",
    relateCollaboration: "Relacionar colaboração",
    reviewNote: "Notas de revisão",
    reviewNoteSingle: "Nota de revisão",
    documentReviewNotes: "Notas do documento",
    noEvidenceFilesAssociated: "Não há documentos de evidência associados a esta tarefa",
    taskReviewNoteWithParenthesess: "Nota(s) da tarefa",
    taskNotes: "Notas de tarefa",
    documentsNotes: "Notas do documento",
    addNewDocumentNote: "Adicionar nota de documento",
    selectDocument: "Selecione um documento",
    taskReviewNotes: "Nota de tarefa",
    showCleared: "Mostrar limpo",
    Replied: "Respondido:",
    showClosed: "Mostrar fechado",
    allNotes: "Todas as notas",
    myNotes: "Minhas anotações",
    noTasksAvailable: "Nenhuma tarefa disponível",
    noWCGWAvailableForTask: "Não há Risco de Distorção Relevante (ROMM) disponível",
    noSubstantiveTasksAvailable: "Nenhuma tarefa substantiva relacionada",
    noNotesAssociatedWithDocument: "Não há notas associadas a este documento",
    noNotesAssociatedWithTak: "Não há notas associadas a esta tarefa",
    otherEngagementNotes: "Outras notas do engagement",
    to: "para",
    deleteReviewNote: "Excluir",
    missingToUserError: "Requerido",
    missingReviewNoteTextError: "O texto da nota de revisão é requerido",
    invalidReviewNoteTextError: "O texto inserido excede o limite",
    dueDateRequiredTextError: "A data de vencimento é requerida",
    saveNoteTextError: "Salvar ou Cancelar para prosseguir",
    engagementName: "Nome do engagement:",
    assignmentsCountLabel: "Atribuições",
    AssignmentsDays: "Dias",
    closedOnTime: "Fechado a tempo",
    daysToPrepare: "Dias para preparar",
    daysToReview: "Dias para revisar",
    totalAssignments: "Total de <br/>atribuições",
    currentlyAssigned: "Atualmente <br>atribuído",
    UpcomingAssignments: "Por vir",
    authoredByMe: "De autoria minha",
    commentsLabel: "Revisar notas",
    clearedOnTime: "Apagado a tempo",
    daysToClear: "Dias para limpar",
    daysToClose: "Dias para fechar",
    totalLabel: "Notas totais",

    criticalAndHighRn: "Notas críticas e altas",
    criticalAndHighComments: "Notas críticas e altas",
    lowAndMediumComments: "Notas médias e baixas",
    metricsInstructionalText: "Veja abaixo as métricas de desempenho de suas tarefas e notas. <br>Selecione um membro da equipe para ver suas métricas ou escolha <b>Visualização do engagement</b> para ver um resumo geral.",
    metricsNewInstructionalText: "Selecione um membro da equipe para ver suas notas de revisão e atribuições ou escolha <b>Visualização do engagement</b> para ver um resumo geral.",
    switchToViewPlaceholder: "Não há dados para exibir. <br>Se selecione outro membro da equipe ou mude para <b>Exibição do engagement.</b>",
    tasksClosedOnTime: "Tarefas encerradas a tempo",
    daysDetailReview: "Dias para detalhar a revisão",
    daysGeneralReview: "Dias para revisão geral",
    totalDaysReview: "Total de dias para revisar",
    metricsInstructionalTextconfiguration: "Veja um resumo geral das métricas de desempenho para tarefas e notas abaixo.",

    //document download
    docSizeMB: "MB",
    docSizeKB: "KB",
    labelForExpiredPackage: "O pacote expirou.",
    headerForDocumentDownload: "Clique no nome do arquivo para baixar",
    labelForNoFiles: "Não havia arquivos nas categorias selecionadas.",
    labelForProcessing: "Os arquivos estão sendo processados.",

    //create dropdown texts
    create: "Criar",
    addRequestText: "Solicitação",
    addExternalTaskText: "Tarefa externa",
    addFindingText: "Finding",
    show: "Mostrar:",
    riskTypeHeader: "Tipo de Risco",
    wcgwHeader: "WCGW",
    hasNotes: "notas em aberto",
    hasNote: "nota aberta",
    noNotes: "(0 notas em aberto)",
    addTemporaryFiles: "Adicionar arquivos temporários",
    addPriorPeriodEvidence: "Adicionar período anterior",
    addExternalDocuments: "Adicionar documentos externos",
    //Nav
    navHeaderTasks: "Tarefas",
    quickFilterAllCompletedTasks: "Todas as tarefas concluídas",
    quickFilterMyCompletedAssignmnets: "Minhas atribuições concluídas",
    quickFilterMyUpcomingAssignments: "Minhas próximas atribuições",
    navHeaderTaskCategory: "Categorias de tarefas",
    navFilterBy: "Opções de filtro",
    navHeaderDocuments: "Documentos",
    navHeaderCollaboration: "Colaboração",
    navHeaderAssignments: "Atribuições",
    navHeaderAutomation: "Automação",
    navHeaderMore: "Mais",
    navDashboard: "Painel de controle",
    navReviewnotes: "Notas de revisão",
    navHeaderManageteam: "Gerenciar a equipe",
    navHeaderMangeteamNew: "Gerenciar equipe - Novo",
    mangeteam: "Gerenciar equipe",
    postArchive: "Após archive",
    addmember: "Adicionar membro",
    addnewmember: "Adicionar novo membro",
    addPriorPeriodMembers: "Adicionar membros inativos",
    addPriorPeriodUsers: "Adicionar membros inativos",
    createPackage: "Criar pacote",
    engagementrole: "Função do engagement",
    noPendingPriorPeriodUsers: "Nenhum membro inativo para convidar",
    sendPriorPeriodUserInvitesWithCount: "Enviar ({0}) convites",
    sendPriorPeriodUserInvitesWithoutCount: "Enviar convites",
    priorPeriodMembersModalHeaderMessage: "Selecione os membros inativos que você gostaria de adicionar ao seu engagement. Os membros receberão permissões que tinham anteriormente no engagement após a reativação.",
    priorPeriodIndependenceModalHeaderMessage: "Selecione os membros inativos de independência apenas que você gostaria de adicionar ao seu engagement",
    disabledPriorPeriodMembersButtonToolTip: "Direitos insuficientes para adicionar membros anteriores. Fale com um membro da equipe do engagement com os direitos apropriados para tomar esta ação.",
    disabledNewMembersButtonToolTip: "Direitos insuficientes para adicionar novos membros. Fale com um membro da equipe de engajamento com os direitos apropriados para tomar esta ação.",
    disabledNewMembersButtonToolTipThirdpartyuser: "Direitos insuficientes para adicionar terceiros. Fale com um membro da equipe de engagement com os direitos apropriados para realizar esta ação.",
    rbacNoRightsForContentUpdateToolTip: "Você não possui credenciais para atualização de contéudo. Entre em contato com o administrador do engagement e solicite permissão para iniciar uma atualização de contéudo",
    deactivateInternalUsersWithCount: "{0} membros selecionados",
    canvasFormSelectionMessageSingular: "Formulário {0} Canvas selecionado",
    canvasFormSelectionMessagePlural: "Formulários {0} Canvas selecionado",
    pspAccountSelectionMessageSingular: "{0} Conta selecionada",
    pspAccountSelectionMessagePlural: "{0} Contas selecionadas",
    manageTeamGroupLabel: "Grupo",
    manageTeamGroupsLabel: "Grupos",
    allAccessGroups: "todos os grupos de acesso",
    reactivate: "Reativar",
    deactivate: "Desativar",
    unselect: "Desmarcar todos",
    deactivateInternalModalTitle: "Desativar membros internos",
    deactivateInternalModalMessage: "Tem certeza que quer desativar os seguintes membros da equipe?",
    deactivateInternalUsersSuccessMessage: "{0} membros foram desativados com sucesso.",
    deactivateExternalModalTitle: "Desativar membros externos",
    deactivateExternalModalMessage: "Tem certeza que deseja desativar os seguintes membros da equipe de {0}? Os itens atribuídos serão reatribuídos aos respectivos grupos de acesso.",
    deactivateExternalSuccessMessage: "Os membros foram desativados com sucesso.",
    internalMember: "Membros internos",
    addinternalmember: "Adicionar membro interno",
    addThirdPartymember: "Adicionar terceiros",
    missingResponsiblePerson: "Responsável não encontrado",
    sentRequests: "Enviado",
    receivedRequests: "Recebido",
    syncProfileNotAllowed: "Perfil de sincronização não permitido",
    allSyncProfileNotAllowedMessage: "O perfil de sincronização não é permitido. Formulário não disponível para este perfil.",
    allCanvasFormsContentUpdateMessage: "O conteúdo não pode ser entregue para atividades de capacitação do EY Canvas FIT que são compartilhadas. Desvincule essas atividades para continuar as atualizações de conteúdo.",
    someFormContentUpdateMessage: "Alguns dos formulários não podem ser sincronizados com o perfil do projeto porque não há conteúdo",
    linkedFormContentUpdateMessage: "O conteúdo não será entregue para as atividades de capacitação do EY Canvas FIT que são compartilhadas. Para atualizar o conteúdo para eles, desvincule essas atividades.",
    leaveUsFeedback: "Deixe-nos um feedback",

    notApplicableLabel: "Não aplicável",
    addThirdPartyMemberDescription: "Essa funcionalidade só deve ser usada para conceder aos revisores terceirizados acesso a este engagement do EY Canvas. As aprovações e autorizações apropriadas devem ser adquiridas a partir da Prática Profissional.",
    hasOverallResponsibilityDescription: "Um membro da equipe de auditoria ou do engagement que assume a responsabilidade geral pela direção, supervisão e execução da auditoria ou engagement e pelo relatório e/ou conclusão interna ser apropriado nas circunstâncias.",
    partnerInChargeHeader: "Sócio responsável /Executivo responsável",
    picFlag: "PIC",
    CannotUpdatePicInArchivedEngagement: "Não é possível processar edições em campos restritos. Atualize e tente novamente",

    noGroupFound: "Nenhum grupo de acesso foi criado neste engagament. Selecione \'Adicionar grupo de acesso\' para criar um novo grupo de acesso de membros externos da equipe.",
    addGroup: "Adicionar grupo",
    deleteGroup: "Excluir grupo de acesso",
    deleteGroupMessage: "Tem certeza de que deseja excluir o grupo de acesso {0}?",
    addAccessGroup: "Adicionar grupo de acesso",
    accessGroupCreated: "Novo grupo de acesso {0} foi criado com sucesso.",
    accessGroupUpdated: "Mudanças para acessar o grupo {0} foram gravadas corretamente",
    editAccessGroup: "Editar grupo de acesso",
    sharedGroupwarning: "Trata-se de um grupo de acesso compartilhado e as alterações serão refletidas para todos os engagements associados.",
    groups: "Grupos",
    addExternalMembers: "Todos os membros externos",
    members: "Membros",
    externalMember: "Membros externos",
    member: "Membro",
    role: "Cargo",
    actions: "Ações",
    internalUserEdit: "Editar",
    internalUserDeactivate: "Desativar",
    usersFilter: "Filtro",
    externalUserEdit: "Editar",
    externalUserDeactivate: "Desativar",
    externalUserGroupLabel: "grupos",
    externalNoUserInGroup: "Nenhum membro foi adicionado a este grupo de acesso.",
    externalNoUserInAllGroup: "Nenhum membro foi adicionado a este engagement.",
    alias: "Alias",
    independence: "Independência",
    navManagegroup: "Gerenciar grupo",
    navCRAsummary: "Resumo do CRA",
    navAuditplan: "Plano de auditoria",
    navWorkplan: "Plano de trabalho",
    navSEM: "Matriz de avaliação substantiva",
    nav440GL: "Alterações após a data do relatório",
    navFindings: "Findings",
    navCanvasformupdates: "Atualizações do formulário do Canvas",
    navPSPContentUpdates: "Atualizações de conteúdo do PSP",
    navCopyhubNew: "Copy hub - Novo",
    navCopyhub: "Copy hub",
    navArchiveChecklist: "Archive checklist",
    navExporthub: "Exportação de hub",
    navReporting: "Relatório",
    navAccountSummary: "Resumo da contas",
    navScotSummary: "Resumo das SCOT",
    navItSummary: "Resumo de TI",
    navGroupInstructionSummary: "Instruções de grupo",
    navGroupInvolvement: "Envolvimento do grupo",
    navHelixProjects: "Conexões do EY Helix",
    navContentUpdates: "Atualização de conteúdo",
    contentUpdateErrorMsg: "Você não tem permissões para salvar alterações. Entre em contato com outros membros da equipe com essas permissões para fazer alterações.",
    contentUpdateTitleTip: "Permissões insuficientes para realizar a atualização do conteúdo. Entre em contato com o administrador do engagament e solicite permissão para iniciar uma atualização de conteúdo",
    noPreviousUpdates: "Sem atualizações anteriores",
    noContentUpdateResults: "Nenhum resultado encontrado",
    noPSPAccountsToUpdate: "Nenhuma conta a ser atualizada",
    rbcaUnavailableMsg: "O EY Canvas não pode salvar as alterações neste momento. Tente novamente e se o problema persistir, entre em contato com o Help Desk",
    showErrInProgressMsg: "29007 - As atualizações de conteúdo não podem ser iniciadas enquanto outras atualizações estão em andamento. Aguarde até que a atualização do conteúdo atual seja concluída ou atualize a página e tente novamente.",
    navHelp: "Ajuda Geral",
    validationNavHelp: "Ajuda de validação",
    searchUserText: "Pesquisar usuário",
    superModelTitle: "Objetos do engagement",
    superModelText: "Super modal",
    independenceOnlyMembers: "Membros de independência apenas",
    noIndependenceOnlyPriorPeriodUsers: "Sem membros inativos de independência apenas para convidar.",

    //Copyright
    copyRight: "Direito Autoral © <year> todos os direitos reservados",

    //Copyhub List labels
    moreRecipient: "mais",
    copyHubPackageName: "Nome do pacote",
    copyHubSentBy: "Enviado por",
    copyHubSentTo: "Enviado para",
    copyHubReceivedBy: "Recebido por",
    copyHubDate: "Data",
    copyHubRemainingTime: "Tempo restante",
    copyHubAvailableFor: "Disponível para",
    copyHubStatus: "Status",
    noCopyHubSentPackages: "Ainda não foram criados pacotes de cópias. Selecione Criar pacote para criar um novo pacote de dados.",
    noCopyHubReceivedPackages: "Não há pacotes de cópias disponíveis para este engagement",
    remainingTimeTooltip: "Os itens serão permanentemente removidos no momento do arquivo, ou 10 dias após a criação",
    copyHubDeleteText: "Excluir",
    appendDays: "Dias",
    generalInformation: "Informações Gerais",
    copyDocuments: "Documentos",
    copyFiles: "Arquivos",
    scots: "SCOTs",
    accounts: "Conta",
    copyHubImport: "Importação",
    copyHubPackageType: "Tipo de pacote:",
    copyHubCreatedModal: "Criado:",
    copyHubRemainingTimeModal: "Tempo restante:",
    copyHubAvailableForModal: "Disponível para:",
    copyHubInstructionModal: "Instruções:",
    copyHubCategories: "Categorias",
    copyHubPendingDeletion: "Exclusão pendente",
    copyHubVersionMismatchCat: "Não é possível mostrar categorias devido à incompatibilidade da versão do pacote",
    copyHubVersionMismatchPersonInfo: "Não é possível mostrar informações de remetente e receptor devido à incompatibilidade da versão do pacote",
    copyHubViewLegacyPacakgeDetails: "Este é o pacote de cópia legado para o qual informações detalhadas não estão disponíveis",
    associateTasks: "Associar tarefas",
    backToForms: "Voltar aos formulários",
    noTaskSelected: "Pelo menos uma tarefa deve ser selecionada",
    taskLabel: "Tarefa :",
    taskMessage: "Você precisa associar a Task com esses formulários de importação.",
    importSuccessMessage: "Pedido de importação na fila com sucesso",
    taskSelectedText: "Tarefas selecionadas",
    insufficientPermissionsToImport: "Permissões insuficientes para importar pacote de cópia.. Entre em contato com o administrador do engajamento e solicite permissão para importar o pacote de cópia.",
    cannotImportExpiredPackage: "Não é possível importar pacote de cópia expirado.",
    cannotImportWhileInProgress: "Não é possível importar pacote de cópia que já está em andamento.",
    deletePackageHeader: "Excluir pacote",
    copyPackageDeleted: "O pacote foi excluído",
    copyPackageDeleteConfirmation: "Tem certeza que deseja excluir este pacote?",
    insufficientPermissionsToDelete: "Permissões insuficientes para excluir pacote de cópia. Entre em contato com seu administrador do engagement e solicite permissão para excluir o pacote de cópias.",
    insufficientPermissions: "Permissões insuficientes",
    GuidedWorkflowsPackageDisplayText: "Selecionar importação atualizará os fluxos de trabalho guiados correspondentes da cópia para este engagement. Fluxos de trabalho guiados sem correspondência não serão importados.",
    copyRequestStatusInQueue: "Na fila",
    GuidedWorkflowImportError: "A importação de fluxos de trabalho guiados não está disponível para engagements multi-entidades",

    //TopHeaderLayout.js
    topHeaderLayoutMilestoneText: "Milestone confronte ou reconcilie as informações financeiras com os registros contábeis subjacentes Obtenha evidência de que as informações financeiras intermediárias cruzam ou reconciliam com os registros contábeis subjacentes.",
    //TaskLayoutHeader
    taskLayoutHeaderSearchPlaceholder: "Pesquisar tarefas",
    taskLayoutHeaderAssignments: "atribuições",
    taskLayoutHeaderAddTask: "Nova tarefa",
    wcgwSearchPlaceholder: "Pesquisar WCGW",
    //TaskListHeader
    taskTypeHeader: "Tipo",
    taskNameHeader: "Nome",
    taskDueDateHeader: "Data de vencimento",
    reviewNoteChangeDueDate: "Alterar data de vencimento",
    taskListHeaderSortByDueDate: "Data de Vencimento",
    taskListHeaderSortByTaskName: "Nome da tarefa",
    sortBy: "Ordenar por:",
    ascending: "Crescente",
    descending: "descendente",
    taskListHeaderSortByKnowledge: "Plano de auditoria",
    taskListHeaderDeleteWarning: "Tem certeza de que deseja excluir as tarefas selecionadas?",
    taskListHeaderSortText: "Ordenar",
    taskListHeaderSortOrderText: "Ordem de classificação",
    taskListHeaderTimePhaseText: "Adicione uma fase de tempo",
    taskListHeaderBookMarkText: "Indicador",
    taskListHeaderFavoriteText: "Favorito",
    taskListHeaderEditText: "Editar título da tarefa",
    moreMenu: "Mais",
    taskListHeaderMoveTaskText: "Mudar o grupo de tarefas",
    taskGroupIconHoverText: "Alterar grupo de tarefas",
    taskGroupLabel: "Alterar grupo",
    task: "Tarefa",
    toc: "TOC",
    tenNotes: "10 notas",
    source: "Fonte",
    nature: "Natureza",
    assertion: "Assertivas",
    relatedAccounts: "Contas relacionadas",
    testOfDetail: "Teste de detalhes",
    testOfControl: "Teste de controle",
    substantiveAnalyticalProcedure: "Procedimento substantivo analítico",
    tod: "TOD",
    sap: "SAP",
    int: "INT",
    ext: "EXT",
    notSel: "NÃO SELECIONADO",
    internal: "Interno",
    external: "Externo",
    notSelected: "Não selecionado",
    documentCannotOpen: "Este documento não pode ser aberto em Detalhes da tarefa. Navegue para a lista de documentos para abrir este documento.",
    //TaskPanelLayout
    emptyTaskDetailsMessage: "Selecione uma tarefa para visualizar detalhes.",
    multiTaskSelectedMessage: "Para habilitar controles em massa, use a tecla Control e selecione várias tarefas. \ n Se você deseja trabalhar em uma tarefa individual, selecione-a na lista de tarefas.",
    emptyAndMultiSelectedMessage: "Para ativar controles em massa, use a caixa de seleção para selecionar uma ou mais tarefas. Use a tecla shift para selecionar várias tarefas ao mesmo tempo. Se você quiser trabalhar em uma tarefa individual, selecione essa tarefa da lista.",
    //Evidence
    evidenceDragAndDrop: "Arraste e solte ou",
    //Timephases
    noResultTimePhase: "Nenhum resultado encontrado.",
    //handoff
    handoff: "Encaminhar",
    handoffConfirmButtonText: "Encaminhar",
    handoffModalTitle: "Encaminhar tarefa",
    handoffTitle: "Transferir para o próximo membro da equipe",
    handoffTextLine2: "Para assinar um arquivo de evidência, selecione uma das opções abaixo.",
    return: "Retornar",
    returnDisabledMessage: "Esta tarefa não pode ser retornada porque: (1) você é o preparador designado, (2) o status da tarefa não está no status “Em revisão” ou “Concluído” ou (3) não há preparador designado.",
    handOffTitleTip: "Encamnhar para revisão",
    //Mark Complete
    markCompleteTitleTip: "Selecionar como completa",
    markCompleteTitle: "Marcar tarefa como concluída",
    markCompleteText: "Sua assinatura será aplicada às evidências associadas a esta tarefa, conforme indicado abaixo. Esta tarefa será selecionada como concluída.",
    markCompleteTextLine1: "Entregue esta tarefa para o próximo membro da equipe.",
    markCompleteTextLine2: "Para assinar um arquivo de evidência, selecione uma das opções abaixo. Se você tiver uma atribuição para esta tarefa e a tiver concluído, selecione <b>Sim</b> para fechá-la. Se esta tarefa exigir aprovação PIC ou EQR, selecione uma das opções abaixo.",
    markCompleteConfirm: "Marcar como concluída",
    signOffAs: "Assinar todos como:",
    additionalSignOff: "Assinaturas adicionais necessárias",
    additionalTaskStatus: "Feche minha tarefa",
    markCompleteModalHeaderTextPart1: "Esta tarefa será marcada completa.",
    markCompleteModalHeaderTextPart2: "Para assinar um arquivo de evidência, selecione uma das opções abaixo. Se você tiver uma atribuição para esta tarefa e a tiver concluído, selecione <b>Sim</b> para fechá-la. Se esta tarefa exigir aprovação PIC ou EQR, selecione uma das opções abaixo.",
    ep: "PIC",
    eqr: "EQR",
    closeMyAssignment: "Fechar minha atribuição",
    tempMarkCompleteMessage: "A tarefa não pode ser marcada como concluída. Atualize a página e tente novamente. Se o problema persistir entre em contato com o Help Desk.",
    tempMarkCompleteEnable: "Marcar Completo-ativar",
    tempMarkCompleteDisable: "Marcar como completo-desativar",
    //TaskDetails
    seeTask: "Ver tarefas",
    NoTasksFound: "Nenhuma tarefa encontrada",
    taskDetailsAddRelate: "Adicionar / Relacionar",
    taskDetailsDocument: "Documento",
    taskDetailsAutomationRequest: "Solicitação de automação",
    taskDetailsExternalTask: "Tarefa externa",
    taskDetailsFinding: "Finding",
    taskDetailsRequest: "Solicitação",
    taskDetailsNotes: "Notas",
    taskDetailsRelatedTask: "Tarefa relacionada",
    epeqr: "PIC/EQR",
    epeqrsignoffheader: "Assinatura é requerida",
    addTaskGroupLabel: "Adicionar grupo de tarefas",
    itgcTaskDescription: "Execute nossos testes projetados de ITGCs para obter evidência de auditoria suficiente e precisa quanto a eficácia operacional durante todo o período de confiança.",
    //create assignment
    createassignmentheaderLine1: "O membro da equipe selecionado não tem uma atribuição para esta tarefa.",
    createassignmentheaderLine2: "Crie uma atribuição aqui. Se outro membro da equipe já tiver uma atribuição incompleta do mesmo tipo,",
    createassignmentheaderLine3: "Selecione",
    createassignmentheaderLine4: "para substituí-lo por esta atribuição.",
    overwriteIncompleAssignments: "Substitua atribuições incompletas",
    //Create Assignment
    createassignmentheader1: "O membro selecionado  da equipe não tem uma designação para esta tarefa.",
    createassignmentheader2: "Crie uma tarefa aqui.",
    //Guidance
    atlasLink: "Link Atlas",
    automationLink: "Link de Automação Smart",
    otherLink: "Outro link",
    helixLink: "Link do helix",
    relatedAutomations: "Automações relacionadas",
    noSuggestedAutomationLabel: "Não há nenhuma automação sugerida para esta tarefa.",
    noSuggestedItemLabel: "Não há itens sugeridos para esta tarefa.",
    noAutomationRequestLabel: "Esta tarefa não está relacionada a nenhuma automação.Para começar, crie uma nova automação ou relacione uma automação existente.",
    relateAutomation: "Relacionar",
    relateAutomationModelHeader: "Relacionar Smart Automations",
    automationSolution: "solução",
    automationName: "Nome da automação",
    relateAutomationTextLine1: "Relacionar uma Smart Automation a essa tarefa.",
    relateAutomationTextLine2: "Uma vez relacionado, você pode visualizar a automação a partir de detalhes da tarefa e clicar para abri-la.",
    noSamrtAutomationForEngagement: "Nenhum Smart Automation foi criado para o seu engagement.",
    searchAutomationLabel: "Pesquisar automações",

    //RelatedItemHeader
    relatedItemsHeader: "Itens relacionados",
    relateButtonText: "Relacionar",
    createButtonText: "Criar",
    relatedItemREQ: "Solicitação",
    relatedItemET: "Tarefa externa",
    relatedItemATM: "Automação",
    relatedItemRelatedTask: "Tarefa relacionada",
    relateObjectsToTaskTitle: "Relacionar objetos a essa tarefa",
    relateObjectsToTaskSubTitle: "Relacionar um ou mais objetos a esta tarefa. Esses objetos aparecerão na seção Itens relacionados dos detalhes da tarefa.",
    relateObjectOptionsHeaderPSPOSP: "Contas, assertivas e contas de risco limitado",
    relateObjectOptionsHeaderITWalkthrough: "Processos de TI",
    relateObjectOptionsHeaderITControl: "Controles de TI (ITGCs e ITSPs)",
    // SDM Nextwave services
    scheduledServicesText: "Serviços relacionados",
    suggestedServicesText: "Serviços sugeridos",
    suggestedServicesDefaultMessage: "Há serviços Nextwave sugeridos para esta tarefa. Clique no",
    suggestedServicesDefaultMessage1: '+',
    suggestedServicesDefaultMessage2: "ícone para começar.",
    suggestedServicesPlaceholderMessage: "Não há serviços sugeridos para esta tarefa.",
    nextWaveServiceOfferingLabel: "Serviço",
    nextWaveServiceStatusLabel: "Status",
    nextWaveServiceStartDateLabel: "Começar",
    nextWaveServiceDueDateLabel: "Vencimento",
    nextWaveServiceRequestCreate: "Criar solicitação",
    nextWaveServiceRequests: "Solicitações de serviços centralizadas",
    nextWaveServiceGatewayRequests: "Solicitações de gateway de serviço",
    onlyShowSelectedTask: "Apenas mostrar tarefa selecionada",
    sdmRestrictAddTaskLabel: "Clique em continuar para prosseguir para a próxima etapa. A seleção de tarefas pode ocorrer depois que a oferta de serviço for aceita e o gerente da equipe com base no processo GDS entrar em contato para discutir o trabalho a ser concluído.",
    //Links
    linksText: "Links",
    //Forms
    formsText: "Formulários",
    /*Accounts*/
    associatedTasks: "Tarefas associadas ao WCGW",
    noAssertionsChecked: "Selecione uma assertiva para visualizar o WCGW relacionado",
    noAccountsCreated: "Nenhuma conta criada",
    noDesignationSelected: "Nenhuma designação selecionada",
    noRelatedAccounts: "Sem contas relacionadas",
    manageAccount: "Gerenciar contas e divulgações",
    /*Risks*/
    risk: "Risco",
    risks: "Riscos",
    wcgw: "WCGW",
    riskWcgw: "Risco:WCGW",
    wcgwTasks: "WCGW: Tarefa",
    riskWcgwLabel: "Relacionar riscos aos WCGWs",
    wcgwTasksLabel: "Relacionar o WCGW à tarefa",
    noRiskTypes: "Nenhum tipo de risco encontrado",
    saveRisk: "Salvar",
    noRisksFound: "Nenhum risco encontrado",
    haveBeenIdentified: "tem sido identificado",
    noAssertionFound: "Nenhuma assertiva relacionada aplicável a este engagement",
    noAssertionApplicable: "Nenhuma assertiva aplicável a este engagement foi associada",
    noWCGWFound: "Não há WCGWs relacionados a esse risco. Clique em Editar associações para relacionar um ou mais WCGWs.",
    noRelatedWCGWs: "Sem WCGWs relacionados",
    noRelatedControls: "Sem controles relacionados",
    noRelatedRisks: "Nenhum risco de TI relacionado",
    noRelatedITGCs: "Nenhum ITGC relacionado",
    iTriskVal: "Risco de TI",
    iTrisksVal: "Riscos de TI",
    iTGCVal: "ITGC",
    iTGCsVal: "ITGCs",
    iTSPVal: "ITSP",
    iTSPsVal: "ITSPs",
    iTGCname: "Nome do ITGC",
    iTSPname: "Nome do ITSP",
    noWCGWAvailable: "Nenhum Risco de Distorção Relevante (ROMM) disponível para as assertivas selecionadas",
    relevantWcgwCountHint: "A contagem exibida ao lado do nome da conta deve ser lida como o número de WCGWs relacionadas a assertivas com uma avaliação de risco de controle not rely ou assertivas relacionadas a estimativas de risco higher, que foram associadas a um procedimento substantivo, em comparação com o número total dessas WCGWs.",
    noAccountsFound: "Nenhum registro encontrado",
    selectAssertionToRelateWCGW: "Selecione Assertiva para relacionar Risco ao WCGW",
    significantAccounts: "Contas Significativas",
    riskName: "Risco:",
    accountName: "Conta:",
    noScotsFound: "Nenhuma Scot relacionada",
    relatedwcgw: "WCGWs relacionados",
    relatedRisks: "Riscos relacionados",
    noRelatedAssertionsLabel: "Nenhuma assertiva selecionada para a conta",
    boltIconTitle: "Risco relacionado",
    instructions: "Instruções",
    expandRisk: "1. Expandir um risco",
    selectAssertion: "2. Selecione uma assertiva",
    identifyRelatedWCGW: "3. Identifique WCGWs relacionados ao risco",
    clickAccount: "1. Clique em uma conta",
    selectWCGW: "2. Selecione um WCGW",
    identifyRelatedTask: "3. Identifique as tarefas que endereçam ao WCGW",
    information: "Informações",
    requiredAssertions: "Assertivas requeridas",
    wcgwWithoutTasks: "WCGW sem tarefas",
    found: "encontrado",
    editAssociations: "Editar associações",
    riskWCGW: "Risco: associado ao WCGW",
    wcgwTask: "WCGW: assoaciado as tarefas",
    requireTaskToBeRelated: "Solicitar que uma tarefa seja relacionada",
    expandCollapse: "Clique aqui para expandir/reduzir",
    requiredAssertionsInfo: "Mostrar apenas assertivas com uma avaliação de risco de controle not rely e assertivas relacionadas a estimativas de risco higher",
    wCGWwithoutTasksInfo: "Mostrar apenas WCGWs relacionados a uma assertiva com uma avaliação de risco de controle not rely e assertivas relacionadas a estimativas de risco higher, que não possuem nenhuma tarefa substantiva responsiva associada",
    noBuildStepsAvailable: "Não há etapas de construção disponíveis para serem apresentadas.",
    accountRiskAssessmentSummary: "Contas e divulgações",
    manageRisk: "Gerenciar riscos",
    addResponsivePSPOSP: "Adicionar PSP/OSP responsivo",
    assertionlbl: "Assertiva",
    addResponsiveControl: "Adicionar controle responsivo",
    addResponsiveTOC: "Adicionar sumário responsivo",
    showOnlyRelatedItems: "Mostrar apenas relacionados",
    relatedControlCounter: "{0} controle",
    relatedControlsCounter: "{0} controles",
    noControlsAvailableForRelateItem: "Nenhum controle disponível",
    relateControlName: "Controles",
    relateContolsAPIErrorMessage: "O controle não pode estar relacionado à assertiva. Atualize a página e tente novamente. Se o problema persistir entre em contato com o Help Desk.",
    relateTasksAPIErrorMessage: "A tarefa não pode estar relacionada à assertiva. Atualize a página e tente novamente. Se o problema persistir entre em contato com o Help Desk.",
    toggleFilterWarningMessage: "Mostrar apenas contas e divulgações sem nenhum procedimentos substantivos",
    toggleFilterWarningMessageForRisk: "Mostrar apenas riscos sem quaisquer procedimentos ou controles/TOCs substantivos responsivos",
    warningIconHoverText: "Risco sem quaisquer procedimentos ou controles/TOCs substantivos responsivos",
    filterYes: "Sim",
    filterNo: "Não",

    /*OrphanedControls*/
    orphanedControls: 'View unrelated controls',
    unRelatedOrphanControls: 'Unrelated controls',
    noOrphanedControlsDataLabel: "No unrelated controls available",
    noOrphanedControlsResultLabel: "No unrelated controls available",
    noControlSelected: 'At least one control must be selected for deletion.',
    controlsDeleteConformation: 'Are you sure that you want to delete the selected controls?',
    controlDeleteConformation: 'Are you sure that you want to delete the selected control?',
    deleteControlModalHeader: 'Confirm deletion of selected control',
    deleteControlsModalHeader: 'Confirm deletion of selected controls',

    /*SEM*/
    select: "Selecione",
    selectAnAccountFromTheDropDown: "1. Selecione uma conta no menu suspenso",
    applyAsertionsFilters: "2. Aplique filtros na assertiva",
    reviewTheTasksThatRespondToTheRisks: "3. Revise as tarefas que respondem ao (s) risco (s)",
    riskOfMaterialMisstatement: "Riscos de distorção material",
    expandScot: "1. Expandir um SCOT",
    selectWCGWToDisplayTheResponsiveTask: "2. Selecione o risco de distorção relevante para exibir as tarefas responsivas",
    tasksWithNoRelatedWCGW: "Tarefas sem riscos relacionados de distorção relevante",
    selected: "selecionado",
    clearSelections: "Desmarcar todos",
    romm: "Risco de distorção relevante (ROMM)",
    selectAccount: "Conta",
    selectHeader: "Selecionar cabeçalho",
    riskOfMaterialMisstatementsWithoutRelatedTask: "Riscos de distorção relevante sem tarefas relacionadas",
    selectOneOrMoreTasksToSeeTheRelatedROMM: "Selecione uma ou mais tarefas para ver o Risco de Distorção Relevante (ROMM) relacionado",
    invalidRelatedEntity: "Conta relacionada não encontrada. Atualize a página e tente novamente. Entre em contato com o suporte técnico se o problema persistir.",
    scrollUp: "Rolar para cima",
    scrollDown: "Rolar para baixo",
    duplicate: "Duplicado",
    showIndex: "Mostrar índice",
    noContentAvailable: "Nenhum conteúdo disponível",
    navigateTo: "Navegar para",
    /*validations */
    semValidation: "Validação SEM",
    riskWCGWValidation: "Validação de risco WCGW",
    showValidation: "Validações",
    wcgwWithNoRelatedTask: "WCGW sem tarefa substantiva relacionada",
    riskWithNoRelatedWCGW: "Risco sem WCGW relacionado",
    noValidationIdentified: "Nenhuma validação identificada",
    onlyShowScotWithNoControlNoWCGW: "Mostrar apenas SCOTs sem WCGW ou controle relacionado",
    /*CRA Badge*/
    ir: "IR",
    cr: "CR",
    cra: "CRA",
    selectToEdit: "Selecione para editar",
    both: "Ambos",
    prefix: "Prefixo",
    suffix: "Sufixo",
    optional: "(opcional)",
    title: "Título",
    charLimitExceeded: "O limite de caracteres foi excedido",
    requiredField: "Campo obrigatório",
    Lastmodifiedby: "Modificado pela última vez por",
    fileSize: " | {1} KB",
    fileSizeInKB: "{1} KB",
    fileSizeHeader: "Tamanho do arquivo",
    daysAgo: "dias atrás",
    weekAgo: "semana anterior",
    weeksAgo: "semanas anteriores",
    monthAgo: "mês anterior",
    monthsAgo: "meses anteriores",
    yearAgo: "ano anterior",
    yearsAgo: "anos anteriores",
    currentlyBeingModifiedBy: "Atualmente sendo modificado por",
    beingEditedInCoeditModeError: 'Being edited in multi-user edit',
    beingEditedInCoeditMode: 'Being edited in multi-user edit. Edit started by {0} ',
    beingEditedInCoeditModeOn: 'on {0}.',
    coEditModeAutomaticallyEnds: 'Multi-user editing. {0} days until multi-user editing automatically ends.',
    coEditModeIsEnding: "A edição de multi-usuário está terminando",
    coEditMode: "Edição de multi-usuário",
    checkInInProgressMessage: "Check-in em andamento. O check-in do documento pode levar até 20 minutos. Atualize para obter atualizações",
    checkOutInProgressMessage: "Check-out em andamento. O check-out do documento pode levar até 20 minutos. Atualize para atualizações",
    daasErrorMessage: "A operação não pode ser concluída neste momento. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    coEditModeIsStarting: "A edição de multi-usuário está começando",
    daasOpenDocumentWarning: 'Multi-user editing may have been ended by another user. Refresh the page and try again.',
    daasStartCollaborationModeWarning: 'Collaboration mode may have been started by another user. Refresh the page and try again.',
    documentCurrentlyBeingModifiedTitle: 'Document currently being modified',
    documentCurrentlyBeingModifiedHeader: 'This document is currently being modified by {0}. This user opened the document',
    documentCurrentlyBeingModifiedBody: 'Starting multi-user edit mode could cause conflicts, so we recommend discussing with {0} before proceeding. Select {1} to start the multi-user edit mode or {2} to return without starting multi-user edit mode.',
    documentEndMultiUserEditingTitle: 'Confirm you want to end multi-user editing',
    documentEndMultiUserEditingHeader: 'Warning: Other users may be actively editing this document.  This can be checked by opening the document and seeing if other users are currently in the file. Please confirm that all changes are complete before ending multi-user mode. File changes in multi-user mode may take up to 1 minute to be processed. Therefore, please wait at least 1 minute after exiting the file before ending multi-user mode.',
    documentEndMultiUserEditingBody: 'Select {0} to end the multi-user edit mode or {1} to return without ending multi-user edit mode.',
    startMultiuserEditing: 'Start',
    continue: "Continuar",
    openReadOnly: "Abrir somente para leitura",
    takeControlFromTeam: "Assumir o controle atual do membro da equipe",
    itapplication: "Aplicação de TI",
    aggregateITevaluation: "Avaliação agregada de TI:",
    control: "Controle",
    itgcitsp: "ITGC / ITSP",
    limitedRisk: "Conta de risco limitado",
    so: "Organização de Serviço",
    itApp: "Aplicação de TI",
    itAppType: "Aplicativo de TI",
    deleteTaskModalHeader: "Confirme a exclusão da tarefa selecionada",
    deleteTasksModalHeader: "Confirmar a exclusão das tarefas selecionadas",
    deleteTaskModalMessage: "Tem certeza de que deseja excluir a tarefa selecionada?",
    deleteTaskModalMessage1: "Evidências que não estão relacionadas a nenhuma outra tarefa neste engagement serão movidas para arquivos temporários. As conclusões e tarefas que não estão relacionadas a nenhuma outra evidência serão excluídas.",
    deleteTasksModalMessage: "Tem certeza de que deseja excluir as tarefas selecionadas?",
    someTasksCannotBeDeleted: "Algumas tarefas não podem ser excluídas",
    onlySomeTasksCanBeDeleted: "Apenas algumas das tarefas que você selecionou podem ser excluídas.",
    tasksThatCanBeDeleted: "Se você optar por continuar, <b>as tarefas listadas abaixo serão removidas</b> do seu engagement. Evidências que não estão relacionadas a outras tarefas em seu trabalho serão movidas para arquivos temporários. As tarefas de descoberta e resposta que não estão relacionadas a outras evidências também serão excluídas.",
    tasksThatCannnotBeDeleted: "<b>As tarefas listadas abaixo não podem ser removidas</b> do seu engagement, mas podem ser rejeitadas no Plano de Auditoria, se necessário.",
    accountHeader: "Contas",
    noAccountsIdentified: "Nenhuma conta foi identificada.",
    noRisksIdentified: "Nenhum risco foi identificado",
    noAssertionsIdentified: "Nenhuma assertiva foi identificada",
    noWcgwsIdentified: "Nenhum WCGW foi identificado",
    // Tasks/TaskDetails/Evidence
    addEvidence: "Adicionar evidência",
    relateEvidence: "Relacionar evidências",
    relateTemporary: "Relacionar arquivos temporários",
    relatePriorPeriod: "Relacionar evidências de períodos anteriores",
    relateExtDoc: "Relacionar documentos externos",
    relateFile: "Relacionar arquivos",
    relateAnalytics: "Relacionar análises",
    quickAddButton: "Adição rápida",
    createPaperProfile: "Criar documento físico",
    paperProfileInformationMessage: "Preparamos toda a documentação eletronicamente, incluindo as aprovações de preparação e revisão. Somente os documentos que são fornecidos a nós pela administração ou terceiros em papel e para os quais uma cópia eletrônica não está disponível (por exemplo, cópia de um contrato assinado entre a entidade e um terceiro) são permitidos como documentação em papel em nossos documentos de trabalho.",
    paperProfileName: "Nome do documento físico",
    paperProfileAdd: "Adicionar",
    paperProfileError: "Digite um nome de papel físico válido",
    otherEngagementsInWorkspace: "Outros engagements neste espaço de trabalho",
    relateDescription: "Relacionar um documento deste engagement ou de outro engagement neste espaço de trabalho.",
    onlyShowRelatedDocuments: "Mostrar apenas documentos relacionados",
    relateDescriptionTemp: "Relacionar um documento deste engagement.",
    added: "Adicionado",
    documentLocation: "Local do documento",
    documentIneligibleForSharingMessage: "Documentos confidenciais não são elegíveis para serem compartilhados.",
    confidentialityNotAppropiateForSharing: "Você não tem o nível de confidencialidade adequado para enviar este documento.",
    documentIsCheckedOut: "O documento está em modo de co-edição e não pode ser compartilhado. Termine o modo de co-edição para compartilhar o documento.",
    addCanvasFormNew: "Adicionar formulário do Canvas (Novo)",
    documentCount: "{0} documento",
    documentsCount: "{0} documentos",
    fitDocumentCannotbeSelected: "Os documentos FIT não podem ser compartilhados entre os projetos.",
    // Task/TaskDetail/Description
    noDescriptionAvailable: "Não há descrição disponível.",
    knowledge: "Informação",
    knowledgeDescription: "Descrição da informação",
    descriptionInstructions: "Descrição das instruções",
    fromInstructions: "A partir de instruções",
    customizeDescription: "Descrição personalizada",
    custimizeTaskDescription: "Descrição personalizada da tarefa",
    editTaskDescription: "Editar descrição da tarefa",
    saveLabel: "Salvar",
    okLabel: "Ok",
    cancelLabel: "Cancelar",
    leaveCommentLabel: "Deixe um comentário",
    addLabel: "Adicionar",
    closeLabel: "Fechar",
    editText: "Editar",
    enterReply: "Inserir resposta",
    reply: "Responder",
    deleteTagDesc: "A exclusão da marcação não pode ser desfeita. Tem certeza de que deseja continuar?",
    requiredText: "O texto é requerido",
    descriptionEmptyError: "A descrição é requerida",
    descriptionMaxLengthError: "O tamanho da descrição excedeu o tamanho máximo permitido",
    assignmentDueDate: "Data de vencimento da atribuição",
    navigateToGuidedWorkflow: "Navegue até a ativação do EY Canvas FIT",
    openInTasksPage: "Abrir em Tarefas",
    copyTaskLink: "Copiar link da tarefa",
    copyReviewNoteLink: "Copiar link da nota de revisão",
    urlCopiedLabel: "Link copiado com sucesso",
    //Related Tasks
    showOnlyRelatedTask: "Mostrar apenas relacionados",
    noTaskAvailable: "Nenhuma tarefa disponível",

    // Client Request / Client Request Detail /  Client Request Drawer
    openInCollaborationPage: "Abrir em Colaboração",
    copyRequestLink: "Copiar link de solicitação",
    requestType2MessageTitleDrawer: "Esta solicitação possui funcionalidades adicionais.",
    requestType2MessageSubtitleDrawer1: "Por favor",
    requestType2MessageSubtitleDrawer2: "clique aqui",
    requestType2MessageSubtitleDrawer3: "para navegar até ele.",

    // SeeMore component
    showMore: "Mostrar mais",
    showLess: "Mostrar menos",
    showMoreEllipsis: "Mostrar mais...",
    showLessEllipsis: "Mostrar menos...",

    // Request Description
    saveAndCloseButtonLabel: "Salvar e fechar",
    saveButtonLabel: "Salvar",
    cancelButtonLabel: "Fechar",

    // Request Description Modal labels
    discardChangesModalText: "Descartar mudanças",
    inlineSaveUnsavedChanges: "Há alterações não salvas. Deseja continuar?",

    // RelateWCGWModal labels
    wcgwName: "Nome do WCGW",
    wcgwByScot: "WCGWs por SCOT",
    unrelatedSCOTsHeader: "SCOTs não relacionadas",
    unrelatedSCOTPlaceholder: "Nenhuma SCOT relacionada",
    noWcgwPlaceholder: "Nenhum WCGW foi criado",
    showOnlyUnrelatedWCGW: "Mostrar apenas não relacionado",

    // CharCount component.
    of: "do",
    characters: "carácteres",
    fromUserLabel: "De",
    toUserLabel: "Para",
    handoffto: "Enviar para",
    priorityLabel: "Prioridade",
    addNoteLabel: "Adicionar",
    replyNoteLabel: "Responder",
    characterCountLabel: " de 4000 carácteres",
    taskNotePlacehodler: "Inserir nota de tarefa",
    documentNotePlacehodler: "Inserir nota do documento",
    taskNoteStatusBy: "por:",
    addNewReviewNoteButtonText: "Nova nota",
    fromKnowledge: "Do Conhecimento",
    /*day labels*/
    mon: "Segunda-feira",
    tues: "Terça-feria",
    wed: "Quarta-feira",
    thurs: "Quinta-feira",
    fri: "Sexta-feira",
    sat: "Sábado",
    sun: "Domingo",
    /*month labels*/
    jan: "Janeiro",
    feb: "Fevereiro",
    march: "Março",
    april: "Abril",
    may: "Maio",
    june: "Junho",
    july: "Julho",
    august: "Agosto",
    sept: "Setembro",
    oct: "Outubro",
    nov: "Novembro",
    dec: "Dezembro",
    /*Rename*/
    documentDropdown: "Lista suspensa de documentos",
    fileNameRequired: "O nome do arquivo é requerido",
	invalidCharacters: 'O nome do arquivo não pode incluir: * /: <> \\? | \"',
    existingFileName: "O nome do arquivo não é exclusivo. Atualize a página ou renomeie o arquivo para remover esta mensagem.",
    unknowError: "Ocorreu um erro inesperado. Atualize a página para remover esta mensagem.",
    maxLengthExceeded: "O nome do documento não pode exceder 115 caracteres.",
    documentNameSyncErrorMessage: "O nome do documento não pôde ser sincronizado com o Canvas Client Portal. Atualize a página e tente novamente.",
    /*Delete*/
    deleteFileTitle: "Excluir documento",
    deleteFileCloseBtnTitle: "Cancelar",
    deleteFileConfirmBtnTitle: "Excluir",
    deleteFileCloseTitle: "Fechado",
    deleteFileModalMessage: "Tem certeza de que deseja excluir o documento selecionado?",
    none: "Nenhum",
    /*Unlink*/
    unlinkFileTitle: "Desvincular evidência compartilhada",
    unlinkSource: "Fonte",
    unlinkTarget: "Objetivo",
    unlinkFileCloseBtnTitle: "Cancelar",
    unlinkFileConfirmBtnTitle: "Confirmar",
    unlinkFileCloseTitle: "Fechar",
    unlinkFileModalMessage: "Tem certeza de que deseja desvincular esse arquivo da evidência compartilhada?",
    /*Relate Tasks*/
    relateTasksTitle: "Relacionar tarefas",
    relateTaskSearchPlaceholder: "Entre para pesquisar",
    relateTaskInstructionalText: "Adicione ou remova tarefas com as qual o documento deve estar relacionado. Se o documento for uma evidência, removê-lo da última tarefa irá movê-lo para arquivos temporários.",
    relatedTaskInstructionalText: "O documento está relacionado com as seguintes tarefas neste engagament. Clique em um nome de tarefa para navegar até ele.",
    relateTaskName: "Nome da tarefa",
    relateTaskType: "Tipo",
    relatedTaskCounter: "{0} tarefa",
    relatedTasksCounter: "{0} tarefas",
    /*Relate Entities*/
    relateEntitiesTitle: "Relacionar entidades",
    relateEntitiesSearchPlaceholder: "Digite para pesquisar por nome",
    relateEntitiesName: "Nome da entidade",
    relateEntitiesIndex: "Índice padrão da entidade",
    relatedEntitiesCounter: "{0} entidades",
    relatedEntityCounter: "{0} entidades",
    onlyShowRelatedEntities: "Mostrar apenas entidades relacionadas",
    unableToRemoveSystemAssociatedRelatedEntity: "Não é possível remover relacionamentos do sistema entre documentos e entidades",
    /* Finalize document */
    document: "Documento",
    finalize: "Finalizar",
    finalizeDocument: "Finalizar documento",
    finalizeDocumentTitle: "Tem certeza de que deseja notificar a equipe principal de que este documento foi finalizado?",
    finalizeDocumentSubtitle: "A finalização de um documento informa à equipe principal que você não espera enviar nenhuma versão adicional do documento e altera o status do documento para <b>Versão final enviada</b>. Caso você faça alterações em um documento finalizado, ainda poderá enviar uma nova versão para a equipe principal.",
    /* Remove From Task */
    removeEvidenceModalTitle: "Remover da tarefa",
    remove: "Remover",
    removeFromTaskModalContent: "Tem certeza de que deseja remover o documento selecionado desta tarefa? Este documento não está associado a nenhuma outra tarefa neste engagement e, portanto, será movido para arquivos temporários.",
    sharedEvidenceRemoveFromTaskModalContent: "Tem certeza de que pretende remover o documento selecionado desta tarefa? Este documento é partilhado e não está associado a qualquer outra tarefa neste engagement. Não estará mais disponível no seu engagement se for removido.",
    /*AddDocumentToTasksModal*/
    modalCheckboxHeading: "Adicione evidência a uma ou mais tarefas",
    modalRadioHeading: "Associar documento a uma ou mais tarefas",
    confirm: "Confirmar",
    proceed: "Continuar",
    modalCheckboxMessage: "Selecione tarefas relevantes para adicionar a este documento.",
    selectedDocument: "Documento selecionado",
    modalRadioMessage: "Este documento foi previamente adicionado a evidências ou arquivos temporários.",
    modalRadioMessage1: "A adição deste documento novamente criará uma cópia duplicada. Selecione se deve associar uma cópia existente deste documento ou criar uma nova cópia deste documento.",
    option: "Opção",
    option1Message: "Associar documento existente a esta tarefa",
    option2Message: "Criar uma nova cópia deste documento",
    addToEvidenceSelectAll: "Selecionar tudo",
    currentTask: "Tarefa atual:",
    createNewCopy: "Crie uma nova cópia",
	fileNameMaxLenError: (maxFileLen) => ` O nome do arquivo está limitado a ${maxFileLen} caracteres.`,
    /* Confidentiality */
    confidentiality: "Confidencialidade",
    confidentialityType: "Confidencialidade (opcional)",
    confidentialityTitle: "Confidencialidade do documento",
    confidentialityPlaceholder: "Selecione a confidencialidade",
    confidentialityText: "Defina o nível de acesso requerido para que este documento seja aberto. Os níveis de acesso são definidos por Administradores do Engagement na página 'Gerenciar Equipe'. Se a confidencialidade já tiver sido definida para este documento, somente aqueles que podem abrir o documento podem alterá-lo.",
    confidentialityNotOpenable: "O documento não pode ser aberto porque seus direitos no engagment são insuficientes. Os níveis de acesso são definidos por administradores do engagement na equipe de gerenciamento.",
    confidentialityTargetNotOpenable: "Documentos confidenciais só podem ser abertos a partir do engagement de origem.",
    /*Sign-off requirements*/
    signOffRequirements: "Requisitos de assinatura",
    signoffRequirementsModalTitle: "Requisitos de assinatura",
    signoffRequirementsModalDescription1: "Ajuste os requisitos de assinatura executiva deste documento abaixo.",
    signoffRequirementsModalDescription2: "Alguns requisitos de aprovação não podem ser ajustados porque são exigidos pelo EY Canvas.",
    signoffRequirementsModalSaveLabel: "Salvar",
    signoffRequirementsModalCancelLabel: "Cancelar",
    signoffRequirementsModalCloseLabel: "Fechar",
    signoffRequirementsModalPICLabel: "PIC",
    signoffRequirementsModalEQRLabel: "EQR",
    /*SEM summary*/
    nextAccount: '>',
    prevAccount: "<",
    reviewedBy: "Revisado por",
    displaytoc: "Exibir TOC",
    viewBy: "Visto por",
    substantiveEvaluation: "Matriz de avaliação substantiva",
    reviewed: "Revisado",
    estimate: "Estimativa",
    /*440GL*/
    FourFortyTitle: "Evidência(s) modificada(s) após data do relatório  ({0})",
    LeftContainerTitle440GL: "Razões para a mudar",
    approvals: "Aprovações",
    approveChangesColumnTitle: "Aprovar alterações",
    approveChangesButton: "Aprovar mudanças",
    deleteApproval: "Remover aprovação",
    unauthorizedAction: "A ação só pode ser realizada por executivos do engagement",
    reasonColumnTitle: "Motivo",
    approvedBy: "Aprovado por:",
    approvedByPeople: "pessoas",
    noChangeReasonCommentAvailable: "Clique em editar motivo nas opções de engrenagem do documento para inserir o motivo da alteração.",
    changeReasonModalTitle: "Editar razão para a mudança",
    changeReasonModalText: "Selecione o motivo para mudança(s) feitas no documento após a data do relatório. Se múltiplas mudanças administrativas foram realizadas, selecione a mais recente mudança no menu abaixo. Se tanto mudanças administrativas e não-administrativas foram realizadas, selecione não-administrativas no menu abaixo.",
    changeReasonUploadModalTitle: "Motivo para upload do documento",
    changeReasonUploadModalText: "Selecione o motivo para mudança(s) feitas no documento após a data do relatório. Se múltiplas mudanças administrativas foram realizadas, selecione a mais recente mudança no menu abaixo. Se tanto mudanças administrativas e não-administrativas foram realizadas, selecione não-administrativas no menu abaixo.",
    changeReasonModalComboPlaceholder: "Selecione",
    changeReasonModalAnnotationText: "Documente as circunstâncias encontradas para adicionar nova evidência ao engagement; novos procedimentos ou procedimentos adicionais, documentos obtidos e conclusões da equipe e o efeito no relatório do auditor",
    changeReasonUploadModalAnnotationText: "Documente as circunstâncias encontradas para adicionar nova evidência ao engagement; novos procedimentos ou procedimentos adicionais, documentos obtidos e conclusões da equipe e o efeito no relatório do auditor",
    changeReasonModalAnnotationPlaceHolder: "Digite a razão para a mudança",
    changeReasonModalChangeReasonRequired: "Mude a razão para salvar.",
    noDocumentsModifiedAfterReportDate: "Sem documentos modificados após a data do relatório",
    noReasonSelected: "Nenhum motivo para modificação selecionado",
    fileSizeColumn: "Tamanho do arquivo",
    changePercent: "% de variação",
    toolTipChangePercent: "A alteração no tamanho do arquivo é calculada utilizando o tamanho do arquivo a partir da data do relatório e do tamanho atual do arquivo",
    /*Account Conclusion*/
    AccountConclusion: "Conclusão de conta",
    AccountDetails: "Detalhes",
    Conclusions: "Conclusões",
    accountDetailsTab: "detalhes",
    conclusionsTab: "conclusões",
    accountConclusionNoContentText: "O conteúdo não foi entregue para este Formulário. Vá para Canvas Form Updates do menu Global Navigation More e atualize manualmente o conteúdo.",
    validations: "Validações",
    /*RelatedFindings*/
    deficiency: "{0} Deficiências relacionadas",
    misstatement: "{0} distorções relacionadas",
    relatedDeficiency: "{0} deficiência relacionada",
    relatedMisstatement: "{0} distorção relacionada",
    deficiencies: "Deficiências",
    misstatements: "Distorções",
    pagingShowtext: "Mostrar",
    documentOpenModelLabel: "Documento sendo modificado no momento",
    openedLabelText: "Aberto",
    modelDocumentOpenedText: "Este documento está sendo modificado atualmente por",
    modelUserOpenedTheDocumentText: "Este usuário abriu o documento",
    modelOpenedDocumentConflictText: "A abertura do documento pode causar conflitos, por isso recomendamos a abertura somente para leitura. Se você deseja se tornar o editor deste documento, então",
    clickHereEnabledText: "Clique aqui.",
    reviewNotesTemporeryFilesTitle: "Notas de revisão para arquivos temporários",
    addNewReviewNoteTitle: "Notas de tarefas",
    /*Assignments*/
    assignedTo: "Atribuído a",
    createAssignment: "Criar atribuição",
    createAssignments: "Criar atribuições",
    editAssignments: "Editar atribuições",
    deleteAssignments: "Excluir atribuições",
    removeAssignments: "'Remova atribuições",
    noTimephaseSelected: "Não selecionado",
    unassigned: "não assinado",
    unassignedCapitalized: "Não atribuído",
    dueDateBlank: "Prazo",
    reviewerAssignment: "Atribuições do revisor",
    manageAssignments: "Gerenciar atribuições de tarefas",
    manageTaskAssignments: "Criar atribuições",
    selectedTasks: "tarefas selecionadas",
    someTasksCannotBeMoved: "Algumas tarefas não podem ser movidas",
    onlySomeTaskCanMoveToOtherGroup: "Apenas algumas das tarefas que você selecionou podem ser movidas para outro grupo de tarefas.",
    taskThatCanBeMovedToOtherGroup: "Se você optar por continuar, <b>as tarefas listadas abaixo serão movidas</b> para o grupo de tarefas que você selecionou.",
    tasksThatCannotBeMovedToOtherGroup: "<b>As tarefas listadas abaixo não podem ser movidas</b> para outro grupo de tarefas.",
    taskGroupSectionNotFound: "Nenhum resultado encontrado",
    placeholderForSearch: "Pesquisar",
    taskFilter: "Filtro",
    noResultsAvavilable: "Nenhum resultado encontrado",
    noTasksAvavilable: "Nenhuma tarefa disponível",
    clearAll: "Limpar tudo",
    engagementPhase: "Fase de auditoria",
    noOptionAvailable: "Nenhuma opção disponível",
    noTimePhase: "Nenhuma fase de tempo atribuída",
    roles: "Papéis",
    users: "Membros da equipe",
    rommAssociatedWNotRelyAssertion: "O Risco de Distorção Relevante (ROMM) está associado a uma Assertiva com estratégia de não confiança de controles ou uma Assertiva com risco inerente alto onde há uma estimativa",
    hasRiskAssociated: "Risco Associado",
    canvas: "Canvas",
    workingoffline: "Trabalhando offline",
    syncinprogress: "Sincronização em andamento",
    prepareoffline: "Preparando dados para offline",
    connectionavilable: "Conexão disponível",
    createAnAssignment: "Crie uma atribuição",
    createAssignmentEnd: "para que essa tarefa comece.",
    // Manage Assignments
    step01: "Etapa 01",
    step02: "Etapa 02",
    step03: "Etapa 03",
    step04: "Etapa 04",
    step05: "Etapa 05",
    manageAssigmentsStep1: "Selecione uma ação.",
    manageAssigmentsStep2: "Editar atribuição de tarefas",
    editAssignment: "Editar atribuição",
    deleteAssignment: "Excluir atribuição",
    manageAssigmentsStep3: "Trabalho completo",
    taskAssigmentStatusHeader: "Status de atribuição",
    taskAssigmentStatusTileHeader: "Status da tarefa e da atribuição",
    taskAssignmentName: "Atribuição",
    dueDateAssigment: "Vencimento",
    editDueDate: "Opcional: Editar dias antes da data de término",
    teamMemberAssigmentLabel: "Membro da equipe",
    currentAssigmentLabel: "Atual",
    handOffToAssigmentLabel: "Encaminhado para:",
    priorToEndDateLabel: "antes da data de término",
    noTimePhaseAssigmentLabel: "Nenhuma fase de tempo atribuída",
    closedByAssigmentLabel: "Fechado por",
    onAssingmentLabel: "em",
    preparerAssigmentOpenTitleTip: "Encaminhe esta tarefa para encerrar sua atribuição de tarefa",
    reviewerAssigmentOpenTitleTip: "Selecionar a atribuição de tarefa como completa",
    reviewerAssigmentClosedTitleTip: "Selecionar a atribuição de tarefa como aberta",
    AssigmentLabel: "Encaminhe esta tarefa para encerrar sua atribuição de tarefa",
    noEvidenceReviewerAssigmentTitleTip: "Adicione evidência para selecionar a atribuição de tarefa como completa",
    noTaskEvidencesHandoffModal: "Não há arquivos de evidências associados a esta tarefa.",
    back: "Voltar",
    savecontinue: "Salvar e continuar",
    finish: "Finalizar",
    save: "Salvar",
    emptyManageAssignmentStep: "...",
    selectAssignmentActionToContinue: "Selecione uma ação para continuar.",
    createNewTaskAssingment: "Criar nova atribuição de tarefa",
    deleteTaskAssingment: "Excluir atribuição de tarefa",
    createTaskAssingment: "Criar atribuição de tarefa",
    editExistingTaskAssingment: "Editar atribuição de tarefa existente",
    editTaskAssingment: "Editar atribuição de tarefas",
    removeExistingTaskAssingment: "Remover atribuição de tarefa existente",
    warningPopUpPreparerAssignmentTitle: "Substitua a atribuição do preparador existente",
    warningPopUpPreparerAssignmentText: "Já existe um preparador atribuído para esta tarefa. Tem certeza que quer substituir essa atribuição?",
    warningPopUpPreparerAssignmentConfirm: "Confirmar",
    warningPopUpPreparerAssignmentCancel: "Cancelar",
    selectTaskAssingment: "Selecionar atribuição de tarefa",
    viewHistoryAndConflicts: "Ver histórico",
    noHistoryAvailable: "Nenhum histórico disponível",
    teamMember: "Membro da equipe",
    dateEdited: "Última modificação",
    viewHistoryHeader: "O histórico das versãos deste documento é exibido abaixo.",
    viewHistorySubHeader: "Clique no nome de um membro da equipe para abrir uma versão anterior deste documento no modo somente leitura. Quaisquer alterações feitas nesta versão anterior não serão salvas no EY Canvas.",
    docConflictedMessage: "Existem conflitos associados a este documento. Navegue até a guia Conflitos da lista de Documentos para resolver.",
    removeTaskAssingment: "Remover atribuição de tarefa",
    addAssignmentInstructionalText: "Digite um novo nome de atribuição de tarefa aqui (por exemplo, revisor de detalhes, revisor geral)",
    addNewAssingmentName: "Adicionar novo nome de atribuição",
    addTaskAssignmentName: "Adicionar nome de atribuição de tarefa",
    assignmentName: "Nome da atribuição da tarefa",
    selectedTask: "tarefa selecionada",
    createTaskAssignmentHeading: "Criar uma nova tarefa aqui.",
    createTaskAssignmentHeading1: "Insira os detalhes da atribuição abaixo e selecione <b>Salvar e fechar</b> para finalizar. Para criar outra atribuição, selecione <b>Salvar e adicionar outra</b>.",
    saveDelete: "Salvar e excluir",
    createTaskAssignmentFinishLabel: "Salvar e fechar",
    createTaskAssignment: "Salvar e adicionar",
    editTaskAssignment: "Salvar & gerenciar outro",
    createTaskAssignmentSaveAndContinueLabel: "Salvar e gerenciar outro",
    daysPriorToEndDate: "Dias antes da data final",
    daysdue: "Dias de vencimento",
    daysPriorToEndDateOptional: "Dias antes da data final (opcional)",
    timephase: "Fase de tempo",
    timephasesLabel: "Fases de tempo",
    manageTimePhase: "Gerenciar fases de tempo",
    removeTaskAssingmentSingleTaskHeading: "Selecione a atribuição que deseja excluir.",
    removeTaskAssingmentSingleTaskHeading2: "Clique em 'Salvar e fechar' se você terminar ou clique em 'Salvar e gerenciar outro' se desejar gerenciar outra tarefa.",
    removeTaskAssingmentMultipleTaskHeading: "Se a atribuição e a combinação de membros da equipe existirem para uma tarefa selecionada, a atribuição será excluída. Faça suas seleções e selecione <b>Salvar & fechar</b> para terminar. Para excluir outra atribuição, selecione <b>Salvar & deletar</b>.",
    editTaskAssingnmentStep2Heading: "Selecione a atribuição da tarefa que você gostaria de editar.",
    selectedAssignment: "Tarefa selecionada:",
    editTaskAssingmentBulkHeading: "Selecione a atribuição que você gostaria de editar.",
    editTaskAssingmentBulkSubHeading1: "Se a combinação de atribuição e membro da equipe existir para uma tarefa selecionada, a tarefa será reatribuída. Você tem a opção de editar os <b>Dias anteriores à data de término</b>. Se você editar esse valor, ele será atualizado para todas as tarefas reatribuídas. Faça suas edições e selecione <b>Salvar & fechar</b>para finalizar. Para editar outra atribuição, selecione <b>Salvar & gerenciar outra</b>.",
    noResultInCategory: "Nenhum resultado encontrado nesta categoria de tarefa",
    searchTaskList: "Pesquisar lista de tarefas",
    searchCanvasFormList: "Pesquisa",
    clearHoverText: "Limpar",
    filtersWarningMessage: "Limite do filtro excedido. Apenas 25 filtros podem ser aplicados ao mesmo tempo.",
    reviewNotesWarningMessage: "Ocorreu um erro ao recuperar os dados. Tente novamente e, se o problema persistir, entre em contato com o Suporte Técnico.",
    editTaskAssingmentSept3Header: "Editar a atribuição selecionada.",
    editTaskAssingmentSept3Header2: "Clique em 'Salvar e fechar' se você terminar ou clique em 'Salvar e gerenciar outro' se desejar gerenciar outra tarefa.",
    editTaskAssignmentHeaderPart1: "Edite as atribuições da tarefa abaixo e selecione <b>Salvar alterações</b>.",
    calculatedDate: "Data calculada",
    saveAndAddbtn: "Salve e adicione outro",

    //Calendar Toggle Labels
    daysPriorToEndDateRequired: "Dias antes da data final (obrigatório)",
    dueDateRequired: "Data de vencimento (obrigatório)",
    selectDate: "Selecione a data",
    calculateDate: "Calcular data",

    /* Bulk TimePhase*/
    taskText: "Tarefa",
    timephasesetsuccess: "{0} fase de tempo definida com sucesso.",
    timephasessetsuccess: "{0} fases de tempo definidas com sucesso.",
    addTimephaseLabel: "Adicionar fase de tempo",
    infoSetTimePhase: "<h3>Definir fases de tempo</h3><p>Arraste e solte de uma fase de tempo para definir essa fase de tempo para os itens selecionados</p>",
    infoEditTimePhase: "<h3>Editar fase de tempo</h3><p>Clique no menu flutuante (três pontos) e selecione Editar para editar as propriedades da fase de tempo.</p>",
    infoAddTimePhase: "<h3>Adicionar fase de tempo</h3><p>Clique em Adicionar fase de tempo para criar uma nova fase de tempo.</p>",
    infoDeleteTimePhase: "<h3>Excluir fase de tempo</h3><p>Clique no menu flutuante (três pontos) e selecione Excluir para excluir a fase de tempo.</p>",
    deletedTimePhaseFilterWarningMessage: "A fase de tempo foi excluída por um usuário diferente.",

    //Set assignment dates modal labels
    setAssignmentTitle: "Definir data de vencimento da(s) tarefa(s)",
    setAssignmentDesc: "Você não definiu a data de vencimento da(s) tarefa(s). Selecione a(s) data(s) de entrega da(s) tarefa(s) abaixo para continuar.",
    setAssignmentDesc2: "Uma ou mais tarefas têm uma data de fase de tempo anterior à data de vencimento selecionada de {0}. Ajuste as datas de vencimento das tarefas ou a data de vencimento da fase de tempo para continuar.",
    timePhaseNameLabel: "Fase de tempo",
    timephaseEndDate: "Data de término da fase de tempo",
	tasksLabel: "Nº de tarefas",
    assignmentDateLabel: "Atribuição",
    noAssignedTimePhase: "Nenhuma fase de tempo atribuída",
    endDate: "Data de conclusão",
    calendarDateError: "A data de vencimento deve ser menor que a data de término da fase de tempo",

    /* Events*/
    addEventLabel: "Adicionar evento",
    sharedWithClient: "Compartilhado",
    noEventsMessage: "Nenhum evento foi identificado",
    naLabel: "N/A",
    deleteEventModalTitle: "Excluir evento",
    deleteEventDescription: "Tem certeza de que deseja excluir este evento?",
    showEventeName: "Evento",
    eventDateLabel: "Data",
    eventDatesLabel: "Datas",
    showEventStartDate: "Data inicial",
    showEventEndDate: "Data final",
    deleteEventSuccessMessage: "Evento excluído com sucesso.",
    eventTypeLabel: "Tipo de evento",
    singleDayEventLabel: "Único dia",
    multiDayEventLabel: "Múltiplos dias",
    dateRangeEventLabel: "Período",
    eventSharedWithClientLabel: "Compartilhado com o cliente",
    editEventLabel: "Editar evento",
    eventUpdateSuccessMessage: "Evento atualizado com sucesso.",
    noTimephasesMessage: "Nenhuma fase de tempo foi identificada.",

    /* Review Notes */
    showAll: "Todos",
    reviewNotesLabel: "Notas de revisão",
    athoredByMeLabel: "De minha autoria",
    assignedToMe: "Atribuído a mim",
    assignedToOpen: "Atribuído a (Abrir)",
    authoredByCleared: "Autoria de (Limpar)",
    totalOpenReviewLabel: "Total de notas de revisão abertas",
    totalClearedReviewLabel: "Total de notas de revisão limpas",
    agingLabel: "Tempo incorrido",
    openLabel: "Abrir",
    clearedLabel: "Limpo",
    noUsersFoundLabel: "Nenhum resultado encontrado",
    chartDataLabel: "Não há dados disponíveis.",
    noClientDataAvailable: "Sem dados disponíveis",
    DaysLessThan10: "<10 dias",
    Days11To30: "<30 dias",
    Days31To60: "<60 dias",
    Days61To90: "<90 dias",
    DaysMoreThan90: "> 90 dias",
    noReviewNotesFound: "Nenhuma nota de revisão encontrada",

    formMaxLength: "O texto não pode exceder {number} caracteres.",
    voiceNote: "Nota de voz",
    microphoneBlockedMessage: "Permita que o navegador acesse seu microfone para usar anotações de voz. Se já permitido, atualize e tente novamente.",
    microphoneBlockedOnVideoMessage: "Permita que o navegador acesse seu microfone para usar voz na gravação de tela. Se já foi permitido, atualize e tente novamente.",
    notInMainWindowVoice: "Gravações de voz não são permitidas dentro da gaveta, abra o documento em uma nova aba para realizar a ação.",
    notInMainWindowScreen: "Gravações de tela não são permitidas dentro da gaveta, abra o documento em uma nova aba para realizar a ação.",
    screenRecord: "Gravação de tela",
    playbackReview: "Revisão de reprodução",
    recording: "Gravação",

    /* Sign Offs */
    preparerHoverText: "Assinar como preparador",
    reviewerHoverText: "Assinar como revisor",
    preparerTitle: "Aprovações do preparador",
    reviewerTitle: "Assinaturas do revisor",
    preparerLetter: "P",
    reviewerLetter: "R",
    deleteHoverText: "Remover assinatura",
    signoffsrequired: "Assinaturas necessárias",
    signoffsOptional: "PIC/EQR opticional",
    eqrLabel: "EQR",
    partnerInChargeLabel: "PIC",

    landingPage: "Página Inicial",
    dashboardPage: "Painel de Controle",
    tasksPage: "Tarefas",
    documentsPage: "Documentos",
    collaborationPage: "Colaboração",
    automationPage: "Automação",
    newContentUpdate: "Atualização de conteúdo",
    contentUpdatesHistory: "História",
    history: "Histórico",
    contentUpdateType: "Tipo de atualização de conteúdo",
    iniciatedBy: "Iniciado por",
    date: "Data",
    clickForOptions: "Clique para mais opções",
    offline: "Offiline",
    eyServiceGateway: 'EY Service Gateway',
    eyAutomation: 'EY Automation',
    eyserviceGatewayAutomation: 'EY Service Gateway & Automation',

    // ContentUpdates
    contentUpdate: "Atualização de conteúdo",
    canvasFormUpdates: "Atualização de conteúdo de formulário do Canvas",
    syncFormProfile: "Sincronizar perfil de formulário",
    documentName: "Nome do documento",
    analyticName: "Nome analítico",
    formType: "Tipo de formullário",
    dateOfContent: "Data do conteúdo",
    formStatus: "Status",
    formsWarningMessage: "Um ou mais formulários do EY Canvas devem ser selecionados para atualização",
    formsUpdateSuccessMessage: "Atualização do formulário do EY Canvas enviada",
    filterTypeOfFormLabel: "Tipo de formulário",
    filterSourceOfFormLabel: "Fonte de formulário",
    documentSelectionRequired: "Selecione um documento para substituir",
    overwriteForm: "Formulário de sobregravação",
    overwriteFormInstructionalText: "Selecione um formulário para substituir as respostas com os dados do formulário do canvas atual. Observe que o formulário do Canvas atual será movido para arquivos temporários.",
    confirmOverwrite: "Confirmar sobregravação",
    confirmOverwriteAreYouSure: "Você tem certeza de que deseja copiar o conteúdo do formulário \'{0}\' para o formulário \'{1}\'?",
    confirmOverwriteDesc: "As respostas serão sobreescritas no formulário \'{1}\', mas evidências e objetos relacionados não. As evidências e objetos relacionados aplicáveis devem ser reassociados ao formulário \'{1}\' após a substituição ter sido concluída. O formulário \'{0}\' manterá seus perfis/GAM existentes, portanto, se esse perfil for diferente do formulário \'{1}\', por favor revise e limpe o conteúdo copiado.",
    confirmOverwriteDoNotClose: "Não feche o navegador ou navegue enquanto o processo de substituição estiver em andamento. Após o processo de substituição ter sido concluído, o formulário \'{0}\' será movido para arquivos temporários. Esta ação não pode ser desfeita.",
    sourceDocument: "documento de origem",
    targetDocument: "documento-alvo",
    profileLayers: "GAM layers",
    pspAccountWarningMessage: "Uma ou mais contas devem ser selecionadas para atualização",
    pspAccountUpdateSuccessMessage: "Atualização de conteúdo do PSP enviada",
    pspAccountconfirmUpdateMessage: "A atualização dessas contas pode ter um impacto significativo no conteúdo. Depois de iniciadas, nenhuma atualização de conteúdo adicional pode ser executada até que sejam concluídas.",
    est: "tem estimativa",
    bookmarkTaskModalHeader: "Não é possível baixar tarefas selecionadas",
    bookmarkTaskModalMessage: "As tarefas selecionadas não podem ser baixadas para trabalhar offline.",
    noGuidanceAvailable: "Nenhuma orientação disponível",
    next: "Próximo",
    previous: "Anterior",
    guidanceLink: "Link",
    addToEvidenceLabel: "Adicionar à evidência",
    otherEngagements: "Outros engagements",
    navigationView: "Exibição de navegação",
    listView: "Exibição da lista",
    detailsView: "Visualização de detalhes",
    closeguidance: "Fechar orientação",
    reviewNotesModalClose: "Fechado",
    gamGuidanceLinkLabel: "Orientação GAM",
    inProgess: "Em andamento",
    upcomingReview: "Para a próxima revisão",
    teamSummaryEmptyTaskDetailsMesage1: "Use o Resumo da Equipe para exibir atribuições de preparador e revisor para cada membro da equipe por status. Para gerenciar todas as atribuições para o seu engagement, selecione",
    teamSummaryEmptyTaskDetailsMesage2: "Gerencie tarefas.",
    teamSummaryEmptyTaskDetailsMesage3: "Para ativar controles em massa, use a caixa de seleção para selecionar uma ou mais tarefas. Use a tecla shift para selecionar várias tarefas ao mesmo tempo. Se você quiser trabalhar em uma tarefa individual, selecione essa tarefa na lista.",
    taskSummaryPoint1: "Selecione 'Para preparar' para visualizar uma lista de tarefas do preparador para cada membro da equipe.",
    taskSummaryPoint2: "Selecione 'Para revisar' para visualizar uma lista de atribuições de revisores para cada membro da equipe.",
    taskSummaryPoint3: "As atribuições são classificadas pelo status de atribuição (não iniciado, em processo e feito).",
    noLinksfound: "Não há links disponíveis para esta tarefa.",
    noFormsfound: "Não há formulários disponíveis para esta tarefa.",
    workofflinemsg: "Isso baixará as versões mais recentes de suas tarefas selecionadas e permitirá que você continue editando offline. Você pode sincronizar suas alterações mais tarde, reconectando-se.",
    workonlinemsg: "Retornar ao modo online sincronizará automaticamente suas alterações. Certifique-se de que uma conexão com a internet esteja disponível antes de se reconectar.",
    workoffline: "Trabalhar offline",
    workonline: "Trabalhar online",
    duplicateFileNames: "Nomes de arquivo duplicados",
    training: "Treinamento",
    duplicateFileNameValidationMessage: "O arquivo que você está tentando adicionar a este engagement tem o mesmo nome que um arquivo existente neste engagement. Renomeie um dos arquivos para continuar.",
	documentHelperConnectionIssue: 'Foi detectado um problema com o EY Canvas Document Helper. Clique <a style="color: #467cbe" href="https://eyt.service-now.com/kb_view.do?sysparm_article=KB0486774" target="_blank">aqui</a> para obter instruções sobre como resolver este problema.',
    incompleteCra: "CRA incompleto",
    noteItemCreated: "Criado:",
    NetworkErrorMessage: "A rede do aplicativo está apresentando um erro. Atualize a página e tente novamente mais tarde. Entre em contato com o suporte técnico se o erro persistir.",
    saveClose: "Salvar e fechar",
    contentupdatePSPs: "Atualização de conteúdo - PSPs",
    /* PAANS */
    paansIsNotReachable: "O Serviço de Autoria, Aprovações e Notificação de Políticas da EY não está disponível no momento. Não podemos confirmar se todas as políticas relevantes foram concluídas. Se você não revisou as políticas relevantes, atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",

    /* Add New Task */
    standardtask: "Tarefa padrão – OST",
    substantivetask: "Tarefa substantiva – OSP",
    walkthroughtask: "Tarefa de Walkthrought - WT",
    controltask: "Tarefa de Controle – TOC",
    addnewTask: "Adicionar nova tarefa",
    taskType: "Tipo de tarefa",
    taskTypeError: "Por favor, selecione o tipo de tarefa",
    selectTaskTypeHeader: "Selecione um tipo de tarefa para continuar.",
    selectTaskType: "Selecionar tipo de tarefa",
    enterTaskDetails: "Digite os detalhes da tarefa",
    assignTask: "Atribuir tarefa",
    taskGroup: "Grupo de tarefas",
    finishLabel: "Salvar & fechar",
    addTaskContinueLabel: "Salvar e atribuir",
    AssignTaskStepSaveandContinueLabel: "Salvar e adicionar outro",
    addTaskDetailsHeader: "Digite os detalhes da tarefa para continuar.",
    addTaskAssignmentHeader: "Opcional: Crie uma atribuição para esta tarefa.",
    addTaskDetailsSubHeader: "Clique em <b>Salvar e atribuir</b> se desejar atribuir esta tarefa agora ou clique em <b>Salvar e fechar</b> se desejar atribuir esta tarefa mais tarde.",
    addTaskAssignmentSubHeader: "Digite os detalhes da atribuição abaixo e selecione",
    addTaskAssignmentSubHeader1: "Digite os detalhes da atribuição abaixo e selecione <b>Salvar & fechar</b> para terminar. Para criar outra atribuição, selecione <b>Salvar & adicionar.</b>",
    addTaskGroup: "Adicione um novo grupo de trabalho aqui. Uma vez adicionado, pode selecionar este grupo de tarefas ao criar novas tarefas, bem como mover as tarefas OST existentes para este grupo de tarefas.",
    relateObjectHeaderAccount: "Selecione uma ou mais assertivas para uma conta ou divulgação significativa ou selecione uma conta de risco limitado.",
    relateObjectSubHeaderAccount: "As tarefas só podem estar relacionadas a uma conta ou divulgação.",
    relateObjectHeader: "Relacionar um ou mais objetos para prosseguir.",
    limitedRiskAccount: "Conta de risco limitada",
    onlyShowAddedObject: "Apenas mostrar objetos adicionados",
    relateObjectRequiredError: "Um ou mais objetos devem ser selecionados para proceder.",
    invalidSelectionWarning: "As tarefas só podem estar relacionadas a uma conta ou divulgação. Remova as assertivas selecionadas ou a conta de risco limitado para relacionar a tarefa às assertivas de uma conta ou divulgação diferente ou de uma conta de risco limitado diferente.",
    invalidSelctionCRA: "Selecione um único tipo de objeto",
    relateObjectOptionsHeaderAccountTask: "Afirmações e contas de risco limitadas",
    relateObjectOptionsHeaderITWalkthroughTask: "Processos de TI/SO",
    relateObjectOptionsHeaderITControlTask: "Controles gerais de TI",
    relateObjectOptionsHeaderITSubstantiveTask: "Procedimentos substantivos de TI",
    relateObjectOptionsHeaderSCOTControlTask: "Controles",
    relateObjectOptionsHeaderSCOTWalkthroughTask: "SCOTs",
    StrategyTypeControls: "Controles",
    StrategyTypeSubstantive: "Substantivo",

    //Manage quick filters labels
    manageQuickFilterHeader: "Selecione um filtro salvo ou sugerido como padrão.",
    manageQuickFilterText: "Se você selecionar um padrão, esse filtro será aplicado quando você navegar para a lista de tarefas.",
    noDefaultFilter: "Sem filtro padrão",
    suggestedFiltersHeading: "Filtros sugeridos",
    savedFiltersHeading: "Filtros salvos",
    manageQuickFilters: "Gerenciar filtros rápidos",
    manageLabel: "Gerenciar",


    /* RNH Labels */
    emptyNoteDetailsMessage: "Selecione uma nota para ver os detalhes. Para habilitar controles em massa, use a tecla control ou shift e selecione várias notas de revisão. Se você quiser trabalhar em uma nota individual, selecione essa nota na lista.",
    emptyRepliesMessage: "Ainda não há respostas",
    emptyRepliesMessageAlt: "Sem Respostas",
    reviewNotes: "notas de revisão",
    reviewNotesStatus: "Revisar status da nota",
    reviewNotesStatusAssignedToMe: "Status das notas de revisão atribuídas a mim",
    reviewNotesStatusAuthoredByMe: "Status das notas de revisão de minha autoria",
    comments: "Revisar notas",
    showHideNotes: "Mostrar / ocultar notas",
    fileType: "Tipo de arquivo",
    noteType: "Tipo",
    statusId: "Status",
    rnhPriority: "Prioridade",
    rnhDueDate: "Prazo:",
    rnhModifiedDate: "Modificado",
    textAreaPlaceholder: "Digite a nota",
    requiredFieldErrorMessage: "Este é um campo obrigatório.",
    meLabel: "Eu",
    editIconHoverText: "Editar",
    deleteIconHoverText: "Excluir",
    deleteIconModalTitle: "Excluir nota",
    deleteIconCommentModalTitle: "Excluir nota",
    deleteReplyIconModalTitle: "Excluir resposta",
    deleteIconModalConfirmMessage: "Tem certeza de que deseja excluir sua resposta a esta nota?",
    deleteIconModalConfirmMessageParent: "Tem certeza de que deseja excluir a nota selecionada?",
    deleteIconModalCommentConfirmMessage: "Tem certeza que deseja excluir essa resposta?",
    deleteIconModalCommentConfirmMessageParent: "Tem certeza de que deseja excluir esta nota? Todas as respostas a esta nota também serão excluídas.",
    deleteIconModalAcceptText: "Excluir",
    replyInputPlaceholder: "Responder a esta nota",
    changeStatus: "Alterar o status",
    emptyReplyErrorMsg: "Adicionar texto ou nota de voz para continuar",
    lengthReplyErrorMsg: "A resposta não pode exceder 4.000 caracteres.",
    closeTitle: "Perto",
    closedBy: "Fechado por",
    ClearedBy: "Apagado por",
    ReopenedBy: "Reaberto por",
    commentTitle: "Observação",
    noteDueDateLabel: "Vencer",
    reopen: "Reabrir",
    noNotesAssociatedWithDocumentLabel: "Deixe uma nota usando as entradas abaixo. Atribua a nota a um usuário e especifique a prioridade e a data de vencimento.",
    noNotesFound: "Nenhuma nota encontrada",

    /* Add new review note RNH */
    addNewNoteButtonTitle: "Nova nota",
    addNewNoteModalTitle: "Adicionar uma nova nota",
    addNewNoteModalClose: "Fechar",
    backButtonLabel: "Voltar",
    cancelButtonLabel: "Cancelar",
    addNewNoteStep1Title: "Selecione o tipo de nota",
    addNewNoteStep2Title: "Selecionar documento ou tarefa",
    addNewNoteStep3Title: "Insira os detalhes da nota",
    editNoteModalTitle: "Editar nota",
    editReplyModelTitle: "Editar resposta",
    voiceNoteButtonLabel: "Nota de voz",
    stopRecordingButtonLabel: "Parar",
    enterText: "Digite o texto",

    /* RNH Review note hub Step 1 */
    step1Title: "Selecione um tipo de nota para continuar.",
    step1Subtitle: "Você só pode adicionar documento e nota de tarefa aqui. Os comentários do formulário Canvas devem ser adicionados no respectivo formulário Canvas.",
    step1NoTypeSelectedError: "Selecione um tipo de nota para prosseguir.",

    /* RNH Review note hub Step 2 */
    step2DocumentTitle: "Selecione o documento ao qual você gostaria de adicionar uma nota.",
    step2TaskTitle: "Selecione a tarefa à qual você gostaria de adicionar uma nota.",
    step2SearchTitle: "Pesquisar",
    step2SearchClearTitleTip: "Limpar",
    step2ErrorMessageTop: "Selecione um item para continuar.",
    step2ErrorMessageBottom: "Preencha os campos obrigatórios identificados acima para prosseguir.",
    step2EmptySearch: "Nenhum resultado encontrado",

    /* RNH Review note hub Step 3 */
    step3InstructionalText: "Insira os detalhes da nota para o documento ou tarefa selecionada.",
    step3InstructionalSubTitle: "Clique em <b>Salvar e fechar</b> quando terminar ou clique em <b>Salvar e adicionar outra</b> se desejar adicionar outra nota ao documento ou tarefa selecionada.",
    step3SelectedDocument: "Documento selecionado:",
    step3SelectedTask: "Tarefa selecionada:",
    step3SaveAndContinue: "Salvar e adicionar outro",
    step3SaveAndClose: "Salvar e fechar",

    /* RNH List Layout Labels*/
    searchReviewNotes: "Pesquisar notas",
    searchReviewNotesResultsNotFound: "Nenhum resultado encontrado nesta categoria de nota",
    searchReviewNotesNotAvailable: "Não há notas disponíveis",
    notesRepliesNotFound: "Nenhuma resposta encontrada para as notas selecionadas.",

    selectValueToContinue: "Selecione um valor para continuar",
    required: "Requerido",
    invalidEngagementId: "O ID do engagement é inválido. Atualize a página e tente novamente. Entre em contato com o suporte técnico se o erro persistir.",
    accessDenied: "Acesso negado",
    annotationDeletedError: "A nota selecionada foi excluída. Atualize a página e tente novamente.",

    /* RNH Filters */
    rnhClearAll: "Limpar tudo",
    rnhShowMore: "Mais",
    rnhFilter: "Filtro",
    hideFiltersLabel: "Ocultar",
    noDocumentChangeTypes: "Não foram encontrados resultados",
    selectatasktype: "Selecione um tipo de tarefa",
    importfromknowledge: "Importar Informação de conteúdo",
    assigntaskoptional: "Atribuir tarefa (opcional)",
    relateanobject: "Relacionar um objeto",
    account: "Conta",
    userOrRole: "Usuário ou cargo",
    userSummary: "Resumo do usuário",
    other: "outros",
    userNotFound: "Usuário não encontrado",
    dueOnOrBefore: "Devido em ou antes",
    dueOnOrAfter: "Devido em ou depois",

    /*Dashboard - Milestone tile*/
    milestonesLabel: "Milestones",
    scopeAndStrategy: "Escopo e estratégia",
    scopeAndStrategyTabLabel: "Escopo & estratégia",
    executionTabLabel: "Execução",
    conclusionTabLabel: "Conclusão",
    viewAllTabLabel: "Visualize tudo",
    noTaskAssociatedToMilestoneMsg: "Não há tarefas associadas aos Milestones nesta fase de auditoria.",
    overdueLabel: "Atrasado",
    upcomingLabel: "Data de vencimento próxima",
    quickLinkText: "Links Rápidos",
    inreviewLabel: "Em revisão",
    CompleteLabel: "Completa",
    completeLabel: "Completa",
    startLabel: "Começar",
    endLabel: "Final",
    auditPhaseSummary: "Resumo da fase de auditoria",
    milestoneView: "Vista Milestone",
    timePhaseView: "Vista de fase de tempo",
    localLandingPageHeader: "Esta página exibe apenas os EY Canvas Engagements que estão disponíveis neste centro de dados.",
    localLandingPage: "PÁGINA DE DESTINO LOCAL",
    noEngagementsAvailable: "Não há engagements disponíveis neste centro de dados",
    engagements: "Engagements",
    /* Document List */
    docListRelatedTasks: "Tarefas relacionadas",
    temporaryFilesTab: "Arquivos temporários",
    priorPeriodEvidenceTab: "Evidências de períodos anteriores",
    conflictsTab: "Conflitos",
    recentlyDeletedTab: "Excluído recentemente",
    docListSelectedDocument: "{0} documento selecionado",
    docListSelectedDocuments: "{0} documentos selecionados",
    shared: "Compartilhado",
    shareStatusOwned: "Propriedade deste engagement.",
    shareStatusShared: "Compartilhado neste engagement.",
    unlinkInprogress: "Desvincular em progresso",
    unlinkError: "Erro de desvinculação",
    documentList: "Documentos",
    restoreModalTitle: "Restaurar para arquivos temporários",
    restoreModalText: "Restaurar para devolver este documento a arquivos temporários.",
    permanentlyDeleteModalTitle: "Excluir permanentemente",
    permanentlyDeleteModalText: "A exclusão permanente do documento o removerá do EY Canvas e não pode ser desfeito. Clique em Excluir permanentemente para continuar.",
    misstatementsInstructionalText: "O documento está relacionado com as seguintes declarações erradas neste compromisso. Clique em um Erro de declaração para navegar até ele.",
    deficienciesInstructionalText: "O documento está relacionado com as seguintes Deficiências neste engagement. Clique em uma Deficiência para navegar até ela.",
    referenceId: "ID",
    findingDescription: "Descrição",
    deficienciesModalTitle: "Deficiências relacionadas",
    misstatementsModalTitle: "Distorções relacionadas",
    startsWith: "Começa com",
    contains: "Contém",
    documentsWherePICEQRSignOffIsRequired: "Documentos onde a assinatura de PIC/EQR é requerida",
    otherDocuments: "Outros documentos",
    documentsWherePICSignOffIsRequired: "Documentos em que a assinatura de PIC é necessária",
    documentSignoffRequiredLabel: "Assinaturas necessárias de:",
    timePhaseFilterLabel: "Fase de tempo",
    drillDownTimePhaseFilterLabel: "Visualizar por fase temporal",
    auditPhasesLabel: "Fase de auditoria",
    openedLabel: "Aberto",

    clientApprovals: "Aprovações externas",
    noTeamsAvailable: "Nenhuma equipe foi criada ainda. Crie uma equipe e envie uma solicitação de link para começar.",
    noDocumentRecieved: "Nenhum documento recebido ainda.",
    team: "Equipe",
    pendingEvidence: "Evidências pendentes",
    noTimePhasePlaceHolder: "Sem fases de tempo",

    regionComponentEvidence: "Evidência de região e componente",
    preparersignoffs: "Aprovações do preparador",
    reviewersignoffs: "Aprovações do revisor",
    receivedon: "Recebido em:",
    nosignoffsyet: "Ainda não há assinaturas.",
    noRegionComponentEvidence: "Nenhum documento foi recebido ainda. Para ver uma lista de regiões e componentes que ainda não enviaram documentos, selecione <b>Documentação pendente</b>.",
    noComponentEvidence: "Nenhum documento foi recebido ainda.",
    assignToRegionOrComponent: "Atribuir a região ou componente",
    assignRegionComponentModalText: "Selecionar a região ou componente a que deseja atribuir este documento.",
    documentAssignedToPGT: "Este documento já foi atribuído a outra região ou componente. Portanto, não está disponível para atribuição.",
    assignedToRegionComponent: "Região ou componente atribuído:",
    noRegionComponentsAvailable: "Não há regiões ou componentes disponíveis",
    documentUnassignedFromComponent: "{0} não assinado por {1}.",
    documentUnassigned: "{0} não foi assinada.",
    documentReturnedToComponent: "{0} devolvido para {1}.",
    documentReturned: "{0} foi devolvida.",
    regionComponentName: "Nome da região ou componente",
    relatedReviewNoteCount: "1 nota aberta de outros engagements",
    relatedReviewNotesCount: "{0} notas abertas de outros engagements",

    deleteVersion: "Excluir versão",
    deleteVersionMessage: "Selecione uma versão para prosseguir.",
    deleteVersionDisabledMessage: "As versões de histórico só podem ser excluídas do engagement de origem do documento pelos administradores do engagement.",
    deleteVersionTitle: "Excluir versão do documento",
    deleteVersionPlaceholder: "Tem certeza que deseja excluir essa versão do histórico? Esta ação não poderá ser desfeita",

    childDocumentsCountLabel: "Cópias existentes",
    childDocumentsModalTitle: "Cópias existentes",
    childDocumentsModalDescription: "Os documentos abaixo foram criados a partir do documento original.",
    childDocumentsModalColumnDocumentName: "Nome do Documento",
    childDocumentsModalColumnDocumentType: "Tipo de documento",
    childDocumentsModalColumnRelatedTasks: "Tarefas relacionadas",
    childDocumentsModalColumnSignoffs: "Aprovações",

    bulkAddToEvidenceDescription1: "Crie uma nova cópia dos documentos apresentados como evidência ou selecione uma cópia existente, se disponível.",
	bulkAddToEvidenceDescription2: 'Por padrão, os documentos recém-criados serão adicionados a todas as tarefas e Canvas Forms aos quais o documento antigo estava relacionado. Use "Opções avançadas" para selecionar manualmente as tarefas e os Canvas Forms aos quais associar o novo documento. Use o recurso localizar e substituir para substituir certas partes do nome do novo documento (por exemplo, o ano); esse recurso pode ser usado várias vezes.',
    bulkAddToEvidenceDescription3: "Quando um documento existente é selecionado, ele só será adicionado à tarefa atual. Se apenas um documento existente estiver disponível, ele foi pré-selecionado; caso contrário, escolha uma cópia existente para adicionar.",
    bulkAddToEvidenceAdvancedOn: "Opções avançadas",
    bulkAddToEvidenceAdvancedOff: "Desligado",
    bulkAddToEvidenceFindText: "Localizar texto",
    bulkAddToEvidenceFindTextRequired: "Insira um texto de busca válido.",
    bulkAddToEvidenceReplaceWith: "Substituir com",
    bulkAddToEvidenceReplaceSuccess: "Substituído {0} por {1}.",
    bulkAddToEvidenceUseExisting: "Usar existente",
    bulkAddToEvidenceCreateNew: "Crie um novo",
    bulkAddToEvidenceDocumentName: "Nome do Documento",
    bulkAddToEvidenceExistingDocument: "Documento existente",
    bulkAddToEvidenceSelectANewOrExistingCopy: "Selecione uma cópia nova ou existente",
    bulkAddToEvidenceAssociateToTasks: "Associar a tarefas",
    bulkAddToEvidenceAssociateToCanvasForms: "Associar aos Formulários Canvas",
    bulkAddToEvidenceOtherRelatedTasks: "Outras tarefas relacionadas",
    bulkAddToEvidenceAssociateToTasksPlaceholder: "Apenas documentos recém-criados podem ser associados a tarefas. Os documentos existentes serão automaticamente associados à tarefa atual.",
    bulkAddToEvidenceSelectedTask: "{0} tarefa relacionada",
    bulkAddToEvidenceSelectedTasks: "{0} tarefas relacionadas",
    bulkAddToEvidenceSelectedTasksPlaceholder: "Nenhuma tarefa relacionada disponível",
    bulkAddToEvidenceAssociateToCanvasFormsPlaceholder: "Apenas documentos recém-criados podem ser associados aos Formulários do Canvas",
    bulkAddToEvidenceRelatedCanvasForms: "Formulários do canvas relacionados",
    bulkAddToEvidenceSelectedForm: "{0} formulário do canvas relacionado",
    bulkAddToEvidenceSelectedForms: "{0} formulários do canvas relacionados",
    bulkAddToEvidenceSelectedFormsPlaceholder: "Sem formulários do canvas relacionados",
    picRequiredValidation: "O documento necessário para assinatura de PIC não está relacionado a uma tarefa de PIC",
    eqrRequiredValidation: "O documento necessário para assinatura de EQR não está relacionado a uma tarefa de EQR",
    picEqrRequiredValidation: "O documento necessário para assinatura de PIC/EQR não está relacionado a uma tarefa de PIC/EQR",

    viewSwitcherDefault: "Visualização padrão",
    viewSwitcherEntity: "Visualização da entidade",
    viewSwitcherAllEntities: "Todas as Entidades",
    viewByEntities: "Visualizar por entidades",

    /* bulk delete modal */
    bulkDeleteFilesModalMessage: "Tem certeza de que deseja excluir os documentos selecionados?",
    bulkDeleteFIlesModalMessageSub: "Os documentos que não podem ser excluídos são indicados abaixo e não serão excluídos.",
    bulkDeleteModalLabel: "Excluir documentos",
    bulkDeleteSuccessMessage: "documentos excluídos com sucesso",
    bulkDeleteValidDocumentsHeader: "Os seguintes documentos serão excluídos",
    bulkDeleteInvalidDocumentsHeader: "Os documentos listados abaixo não podem ser excluídos",

    /* Bulk sign-off requirements modal */
    bulkSignOffRequirementsModalMessage: "Ajuste os documentos selecionados\' requisitos de assinatura executiva abaixo. Alguns requisitos de aprovação não podem ser ajustados porque são exigidos pelo EY Canvas.",
    bulkSignOffRequirementsResultMessage: "{0} requisitos de aprovação de documentos atualizados com sucesso",


    bulkOpenCountWarning: "O número de documentos selecionados excede o máximo permitido. Apenas o primeiro {0} será aberto",

    /* Pending evidence modal */
    pendingEvidenceInstructionalText: "As equipes listadas abaixo ainda não enviaram nenhum documento de grupo.",
    pendingEvidenceDueDate: "Data de vencimento",
    searchRegionComponentLabel: "Pesquise regiões e componentes",

    /* Review Notes Count */
    noReviewNotesAssignedOrAuthored: "Não há notas para o membro da equipe selecionado.",
    noUserSelected: "Selecione um usuário para ver detalhes. Você não pode atribuir notas a funções no EY Canvas.",
    reviewNotesText: "notas de revisão",
    assigned: "Atribuído",
    authored: "Autor",
    overdue: "atrasado",
    comingDue: "A vencer",
    cleared: "Endereçado",
    open: "Aberto",
    closed: "Fechado",
    noTaskAssignedToUser: "Não há tarefas atribuídas ao membro ou função da equipe selecionada.",
    preparer: "Preparador",
    reviewer: "Revisor",
    assignments: "Atribuições",
    notStarted: "Não iniciado",
    inProgress: "Em andamento",
    done: "Feito",
    forUpcomingReview: "Próximo",
    noTaskOrNotesAssigned: "Não há tarefas ou notas de revisão para o membro ou função da equipe selecionada.",
    fromTo: "De / para",

    /* Collaboration grid */
    overdueCollaboration: "Atrasado",
    comingDueCollaboration: "Vencendo",

    /*Document Conflict*/
    documentConflict: "Conflito de documentos",
    documentConflictModalConfirm: "Mantenha esta versão",
    documentConflictModalClose: "Cancelar",
    documentConflictInstruction: "Para resolver o conflito, selecione a versão do documento que deve ser retido.",
    documentConflictMessage: "Clique no nome de um membro da equipe para abrir uma versão anterior deste documento no modo somente leitura. Quaisquer alterações feitas nesta versão anterior não serão salvas no EY Canvas.",
    lastmodifiedDate: "Última data modificada",
    modifiedBy: "Modificado por",
    documentConflictErrorMessage: "Selecione uma versão para prosseguir.",
    currentVersion: "Versão atual",
    documentConflictError: "Mensagem de erro de conflito de documentos",
    documentConflictHeader: "Este documento está em conflito.",
    viewHistory: "Ver história",
    confirmButtonToolTip: "Você deve ter permissão para resolver conflitos para os documentos do grupo. Entre em contato com um administrador do engagement e solicite permissão para realizar esta ação.",
    documentHistoryHeader: "O histórico de versão deste documento é exibido abaixo.",
    documentHistoryMessage: "Clique no nome de um membro da equipe para abrir uma versão anterior deste documento no modo somente leitura. Quaisquer alterações feitas nesta versão anterior não serão salvas no EY Canvas.",

	documentHistoryInstruction: 'Se uma versão anterior deve ser a versão atual, selecione essa versão e clique em "Atualizar versão"',
	documentHistoryAdminInstruction: 'Se uma versão não for necessária, selecione a versão e clique em "Excluir versão".',

    documentHistoryModalConfirm: "Versão atualizada",
    documentHistoryModalClose: "Fechar",
    documentHistoryErrorMessage: "O documento tem um conflito, por favor, resolva-o antes de proceder",

    /* Dashboard  - Collaboration Tile*/
    clientCollboration: "Client Collaboration",
    nextwaveServices: "Serviços centralizados",
    receivedStatusLabel: "Recebido",
    acceptedStatusLabel: "Aceito",
    outstandingStatusLabel: "Em aberto",
    collaborationNonUsageMessage1: "Utilize o menu Collaboration para enviar solicitações e tarefas externas aos membros externos da equipe diretamente no EY Canvas. Para ativar o Collaboration, primeiro inscreva seu cliente no EY Canvas Client Portal. Em seguida, configure grupos de acesso. Em seguida, crie solicitações e / ou atribua tarefas externas. Clique em",
    collaborationNonUsageMessage2: "para habilitar como começar.",
    collaborationNonUsageMessageHyperlinkText: "aqui",
    collaborationNonSentMessage1: "Navegar para",
    collaborationNonSentMessage2: "e envie rascunhos para começar.",
    collaborationNonSentMessageHyperlinkText: "Colaboração",
    noBodies: "Sem textos",
    editResponse: "Editar resposta",
    unsentDrafts: "rascunhos não enviados",
    unsentDraft: "rascunho não enviado",
    noUnsentDrafts: "Nenhum rascunho não enviado",
    requestsSent: "Pedidos enviados",
    nextWavetotalTasks: "TOTAL DE TAREFAS",
    comingDueTimeframe: "Prazo",
    otherTimeframeDataAvailableMessage: "Selecione outro prazo para exibir dados",

    /* Dashboard Engagement Metrics */
    engagementMetricsTileHeader: "Métricas do engagement",
    overdueColumnHeader: "Atrasado",
    comingDueColumnHeader: "Vencendo",
    whatsNewColumnHeader: "O que há de novo",
    placeholderMessageNoContentInSpecifiedTimeframe: "Selecione outro período de tempo para visualizar os dados",
    placeholderMessageNoEngagementMetrics: "Não há métricas disponíveis para o seu engagement.",
    performanceMetrics: "Métricas de desempenho",
    reviewNotesAndAssignments: "Revisar notas e atribuições",
    /*Dashboard Engagement overview*/
    engagementOverview: "Visão geral do engagement",
    engagementOverviewInstructionalText: "Revise o progresso de seus engagements por fase de auditoria abaixo.",

    /*Dashboard Milestone tile*/
    milestoneprogressTileHeader: "Milestones",
    milestoneprogressSubHeader: "Selecione uma fase de auditoria abaixo para visualizar a conclusão da tarefa por milestones. Para visualizar a conclusão da tarefa por fase de tempo, selecione <b>Visualizar por fase de tempo</b>. Para ver o progresso detalhado de cada milestone ou fase, selecione <b>Mostrar detalhes.</b>",
    tasksStatus: "Status das tarefas",
    preparerAssignments: "Tarefas do preparador",
    reviewerAssignments: "Atribuições de revisor",
    openComments: "Abrir notas",
    /* Dashboard Profile Page */
    groupAudit: "Auditoria em grupo",
    groupStatus: "Status do grupo",
    viewInstructions: "Ver instruções",
    instructionsInstructionalText: "As instruções recebidas da equipe principal são exibidas abaixo. Selecione um link para ver as instruções.",
    noInstructionsAccepted: "Nenhuma instrução foi aceita ainda.",

    /* Dashboard SDM Summary */
    nextWaveservices: "Serviços centralizados",
    totalTasksLabel: "Total de tarefas",
    tasksUsingNextWaveservices: "tarefas usando serviços centralizados",
    tasksSuggestedForNextwaveUse: "tarefas sugeridas para serviços centralizados",
    outOf: "fora de",
    tasksUsing: "tarefas usando",
    suggestedFor: "sugerido para",
    nextwaveUse: "Serviços centralizados",
    draftRequests: "solicitações de rascunho",
    draftRequest: "pedido de rascunho",
    createRequests: "Criar solicitações",
    noRequestCreated: "Ainda não há solicitações criadas. Crie e envie uma solicitação para começar.",

    /* RNH Bulk Controls */
    rnhBulkAssignPriorityTitle: "Alterar prioridade",
    rnhBulkAssignPriorityTooltip: "Prioridade",
    rnhBulkDueDateTooltip: "Data de vencimento",
    rnhBulkAssignPriorityModalHeader: "Não foi possível editar as notas selecionadas",
    rnhBulkAssignPriorityModalContent: "Você só pode alterar a prioridade das notas com o status Aberto. Reabra as notas com o status Limpa ou Fechada para alterar a prioridade.",
    rnhBulkAssignDueDateModalContent: "Você só pode alterar a data de vencimento das notas com o status Aberto. Reabra as notas com o status Limpa ou Fechada para alterar a data de vencimento.",
    rnhBulkAssignUserTooltip: "Reatribuir",
    rnhBulkAssignUserSearch: "Pesquisar",
    rnhBulkAssignUserTitle: "Não foi possível editar as notas de revisão selecionadas",
    rnhBulkAssignUserText: "Você só pode reatribuir notas de revisão com o status Aberto. Reabra as notas de revisão com o status Limpo ou Fechado para reatribuir.",
    rnhBulkAssignStatusTooltip: "Status",
    rnhBulkAssignUserNoFound: "Não foram encontrados resultados",
    rnhBulkDueDatePlaceholder: "Escolha uma data",
    rnhBulkDeleteTextCorrect: "Tem certeza de que deseja excluir as notas selecionadas? Depois que uma nota de revisão for excluída, você não poderá mais acessá-la.",
    rnhBulkDeleteTextIncorrect: "Você só pode excluir notas com o status Fechado. Feche as notas com status Aberto ou Limpo para excluir.",
    rhnBulkDeleteTitleCorrect: "Excluir notas selecionadas",
    rhnBulkDeleteTitleIncorrect: "Não foi possível excluir as notas selecionadas",
    rnhBulkDeleteTextIncorrectComment: "Você só pode excluir notas de revisão com o status Fechado. Feche as notas de revisão com status Aberto ou Limpo para excluir.",
    rhnBulkDeleteDescriptionAuthorComment: "Você só pode excluir notas de sua autoria.",
    rnhBulkDeleteEngagementComment: "Tem certeza de que deseja excluir as notas de revisão selecionadas? Depois que uma nota de revisão for excluída, você não poderá mais acessá-la.",
    rhnBulkDeleteTitleCorrectEngagementComment: "Excluir notas selecionadas",
    rhnBulkDeleteTitleCommentCloseStatus: "Não foi possível excluir as notas selecionadas",


    fourFortyFilters: "filtros",
    fourFortySearch: "Pesquisar",

    /* Add External Member Start*/
    addExternalModalTitle: "Adicionar membro externo",
    accessGroupSelection: "Seleção de grupos de acesso",
    noRecordinGroups: "Não foram encontrados resultados",
    permission: "Permissões",
    permissionProjectManagement: "Gestão de Projetos",
    permissionProjectManagementDesc: "Capacidade de visualizar o status das solicitações do cliente e tarefas externas no EY Canvas Client Portal. Este membro externo não poderá acessar detalhes de solicitações de clientes e tarefas externas.",
    permissionInfoTooltip: "lista de todas as permissões",
    groupInfoTooltip: "Lista de grupos",
    groupRequired: "Por favor, selecione grupo(s)",
    firstnameRequired: "Primeiro nome requerido",
    lastnameRequired: "Sobrenome requerido",
    initialsRequired: "Iniciais requeridas",
    roleRequired: "Função no engagement requerido",
    confidentialityRequired: "Nível de confidencialidade requerido",
    groupLabel: "Grupos de acesso",
    firstnameLabel: "Primeiro nome",
    lastnameLabel: "Sobrenome",
    initialsLabel: "Iniciais",
    userinfo: "Informações do usuário",
    userinfoDescription: "Insira o primeiro nome, sobrenome ou endereço de e-mail do membro da equipe que deseja convidar e pressione entrar.",
    inviteAndClose: "Convidar e fechar",
    inviteAndAddOther: "Convidar e adicionar outro",
    addAndClose: "Convide e finalize",
    addAndAddOther: "Convide e selecione outro",
    externalUserCreatedSuccessMessage: "Você adicionou com sucesso",
    accessGroupSelectionMessage: "Os grupos de acesso permitem que as equipes gerenciem quem na equipe externa pode ver as solicitações enviadas ao EY Canvas Client Portal. Combine com seu cliente a lista de Grupos de Acesso e usuários que terão acesso EY Canvas Client Portal. Quando uma solicitação é atribuída a um usuário externo que faz parte do grupo, ela ficará visível para TODOS os membros desse grupo.",
    accessGroupSectionMessage1: "Os membros externos da equipe devem ser registrados usando o My EY Admin Portal antes de serem adicionados ao EY Canvas. Clique",
    accessGroupSectionMessage2: "para acessar o My EY Admin Portal e começar.",
    accessGroupMessageHyperlinkText: "aqui",
    accessGroupUserMessage1: "Para obter mais informações sobre a integração de usuários, clique em",
    accessGroupUserMessage2: "para acessar o EY Atlas.",
    noRecordForExternalMember1: "O endereço de e-mail não foi encontrado.",
    noRecordForExternalMember2: "Certifique-se de que o membro da equipe externa esteja registrado no My EY.",

    /* Add External Member End*/

    /* Edit External Member Start*/

    editExternalModalTitle: "Editar membro externo",
    editExternalaccessGroupSelection: "Seleção de grupos de acesso",
    editExternalGroupInfoTooltip: "Lista de grupos",
    editExternalGroupLabel: "Grupos de acesso",
    editExternalGroupRequired: "Selecione o grupo(s)",
    editExternalNoRecordinGroups: "Nenhum resultado encontrado",
    editExternalUserinfo: "Infomation do usuário",
    editExternalUserinfoDescription: "Edite o primeiro nome, sobrenome ou iniciais.",
    editExternalEmailLabel: "Email",
    editExternalFirstnameLabel: "Primeiro nome",
    editExternalLastnameLabel: "Sobrenome",
    editExternalInitialsLabel: "Iniciais",
    editExternalSaveLabel: "Salvar",
    editExternalUsersSuccessMessage: "As alterações em {0} {1} foram salvas com sucesso.",
    editExternalUsersCloseLabel: "Fechar",

    /* Edit External Member End*/



    /*access group*/
    groupName: "Nome do grupo",
    groupNameHelp: "Um nome é necessário para criar um grupo de acesso.",
    groupNameHelpOnEdit: "Nome é necessário",
    groupNameReq: "Nome do grupo é obrigatório",
    groupNameInvalidCharacter: "Caracteres inválidos",
    grpDomainManage: "Gerenciar domínios",
    grpDomainHelp: "Os domínios restringem os usuários que podem ser adicionados a este Grupo de Acesso. Pelo menos um domínio é necessário para criar um Grupo de Acesso. Domínio refere-se aos caracteres após símbolo do @. Use *  (por exemplo, *.ey.com).",
    btnAddNewDomain: "Adicionar novo domínio",
    btnAddExistingDomain: "Adicionar domínio existente",
    domainValidation01: "Pelo menos um domínio válido é necessário",
    domainValidation02: "Escolha um domínio",
    domainValidation03: "Entrada duplicada",
    domainValidation04: "Nome de domínio inválido",
    domainValidation05: "Nome de domínio é obrigatório",
    domainName: "Nome de domínio",
    emailDomain: "Domínio de e-mail",
    groupDeletionErrorPendingReqMsg: "Ocorreu um erro ao excluir o grupo de acesso. Certifique-se de que não há solicitações/tarefas externas atribuídas a este grupo ou aos membros deste grupo e tente novamente",
    groupDeletionSuccessMsg: "{0} foi deletado com sucesso. Todos os membros ativos foram desativados.",

    /* uncommon values for internal mem */
    editInternalMember: "Editar membro interno",
    editThirdPartyMember: "Editar terceiros",
    listOfAllPerm: "Lista de todas as permissões",
    internalPermiInviteExt: "Convidar membros internos",
    internalPermiInviteInt: "Convidar membros externos",
    internalPermiAssignPer: "Atribuir permissões",
    internalPermiDeleteEng: "Apagar o engagement",
    internalPermiArchEng: "Arquivar o engagement",
    internalPermiUpdateContet: "Atualizar o conteúdo",

    internalPermiInviteExtToolTp: "Capacidade de convidar membros da equipe interna para o engagement",
    internalPermiInviteIntToolTp: "Capacidade de convidar membros da equipa externa para o engagement",
    internalPermiAssignPerToolTp: "Capacidade de atribuir estas permissões a membros da equipe interna e externa do engagement",
    internalPermiDeleteEngToolTp: "Capacidade de apagar o engagement",
    internalPermiArchEngToolTp: "Capacidade de arquivar o engagement",
    internalPermiUpdateContetToolTp: "Capacidade de editar o perfil e aceitar uma atualização de conteúdo",
    internalMemberInviteSuccessMessage: "Você enviou com sucesso um convite para {0} {1}",
    internalMemberPostArchivalAdditionSuccessMessage: "Você adicionou com sucesso {0} {1}",
    invitePriorPeriodUsersSuccessMessage: "Você enviou com sucesso um convite para usuários inativos",
    editInternalUsersSuccessMessage: "Suas mudanças para {0} {1} foram salvas com sucesso",
    rbacErrorEditUser: "Não é possível salvar as alterações no momento. Tente novamente e se o problema persistir, entre em contato com o Help Desk.",
    universalQueueErrorEditUser: "A Página de Início do EY Canvas não está acessível no momento e é necessário para editar. Tente novamente e se o problema persistir, entre em contato com o Help Desk",
    removeExternalUsersSuccessMessage: "{0} {1} foi removido com sucesso.",
    reActivateExternalUsersSuccessMessage: "{0} {1} foi reativado nos seguintes grupos de acesso: {2}",

    /*user search component*/
    seachInputRequired: "Entrada no campo de pesquisa necessária",
    nameOrEmail: "Nome ou e-mail",
    emailForExternal: "E-mail",
    noRecord: "Não foram encontrados resultados",
    userSearchPlaceholder: "Insira o nome ou e-mail e introduza para ver os resultados.",
    userSearchPlaceholderForExternal: "Digite o e-mail e pressione enter para ver os resultados.",
    clearAllValues: "Limpar todos os valores",
    inValidEmail: "Por favor, insira um e-mail válido",

    maxLengthForEditResponse: "Os caracteres máximos, incluindo etiquetas de formatação de texto é de 30.000. Remover formatação desnecessária e tentar novamente.",
    clickEditResponseToContinue: "Clique na resposta de edição para continuar",
    bodyDescriptionFromKnowledge: "Descrição do texto a partir do conhecimento",
    execution: "Execução",
    cannotpasteimages: "Não é possível colar imagens",
    pastingImagesNotAllowed: "Não é permitido colar imagens. Se forem necessárias imagens, carregue-as como evidência e as referencie.",
    saveResponse: "Há mudanças não salvas, você deseja continuar",
    conclusion: "Conclusão",
    referenceDocsPlaceHolder: "Abra rapidamente arquivos acessados com frequência, adicionando-os aqui.",
    referenceDocsTeamPlaceHolder: "Nenhum documento de referência da equipe foi adicionado neste trabalho. Clique em 'Adicionar documento' para começar.",
    referenceDocsMyPlaceHolder: "Você não adicionou nenhum documento de referência. Clique em 'Adicionar documento' para começar.",
    teamDocuments: "Equipe fixada",
    myDocuments: "Meu fixado",
    teamDocumentsModalTitle: "Documentos da equipe",
    myDocumentsModalTitle: "Meus documentos",
    referenceDocuments: "Equipe fixada",

    /* PinnedDocument  */
    PinnedDocument: "Documentos fixados",
    PinnedDocumentSubTite: "Crie uma lista de documentos acessados com frequência fixando itens em sua própria lista ou na lista de equipes abaixo. Para modificar a lista, selecione <b>Adicionar documento</b>.",
    PinnedDocPaceholder: "Você não fixou nenhum documento. <br> Selecione <b>Adicionar documento</b> para fixar documentos aqui.",
    PinnedTeamDocPlaceholder: "Sua equipe não fixou nenhum documento. <br> Selecione <b>Adicionar documento</b> para fixar documentos aqui.",
    PinnedDocAddDocHeaderText: "Selecione evidências e arquivos temporários para personalizar a lista de documentos fixados.",
    onlyShowPinnedDocuments: "Mostrar apenas documentos fixados",
    pinned: "Fixado",
    /* Arc Timeline */
    arcTitle: "Lista de verificação de arquivo",
    arcCompleted: "concluído",
    arcSubmit: "Submeter arquivo",
    arcDescription: "Complete todos os itens na lista de verificação para arquivar este contrato",
    invalidEngagementCode: "Código de engagement inválido",
    invalidClientCode: "Código do cliente inválido",
    arcCheckBox: "Substituição de arquivo",
    arcUnlinkEvidenceButtonText: "Desvincular todos",
    arcUnlinkEvidenceModalTitle: "Desvincular todas as evidências compartilhadas",
    arcUnlinkEvidenceModalText: "Tem certeza de que deseja desvincular todas as evidências compartilhadas neste engagament de outros engagements? Uma vez concluída esta operação, ela não pode ser desfeita.",
    arcUnlinkEvidenceModalConfirmButton: "Desvincular todos",
    arcUnlinkEvidenceModalCancelButton: "Cancelar",
    arcUnlinkEvidenceButtonUnlinkInProgress: "Desvinculação em andamento",
    arcUnlinkEvidenceButtonUnlinkError: "Desvincular erro",
    arcUnlinkGroupEngagementButtonText: "Desvincular do grupo",
    arcUnlinkGroupEngagementModalTitle: "Desvincular este engagament do grupo",
    arcUnlinkGroupEngagementModalText: "Tem certeza que deseja desvincular esse engagement de outros engagements neste espaço de trabalho? Uma vez concluída esta operação, ela não pode ser desfeita.",
    arcUnlinkGroupEngagementModalConfirmButton: "Desvincular",
    arcUnlinkGroupEngagementModalCancelButton: "Cancelar",
    arcUnlinkGroupEngagementButtonUnlinkInProcess: "Desvinculação em andamento",
    arcModalTitle: "Registro ARC existente",
    arcProceedWithArchive: "Prossiga com o arquivo",
    arcModalBodyText: "Você está tentando arquivar um arquivo de um engagement restaurado. Este arquivo já existe no Archive Records Center (ARC). Tem certeza de que deseja continuar?",
    noDataAvailabel: "Nenhum dado disponível no momento. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    reportDateBeforeCurrentDate: "A data do relatório do engagement deve ser igual ou anterior à data atual. Atualize a data do relatório para continuar. Para atualizar a data do relatório, clique no link Confirmar a precisão das principais datas do engagement.",

    /*Helix Projects*/
    linkedProjects: "Projetos vinculados",
    suggestedAnalyzers: "Analisadores sugeridos",
    linkSelected: "Link selecionado",
    noLinkedProjectsAvailable: "Não há projetos vinculados",
    helixProjectTitle: "Projetos EY Helix",
    findProjects: "Encontre projetos",
    findProjectsModalTitle: "Encontre projetos do EY Helix",
    selectProjectsToLink: "Selecione um ou mais projetos do EY Helix abaixo para criar um link com seu engagement no Canvas. Você pode pesquisar manualmente por código do cliente para encontrar outros projetos do EY Helix.",
    newSearch: "Nova pesquisa",
    noResultsFound: "Nenhum resultado encontrado",
    enterClientCode: "Digite um código de cliente para pesquisar novamente.",
    enterClientCodeToDisplayAnalizers: "Insira um código de cliente para exibir uma lista de analyzers disponíveis.",
    defaultClientCodeIsInvalid: "O código do cliente padrão {0} para este engagement está inválido. Insira um código de cliente válido para exibir uma lista de analyzers disponíveis.",
    mirrorCodesNotAccepted: "Observe que os códigos do espelho não são aceitos.",
    helixProjectSearch: "Busca",
    helixProjectsSearchPlaceholderText: "Digite código do cliente para pesquisar",
    helixWizardProjectsSearchPlaceholderText: "Pesquisa de analyzer por código do cliente",
    selectOneOrMoreProjects: "Selecione um ou mais projetos Helix da lista para vincular",
    noPermissionLabel: "Você deve ter permissão de Archive para submeter esse engagement para arquivamento.",
    linkProject: "Vincular projeto",
    oneAnalyzerMustBeSelected: "Um analyzer deve ser selecionado.",
    selectAnAnalyzer: "Selecione um analyzer",
    selectOneAnalyzer: "Selecione um EY Helix analyzer abaixo para criar um link com seu engagement no EY Canvas. Você pode pesquisar manualmente por código do cliente para encontrar projetos do EY Helix e o(s) analyzer(s) relacionado(s).",
    selectAnalyzerModalTitle: "Selecione o Analyzer para",
    selectAnalyzerModalBodyText: "Selecione um EY Helix Analyzer para vincular ao seu engagement do EY Canvas",
    selectAnalyzerModalSubmitButtonLabel: "Vincular projeto",
    projectCanNotBeLikedTootip: "Este projeto do EY Helix não está disponível porque sua localização não corresponde à localização do Engagement no EY Canvas.",
    unlinkProjectConfirmationModalTitle: "Aviso – deslinkar projeto",
    unlinkProjectConfirmationModalBodyText: "O EY Helix analyzer que está sendo deslinkado possui marcadores de clientes associados a este engagement. Deslinkar este analyzer fará com que esses marcadores não estejam mais disponíveis. Essa ação não pode ser desfeita. Você quer continuar?",
    defineConnectionSettings: "Definir configurações de conexão",

    helixConnectionPageTitle: "Conexões do EY Helix",
    helixConnectionPageSubtitle: "EY Helix analyzers conectados, seus dados importados e a porcentagem de contas GL que foram mapeadas para contas EY. Clique na porcentagem mapeada para ajustar o mapeamento. A porcentagem mapeada pode ser diferente entre a conexão e os dados importados. Por exemplo, se o mapeamento ocorreu após a data importada. Importe novamente os dados para obter o mapeamento mais recente.",
    helixIntegrationPageNoConnectedAnalyzerLabel: "Nenhum analyzer conectado",
    helixIntegrationPageTitle: "Integração do EY Helix",
    helixIntegrationPageSubtitle: "Relacione um ou mais EY Helix analyzer ao seu engagement no EY Canvas.",
    helixIntegrationPageNoHelixProjectLinkedLabel1: "Nenhum analyzer relacionado. Para relacionar um novo analyzer,",
    helixIntegrationPageNoHelixProjectLinkedLabel2: " Clique aqui.",
    helixIntegrationPageColumnConnectionName: "Nome da conexão",
    helixIntegrationPageColumnConnectionType: "Tipo de conexão",
    helixIntegrationPageColumnAnalysisPeriod: "Data de análise",
    helixIntegrationPageColumnAnalyzerName: "Nome do EY Helix Analyzer",
    helixIntegrationPageColumnLastConnectedBy: "Conectado pela última vez por",
    connectAnalyzer: "Conectar analyzer",
    dataImportModalTitle: "Confirmação de importação",
    dataImportModalBodyLabel: "Já existe uma importação de 'Escopo & estratégia' neste engagement. Somente uma única importação de 'Escopo & estratégia' é permitida por engagement. A importação destes dados substituirá a importação existente de 'Escopo & estratégia'. Você quer continuar? Esta ação não pode ser desfeita.",
    dataImportModalBodyLabelMest: "Já existe uma importação de 'Escopo & estratégia' para esta entidade. Somente uma única importação de 'Escopo & estratégia' é permitida por entidade. A importação destes dados substituirá a importação existente de 'Escopo e estratégia'. Você quer continuar? Esta ação não pode ser desfeita.",
    dataImportModalCancelButtonLabel: "Cancelar",
    dataImportModalCloseButtonLabel: "Fechar",
    dataImportModalConfirmButtonLabel: "Importar",
    dataImportModalImportError: "Ocorreu um erro relacionado ao EY Helix Analyzer conectado. Os dados não podem ser importados. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",

    //Entites to Business Mapping Modal
    entityMappingModalTitle: 'Entity mapping',
    entityMappingModalCancelLabel: 'Cancel',
    entityMappingModalSaveLabel: 'Save',
    entityMappingModalDescription: 'Manage the mapping between entities and business units for this connection. Each business unit can be mapped to a single entity only.',
    entityMappingModalBusinessUnitsPlaceholder: 'Business unit(s)',
    entityMappingModalAllBusinessUnitsLabel: 'All business units',
    entityMappingModalBusinessUnitSelectedCount: '{0} business unit',
    entityMappingModalBusinessUnitsSelectedCount: '{0} business units',
    entityMappingModalNoResultsFound: 'No results found',
    entityMappingModalNoEntitiesLabel1: 'No entities exists in the engagement.',
    entityMappingModalNoEntitiesLabel2: 'Create an entity to get started.',
    entityMappingModalBusinessUnitAlreadyMapped: 'A business unit can be related to only one entity. Unrelate from other entities to enable.',
    /*Entites to Business Table*/
    entityMappingTableEntityColumnLabel: 'Entity',
    entityMappingTableBusinessUnitsColumnLabel: 'Business unit(s)',

    helixProjectPageTitle: "Projetos do EY Helix",
    helixProjectPageSubtitle: "Vincule o(s) projeto(s) do EY Helix relevante(s) a este engagement do EY Canvas. Quando mais de um projeto EY Helix estiver vinculado, selecione um como projeto principal para permitir a integração de dados no EY Canvas. Apenas o projeto primário pode ser integrado ao EY Canvas, portanto ele deve conter todas as atividades de lançamento no diário para a data que for relevante para o engagement.",
    helixProjectPageNoHelixProjectLinkedLabel1: "Atualmente, não existem projetos do EY Helix ligados ao engagement.",
    helixProjectPageNoHelixProjectLinkedLabel2: "Adicionar novo projeto do EY Helix",
    helixProjectPageNoHelixProjectLinkedLabel3: "para começar.",
    helixProjectPageNoHelixProjectLinkedLabel4: "Clicar",
    linkToHelixProject: "Abrir no EY Helix",
    addNewEYHelixProject: "Adicionar novo projeto do EY Helix",
    eyHelixSetup: "Integar dados do EY Helix",
    existingConnectionDetectedModalTitle: "Conexão(ões) existente(s) detectada(s)",
    existingConnectionDetectedDescription: "O analyzer selecionado já foi conectado a este engagement do EY Canvas. Você pode criar uma nova conexão ou selecionar uma conexão existente abaixo.",
    selectExistingConnection: "Selecionar uma conexão existente",
    selectCreateNewConnection: "Criar uma nova conexão",
    connectionNoRecords: "Nenhuma conexão encontrada",
    selectOneOfTheOptionsToProceed: "Selecione uma das opções para continuar.",
    saveHelixProjectErrorMessage: "Não foi possível salvar o analyzer selecionado. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    noResultFoundForAnalyzerSelection: "Certifique-se de que o analyzer que você está procurando está em um estado válido e que você tem acesso concedido ao analyzer. Entre em contato com um administrador do EY Helix para mais detalhes. Insira um código de cliente para pesquisar novamente.",

    /*Helix Analyzer Details Drawer*/
    connectButtonLabel: "Conectar",
    reConnectButtonLabel: "Reconectar",
    demoteFromFinancialStatementsOptionLabel: "Rebaixar das demonstrações financeiras",
    promoteToFinancialStatementsOptionLabel: "Promover para as demonstrações financeiras",
    deleteOptionLabel: "Excluir",
    projectAndAnalyzerDetailsSectionTitle: "Detalhes do projeto e do analyzer",
    projectNameLabel: "Nome do projeto",
    clientCodeLabel: "Código do cliente",
    analyzerNameLabel: "Nome do analyzer",
    periodEndDateLabel: "Data de término",
    analysisDateLabel: "Data da análise",
    lastConnectedByLabel: "Última conexão por",
    connectionSettingsSectionTitle: "Configurações de conexão",
    connectionTypesLabel: "Tipo(s) de conexão",
    currencyTypeLabel: "Tipo de moeda",
    currencyLabel: "Moeda",
    currencyCodeLabel: "Código da moeda",
    businessUnitsLabel: "Unidade(s) de negócios",
    entitiesLabel: "Entidades",
    analysisPeriodLabel: "Data de análise",
    comparativePeriod1Label: "Data comparativa 1",
    comparativePeriod2Label: "Data comparativa 2",
    manageAccountMappingSectionTitle: "Gerenciar mapeamento de contas",
    manageAccountMappingButtonLabel: "Gerenciar mapeamento de contas",
    mappedGLAccountsLabel: "% de contas GL mapeadas:",
    updateSettingsButtonLabel: "Atualizar configurações",
    deleteConnection: "Excluir conexão",
    deleteConnectionQuestion: "Tem certeza de que deseja excluir a conexão selecionada? Todos os dados integrados anteriormente relacionados a esta conexão serão excluídos. Esta ação não pode ser desfeita.",
    deleteConnectionWithAnalyticsQuestion: "Tem certeza de que deseja excluir a conexão selecionada? Todos os dados integrados anteriormente relacionados a esta conexão serão excluídos. Além disso, a conexão selecionada tem marcadores de cliente associados a este engagement. Excluir a conexão resultará na indisponibilidade desses marcadores. Esta ação não pode ser desfeita.",

    /*Helix Projects Table*/
    tableShowing: "Mostrando resultados para:",
    tableClientCode: " - Código do cliente:",
    tableEngagementCode: "Código do engagement",
    tableEngagementCodeName: "Nome do engagement",
    tableProjectID: "ID do Projeto",
    tableProjectName: "Nome do projeto",
    tableAnalyzerName: "Nome do analyzer",
    tablePeriodEndDate: 'Period end date',
    tableEYHelixPeriodEndDate: "Data de término",
    tableAnalysisDate: "Data de análise",
    tableEYHelixAnalysisDate: "Data de análise",
    tableAssignedPartner: "Sócio atribuído",
    tableProjectLinked: "Projeto vinculado",
    tableTooltipAnalizerIsDeleted: "O analyzer foi excluído no EY Helix. Para excluir permanentemente a conexão, clique para abrir a gaveta de detalhes. Considere se outro analyzer deve ser conectado.",
    tableTooltipAnalizerIsUnavailable: "O analyzer está indisponível no EY Helix. Entre em contato com um administrador do EY Helix para mais detalhes. Para excluir permanentemente a conexão, clique para abrir a gaveta de detalhes. Considere se outro analyzer deve ser conectado.",
    tableTooltipNotValidUser: "Você não é um membro autorizado da equipe do analyzer selecionado. Entre em contato com o administrador do projeto EY Helix para obter acesso e tente novamente.",

    /*Helix Project Cards*/
    cardAnalyzerConnectionLabel: "Conexões",
    cardAnalyzerHelixLabel: "EY Helix analyzers",
    cardAnalyzerMappedGLAccountsLabel: "Contas GL mapeadas",
    cardAnalyzerEntityMappingLabel: 'Entity mapping',
    cardAnalyzerManageGLAccountsLink: "Gerenciar mapeamento de contas",
    cardAnalyzerSectionScopeAndStrategy: "Escopo & estratégia",
    cardAnalyzerSectionFinancialStatements: "Demonstrações financeiras",
    cardAnalyzerSectionButtonLink: "aqui",
    cardAnalyzerSectionButtonDisconnect: "Desconectar analyzer",
    cardAnalyzerSectionScopeAndStrategyNoBalance: "Os dados de escopo & estratégia são usados para apresentar saldos nas atividades de escopo & estratégia, como materialidade. Clique em {0} para importar dados de escopo & estratégia.",
    cardAnalyzerSectionFinancialStatementsNoBalance: "As demonstrações financeiras podem ser importadas para o EY Canvas para fornecer detalhamento das demonstrações financeiras até onde o trabalho foi realizado no engagement do EY Canvas. Clique em {0} para importar as demonstrações financeiras.",
    cardAnalyzerSectionAnotherAnalyzerType: "Este analyzer foi conectado para facilitar a integração entre EY Canvas, EY Helix e/ou EY Smart Sampling. Clique em {0} para desconectar este analyzer.",
    cardAnalyzerSectionButtonLinkDisableTooltip: "Você não é um membro autorizado da equipe do analyzer vinculado. Entre em contato com o administrador do projeto EY Helix para obter acesso.",
	cardAnalyzerSectionButtonLinkDisableTooltipPermission: 'Você não tem as permissões necessárias para importar esses dados. Certifique-se de ter a permissão "Importar dados EY Helix" neste engagement do Canvas e tente novamente.',
    cardAnalyzerTrialBalanceAnalisysPeriod: "Data de análise",
    cardAnalyzerTrialBalanceComparativePeriod: "Data comparativa",
    cardAnalyzerTrialBalanceSecondComparativePeriod: "Segunda data comparativa",
    cardAnalyzerTrialBalanceLastImportDate: "Data da última importação",
    cardAnalyzerTrialBalanceCurrency: "Moeda",
    cardAnalyzerTrialBalanceBusinessUnits: "Unidade(s) de negócios",
    cardAnalyzerTrialBalanceMapedGLAccounts: "Contas GL mapeadas",
    cardAnalyzerTrialBalanceImportStatus: "Status de importação",
    cardAnalyzerTrialBalanceCurrencyTypeFunctional: "Moeda Funcional",
    cardAnalyzerTrialBalanceCurrencyTypeReporting: "Moeda de Apresentação",
    cardAnalyzerTrialBalanceImportData: "Importar dados",
    cardAnalyzerTrialBalanceAdjustmentModule: "Módulo de ajuste",
    cardAnalyzerTrialBalanceReImport: "Reimportar",
    cardAnalyzerTrialBalanceRemove: "Remover",
    cardAnalyzerTrialBalanceImportStatusInProgress: "Em andamento",
    cardAnalyzerTrialBalanceImportStatusImported: "Importado",
    cardAnalyzerTrialBalanceImportStatusError: "Erro",
    cardAnalyzerTrialBalanceImportStatusDisconnected: "Desconectado",
    cardAnalyzerTrialBalanceImportModalTitle: "Importar dados",
    cardAnalyzerTrialBalanceImportModalDescription: "Selecione os atributos da importação e clique em 'importar' para importar",
    cardAnalyzerTrialBalanceImportModalButton: "Importar",
    cardAnalyzerTrialBalanceReImportModalTitle: "Reimportar dados",
    cardAnalyzerTrialBalanceReImportModalDescription: "Selecione os atributos da importação e clique em 'reimportar' para reimportar.",
    cardAnalyzerTrialBalanceReImportModalButton: "Reimportar",
    cardAnalyzerTrialBalanceImportInProgressTooltip: "A importação está em andamento. Isso pode levar vários minutos.",
    cardAnalyzerTrialBalanceImportEntityTooltip: "A entidade não pode ser alterada durante uma reimportação. Crie uma nova importação para selecionar uma entidade diferente.",
    cardAnalyzerTrialBalanceImportMestEntity: "Esta seleção foi feita na etapa anterior. Para editar, você deve retornar lá.",
    cardAnalyzerTrialBalanceMestBusinessUnit: "Esta seleção é baseada na entidade acima. Para editar o relacionamento entre entidade e unidade(s) de negócios, acesse o 'Mapeamento de entidade' na página de resumo subjacente.",
    cardAnalyzerTrialBalanceFirstSelectCurrencyTypeTooltip: "Primeiro selecione um 'Tipo de moeda' para ativar este campo.",
    cardAnalyzerTrialBalanceFirstSelectCurrencyTooltip: "Primeiro selecione uma 'Moeda' para ativar este campo.",

    /*Helis Linked Projects Cards*/
    analysisDate: "Data de análise:",
    unlinkProject: "Desassocie o link do projeto",
    editAnalyzer: "Editar analyzer",
    deleteProject: "Delete o projeto",
    projectDeleted: "Projeto foi apagado",
    loadingProjectDataLinked: "Carregando dados do EY Helix",
    projectMarkPrimaryConfirmationHeader: "Alterar o projeto principal no EY Helix",
    projectMarkPrimaryConfirmationMsg: "Tem certeza que quer mudar o projeto principal no EY Helix?",
    projectPrimaryEYHexliProject: "Projeto principal no EY Helix",
    helixProjectUnlink: "Desvincular",
    helixProjectDelete: "Excluir",
    analyzersLabel: "Analyzers:",


    /*Helix Import List*/
    importHelixList: "Lista de importação do EY Helix",
    importDocumentName: "Nome do Documento",
    importDocumentID: "ID do Documento",
    importFileSize: "Tamanho do aquivo (in KB)",
    importDownload: "Baixar",
    importNoRecords: "Nenhum documento encontrado",
    importInvalidDocumentID: "O ID do documento requer que seja o mesmo para pesquisar. Certifique-se de ter incluído o ID completo do documento",

    /*Helix Connect analyzer modal*/
    connectAnalyzerClientLabel: "Cliente:",
    addConnectionNameLabel: "Adicionar nome de conexão",
    connectionNamePlaceholder: "Nome da conexão",
    connectionNameRequired: "Obrigatório",
    connectAnalyzerModalTitle: "Conectar analyzer",
    connectAnalyzerDescription: "Selecione um analyzer abaixo para criar um link com este engagement do EY Canvas. Pesquise por código do cliente para encontrar projetos EY Helix e os analyzer relacionados.",
    analyzerLocationIncompatibleErrorMessage: "O analyzer não pode ser conectado porque seus dados estão armazenados em local incompatível com o local do engagement no EY Canvas.",
    analyzerMaxConnectionReachedErrorMessage: "O número máximo de conexões permitidas foi atingido para o analyzer selecionado. Selecione outro analisador para continuar.",
    helixAnalyzerErrorMessage: "Ocorreu um erro ao conectar-se ao EY Helix analyzer. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    helixAnalyzerGLAConnectionErrorMessage: "Há um ou mais erros ao conectar-se ao EY Helix analyzer para obter a contagem de contas mapeadas. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    helixReImportErrorMessage: "Ocorreu um erro ao importar dados do EY Helix. Atualize a página e tente novamente. Se o problema persistir entre em contato com o Help Desk.",

    /*Helix Select Entity Modal*/
    selectEntityModalTitle: "Selecione a entidade",
    noEntitiesMappedToBusiness: "Nenhuma entidade foi mapeada para unidade(s) de negócios.",
    noEntitiesMappedToBusinessFirst: "Clique",
    noEntitiesMappedToBusinessLink: "aqui",
    noEntitiesMappedToBusinessLinkText: "para começar.",
    searchEntityPlaceholder: "Entidade de pesquisa",
    entityListHeader: "Entidade",
    selectEntityErrorMessage: "Selecione uma entidade para continuar.",
    entityAlreadyConnectedToScopeAndStrategy: "Já existe uma importação de 'Escopo & estratégia' para esta entidade. Somente uma única importação de 'Escopo & estratégia' é permitida por entidade. Remova a importação existente para ativar esta seleção.",
    selectEntityNoEntitiesFound: "Nenhum resultado encontrado",
    selectEntityModalDescription: "Selecione uma entidade para a qual deseja importar dados.",

    /*Manage Account Mapping*/
    manageAccountMapping: "Gerenciar mapeamento de contas",
    manageAccountMappingErrorMessage: "Não foi possível conectar-se ao EY Helix. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    helixViewerLoader: "Carregando o visualizador Helix...",

    /*Helix Remove Import Modal*/
    removeImportModalTitle: "Remover importação",
    removeImportRemoveButtonLabel: "Remover",
    removeImportDescription: "Tem certeza de que deseja remover a importação a seguir?",
    removeImportActionUndoneDescription1: "Tem certeza de que deseja remover a importação a seguir?",
    removeImportActionUndoneDescription2: "Esta ação não pode ser desfeita.",
    removeImportErrorMessage: "Os dados importados foram alterados desde que você abriu esta tela. Para continuar com a remoção, atualize a página e tente novamente.",

    /*Disconnect analyzer modal*/
    disconnectAnalyzerModalTitle: "Desconectar analyzer",
    disconnectAnalyzerDisconnectButtonLabel: "Desconectar",
    disconnectAnalyzerDescription: "Tem certeza de que deseja desconectar o analyzer selecionado?",
    disconnectAnalyzerImportsExistErrorMessage: "Uma importação foi adicionada a esta conexão desde que você abriu esta tela. Uma conexão só poderá ser desconectada se todas as importações associadas forem removidas primeiro. Atualize a página e tente novamente.",

    /*Content Update */
    quote: '"',
    performContentUpdate: "Executar atualização de conteúdo",
    contentupdate: "Atualização de conteúdo",
    btnContentUpdate: "Atualização",
    btnContentUpdateSelected: "Atualizar",
    updateSuccessMessage: "Atualização de conteúdo enviada",
    msgContentUpdate: "Selecione uma ou mais categorias abaixo para atualizar o conteúdo. Se quantidades substanciais de trabalho já tiverem sido concluídas, discuta com os executivos do engagement se uma atualização de conteúdo for apropriada. Atualizações de conteúdo não podem ser desfeitas.",
    msgIndependance: "A atualização da Independência pode resultar em confirmações de independência sendo requeridas para serem concluídas novamente.",
    msgProfile: "A atualização do perfil pode ter um impacto significativo no conteúdo do engagement. Os usuários podem perder o acesso ao perfil até que um novo perfil seja submetido. Esta ação não pode ser desfeita.",
    msgHistoryContentUpdate: "Atualizações de conteúdo realizadas anteriormente e o status delas.",
    msgWarningTitle: "Aviso",
    btnProceedContentUpdate: "Prosseguir",
    btnCancelContentUpdate: "Cancelar",
    confirmationMessageP1: "Você está prestes a concluir uma atualização de conteúdo para as categorias de conteúdo selecionadas. Selecione",
    confirmationMessageP2: "para continuar ou selecionar",
    confirmationMessageP3: "se você não deseja concluir a atualização de conteúdo neste momento.",
    warningMessage: "Um ou mais tipos de conteúdo devem ser selecionados para atualização",
    groupReportingFormsSent: "Relatório de grupo <b>formulários enviados</b>",
    groupReportingFromStatus: "Status do formulário de relatórios de grupo",
    primaryTeamReviewStatus: "Status de revisão da equipe primária",
    reportingStatus: "Status dos relatórios",
    taskStatusLabel: "Status da tarefa",
    primaryTeam: "Equipe primária",
    componentTeam: "Equipe de componentes",
    groupTasksReceived: "auditoria de grupo <b>tarefa recebida</b>",
    group: "Grupo",
    regionalTeam: "Equipe regional",
    unlinkedLabel: "Desvinculado",
    linkedLabel: "Associado",
    unlinkedTasks: "<b> tarefas desvinculadas</b>",
    unlinkedTask: "<b> tarefa desvinculada</b>",
    primaryTeamGroupTaskPlaceholder: "Crie componentes e envie instruções de grupo para monitorar o progresso aqui.",
    componentTeamGroupTaskPlaceholder: "Aceite tarefas de grupo componente da equipe principal para ver um resumo do progresso aqui.",
    confirmUpdateMessage1: "A atualização desses formulários pode ter um impacto significativo no conteúdo. Uma vez iniciada, nenhuma atualização adicional de conteúdo pode ser realizada até que estas sejam concluídos.",
    confirmUpdateMessage2: "Selecione 'Prosseguir' para continuar ou selecione 'Cancelar' se você não desejar concluir a atualização de conteúdo no momento.",
    updateSelectedTitle: "Atualização selecionada",
    statusCodeForbidden: 403,
    pspAccountHeader: "Conta",
    pspAccountDateHeader: "Data do conteúdo",
    pspAccountStatus: "Status",
    pspAccountSelected: "Selecionado",

    /*Preapre for Arc*/
    YearEndDate: "Data de final do ano:",
    PeriodEndDate: "Data final do período coberto:",
    ReportDate: "Data do relatório:",
    ArcDeadlineDate: "Data do prazo do arquivamento:",
    ClientCode: "Código do cliente:",
    PrimaryEngCode: "Código do engagement primário:",
    SecondaryEngCode: "Código do engagement secundário:",
    ReportType: "O relatório é qualificado de alguma forma e/ou com parágrafo de ênfase?:",
    ProtectedDocuments: "Nota: Documentos protegidos não devem ser retidos em arquivos de trabalho, a menos que seja necessário",
    noObjectsAvailable: "Sem objetos disponíveis",
    CurrentlyUnavailable: "Atualmente indisponível",
    showMoreToggle: "Mostrar mais",
    showLessToggle: "Mostrar menos",

    //#region Document upload status

	docListUploadTemporaryPlaceholder: '<center>Nenhum documento disponível<br />-<br />Você pode arrastar e soltar um ou mais documentos ou clicar em <button class="motif - button Motif - text - alt - button Motif - button - small ">Adicionar arquivos temporário </button></center>',
    uploadEvidencePlaceholder: "Arraste e solte um ou mais documentos ou clique em <a>Adicionar evidência</a>",
    uploadTemporaryPlaceholder: "Arraste e solte um ou mais documentos ou clique em <a>Adicionar arquivos temporários</a>",

    processing: "Processando",
    uploading: "Carregando",
    uploadComplete: "Processando",
    downloading: "Transferindo",
    downloadComplete: "Download completo",
    loading: "Carregamento",

    //#region Filter

    filter: "Filtro",
    noFiltersAvailable: "Nenhum filtro disponível",
    pickADate: "Escolha uma data",
    filterYes: "Sim",
    filterNo: "Não",

    //#region Document list filters
    filterGroupDocumentsLabel: "Documentos",
    filterDocumentContentLabel: "Conteúdo do documento",
    filterSharedEvidenceLabel: "Evidências compartilhadas",
    filterFileExtensionLabel: "Extensão",
    filterDocumentConflictLabel: "Conflitos",
    filterDuplicateFileNameLabel: "Nome do arquivo duplicado",
    filterCanvasFormsLabel: "Formulários do Canvas",

    filterGroupModificationsLabel: "Modificações",
    filterLastModifyUserLabel: "Última modificação por",
    filterModifyAfterReviwerSignoffLabel: "Modificado desde a aprovação do revisor",
    filterModifiedAfterLabel: "Modificado após",

    filterGroupReviewNotesLabel: "Notas de revisão",
    filterReviewNoteStatusLabel: "Status",
    filterReviewNoteAssignedToLabel: "Atribuído a",
    filterReviewNoteAuthoredByLabel: "Autoria de",
    filterReviewNoteOtherEngagementLabel: "De outros engagaments",

    filterGroupSignOffsLabel: "Aprovações",
    filterSignOffMissingLabel: "Aprovações perdidas",
    filterSignedOffByUserLabel: "Assinado por",
    filterNotSignedOffByUserLabel: "Não assinado por",
    filterSignOffRequirementsLabel: "Requisitos de assinatura",

    filterGroupOtherLabel: "Outros",
    documentLink: "Link do documento",
    filterByCopyLinkDocument: "Filtrado por copiar link do documento",
    filterGroupAuditComponentLabel: "Equipe de região/componente",
    noGroupAuditComponents: "Nenhum componente foi criado",
    filterFindingsLabel: "Resultados",
    filterGroupInstruction: "Instrução de grupo",
    noGroupInstruction: "Nenhuma instrução foi criada",

    documentSearchPlaceholderLabel: "Documentos de pesquisa",
    analyticSearchPlaceholderLabel: "Pesquisar analytics",
    //#endregion

    //#endregion

    pendingResponseLabel: "Resposta pendente",
    receivedLabel: "Recebido",
    dueToPrimaryTeam: "Devido à equipe primária",
    sentToPrimaryTeam: "Enviado para a equipe primária",
    documentationPending: "Documentação pendente",
    documentationComplete: "Documentação completa",
    viewBytimephaseTextLabel: "Ver por fase do tempo",
    showDetails: "Mostrar detalhes",
    referenceDocAddDocHeaderText: "Relacionar evidências ou arquivos temporários deste engagement, a fim de acessá-los a partir do painel.",
    addDocsToTeam: "Adicionar documentos aos documentos da equipe",
    addDocsToMy: "Adicione documentos aos meus documentos",
    addDocument: "Adicionar documento",
    externalUserRemove: "Remover",

    // Internal user roles abbr
    adminRole: "Admin",
    readOnlyRoleForThirdPartyUser: "Somente leitura",
    legacy: "sem restrições",
    permissionLabel: "Permissão",
    displayPermissionErrorText: "Não é possível exibir permissões no momento. Tente novamente e se o problema persistir, entre em contato com o Help Desk.",
    onlyShowRelatedTasks: "Apenas mostrar tarefas relacionadas",

    softwareUpdate: "Atualizações de software",
    updateNow: "Atualizar agora",
    updateMsg: "Atualizações de software estão disponíveis para o EY Canvas. Selecione Atualizar Agora para baixar e instalar as atualizações. A página será atualizada.",

    processingError: "Erro de processamento",

    //Create tag modal labels
    createtags: "Crie etiquetas de identificação",
    reportDate: "Data do relatório",
    managetags: "Gerenciar etiquetas",
    savechanges: "Salvar mudanças",
    manageTagGroupCreate: "Criar",
    manageTagGroupDiscard: "Descartar",
    manageTagGroupCreateTooltip: "Etiqueta de grupo",
    deletetag: "Excluir tag",
    deletetaggroup: "Apagar etiqueta de grupo",
    createTagGroup: "Criar etiqueta de grupo",
    manageTagGroupName: "Etiqueta de grupo",
    countOftasksAssigned: "Contagem de tarefas atribuídas",
    createTagGroupMessage: "Crie grupos de tags para começar. Clique em {0} para criar um grupo de tags.",
    tagsContnetSearchPlaceholder: "Pesquisar eitquetas",
    deleteTagHoverText: "Esta tag será removida de todas as tarefas do seu engagement.",
    deleteTagGroupHoverText: "Todas as tags deste grupo serão excluídas e removidas de todas as tarefas do seu engagement.",
    tagSaveChangesInfoText: "Mudanças serão aplicadas ao salvar.",
    tagConfirmModalTitleText: "Confirmar mudanças",
    tagConfirmModalPrimaryMessage: "Você tem certeza que deseja salvar essas mudanças?",
    tagConfirmModalSecondaryMessage: "Uma vez salvo, quaisquer tags excluídas ou grupos de tags não poderão ser recuperados.",
    tagDeleteModalSecondaryMessage: "Uma vez salvas, todas as tags excluídas não podem ser recuperadas.",
    createNewTag: "Criar nova tag",
    tagWillBeRemovedFromRequests: "Esta tag será removida de todos os pedidos em seu egagement.",
    eyTags: "EY tags",
    clientTags: "Tags de cliente",
    allTags: "Todas as tags",
    // Add canvas form
    addCanvasForm: "Adicionar formulário no Canvas",
    addCanvasFormName: "Nome do documento",
    addCanvasFormNameBlankMessage: "Nome do documento é um campo requerido",
	addCanvasFormNameInvalidCharacterMessage: 'O nome não pode conter nenhum dos seguintes caracteres: */:<br>\\?|"',
    addCanvasFormDigital: "Digital",
    addCanvasFormCore: "Tradicional",
    addCanvasFormNonComplex: "Não-Complexo",
    addCanvasFormComplex: "Complexo",
    addCanvasFormListed: "Companhia aberta",
    addCanvasFormGroupAudit: "Auditoria de grupo",
    addCanvasFormPCAOBFS: "PCAOB-FS",
    addCanvasFormPCAOBIA: "PCAOB-IA",
    addCanvasFormStandards: "Normas",
    addCanvasFormStandardsNotSelectedMessage: "Normas são requeridas",
    addCanvasFormLanguage: "Idioma",
    addCanvasFormLanguageNotSelectedMessage: "Idioma é requerido",
    addCanvasFormNoResultFound: "Nenhum resultado encontrado",
    addCanvasFormManageTasks: "Gerenciar tarefas",
    addCanvasFormAvailableTasks: "Nome da tarefa",
    addCanvasFormAvailableTaskType: "Tipo",
    addCanvasFormTypeOfForm: "Tipo de formulário",
    addCanvasFormSubServiceLine: "Sub service line",
    addCanvasFormTypeOfFormNotSelectedMessage: "Tipo de formulário é requerido",
    addCanvasFormSelectedTasks: "Tarefas selecionadas",
    addCanvasFormNoTaskDataAvailable: 'No tasks selected. Select at least one task to create a form.',
    addCanvasFormCreateForm: "Criar formulário",
    addCanvasFormCancel: "Cancelar",
    addCanvasFormSuccessMessage: "{0} foi criado com sucesso. Pode levar até dez minutos para que o conteúdo seja entregue.",
    // Add Canvas form manage Objects
    addCanvasFormManageObjects: "Gerenciar {0}",
    addCanvasFormAvailableObjects: "{0} nome //",
    addCanvasFormSelectedObjects: "Selecionado {0}",
    addCanvasFormClickHereToOpenManageTab: "Clique aqui para abrir a guia Gerenciar {0} aba",
    addCanvasFormNoObjectsDataAvailableRequired: "Nenhum {0} selecionado. Selecione pelo menos um para criar um formulário",
    addCanvasFormNoObjectsDataAvailableOptional: 'No {0} selected.',
    addCanvasFormObjectNotDefinedMessage: "Objetos não estão disponíveis para este formulário",
    addCanvasFormOptional: "(opcional)",
    addCanvasFormObjects: "objetos",
    addCanvasFormObject: "óbjeto",
    addCanvasFormSCOT: "SCOT",
    addCanvasFormSCOTs: "SCOTs",
    addCanvasFormITProcess: "Processo de TI",
    addCanvasFormITProcesses: "Processos de TI",
    addCanvasFormControl: "Controle",
    addCanvasFormControls: "Controles",
    addCanvasFormITControl: "Controle de TI",
    addCanvasFormITControls: "Controles de TI",
    addCanvasFormITApplication: "Aplicativo de TI",
    addCanvasFormITApplications: "Aplicações de TI",
    addCanvasFormSignoffRequirements: "Assinaturas necessárias:",
    addCanvasFormPICCheckBox: "PIC",
    addCanvasFormEQRCheckBox: "EQR",
    itProcessRelatedITGCITSP: "Processo de TI e ITGCs/ITSPs relacionados",
    taskTitle: "Entenda e documente o processo de TI: {0}",
    taskDescription: "Documente nossa compreensão do processo de TI. Anexe o formulário relevante como evidência para apoiar nossa compreensão do processo de TI.<br>Quando os ITGCs aparecerem na seção Atributos da Tarefa, execute os procedimentos passo a passo para confirmar nosso entendimento dos ITGCs e avaliar seu design e implementação. Anexe evidências de nossos procedimentos.",
    addCanvasFormAccounts: "contas",
    addCanvasFormAccount: "contas",
    addCanvasFormErrorMessage: "Este formulário só pode estar relacionado a uma conta",
    addCanvasFormValidationMessage: "É seleção é requerida",
    addCanvasFormEstimates: "estimativas",
    addCanvasFormEstimate: "estimativa",
    addEstimateCanvasFormErrorMessage: "Este formulário só pode estar relacionado a uma estimativa",
    addControlCanvasFormErrorMessage: "Este formulário só pode estar relacionado a um controle",
    addScotCanvasFormErrorMessage: "Este formulário só pode estar relacionado a uma SCOT",

    //Independence Confirmation
    sortOrderIndependence: "Ordernar",
    confirmationStatus: "Status da confirmação",
    confirmationDate: "Data da confirmação",
    independenceConfirmationSearch: "Pesquisar membros do engagement",
    editTemplate: "Editar template",
    viewTemplate: "Ver modelo",
    confirmedBy: "Confirmado por",
    overriddenBy: "Autorizado por",
    grantedBy: "acesso concedido por",
    deniedBy: "acesso negado por",
    list: "Lista",
    paginationShow: "Mostrar",
    options: "Opções",
    removeTeamMemberModalText: "Tem certeza que quer remover esse membro da equipe do seu engagement?",
    removeTeamMemberModalTitle: "Remover membro da equipe",
    overrideRemovedBy: "Substituição removida por",

    // Custom instructions
    addCustomInstruction: "Adicionar instruções personalizadas",
    editCustomInstruction: "Editar instruções personalizadas",
    customInstructionInstructionalText: "Adicione ou edite instruções personalizadas aqui. Essas instruções aparecerão na confirmação de independência individual de cada membro da equipe para fornecer orientações sobre como responder a perguntas específicas do cliente.",
    customInstructionPermissionTooltip: "Você deve ter a permissão <b> Administrar engagement</b> para realizar esta ação. Fale com um <b> administrador do Engagement </b> para solicitar permissão.",
    customInstructionMaxLengthExceeded: "O texto excedeu o comprimento máximo permitido",

    //Independence Confirmation Details
    details: "Detalhe",
    question: "Pergunta",
    answer: "Resposta",
    countTeamMembers: "Contagem de membros da equipe",
    executiveApproval: "Aprovação executiva",
    yes: "Sim",
    no: "Não",
    independenceModalText: "Aqui você pode ver os membros da equipe que selecionaram esta resposta em sua Confirmação de Independência Individual.",
    notApplicable: "Não é aplicável",
    readMore: "Leia mais",
    readLess: "Leia menos",
    teamMembsersTitle: "Detalhes do membro da equipe",

    tasksSelected: "Tarefas selecionadas",
    taskSelected: "Tarefa selecionada",
    unselectAll: "Desmarcar todos",
    addForm: "Adicionar formulário",
    addFormName: "Nome",
    addFormDigital: "Digital",
    addFormCore: "Tradicional",
    addFormNonComplex: "Não-Complexo",
    addFormComplex: "Complexo",
    addFormListed: "Companhia aberta",
    addFormGroupAudit: "Auditoria de grupo",
    addFormPCAOBFS: "PCAOB-FS",
    addFormPCAOBIA: "PCAOB-IA",
    addFormStandards: "Normas",
    addFormLanguage: "Idioma",
    addFormManageTasks: "Gerenciar tarefas",
    addFormManageObjects: "Gerenciar objetos",
    addFormAvailableTasks: "Tarefas disponíveis",
    addFormAvailableObjects: "Objetos disponíveis",
    addFormTypeOfForm: "Tipo de formulário",
    addFormSelectedTasks: "Tarefas selecionadas",
    addFormSelectedObjects: "Objetos selecionados",
    addFormCreateForm: "Criar formulário",
    addFormCancel: "Cancelar",
    createtag: "Criar etiqueta",
    tagsLabel: "Etiquetas",

    //Group instruction summary
    sInstruction: "Escopo",
    iInstruction: "Individual",

    //CGT and CGT Unlinked related labels
    cgtSend: "Enviar",
    cgtDueDate: "Data para conclusão",
    cgtFrom: "De",

    notesSelected: "notas selecionadas",
    noteSelected: "nota selecionada",
    cgtUnlinkedLabel: "Desassociado",
    cgtUnlinkedInformationMessage: "Essa tarefa não está mais associada com um engagement de grupo e pode ser apagada caso não seja mais necessária",
    sendtoPrimaryTeam: "Enviar para a equipe primária",
    sendtoPrimaryTeamdisableBtn: "Esta tarefa deve conter evidências com pelo menos uma assinatura do preparador e do revisor para enviar para a equipe primária",
	cgtSendModalHeader: 'Selecione um ou mais documentos para enviar à equipe principal. <span class="modal-instrução-texto">Os formulários do canvas serão enviados em formato PDF. Um registro de formulários em PDF do Canvas enviados para a equipe principal está disponível em arquivos temporários.</span>',
    cgtNotifyCheck: "Notifique a equipe primária de que nenhum outro documento deve ser enviado.",
    cgtCanvasFormValidation: "Existem validações não resolvidas neste formulário Canvas. Considere se as validações devem ser resolvidas antes de enviá-las à equipe principal.",
    finalVersionLabel: "Versão final",
    draftVersionLabel: "Versão preliminar",
    otherEvidence: "Outras evidencias",
    selectAtLeastOneDocument: "Selecione pelo menos um documento para continuar.",
	cgtsendmodelinstructionheader: 'Selecione um ou mais documentos para enviar à equipe principal. <span class="modal-instrução-texto">Marcando um documento como <b>versão rascunho</b> informe a equipe principal que você ainda está trabalhando no documento e pode enviar versões adicionais. Marcar o documento como <b>versão final</b> informe a equipe principal que seu trabalho está concluído e que você não espera enviar quaisquer versões adicionais do documento.</span>',
    //Independence confirmation
    undefined: "Indefinido",
    incomplete: "Imcompleto",
    nomattersidentified: "Sem assuntos identificados",
    matteridentifiedpendingaction: "Assunto identificado - Ação pendente",
    matterresolveddeniedaccess: "Assunto resolvido - Acesso negado",
    matterresolvedgrantedaccess: "Assunto resolvido - Acesso concedido",
    notapplicable: "Não é aplicável",
    restored: "Restaurado",
    overriden: "Anulado",
    override: "Anule",
    priornomattersidentified: "Anterior - Sem Assuntos Identificados",
    priormatteridentifiedpendingaction: "Anterior - Questão identificada - Ação pendente",
    priormatterresolvedgrantedaccess: "Anterior - Questão Resolvida - Acesso Concedido",
    priormatterresolveddeniedaccess: "Anterior - Questão Resolvida - Acesso Negado",
    addTagsLabelForTaskList: "Adicionar etiqueta",
    addTagLabelForTaskDetails: " + Adicionar etiqueta",
    manageTagsColorInputLabel: "Cor",
    manageTagsTagNameInputLabel: "Nome da etiqueta",
    addTagRequiredMessage: "Requerido",
    addNewTagLinkText: "Adicionar nova etiqueta",
    manageTagsLabel: "Gerenciar tarefas",
    manageTagGroupHeader: "Crie novas tags e grupos aqui. Você também pode editar e excluir tags e grupos existentes. Tarefas de marcação podem melhorar a organização do seu engagement e o gerenciamento de projetos.",
    //add tag color dropdown
    addTagRedColorText: "Vermelho",
    addTagOrangeColorText: "Laranja",
    addTagTealColorText: "Verde-água",
    addTagBlueColorText: "Azul",
    addTagPurpleColorText: "Roxe",
    addTagGreenColorText: "Verde",
    deleteAssignmentConfirmationMessage: "Você tem certeza que você quer excluir esta atribuição?",

    // Return label for Returned document
    recieved: "Recebido",

    selectServiceOffering: "Selecionar serviço",
    selectTasks: "Selecionar tarefas",
    reviewSuggestedTasks: "Revisão de tarefas sugeridas",
    reviewAvailableTasks: "Rever tarefas disponíveis",
    setDueDate: "Definir data de vencimento",
    schedulerCreateRequestStep4TabText: "Protocolos de funcionamento e comunicação",
    createWorkRequestHeadingpart1: "Identifique sua solicitação de serviço e selecione um serviço para começar.",
    createWorkRequestHeadingpart2: "As ofertas de serviço listadas abaixo são baseadas no perfil do seu engagement e nos serviços disponíveis em sua região. Os custos variam de acordo com a classificação de recursos atribuídos e complexidade.",
    createWorkRequestHeadingpart3: "Se foi realizado o rollfoward do seu engagement, quaisquer ofertas de serviço usadas pelo seu engagement no período anterior são rotuladas com um",
    createWorkRequestHeadingpart4: "Período anterior",
    createWorkRequestHeadingpart5: "badge.",
    createWorkRequestStep2Headingpart1: "Revise as tarefas que estão disponíveis para o",
    createWorkRequestStep2Headingpart2: "oferta de serviço.",
    createWorkRequestStep2Headingpart3: "<u>Para a participação da equipe no piloto de centralização de Wave 2</u>, selecione as tarefas relevantes com base nos seguintes critérios, que os membros da equipe centralizada podem realizar: (1) Procedimentos objetivos de auditoria (ou seja, aqueles procedimentos que requerem pouco ou nenhum julgamento), (2) Procedimentos subjetivos (ou seja, aqueles procedimentos que requerem julgamento) apenas para estimativas de menor risco ou quando o risco inerente for menor para a afirmação relevante(s). As tarefas que já estão incluídas em outra solicitação de serviço centralizada são rotuladas como",
    createWorkRequestStep2Headingpart4: ". Se você usou este serviço antes, as tarefas que foram incluídas em sua solicitação de período anterior são rotuladas como",
    createWorkRequestStep2Headingpart5: "Período anterior.",
    requestName: "Nome do pedido",
    submittedBy: "Enviado por",

    // Next wave labels
    totalTasks: "Tarefas",
    noServiceRequest: "Nenhuma solicitação de serviço foi criada ainda. Crie e envie solicitações de serviço para começar.",
    eyContact: "Contato da EY",
    requestStatusText: "Status de solicitação",
    requestsByStatusText: "Solicitações por status",
    serviceRequest: "Solicitações de serviço",
    serviceGateway: "Porta de entrada de serviço",
    centralizedServices: "Solicitar serviços",
    serviceRequestDueDate: "Vencimento",
    NA: "N/A",
    more: "Mais",
    eycontacts: "Contatos da EY",
    addEYContact: "Adicionar contato EY",
    editEYContacts: "Editar contatos EY",
    addEYContactInstructions: "Adicione ou remova contatos EY para esta solicitação. Os contatos EY atualizados serão enviados para os gerentes de recursos e recursos atribuídos.",
    editEYContactDisabledInstructions: "Você deve ter a permissão <b>Solicitar serviços</b> para realizar esta ação. Fale com um administrador de engajamento para obter acesso.",
    emptyEYContactsPlaceholder: "Adicione pelo menos um contato da EY para continuar.",
    estimatedHours: "Tempo para completar (horas)",
    resourceManagers: "Gestão de recursos",
    nextWaveServices: "Serviços Centralizados",
    centralizedservices: "Serviços centralizados",
    onlyShowAccepetedRequests: "Mostrar apenas pedidos aceitos",
    showSelectedOnly: "Mostar apenas selecionados",
    emptyEngCodeMessage: "Não há códigos válidos para seu engagement",
    primary: "Primário",
    estimatedCosts: "Custos estimados",
    assignedResources: "Recursos atribuídos",
    generalAuditTasks: "Tarefas gerais de auditoria",
    generalInfo: "Informação geral",
    requestID: "ID da Requisição",
    createdDate: "Criado",
    startDate: "Iniciar",
    serviceRequestDue: "Vencimento",
    comingDueIn: "Vencendo em",
    comingDueTodayLabel: "Vence hoje",
    daysLabel: "dias",
    dayLabel: "dia",
    createByLabel: "Criado por",
    notProvidedLabel: "Não fornecido",
    editLabel: "Editar",
    serviceRequestNoHistoryLabel: "Não há histórico para este pedido",
    serviceRequestHistoryLabel: "Histórico",
    serviceRequestTasks: "Tarefas de solicitação de serviço",
    suggestedRequestTasks: "Tarefas de solicitação sugeridas",
    estimatedCost: "Custo estimado",
    addinstructionsAndRelatedFiles: "Adicione outros protocolos de funcionamento e comunicação para este pedido.",
    instructionText: "As evidências relacionadas a esta solicitação serão arquivadas e incluídas com a solicitação se você fizer o roll forward no próximo ano. Os arquivos temporários não serão inclusos nessa solicitação se você fizer o roll forward desse engangement.",
    instructionPlaceHolder: "Outros protocolos de funcionamento e comunicação",
    warningText: "As evidências serão arquivadas com a solicitação mas os arquivos temporários não.",
    availableDocuments: "Documentos disponíveis",
    noDocumentsAvailable: "Nenhum documento disponível",
    selectAll: "Selecione todos",
    deselectAll: "Desmarcar todos",
    documentsSelected: "documentos selecionados",
    selectedDocuments: "Documentos selecionados",
    noDocumentSelected: "Nenhum documento foi selecionado ainda. Selecione um documento para começar (opcional).",
    TaskName: "Nome da tarefa",
    AssignmentsLabel: "Atribuições",
    noTaskAssociatedToServiceRequest: "Não há tarefas associadas a esta solicitação.",
    requestServices: "Solicitar serviços",

    serviceNotEditable1: "Para modificar as tarefas incluídas nesta solicitação, selecione",
    serviceNotEditable2: "Editar",
    serviceNotEditable3: "no",
    serviceNotEditable4: "Tarefas",
    serviceNotEditable5: "guia. Para fazer alterações adicionais ou cancelar esta solicitação de serviço, em seguida,",
    serviceNotEditable6: "entrar em contato com um dos gestores de recursos",
    serviceNotEditable7: "(se atribuído).",

    serviceReqMarkComplete: "Marcar uma solicitação de serviço centralizada como completa informará ao provedor de serviços que nenhum trabalho adicional é necessário e que você terminou sua revisão. Uma vez que a solicitação de serviço esteja marcada como completa, ela não pode ser desfeita.",
    serviceReqMarkCompleted: "Concluído",
    editServiceRequestTasks1: "Revise tarefas selecionadas para esta solicitação de serviço.",
    editServiceRequestTasks2: "Todas as tarefas que são sugeridas para o",
    editServiceRequestTasks3: "oferta de serviços são apresentadas aqui. Para adicionar uma tarefa, selecione-a na lista abaixo. Para remover uma tarefa, desmarque.",

    submitServiceRequestConfirmation1: "Você tem certeza de que deseja enviar essa solicitação de serviço?",
    submitServiceRequestConfirmation2: "Você selecionou uma oferta de serviço que já foi submetida ao seu engagement.",
    alreadyScheduledHeader: "Oferta de serviço já programada",

    createServiceRequestPermission1: "Você deve ter criar permissões de solicitação de serviço para continuar.",
    createServiceRequestPermission: "Você deve ter a permissão <b>Gerenciar solicitações de serviço</b> para tomar esta ação. Fale com um administrador do engagement para ter acesso.",
    schedulerRequestSubmissionError: "Ocorreu um erro que impediu que essa solicitação fosse submetida ao programador. Selecione <b>Reenviar</b> para tentar novamente. Entre em contato com o Help Desk se o erro persistir.",
    resubmit: "Reenviar",
    noServiceManager: "Um gerente de recursos ainda não foi designado para este pedido.",
    noAssignedResource: "Nenhum recurso foi atribuído a este pedido ainda.",
    noMileStoneSetForService: "Milestones iniciado e as datas de vencimento ainda não foram definidas para este pedido.",
    isEngagementNominnatedForCentralizeService: "Seu compromisso foi selecionado ou confirmado pela sua Região para participar do piloto de Centralização do GDS?",
    needApprovalForSericeRequestCreation: "Entre em contato com o seu sócio de Gestão de Garantia Regional para obter a aprovação adequada para continuar com este pedido de serviço.",

    //TaskList Filters
    filterMissingRelatedTaskLabel: "Documento PIC/EQR não relacionado à tarefa",
    filterRelatedToRisksLabel: "Relacionado a riscos",
    filterGroupTasksLabel: "Tarefas",
    filterGroupAssignmentsLabel: "Alocações",
    filterGroupDocumentsignoffsLabel: "Aprovações de documentos",
    filterGroupProjectManagementLabel: "Gerenciamento de projetos",
    filterAssignmentTypeLabel: "Tipo de atribuição",
    filterTaskStatusLabel: "Status da tarefas",
    filterTaskTypeLabel: "Tipo de tarefa",
    filterAssignedToLabel: "Atribuído à",
    filterAssignmentStatusLabel: "Status da atribuição",
    filterTaskReviewNoteStatusLabel: "Status da nota",
    filterTaskCommentStatusLabel: "Status das notas",
    filterTaskReviewNoteAssignedToLabel: "Atribuído à",
    filterTaskReviewNoteAuthoredByLabel: "Criado por",
    filterPICDocumentsAssociated: "Documentos de PIC associados",
    filterEQRDocumentsAssociated: "Documentos de EQR associados",
    missingSignOffs: "Ausência de assinaturas",
    signedOffBy: "Assinado por",
    notSignedOffBy: "Não assinado por",
    filterTimePhaseLabel: "Fase do tempo",
    filterMilestoneLabel: "Milestone",
    filterAuditPhaseLabel: "Fase da auditoria",
    filterEngagementPhaseLabel: "Fase do engagement",
    filterDocumentConflictsLabel: "Conflitos de documentos",
    filterEntitiesLabel: "Entidade",
    missingEntityDocuments: "Documentos de entidade ausentes",
    filterDownloadedForOfflineLabel: "Baixado para offline",
    filterNextwaveServicesLabel: "Serviços centralizados",
    filterServiceGateway: "Gateway de serviço",
    filterScheduledServicesLabel: "Serviços relacionados",
    filterSuggestedServicesLabel: "Serviços sugeridos",
    NoDocumentSignedOffLabel: "Nenhum documento assinado por",
    SomeDocumentSignedOffLabel: "Alguns documentos assinados por",
    AllDocumentSignedOffLabel: "Todos os documentos assinados por",
    usersLabel: "Membros da equipe",
    serviceRequests: "Serviços centralizados",
    backToMainPage: "Voltar para página principal",
    suggestedNextwaveRequests: "Solicitações centralizadas sugeridas",
    /* Component Send Status */
    deliveredDate: "Entregue: {0}",
    sentDate: "Enviado: {0}",
    sentFailure: "Ocorreu falha na entrega tente novamente e se o problema persistir entre em contato com o Help Desk.",
    chooseTaskInstructionLabel: "Escolha as tarefas a serem incluídas nesta solicitação",
    createSRstep2InstructionalTextPart1: "As tarefas que já estão incluídas em outra solicitação são rotuladas como",
    createSRstep2InstructionalTextPart2: ". Se você usou essa oferta de serviço antes, as tarefas que foram incluídas em sua solicitação de período anterior são rotuladas como",
    createSRstep2InstructionalTextPart3: "Use o botão abaixo para mostrar apenas as tarefas sugeridas.",
    availableTasksLabel: "Tarefas disponíveis",
    guidance: "Orientação atlas",
    helixAnalyzers: "Helix analyzers",
    eyHelix: "EY Helix",
    smartAutomationLinks: "Smart Automation",
    createAutomation: "Criar automação",
    noProjectTitle: "Vincular um projeto Helix",
    multipleProjectsTitle: "Selecione um projeto Helix vinculado",
    noProjectMessage: "Vincule um projeto Helix a este engagement para começar neste Helix analyzer.",
    multipleProjectsMessage: "Esse engagement está ligado a vários projetos do Helix. Selecione um projeto Helix na lista abaixo para prosseguir.",

    automationGuidanceHeader: "Automações sugeridas",
    helixAnalyzersHeader: "Analyzers sugeridos",
    linkToHelixLabel: "Link para o Helix",
    noSelectedTasksText: "Nenhuma tarefa foi selecionada ainda. Selecione uma tarefa para começar.",
    selectedTasksLabel: "Tarefas selecionadas",
    serviceOffering: "Oferta de serviços",
    submitRequest: "Enviar solicitação",
    scheduleYourRequest: "Agende seu pedido.",
    serviceRequestStep3HeaderText: "Selecione a data de início em que você gostaria que os recursos atribuídos começassem a trabalhar nessas tarefas. Em seguida, selecione a data em que essas tarefas devem ser concluídas.",
    serviceRequestMilestoneDueDateHeaderText1: "Selecione o",
    startanddue: "data de início e vencimento",
    eachmilestone: "para cada milestones.",
    serviceRequestMilestoneDueDateHeaderText2: "Sua equipe é a responsável final por todo o trabalho entregue. Portanto, a data de vencimento selecionada deve permitir tempo suficiente para sua equipe revisar o trabalho entregue.",
    serviceRequestMilestoneDueDateHeaderText3: "O tempo estimado para ser concluído deve incluir apenas o tempo que espera que o prestador de serviços incorre.",
    schedulerBudgetMainQuestion: "Tem a sua equipe de engagement:",
    schedulerBudgetFirstQuestion: "Incluiu todo o trabalho para este pedido nos seus processos financeiros, de preços e de planeamento?",
    schedulerBudgetSecondQuestion: "Notificou o seu Gestor de Experiências onshore sobre este pedido?",
    schedulerBudgetThirdQuestion: "Horário ajustado para membros da equipe onshore adequadamente?",
    timetocompleteinfo1: "O tempo estimado para concluir deve incluir apenas",
    timetocompleteinfo2: "tempo que você espera que o provedor de serviços incorra.",
    serviceRequestStartDate: "Começar",
    saveDraft: "Salvar rascunho",
    step3ValidationError: "A data de vencimento deve ser após a data de início",
    scheduledLabel: "Agendada",
    suggestedLabel: "Sugerida",
    searchTasksLabel: "Procurar tasks",
    submit: "Enviar",
    selectTaskRequiredErrorMessage: "Você deve selecionar pelo menos uma tarefa para continuar.",
    moveToCompleted: "Mover para concluído",
    requestResubmitMessagePart1: "O re-envio desta solicitação redefinirá o status para",
    requestResubmitMessagePart2: "Pendente.",
    requestResubmitMessagePart3: "Quaisquer alterações feitas serão revisadas pelo Agendador.",
    showSuggestedTaskToggle: "Apenas mostrar tarefas sugeridas",

    // Assignments
    addAssignmentName: "Adicionar nome de atribuição",
    editAssignmentName: "Editar o nome da atribuição",
    deleteAssignmentName: "Excluir o nome da atribuição",
    deleteAssignmentNameInstructionalTextHeader: "Tem certeza que deseja excluir esse nome da atribuição?",
    deleteAssignmentNameInstructionalText: "Uma vez excluída, a atribuição será removida de todos os membros da equipe e funções em seu engagement.",
    assignmentType: "Tipo de atribuição",
    assignmentTypeInstructionalText: "Selecione um tipo de atribuição e digite um nome abaixo. Clique <b>Add</b> quando terminar.",
    assignmentEditInstructionalText: "Edite o tipo de atribuição e o nome abaixo. Clique em <b>Salvar alterações</b> quando terminar.",
    noSuggestedTaskLabel: "Não há tarefas sugeridas nesta categoria.",
    manageAssignmentsLabel: "Gerenciar atribuições",
    myAssignmentsLabel: "Minhas tarefas",
    myAssignedTasks: "Minhas tarefas atribuídas",
    currentlyAssignedTasks: "Atualmente atribuído",
    assignmentModalInstructionalText1: "Para reatribuir ou remover tarefas atribuídas a um membro da equipe ou função, selecione seu nome abaixo. Você também pode usar o ícone <b>Deletar</b> para excluir todas as atribuições de um membro da equipe ou função. Para editar ou excluir o nome de uma atribuição, selecione o menu <b>Mais</b>.",
    unassignedTasks: "Tarefas não-assinadas",
    assignedTasks: "Tarefas atribuídas",
    type: "Tipo",
    priorperiodservicerequests: "Solicitações de serviços do período anterior",
    unmarkcomplete: "Desmarcar completo",
    taskAttributes: "Atributir tarefas",
    engagementTeam: "Equipe do engagement",
    assignTo: "Atribuir a",
    reAssignTo: "Reatribuir para",
    assign: "Atribuir",
    reAssign: "Reatribuir",
    reAssignWarningLabel: "Selecione uma ou mais tarefas para reatribuir.",
    assignWarningLabel: "Selecione uma ou mais tarefas para atribuir.",
    searchByTaskName: "Pesquisar pelo nome da tarefa",
    searchByTimePhaseName: "Pesquise pelo nome da fase de tempo",
    assignment: "Atribuição",
    noMembersWithThisAssignment: "Não há membros da equipe ou funções com esta atribuição.",
    deleteTaskAssingmentByMemberAndAssignmentIntructionalText: "A tarefa será removida de todas as tarefas do seu engagement.",
    noTaskAttributes: "Não há atributos para esta tarefa. Selecione Criar ou Relacionar para começar.",
    assignmentWithoutAssignedUser: "Este nome de atribuição não está em uso no momento.",

    // v2 profile navigation Zeus to Hercules to Kronos message
    v2ProfileDocumentIdAvailableMessage: "Coletando informações do perfil, por favor, espere",
    v2ProfileDocumentIdDeletedMessage: "Nenhuma informação de perfil foi encontrada. Atualize a página e tente novamente. se o erro persistir, entre em contato com o Help Desk.",
    accountAndRelatedAssertions: "Contas e assertivas relacionadas",
    risks: "Riscos",
    scotName: "Nome da SCOT",
    strategy: "Estratégia",
    transactionType: "Tipo de transação",
    notSelectedText: "Não selecionado",
    relatedBy: "Relacionado por",
    collaboration: "Colaboração",
    controlsLabel: "Controles",
    scotAndRelatedControls: "SCOT e controles relacionados",
    scotAndRelatedRisks: "SCOT e riscos relacionados a distorção material",
    frequencyLabel: "Freqüência",
    operatingEffectively: "Operando de forma eficaz",
    designedEffectively: "Desenhado de forma eficaz",
    timeToCompleteHours: "Prazo para completar (horas)",
    completeRequiredFieldValidationError: "Por favor, complete todos os campos necessários para prosseguir.",
    itgcsAndItsps: "ITGCs e ITSPs",
    itprocessItgcsAndItsps: "Processo de TI e ITGC/ITSPs",
    approachLabel: "Abordagem",
    typeLabel: "Tipo",
    itProcessName: "Nome do processo de TI",
    processEvaluation: "Avaliação de processos",
    unrelatedControls: "Controles não relacionados",
    disableNextwavePlaceholder: "Serviços centralizados não estão disponíveis no momento para o seu país. Atualize a página e tente novamente. Entre em contato com a Help Desk se o erro persistir.",
    disableNextwavePlaceholderDataCenter: "Os serviços centralizados não estão atualmente disponíveis para o seu centro de dados local. Atualize a página e tente novamente. Contate o help desk se o erro persistir.",
    dataPrivacyInviteMessage: "Antes de convidar, você já considerou adequadamente as restrições de acesso a documentos de trabalho que podem ser aplicados devido às regras de privacidade de dados?",
    //Session Timeout
    sessionTimerMsg: "Devido à inatividade, sua sessão de trabalho atual está prestes a expirar. Para sua segurança, as sessões do EY Canvas terminam automaticamente após 30 minutos de inatividade. Sua sessão atual expirará em {0} minutos. Se você deseja permanecer logado, clique em Continuar.",
    logout: "Logout",
    sessionPopupTitle: "Logout automático para sua proteção",
    allSuggestedTasks: "Tarefas",
    viewByAccount: "Exibir por conta",
    viewBySCOT: "Ver por SCOT",
    noServiceOfferingsAvailable: "Não há ofertas de serviço disponíveis para o seu engagement no momento. Atualize a página e tente novamente. Entre em contato com a Help Desk se o problema persistir.",

    //Collaboration
    myRequests: "Meus pedidos",
    allRequests: "Todos os pedidos",
    calendar: "Calendário",
    calendarTodayButton: "Hoje",
    requestsListButton: "Lista de solicitações",
    eventsButton: "Eventos",
    analyticsButton: "Análises",
    showAssignedToMe: "Mostrar minhas requisições",
    selectRequestsTitle: "Selecione solicitações para visualizar detalhes",
    selectRequestsSub1: "Para habilitar os controles em massa, use as caixas de seleção ou segure o",
    selectRequestsSub2: "shift ou chaves de controle enquanto seleciona várias solicitações.",
    noTagMessage: "Nenhuma tag criada ainda. Clique <b> aqui <b> para começar.",
    tagAs: "Tag como:",
    addTag: "Adicionar tag",
    searchTag: "Pesquisar tags",
    documentsAttached: "Documentos anexados",
    editDraftRequest: "Editar solicitação de rascunho",
    deleteRequest: "Apagar solicitação",
    deleteLabel: "Excluir",
    deleteLabelDisabled: "Permissões insuficientes para exclusão em massa. Entre em contato com o administrador do projeto e solicite permissão para excluir em massa.",
    DeleteRequestConfirmMsg1: "Tem certeza de que deseja excluir esta solicitação?",
    DeleteRequestConfirmMsg2: "Essa ação não pode ser desfeita.",
    deleteRequestSuccess: "O pedido foi deletado",
    DeleteRequestsConfirmMsg1: "Tem certeza de que deseja excluir essas {0} solicitações?",
    dueDateCollabLabel: "Data de Vencimento",
    requestLabel: "Solicitações",
    statusLabel: "Status",
    inValidRequestTitleLabel: "As seguintes solicitações não podem ser excluídas no status atual",
    bulkSendButton: "Mandar",
    bulkDeleteButton: "Excluir",
    commentSyncFailedRetry: "O comentário não pôde ser entregue ao EY Canvas Client Portal.",
    commentSyncFailedRetrySendAgain: "Envie novamente.",
    commentDeleted: "Esta mensagem foi apagada.",
    CommmentDeletionSyncFailed: "O comentário não pôde ser excluído do EY Canvas Client Portal",
    clickLabel: "Clique",
    toRetry: "para tentar novamente.",
    replySyncFailedRetry: "A resposta não pôde ser entregue no EY Canvas Client Portal.",
    quickFilterPriority: "Prioridade",
    quickFilterErrorCounterTooltip: "Uma ou mais solicitações têm um erro e requerem atenção.",

    eyContactNoResultsFound: "Usuário não encontrado",
    eyContactClear: "Resolvido",
    eyContactSearch: "Buscar",
    eyContactCollaboration: "Contato EY",
    eyParticipantsCollaboration: "Participantes da EY",
    externalParticipantsCollaboration: "Participantes externos",
    syncInProgressEYContact: "Sincronização em andamento",
    syncErrorEyContact: "Erro de sincronização. Por favor, tente novamente.",
    noAssignedContact: "Nenhum contato atribuído",
    noAssignedParticipant: "Nenhum participante adicionado",

    commentsTooltipLabel: "Comentários",
    recordingVirusScanInProgress1: "Verificação de vírus em andamento. A nota de voz estará disponível após a conclusão.",
    screenrecordVirusScanInProgress1: "Verificação de vírus em andamento. A gravação da tela estará disponível após a conclusão.",
    recordingVirusScanInProgress2: "Atualize a página e tente novamente.",
    confidentialDocumentsModalTitle: "Documentos confidenciais",
    confidentialDocumentsModalMsg1: "Os seguintes documentos confidenciais foram adicionados à solicitação.",
    confidentialDocumentsModalMsg2: "Ao clicar em Continuar, você confirma que possui o nível de confidencialidade apropriado para enviar o documento ao Portal do Cliente do EY Canvas e que revisou a atribuição da solicitação.",
    confidentialDocumentsModalMsg3: "Você não possui o nível de confidencialidade apropriado para enviar um ou mais desses documentos ao Portal do Cliente do EY Canvas. Remova todos os documentos confidenciais aos quais você não tem acesso para continuar.",
    confidentialityLevel: "Nível de confidencialidade",
    voiceNoteUploadError: "Erro ao obter detalhes do documento. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    requestEventTitle: "Evemto",
    noTaskDescription: "Sem descrição da tarefa",

    newRequestLabel: "Nova solicitação",
    newEventLabel: "Novo evento",

    //Analytics Tab
    analyticsCreateDateLabel: "Criar Data:",
    createdByLabel: "Criado por:",
    expirationDateLabel: "Data de validade:",
    sharedWithLabel1: "Compartilhado com",
    sharedWithLabel2: "solicitações",
    sharedWithLabel3: "solicitar",
    analyticsTabTitle: "Análises",
    analyticsTabSubtitle: "Compartilhe análises com clientes de projetos conectados do EY Helix. Para começar, crie uma consulta de cliente no painel de favoritos em",
    analyticsTabSubtitle2: "EY Helix",
    analyticsTabSubtitle3: '.',
    noActiveAnalyticsLabel: "Nenhuma análise selecionada",
    noActiveAnalyticsSubtitleLabel1: "Nenhuma análise foi criada. Clique",
    noActiveAnalyticsSubtitleLabel2: "aqui",
    noActiveAnalyticsSubtitleLabel3: "para começar.",
    noActiveAnalyticsSubtitleLabel4: "Depois de vincular um projeto e salvar os favoritos no EY Helix, volte a esta página para visualizar as análises que podem ser compartilhadas no EY Canvas Client Portal.",
    selectAnalyticsLabel: "Selecionar análise",
    analyticsNoPrimaryHelixProjectsMessage: "Este engagement não está vinculado a um Projeto Primário do EY Helix",
    selectAnalyticsModal: {
        closeTitleTip: "Fechar",
        modalTitle: "Selecionar análise",
        modalHeader: "Selecionar uma análise para compartilhar com membros externos da equipe",
        selectAnalyticPlaceholder: "Selecionar análise",
        selectAnalyticError: "Análise é necessária",
        analyticNamePlaceholder: "Insira o nome analítico (obrigatório)",
        analyticNameError: "O nome analítico é obrigatório",
        cancel: "Cancelar",
        viewPreview: "Visualizar analítico",
        noPreviewAvailable: "Nenhuma visualização disponível",
        noPreviewDescription: "Selecione um analisador para ativar a visualização",
        clickPreviewAnalytic: "Clique para visualizar a análise selecionada",
        documentObservation: {
            label: "Documente qualquer observação ou consulta sobre a análise selecionada",
            placeHolderLabel: "Insira observação ou consulta (opcional)"
        }
    },
    viewAnalyticsModal: {
        closeTitleTip: "Fechar",
        observationFieldPlaceholder: "Observações ou consultas sobre a análise selecionada",
        noObservationField: "Não existem observações ou consultas para esta análise.",
        appliedFiltersLabel: "Filtros aplicados",
        appliedFilters: [{
                id: '1',
                label: "Moeda de análise"
            },
            {
                id: '2',
                label: "Código da moeda"
            },
            {
                id: '3',
                label: "Exibir arredondamento"
            },
            {
                id: '4',
                label: "Grupo de unidades de negócios"
            },
            {
                id: '5',
                label: "Unidade de negócio"
            },
            {
                id: '6',
                label: "Tipo de conta principal"
            },
            {
                id: '7',
                label: "Subtipo de conta principal"
            },
            {
                id: '8',
                label: "Classe de conta principal"
            },
            {
                id: '9',
                label: "Subclasse de conta principal"
            },
            {
                id: '10',
                label: "Nome da conta principal"
            },
            {
                id: '11',
                label: "Designação de conta EY primária"
            },
            {
                id: '12',
                label: "Conta EY primária"
            },
            {
                id: '13',
                label: "Unidade de negócio"
            },
            {
                id: '14',
                label: "Data de análise"
            },
            {
                id: '15',
                label: "Data comparativa"
            },
            {
                id: '16',
                label: "Grupo segmento 01"
            },
            {
                id: '17',
                label: "Grupo segmento 02"
            },
            {
                id: '18',
                label: "Grupo segmento 03"
            },
            {
                id: '19',
                label: "Grupo segmento 04"
            },
            {
                id: '20',
                label: "Grupo segmento 05"
            }
        ],
        save: "Salvar",
        cancel: "Cancelar",
        disabledEdit: "A observação não pode ser editada porque a solicitação já foi enviada para o Portal do Cliente do EY Canvas. Retire a solicitação para habilitar esta ação.",
        errors: {
            unautorizedUser: "Você não é um membro autorizado da equipe do projeto EY Helix relacionado. Entre em contato com o administrador do projeto EY Helix para obter acesso e tente novamente.",
            bookmarkNotFound: "A análise selecionada foi excluída. Acesse EY Helix para gerenciar análises excluídas ou para criar uma nova análise.",
            unautorizedAccessToBookmark: "Você não tem acesso ao marcador EY Helix solicitado. Entre em contato com o administrador do projeto EY Helix para obter acesso e tente novamente.",
            authenticationError: "Erro de autenticação. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
            genericError: "Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
            defaultError: "{0} Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir."
        }
    },
    deleteAnalyticModal: {
        modalTitle: "Excluir analytic",
        modalHeader: "Tem certeza de que deseja excluir este analytic? O analytic não estará mais disponível no EY Canvas."
    },
    // activity feed
    search: "Pesquisar",
    searchTeams: "Pesquisar times",
    clear: "Limpar",
    groupActivityLabel: "Atividade em grupo",
    documents: "Documentos",
    documentLabel: "Documento",
    linkRequests: "Solicitações de link",
    received: "Recebido",
    returned: "Devolvido",
    rejected: "Rejeitado",
    accepted: "Aceito",
    sent: "Enviado",
    unlinked: "Desvinculado",
    finalized: "Finalizado",
    groupActivityFeed: "Feed de atividades do Grupo",
    component: "Componente",
    noExternalApprovalsMessage: "Não há aprovações externas",
    noFileSelectedMessage: "Selecione um documento para ver os detalhes",
    noInstructionSelectedMessage: "Selecione um item para visualizar detalhes.",
    noLinkRequestSelectedMessage: "Selecione um item para visualizar detalhes.",
    noItemSelectedMessage: "Selecione um item para ver os detalhes",
    viewGroupActivity: "Ver atividade do grupo",
    pointOfContact: "Ponto de contato",
    currentStatus: "Status atual",
    resolved: "Resolvido",
    viewVersion: "Ver versão",

    // activity feed right pane headings
    scope: "Scope",
    groupRole: "Tarefa do grupo",
    linkRequestStatus: "Status de solicitação de link",
    instructionStatus: "Status de instrução",
    linkStatus: "Status do link",
    today: "Hoje",
    yesterday: "Ontem",
    thisWeek: "Esta semana",
    lastWeek: "A semana passada",
    twoWeeksAgo: "Duas semanas atrás",
    threeWeeksAgo: "Três semanas atrás",
    lastMonth: "Mês passado",
    older: "Antigo",
    actionsDateNote: "Todas as datas e horários são informados no horário de GMT.",
    noActionsMessage: "Não há dados para exibir.",
    noManageRequestPermissionMessagePart1: "Você deve ter <b>Gerenciar solicitação de serviço</b> permissões para tomar esta ação.",
    guidedWorkflow: "Ativação do EY Canvas FIT",
    navExecution: "Execução",
    navCanvasEconomics: "EY Canvas Economics",
    navOversight: "Supervisão do EY Canvas",
    navConclusion: "Conclusão",
    navTeamMemberIndependence: "Independência do membro da equipe",
    navGroupAudit: "Gerenciamento de grupo",
    navGroupActivityFeed: "Feed de atividade de grupo",
    navPrimaryStatus: "Equipe primária",
    navComponentStatus: "Equipe componente",
    navGroupStatus: "Status do Grupo",
    navEngagementManagement: "Gestão do engagement",
    navProfile: "Perfil",
    navGroupStructureSummary: "Estrutura de grupo",
    OpenGuidedWorkflowDocument: "Abra este documento por meio da ativação do EY Canvas FIT",
    navNotApplicable: "Não é aplicável",
    canvasForms: "Canvas forms",
    eYCanvasEconomics: "Economia EY Canvas",
    overDueAssignments: "Atribuições atrasadas",
    comingDueAssignments: "Atribuições a vencer",
    overDueReviewNotes: "Notas de revisão atrasadas",
    comingDueReviewNotes: "Notas de revisão a vencer",

    //Group Audit/Status  for DashboardV2

    Reportingformsbystatus: "Formulários de relatório por status",
    ReportingStatusSubTitle: "Veja as tarefas do grupo atribuídas às equipes de componentes abaixo, bem como um resumo dos documentos do grupo recebidos por status. <br/> Você pode selecionar para revisar o progresso detalhado por equipe ou por tarefa de grupo.",

    Total: "Total",
    Returned: "Retornado",
    Overdue: "Atrasado",
    PendingResponse: "Resposta pendente",
    Received: "Recebido",
    ReadyForReview: "Pronto para revisão",
    messageNoDocument: "Nenhum documento recebido ainda.",
    byTeam: "Por equipe",
    byGroupTask: "Por tarefa em grupo",
    groupStructureLabel: "Estrutura do grupo",
    instructionPending: "Instruções pendentes de aceitação",
    linkRequestPending: "Solicitação de link pendente",
    notusingeycanvas: "Não usar EY Canvas",
    pendingLabel: "Pendente",
    teams: "Equipes",
    NoDocumentReceiced: "Nenhum documento recebido ainda.",
    selectTeamToSeeData: "Não há dados disponíveis. Selecione uma equipe para ver dados aqui.",
    noDataAvailable: "Não há dados disponíveis.",
    prepared: "Preparado",
    tasksAssigned: "Tarefas atribuídas",
    taskAssigned: "Tarefa atribuída",
    instructionNotSent: "Instruções não enviadas",
    assignedTeamNotProvidedDocForTasks: "\{0}\ equipes não enviaram documentos para essas tarefas | \{1}\ documentos esperados",
    documentRecievedOutOfAssignedTasks: "Documentos recebidos <br><b>\{0}\</b> de \{1}\ Tarefas atribuídas",
    documentRecievedOutOfAssignedTeams: "Documentos recebidos <br><b>\{0}\</b> de \{1}\ Equipes atribuídas",

    groupStatusSubTitle: "Veja abaixo as tarefas do grupo atribuídas pela equipe principal, bem como um resumo dos documentos do grupo por status. <br/> Você pode selecionar para filtrar as tarefas do grupo por tarefa ou status do documento.",
    notSent: "Não enviado",
    draftsent: "Rascunho enviado",
    finalsent: "Final enviado",
    noTaskForComponent: "Não há dados disponíveis. <p> As tarefas em grupo enviadas da equipe principal serão exibidas aqui depois de aceitas.</p>",
    noTaskForComponentWithStatus: "Não há dados disponíveis. <p> Selecione uma ou mais opções de status para ver dados aqui.</p>",

    //Dashboard V2 - activity feed
    activityFeedSubHeadingText: "Selecione um tipo de atividade para revisar a atividade do engagements relevante nos últimos 10 dias. <br/> Clique no ícone <b>Atividade</b> de um item específico para visualizar todas as atividades desse item. <br/> Você também pode usar a alternância para refinar sua visualização.",
    activityFeedSubHeadingGroupAudit: "Selecione um tipo de atividade para revisar a atividade do engagements relevante nos últimos 10 dias. <br/> Clique no ícone <b>Atividade</b> de um item específico para visualizar todas as atividades desse item. <br/> Você também pode usar a alternância para refinar sua visualização.",
    teamHistoryInstructionalText: "Revise a atividade desta equipe nos últimos 10 dias.",
    teamHistory: "Histórico da equipe",
    onlySeeMyActivity: "Ver apenas minha atividade",

    taskAddedBy: "Tarefa adicionada por",
    taskMarkedCompleteBy: "Tarefa marcada como concluída por",
    taskUnmarkedCompleteBy: "Tarefa desmarcada como concluída por",
    taskHandedOffBy: "Tarefa entregue por",
    assignmentAddedBy: "Atribuição adicionada por",
    assignmentEditedBy: "Tarefa editada por",
    assignmentClosedBy: "Atribuição encerrada por",
    assignmentReOpenedBy: "Atribuição reaberta por",
    assignmentDeletedBy: "Atribuição excluída por",
    noteAddedBy: "Nota adicionada por",
    noteClearedBy: "Nota apagada por",
    noteClosedBy: "Nota fechada por",
    noteReopenedBy: "Nota reaberta por",

    linkRequestSent: "Solicitação de link enviado por",
    instructionSentBy: "Instruções enviadas por",
    linkRequestAcceptedBy: "Solicitação de link aceita por",
    engagementUnlinkedBy: "Engagement o desvinculado por",
    instructionAcceptedBy: "Instruções aceitas por",
    instructionReturnedBy: "Instruções retornadas por,",
    labelTo: "para",
    instructionReceivedFrom: "Instruções recebidas de",
    filtersLabel: "Filtros",
    advanceOptions: "Operações em massa",
    advanceOptionsLabel: "Operações em massa",
    relatedScots: "SCOTs relacionadas",
    noRelatedScots: "Nenhuma SCOT relacionada",
    materialityLabel: "Materialidade",
    currentPeriod: "Data atual",
    previousPeriod: "Data anterior",
    showCurrentPeriod: "Mostrar data atual",
    showPriorPeriod: "Mostrar data anterior",
    planningMateriality: "Materialidade planejada",
    tolerableError: "Erro tolerável",
    sadNominalAmount: "Valor nominal do SAD",
    pmLabel: "MP",
    teLabel: "ET",
    sadLabel: "SAD",
    accountBalance: "Saldo da conta",
    mapAccountBalances: "Mapear saldos de contas",
    connectToHelixProject: "Conecte-se a um projeto do Helix",
    connectToImportBalances: "importar saldos",
    helixMultiple: "Múltiplo",
    selectMESTentity: "Selecione uma entidade para ver detalhes",
    relatedWCGWAndControls: "WCGWs e controles relacionados",
    relateAtLeastOneWCGW: "Cada assertiva com risco de Confiança em controle deve ter pelo menos um WCGW relacionado.",
    notRelyRelateWCGW: 'Assertions with a control risk of Not Rely do not have a requirement to identify a WCGW.',
    relatedITProcesses: "Processos de TI relacionados",
    noRelatedITProcesses: "Nenhum processo de TI relacionado",
    relatedITRiskITGCs: "Riscos de TI relacionados, ITGCs e ITSPs",
    relatedITRisks: "Riscos de TI relacionados",
    ALRAHigherRiskCode: "H",
    materialityMestSelectEntity: "Selecione uma entidade para ver detalhes",
    OARCurrentPeriod: "Data de análise",
    OARComparative1Period: "Data comparativa 1",
    xTELabel: "xET",
    priorPeriodDesignation: "Designação de período anterior:",
    priorPeriodEstimate: "Estimativa do período anterior:",
    notApplicableAbbreviation: "N/A",
    accountDetails: "Detalhes da conta",
    launchGuidedWorkflow: "Iniciar fluxo de trabalho guiado",
    guidedWorkflowTitle: 'Guided workflow',
    viewAccountBalace: "Ver saldos de contas",
    viewAccountBalaceForEntity: "Selecione uma entidade para visualizar os saldos das contas",
    mainActivities: "Atividades principais",
    oversightProjectTile: {
        typeOversight: "oversight",
        createProject: "Criar projeto",
        oversightProjectengagementNotConnectedMessage1: "O aplicativo EY Canvas Oversight resume o progresso do milestone, gerenciamento de projetos e auditoria de grupo para engagements conectados. Use-o para garantir que a auditoria do grupo ou o portfólio do engagement esteja no caminho certo.",
        oversightProjectengagementNotConnectedMessage2: "Seu engagement não está conectado a nenhum projeto do EY Canvas Oversight.",
        click: "Clique",
        togetstarted: "para começar",
        clickProjectmessage: "Clique <b>+ Criar projeto </b> para começar.",
        lblclient: "Clientes:",
        lblEngagementCount: "Engagements:",
        lblTaskscompleted: "Tarefas concluídas:",
        lblMore: "mais",
        myProject: "Meus projetos",
        OtherProject: "Outros projetos",
        oversightNoProjectConnectedMessage: "Você não é membro de nenhum dos projetos do EY Canvas Oversight aos seus engagements.",
        oversightOtherProjectNotConnectedMessage: "Você é membro de todos os projetos do EY Canvas Oversight aos anúncios que seu engagement está conectado.",
        draft: "Rascunho",
        allTask: "Toda a tarefa",
        totalTask: "Tarefa Total"
    },

    economicsProjectTile: {
        typeEconomics: "economics",
        economicsProjectengagementNotConnectedMessage1: "O aplicativo EY Canvas Economics resume o progresso financeiro e do EY Canvas. Use-o para gerenciar a economia de seu portfólio de compromissos.",
        economicsProjectengagementNotConnectedMessage2: "Seu engagement  não está conectado a nenhum projeto de economics do  EY Canvas.",
        clickProjectmessage: "Clique <b>+ Criar projeto </b> para começar.",
        economicsNoProjectConnectedMessage: "Você não é membro de nenhum dos projetos da EY Canvas Economics aos quais seu envolvimento está conectado.",
        lblForecasted: "Previsto:",
        lblActual: "Atual:",
        lblETC: "ETC:",
        lblVariance: "Variação"
    },
    leftNavigation: {

        engagementOverview: "Visão geral do engagement",
        myProgress: "Meu progresso",
        executiveTasks: "Áreas de foco",
        integration: "Integração",
        groupAudit: "Status do grupo",
        pinnedDocuments: "Documentos fixados",
        Validations: "Validações",
        activityFeed: "Feed de atividade",
        primaryStatus: "Status principal",
        componentStatus: "Status do componente",
        picProgress: "Progresso PIC",
        picEQRProgress: "Progresso PIC/EQR",
        drillDown: "Detalhamento",
        maps: "Mapas",
        financialStatement: "Demonstrações financeiras"
    },
    nowRowOverlayClientRequest: {
        createNew: "Clique em Adicionar pedido para criar um novo pedido",
        all: "Nenhum pedido foi criado",
        draft: "Nenhuma solicitação está no status de Draft",
        pending: "Nenhuma solicitação está com status de resposta pendente",
        received: "Nenhum pedido foi recebido",
        accepted: "Nenhum pedido foi aceito",
        customFilter: "Nenhuma equivalência encontrada. Por favor, tente novamente."
    },

    clientRequestPrefixes: {
        draft: "Rascunho",
        returned: "Devolvido",
        recalled: "Recuperado",
        withdrawn: "Retirado"
    },

    clientRequestsTabHeader: {
        all: "Todos",
        draft: "Rascunho",
        pending: "Pendente",
        received: "Recebido",
        accepted: "Aceito"
    },

    clientRequestsPriorityFilters: {
        all: "Todos",
        normal: "Normal",
        high: "Alto",
        critical: "Crítico",
        highAndCritical: "Alto + Crítico"
    },

    requestTableHeader: {
        requestId: "ID do pedido",
        title: "Título",
        receivedDate: "Data de recebimento",
        dueDate: "Data de vencimento",
        sentDate: "Data de envio",
        acceptedDate: "Data aceita",
        assignedTo: "Atribuído a",
        group: "Grupo",
        status: "Status",
        priorityType: "Prioridade",
        tags: "Etiquetas"
    },

    dropdownColumnsFilter: {
        1: "Atribuído a",
        2: "Grupo",
        3: "Data de vencimento",
        4: "Data de envio",
        5: "Data de recebimento",
        6: "Data aceita",
        7: "Status",
        8: "Prioridade",
        9: "Etiquetas"
    },

    requestTableDropdownFilter: {
        customizeTable: "Personalizar tabela",
        selectInfo: "Selecione até 4 opções",
        selectInfoTooltip: "Selecione até quatro colunas. Desmarque uma ou mais opções para continuar."
    },

    ClientStatus: {
        1: "Rascunho",
        2: "Rascunho - Sem contato",
        3: "Enviado",
        4: "Erro no sistema",
        5: "Contato de cliente inválido",
        6: "Resposta pendente",
        7: "Recebido",
        8: "Aceitado",
        9: "Retornado",
        10: "Retirado",
        11: "Envio em andamento",
        12: "Aceite em andamento",
        13: "Retirada em andamento",
        14: "Exclusão em andamento",
        15: "Retorno em andamento",
        16: "Resposta em andamento",
        17: "Deletado",
        18: "Contato de cliente inválido",
        19: "Retirada em trânsito",
        20: "Recuperado",
        21: "Conclusão em andamento",
        22: "Retirada em andamento"
    },

    analyticStatus: {
        1: "Rascunho",
        2: "Pendente aprovação",
        3: "Aprovado",
        4: "Expirado"
    },

    paginationControl: {
        firstPage: "Primeira página",
        lastPage: "Última página",
        previousPage: "Página anterior",
        nextPage: "Próxima página",
		show: "Mostrar"
    },

    auditPlanFilterLabels: {
        showMore: "mais",
        filterTypeOfScots: "SCOT",
        noScotsAvailable: "Nenhuma SCOT disponível",
        filterTypeOfITProcess: "Processo de TI",
		noITProcessAvailable: "Nenhum processo de TI disponível"
    },

    controlListBuildStep4FilterLabels: {
        scots: {
            filterTypeOfScots: "SCOTs",
			noScotsAvailable: "'Nenhuma SCOT disponível"
        },
        testing: {
            filterTypeOfTesting: "Teste",
			noTestingAvailable: "Nenhum teste disponível"
        },
        designEffectiveness: {
            filterTypeOfDesignEffectiveness: "Efetividade do desenho",
			noDesignEffectivenessAvailable: "Nenhuma efitividade do desenho disponível"
        },
    },

    clientRequestsFilterLabels: {
        filterAssignedTo: "Atribuído a",
        filterAttachmentsLabel: "Tipo de anexo",
        filterCreatedByLabel: "Criado por",
        filterStatusLabel: "Status",
        filterDueAfterLabel: "Vencido depois de",
        filterDueBeforeLabel: "Vencido antes",
        filterErrorsLabel: "Erros",
        filterOverdueLabel: "Atrasado",
        filterTagLabel: "Tag",
        filterTimePhaseLabel: "Time Phase",
        filterTypeLabel: "Tipo",
        filterPriorityLabel: "Prioridade",
        searchMembers: "Pesquisar membros",
        noTags: "Nenhuma tag foi criada",
        noTimephase: "Sem Time Phase",
        clearAll: "Apagar tudo",
        clearHoverText: "Claro",
        noResultsFound: "Nenhum resultado encontrado",
        yes: "Sim",
        no: "Não",
        showMore: "Mostre mais",
        // Check this
        filterNoMatchesFound: "Nenhuma equivalência encontrada. Por favor, tente novamente.",
        filter: "Filtro",
        title: "Filtros",
        noRelatedTask: "Nenhuma tarefa relacionada",
    },
    //Dashboard - integration

    collaborationInstruction: "Veja suas solicitações de colaboração por status abaixo. <br/> Clique em uma contagem para navegar até a lista de solicitações com filtros aplicados.",
    noValidationsAvailable: "Não há validações para esta fase de auditoria.",
    individualView: "Visão individual",
    engagementView: "Exibição do engagement",
    centralizedServiceInstruction: "Veja a porcentagem de tarefas que estão aproveitando os Serviços Centralizados, bem como as solicitações por status abaixo. <section >Para criar uma nova solicitação, selecione <b>Solicitar serviços.</b></section>",
    // Dashboard - todo list
    todoList: "Lista de tarefas",
    todoListInProgress: "Atual",
    todoListOpen: "Por vir",
    todoListClosed: "Concluído",
    todoListInstruction: "Visualize as atribuições e revise notas a vencer por status. <br /> Selecione um período ou categoria para refinar sua visualização. <br /> Para abrir um item, clique no nome da tarefa ou da nota de revisão.",
    noOpenAssignments: "Você não tem nenhuma atribuição em aberto.",
    noInProgressAssignments: "Você não tem nenhuma atribuição em andamento.",
    noClosedAssignments: "Você não tem nenhuma atribuição fechada.",
    allLabel: "Todo",
    dueLabel: "Vencimento",
    noAssignments: "Você não tem nenhuma atribuição.",
    executiveReview: "Revisão executiva",
    epTasksStatusSignOffWithoutDetails: "Veja um resumo do status do PIC abaixo.",
    epTasksStatusSignOff: "Veja um resumo do status do PIC abaixo. Para uma visão detalhada, selecione <b>Ver detalhes</b>.",
    epeqrTasksStatusSignOffWithoutDetails: "Veja um resumo do status de PIC e EQR abaixo.",
    epeqrTasksStatusSignOff: "Veja um resumo do status de PIC e EQR abaixo. Para uma visão detalhada, selecione <b>Ver detalhes</b>.",
    eqrDefaultMessage: "Este projeto não requer um EQR.",
    selectPartners: "Selecione um sócio",
    noPartnersInEng: "Não há sócios em seu engagement.",
    epTasks: "Tarefas de PIC",
    eqrTasks: "Tarefas de EQR",
    viewDetails: "Ver detalhes",
    picReview: "Revisão de PIC",
    eqrReview: "Revisão de EQR",
    eqrtasksWithSignOff: "Tarefas com assinaturas de EQR <br/> incompletas",
    eqrdocumentsWithSignOff: "Documentos com assinaturas de EQR <br/> incompletos",
    pictasksWithSignOff: "Tarefas com assinaturas de PIC <br/> incompletas",
    picdocumentsWithSignOff: "Documentos com assinaturas de PIC <br/> incompletos",
    partnerSignoffs: "Aprovações de sócios",
    epTaskswithpartnersignoffs: "Clique em uma contagem para navegar até a lista de tarefas com filtros aplicados.",
    allDocssignedoff: "Todos os documentos <br/>assinados",
    someDocssignedoff: "Alguns documentos <br/>assinados",
    noDocssignedoff: "Sem documentos <br/>assinados",
    partnernotinvited: "Sócio não convidado",
    noEQRsinyourengagement: "Não há EQRs em seu engagement.",
    selectEQRs: "Selecione um EQR",
    eqrNotinvited: "EQR não convidado",
    eqrsignoffs: "Aprovações do EQR",
    eqrtaskswithpartnersignoffs: "Clique em uma contagem para navegar até a lista de tarefas com filtros aplicados.",
    allpartners: "Todos os sócios",
    allEQRs: "Todos os EQRs",
    reviewComments: "Revisar notas",
    noOpenReviewComments: "Você não tem nenhuma nota de revisão aberta.",
    noClearedReviewComments: "Você não tem notas de revisão liberadas.",
    noClosedReviewComments: "Você não tem notas de revisão fechadas.",
    noReviewCommentsForSelectedTime: "Você não tem notas de revisão para o período de tempo selecionado. Selecione outro período de tempo para continuar.",
    picTasksSomeDocSignOff: "Tarefas com alguns documentos assinados pelo PIC",
    picTasksNoDocSignOff: "Tarefas sem documentos assinados pelo PIC",
    eqrTasksSomeDocSignOff: "Tarefas com alguns documentos assinados pelo EQR",
    eqrTasksNoDocSignOff: "Tarefas sem documentos assinados pelo EQR",
    picNotIdentified: "Nenhum PIC foi identificado",
    eqrNotIndentified: "Nenhum EQR foi identificado",
    todoReviewNote: "Nota de revisão",

    // Dashboard - Executive Tasks
    executiveTasks: "Áreas de foco",
    executiveTasksInstruction: "Selecione para visualizar as tarefas por risco ou por conta abaixo. <br/> Depois de fazer sua seleção, passe o mouse sobre uma contagem para ver mais detalhes ou selecione uma tarefa para navegar até sua página de detalhes específica.",
    byRisk: "Por risco",
    byAccount: "Por conta",
    responsiveTasks: "Tarefas relacionadas",
    openNotes: "Abrir notas",
    lowLabel: "Baixo",
    mediumLabel: "Médio",
    highLabel: "Alto",
    criticalLabel: "Crítico",
    epRequired: "PIC requerido",
    eqrRequired: "EQR necessário",
    noDocumentsSignedOff: "Nenhum documento assinado",
    someDocumentsSignedOff: "Alguns documentos assinados",
    allDocumentsSignedOff: "Todos os documentos assinados",
    completedAssignments: "Atribuições concluídas",
    designation: "Designação",
    significantAccount: "Conta significativa",
    epSignOff: "Assinatura de PIC",
    eqrSignOff: "Aprovação do EQR",
    someLabel: "Algum",
    riskNoDataLabel: "Este risco não está relacionado a nenhuma tarefa.",
    accountNoDataLabel: "Esta conta e suas assertivas não foram relacionadas a nenhuma tarefa.",
    NoDataLabel: "Não há dados disponíveis para o acordeão selecionado",
    // Manage tags
    manageTagsInstructionalText: "Crie novas tags aqui. Você também pode editar e excluir tags existentes. Solicitações de marcação podem melhorar a organização do seu engagement e a gestão de projetos.',",
    noTagsAdded: "Sem tags adicionadas. Crie uma tag para começar.",

    // Client Request Comments
    noCommentsCreatedYet: "Nenhum comentário foi criado ainda.",
    addCommentTitleTip: "Adicionar comentário",
    addReplyTitleTip: "Adicionar resposta",
    addAComment: "Deixe um comentário…",
    addAReply: "Adicionar uma resposta",
    deleteCommentConfirmationModalTitle: "Excluir comentário",
    deleteCommentConfirmationModalMessage: "Tem certeza de que deseja excluir este comentário? Todas as respostas deste comentário também serão excluídas.",

    // Client Request Voice Note Comment Labels
    voiceNoteCommentRecordLabel: "Nota de voz",
    voiceNoteCommentStopLabel: "Parar",
    voiceNoteCommentPlayLabel: "Iniciar",
    voiceNoteCommentDeleteLabel: "Excluir",

    //Client Request Status/Tooltip messages
    SendRequestSuccess: "A solicitação foi submetida com sucesso",
    BulkSendRequestSuccess: "{0} solicitações foram enviados com sucesso",
    BulkSendOneRequestSuccess: "1 solicitação foi enviada com sucesso",
    SendInProgress: "Envio em andamento",
    AcceptInProgress: "Aceitar em andamento",
    CompleteInProgress: "Concluído em andamento",
    HasErrorState: "O pedido não pôde ser enviado. Por favor, tente de novo.",
    WithdrawRequestSuccess: "A solicitação foi retirada.",
    WithdrawInProgress: "Withdraw em andamento",
    WithdrawRequestError: "A solicitação não pôde ser retirada, por favor tente novamente.",
    DeleteRequestError: "A solicitação não pôde ser excluída. Atualize a página e tente novamente.",
    AcceptRequestError: "Não foi possível aceitar a solicitação, tente novamente.",
    CompleteRequestError: "Não foi possível concluir a solicitação, tente novamente.",
    InvalidClientContact: "Contato de cliente inválido.",
    BulkSendInvalid: "Uma ou mais solicitações selecionadas não podem ser enviadas sem que outras ações sejam tomadas. Por favor revise e tente novamente.",
    returnInProgress: "Retorno em andamento",
    returnRequestError: "Não foi possível retornar a solicitação. Por favor tente novamente",

    //Client Withdraw Request
    WithdrawRequest: "Pedido de retirada",
    WithdrawReuestConfirmMsg: "Tem certeza que quer retirar esta solicitação? Uma vez retirada, o cliente não pode mais visualizá-la. A solicitação passará para a lista de rascunhos uma vez concluída",
    WithdrawMenuOption: "Retirar",
    MoreOptions: "Mais opções",
    Complete: "Completar",
    WithdrawLabel: "Retirado",
    CompleteInstructionalText: "Use complete quando as informações já foram fornecidas pelo cliente",

    //Client Complete Request
    CompleteRequestConfirmMsg: "A conclusão de uma solicitação remove a solicitação da lista de tarefas do cliente e atualiza o status para Enviado para o cliente. A solicitação será movida para a lista Recebidos no EY Canvas. Pode ser utilizado, por exemplo, quando a informação solicitada já tiver sido recebida por meios alternativos.",
    CompleteRequest: "Solicitação completa",
    CompleteRequestSuccess: "A solicitação foi concluída",

    //Client Accept Return Request
    AcceptLabel: "Aceitar",
    ReturnLabel: "Retornar",
    ReturnRequest: "Solicitação de devolução",
    acceptRequest: "Aceitar solicitação",
    acceptRequestWithoutTask: "Tem certeza de que deseja aceitar a solicitação selecionada?",
    acceptRequestWithTask: "<b>Tem certeza de que deseja aceitar a solicitação selecionada?</b> Os documentos anexados estarão disponíveis na guia de documentos externos das {0} tarefas relacionadas.",
    acceptRequestSuccess: "A solicitação foi aceita",
    returnedRequestSuccess: "A solicitação foi devolvida -",

    // Client Request Relate Files modal
    noRecordsFound: "Nenhum registro encontrado",
    relateSelected: "Relate selecionado",
    relateFilesModalHeader: "Para relacionar os documentos existentes a esta solicitação, selecione os documentos e clique em Relacionar selecionados.",
    relateAnalyticModalHeader: "Para relacionar análises existentes a esta solicitação, marque a opção da análise selecionada. Para visualizar outras análises disponíveis, clique",
    relateAnalyticHereModalHeader: "aqui",
    noAnalyticsRecordsFound: "Não há análises disponíveis para compartilhar. Clique",
    noAnalyticsRecordsFoundGetStarted: "para começar.",
    associateExistingDocumentsSelected: "documentos adicionados",
    associateExistingDocumentSelected: "documento adicionado",

    // Client Request Details Header
    timePhaseLabel: "Time phase:",
    receivedDateLabel: "Recebido:",
    dueDateLabel: "Vencimento:",
    sentDateLabel: "Enviado:",
    acceptedDateLabel: "Aceitado:",
    clientRequestSyncLabel: "Atualizações estão sendo enviadas para o EY Canvas Client Portal",
    editDescriptionLabel: "Edite a Descrição",
    createdDateLabel: "Criado:",

    //Client Advance Search
    advancedSearch: "Busca Avançada",
    advancedSearchRefereceNumberCheck: "Referência #",
    advancedSearchTitleCheck: "Título",
    advancedSearchDocumentsCheck: "Documentos",
    advancedSearchCommentsCheck: "Comentários",
    advancedSearchApplyButton: "Aplicar",
    searchRequest: "Procurar",
    clearSearch: "Limpar pesquisa",

    //Adjustment Topup module
    adjustmentModule: {
        currencyType: "Tipo de moeda",
        currencyCode: "Código da moeda",
        businessUnit: "Unidade de negócios",
        all: "Todos",
        moduleName: "Módulo de ajuste",
        financialStatement: "Demonstrações financeiras",
        viewByTrialBalanceType: "Visualizar por tipo de balancete",
        multiEntry: "Multi-entidade",
        balanceSheet: "Balanço patrimonial",
        incomeStatement: "Demonstração do resultado",
        currentperiodUnadjusted: "Analysis date",
        unadjusted: "(não ajustado)",
        currentperiodAdjusted: "Analysis date",
        adjusted: "(ajustado)",
        adjustment: "Ajuste",
        newAdjustment: "Novo ajuste",
        noRecordsFound: "Nenhum registro encontrado",
        periodEnded: " data de término",
        periodsEnded: " datas terminadas",
        noResultsFound: "Nenhum resultado encontrado",
        notApplicableAbbreviation: "N/A",
        noAdjustmentCreated: "Nenhum ajuste criado.",
        createAdjustment: "Crie um {0}.",
        next: "Próxima página",
        previous: "Página anterior",
        reclassification: "Reclassificação",
        manageAdjustment: "Gerenciar ajustes",
        lastPage: "Última página",
        firstPage: "Primeira página",
        filterYes: "Sim",
        filterNo: "Não",
        showOnlyAdjustedAccountClasses: "Mostrar apenas classes de contas ajustadas",
        noneAvailable: "Nenhum disponível",
        noImportedTrialbalanceAvailable: "Nenhum balancete de verificação importado.",
        trialBalanceRequired: "Balancete",
        comparativeperiodUnadjusted: "Data comparativa",
        comparativeperiodAdjusted: "Data comparativa",
        multityEntityRequired: "Multi-entidade",
        placeHolderMessageWhenHelixMappingIsTrue: "Nenhum balancete de verificação importado. Clique em {0} para relacionar um novo analyzer.",
        placeHolderMessageWhenHelixMappingIsFalse: "A integração com o EY Helix não está disponível. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
        eyHelixIntegrationLinkText: "Conexões do EY Helix",
        noEntitiesAvailablePlaceholder: "Nenhuma entidade criada. Crie entidades para começar.",
        search: "Procurar",
        viewAdjustmentWithValidations: "Visualizar ajustes com validações ({0})",
    },

    misstatementLabels: {
        name: "Nome",
        notes: "Notas",
        signOffs: "Assinaturas",
        open: "Abrir",
        openReadOnly: "Abrir somente leitura",
        delete: "Excluir",
        rename: "Renomear",
        signOffRequirements: "Requisitos de aprovação",
        confidentiality: "Confidencialidade",
        unlink: "Desvincular",
        removeFromAdjustment: "Remover do ajuste"
    },

    allControls: "Todos os controles",
    //Client Request Document labels
    clientRequestDocuments: {
        externalDocuments: "Externo",
        taskDocuments: "Documentos",
        deletedDocuments: "Deletado",
        priorPeriodDocuments: "Ano passado",
        priorPeriodInfoMessage: "Estes documentos não podem ser baixados",
        uploadedBy: "Carregado por",
        deletedBy: "Deletado por",
        lastModifiedBy: "Última modificação por",
        eyBadge: "Excluído dos Documentos",
        externalBadge: "Excluído do Externo",
        uploadInProgress: "Carregamento em andamento",
        refreshdocuments: "Atualizar documentos",
        disabledDocument: "Operações em massa não são permitidas para este tipo de documento.",
        menuOptions: {
            delete: "Deletado",
            open: "Aberto",
            openr: "Aberto somente leitura",
            restore: "Restaurar",
            remove: "Remover",
            rename: "Renomear",
            editInHelix: "Editar no EY Helix"
        },
        externalPriorPeriod: "Cliente",
        eyPriorPeriod: "EY",
        uploadedByEY: "EY"
    },

    //Client Request Assigned To Errors
    clientRequestAssignedToErrorLabel: "Usuário ou grupo atribuído não é válido. Atualize a tarefa para continuar. Clique",
    clientRequestAssignedToErrorLabelEnd: "para editar membros da equipe externa.",
    clickHereLabel: "aqui",
    clientRequestAssignedToIconErrorLabel: "O grupo designado não tem membros ativos. Atribua a solicitação a um usuário/grupo ativo ou adicione membros ao grupo para continuar.",
    clientRequestDueDateErrorLabel: "A data de vencimento é obrigatória. Atualize a data de vencimento para continuar.",

	clientRequestDocumentsNoDocsFound: [{
		id: 'externalDocuments',
		label: "Nenhum documento externo adicionado"
	},
	{
		id: 'taskDocuments',
		label: "Arraste e solte um ou mais documentos ou clique em Adicionar documento"
	},
	{
		id: 'deletedDocuments',
		label: "Nenhum documento foi excluído."
	},
	{
		id: 'searchRequestDocuments',
		label: "Nenhuma correspondência encontrada, tente novamente"
	},
	{
		id: 'priorPeriodDocuments',
		label: "Não há documentos do ano anterior disponíveis"
	}
	],

    liveNotifications: {
        "ey.at.hercules.annotation.created": "Anotação criada",
        "ey.at.hercules.annotation.edited": "Anotação editada",
        "ey.at.hercules.annotation.replied": "Anotação respondida",
        "ey.at.hercules.contentupdate.updated": "Conteúdo atualizado",
        "ey.at.hercules.contentupdate.failed": "Falha na atualização do conteúdo"
    },

    //Assign to
    usersOption: "Usuários",
    externalUsersOption: "Usuários externos",
    groupsOption: "Grupos",
    lblassignedto: "Atribuído a",
    searchGroup: "Pesquisar grupo",
    requiredAssignedTo: "Atribuído a é obrigatório",
    rdSubmitRequest: "Enviar pedido",

    closeDrawer: "Fechar e desmarcar tudo",
    requestSelected: "solicitação selecionada",
    requestsSelected: "solicitações selecionadas",
    //GA Scopes labels
    engagementScopesAndCustomSubScopes: "Escopos do engagement e sub-escopos personalizados",
    defineGroupScopes: "Definir escopos de grupo",
    gaScopeIntro: "Escopos de projetos pelo EY GAM estão incluídos aqui de forma padrão. Se você precisar personalizar as tarefas e instruções de grupo para equipes que compartilham o mesmo escopo, considere a criação de um sub-escopo. Quando enviar instruções, você poderá enviar versões diferentes para cada sub-escopo.",
    addSubScope: "Adicionar sub-escopo",
    customSubScope: "Subseção personalizada",
    noCustomSubscopes1: "Não há subs-escopos personalizados para o escopo deste engagement.",
    noCustomSubscopes2: "Selecione <b>Adicionar sub-escopo<b> para começar.",
    subScopeName: "Nome do sub-escopo",
    addDescription: "Adicionar descrição",
    textExceedsLength500: "O texto não pode exceder 500 caracteres.",
    manageGroupPermission: "Você deve ter a permissão <b> Administrar grupo </b> para tomar esta ação. Fale com um administrador do Engagement para solicitar permissão.",
    deleteCustomSubScope: "Exclua o sub-escopo personalizado",
    areYouSureDeleteCustomSubScope: "Tem certeza de que deseja excluir este sub-escopo personalizado?",

    //GA Component labels
    newTeam: "Nova equipe",
    teamName: "Nome da equipe",
    legalEntityName: "Nome de pessoa jurídica",
    parentTeam: "Equipe primária",
    isReferenceOnly: "Somente referência",
    isNotUsingCanvas: "Equipe não está usando EY Canvas",

    referenceOnlyTooltip: "As equipes designadas como <b> Somente referência </b> não receberão solicitações de links, instruções ou tarefas. Eles são usados apenas para fins organizacionais.",

    canvasFormNotOwnedByEng: "Formulários compartilhados do Canvas que não pertencem a este engagement não podem ser enviados ao EY Canvas Client Portal. Faça uma cópia do formulário neste contrato se você precisar enviá-lo ou enviá-lo a partir do engagement de origem.",
    canvasFormNotAllowedInCtry: "O compartilhamento de formulários do Canvas com clientes não está disponível em seu país.",
    on: "em",
    sendRequest: "Enviar solicitação",
    selectUserOrGroup: "Selecione usuário ou grupo",
    canvasFormShowAttachments: "Mostrar {0} anexos",
    canvasFormShowOneAttachment: "Mostrar 1 anexo",
    canvasFormHideAttachments: "Ocultar {0} anexos",
    canvasFormHideOneAttachment: "Ocultar 1 anexo",

    //GA Components
    createGroupStructure: "Criar estrutura de grupo",
    componentText: "Crie regiões e componentes para cada equipe do projeto que enviará os formulários por meio do EY Canvas. Você tem a opção de designar equipes como <b>Não usando o EY Canvas</b> se eles não enviarem formulários por meio do EY Canvas. Você também pode criar equipes para fins organizacionais e designá-las como <b>Somente para referência</b>. Essas equipes não receberão solicitações de links, instruções ou tarefas. Quando terminar, selecione <b>Enviar solicitações de link</b>.",
    addTeam: "Adicionar equipe",
    sendLinkRequests: "Enviar solicitações de link",
    noComponents: "Nenhuma equipe foi criada ainda.  Selecione <b>A equipe <b> para começar.",
    editTeam: "Editar equipe",
    deleteTeam: "Excluir equipe",
    deleteInstructional: "Tem certeza de que deseja excluir esta equipe? <br/><br/> O link para esta equipe será quebrado e seus engagements não poderão mais trocar documentação. Além disso, todas as instruções e tarefas personalizadas atribuídas a essa equipe serão excluídas.",
    linkRequestHasBeenSent: "Você não pode editar o escopo ou a designação dessa equipe porque uma solicitação de link já foi enviada ou a designação já está definida.",
    selectScopes: "Selecione o(s) escopo(s)",
    searchScopes: "Escopos de pesquisa",
    selectTeams: "Selecionar equipe(s)",
    sendLinkRequestsDescription: "Selecione os escopos ou equipes aos quais você gostaria de vincular seu engagement.<br> Uma solicitação de vinculação será enviada ao ponto de contato de cada equipe. Depois que o ponto de contato aceitar o link de solicitação, ele receberá instruções e tarefas do grupo por meio do EY Canvas.",
    sendVersionsDescription: "Selecione os escopos ou equipes para os quais você gostaria de enviar a versão mais recente das instruções e tarefas do grupo.<br>Uma equipe deve estar vinculada ao seu engagement para receber instruções e tarefas do grupo. Depois que a equipe aceitar a versão mais recente, ela estará disponível em seu engagement.",
    notSentYet: "Nenhuma versão enviada ainda",
    notLinkedYet: "Solicitação de link não enviada",
    cardView: "Exibição do cartão",
    noItemsPlaceholder: "A versão ainda não foi publicada. Publique uma versão das instruções e tarefas de grupo para ver os dados aqui.",

    //GA Instructions
    customizeGroupInstructions: "Personalizar instruções do grupo",
    gaInstructionsIntro: "As instruções de grupo pelo EY GAM são incluídas de forma padrão e são informativas por natureza. Destinam-se a informar as equipes regionais e componentes sobre as principais informações, escopo de trabalho e procedimentos realizados de forma centralizada. Personalize as instruções do EY GAM, adicione instruções adicionais, se necessário, e defina se cada instrução deve ser atribuída a um escopo ou equipe. Quando terminar, publique suas instruções para que fiquem disponíveis para envio aos escopos ou equipes designados.",
    addInstruction: "Adicionar instrução",
    instruction: "Instrução",
    groupTaskSelected: "Tarefa de grupo",
    assignScopes: "Atribuir escopos",
    assignTeams: "Atribuir às equipes",
    maxLengthMessage: "O texto não pode exceder <b>500<b> caracteres.",
    addScope: "Adicionar escopo",
    editInstruction: "Editar instruções personalizadas",
    editKnowledgeInstruction: "Editar instrução de conhecimento",
    editKnowledgeTask: "Editar tarefa de conhecimento",
    editCustomTask: "Editar tarefa personalizada",
    saveChangesInstruction: "Salvar alterações",
    updatedOnInstruction: "Última atualização:",
    knowledgeDescriptionInstruction: "Descrição do conhecimento",
    editDisabledTitle: "Você deve ter a permissão <b>Gerenciar grupo</b> para realizar esta ação. Fale com um Administrador do Engagement para solicitar permissão.",
    deleteCustomInstruction: "Excluir instruções",
    deleteGroupTask: "Excluir tarefa de grupo",
    areYouSureDeleteCustomInstruction: "Tem certeza de que deseja excluir essa instrução personalizada?",
    areYouSureDeleteCustomTask: "Tem certeza de que deseja excluir essa tarefa personalizada?",
    publishAfterDelete: "Se você excluir esta instrução, precisará publicar suas alterações e reenviar o conjunto de instruções recém-publicado para os escopos ou equipes atribuídos.",
    publishAfterDeleteGroupTask: "Se você excluir esta tarefa de grupo, precisará publicar suas alterações e reenviar o conjunto de tarefas recém-publicado para os escopos ou equipes atribuídos.",
    resendPublishInformation: "Você pode publicar suas alterações nesta etapa. Você pode reenviar o conjunto de instruções recém-publicado a partir do resumo.",
    resendPublishInformationGroupTask: "Você pode publicar suas alterações nesta etapa. Você pode reenviar o conjunto de tarefas recém-publicadas do resumo.",
    compareVersionsNoVersionSelectedTitle: "Nenhuma versão foi selecionada para comparação!",
    compareVersionsNoVersionSelectedSubtitle: "Selecione a versão no menu suspenso para comparar com a versão mais recente",

    //Add Section
    addSection: "Adicionar seção",
    addSectionInstructionalText: "Adicione uma seção para organizar suas instruções personalizadas.",
    addSectionPlaceholder: "Nome da Seção",

    //Edit Section
    editSection: "Editar nome da seção",
    editSectionInstructionalText: "Faça alterações no nome desta seção personalizada. <br> Quando terminar, publique suas alterações para enviar uma versão atualizada para escopos ou equipes selecionadas.",
    editSectionSave: "Salvar alterações",

    //Delete Section
    deleteCustomSection: "Excluir seção",
    areYouSureDeleteCustomSection: "Tem certeza de que deseja excluir esta seção? <br>Todas as instruções nesta seção serão excluídas. Quando terminar, publique suas alterações para enviar uma versão atualizada para escopos ou equipes selecionadas.",
    customSection: "Seção",

    //Publish Changes
    publishChanges: "Publicar alterações",
    publishChangesInstructional: "Tem certeza de que deseja publicar alterações no conjunto atual de instruções e tarefas? <br><br>O conjunto anterior de instruções e tarefas será substituído. Depois de publicar suas alterações, você pode enviar o conjunto atualizado de instruções e tarefas do resumo.",
    publishChangesNotAvailable: "Ainda não está disponível.",

    //GA Tasks
    costomizeGroupTasks: "Personalizar tarefas de grupo",
    gaTasksIntro: "As tarefas de grupo pelo EY GAM são incluídas de forma padrão e enviadas para projetos vinculados. Personalize as tarefas do EY GAM, adicione tarefas adicionais, se necessário, e defina se cada tarefa deve ser atribuída a um escopo ou equipe. Quando terminar, publique suas tarefas para que fiquem disponíveis para envio aos escopos ou equipes atribuídos.",
    addCustomTask: "Adicionar tarefa personalizada",
    groupTask: "Agrupar tarefas",
    gaTasks: "Tarefas",
    attachments: "Anexos",
    notAvailable: "Não disponível",
    gaDocument: "documento",
    gaDocuments: "documentos",
    gaScope: "escopo",
    gaScopes: "escopos",
    gaScopesCapitalized: "Escopos",
    gaTeam: "equipe",
    gaTeams: "equipes",
    gaUnassignedScopeTeam: "Não atribuído",
    hideDetails: "Detalhes ocultos",
    gaAssignedScopes: "Escopos atribuídos",
    gaAssignedTeams: "Equipes atribuídas",
    addTask: "Nova tarefa",
    due: "Vencimento",
    noAttachments: "Nenhum anexo foi adicionado.",

    // Chip component
    chipMore: "mais",

    // GS Group Summary labels
    assignedTeam: "Equipe atribuída",
    lastPublished: "Última publicação",
    versionStatus: "Status da versão",
    lastSent: "Último envio",
    lastSentTooltip: "Esta é a data em que uma versão de instruções e tarefas foi enviada pela última vez a cada equipe. Clique na data para visualizar a versão enviada à equipe.",
    lastSentBeforeTooltip: "Há uma nova versão de instruções e tarefas disponíveis para <b><<Nome do escopo>><b>. Considere se você deve enviar a versão mais recente para essa equipe.",
    groupSummary: "Resumo do grupo",
    summarySubTitle: "Revise a versão mais recente das instruções e tarefas atribuídas a cada escopo e equipe abaixo. Para enviar esta versão para os escopos e equipes atribuídos, selecione <b>Enviar versão</b>.<br/>Você também pode visualizar a versão enviada para uma equipe específica selecionando a data de envio relevante.",
    compareVersions: "Comparar versões",
    sendVersion: "Enviar versão",
    compareVersionsInstructional: "Compare a versão mais recente das instruções e tarefas publicadas com a versão enviada a uma equipe para identificar diferenças. Se houver diferenças entre as versões, avalie se uma nova versão precisa ser enviada à equipe.",
    publishedVersion: "Versão publicada",
    sentVersion: "Versão enviada",
    emptyPublishedVersion: "Não há escopos disponíveis. <br/>Os escopos atribuídos às equipes de componentes estão listados aqui.",
    emptySentVersion: "Não há equipes disponíveis.",
    selectPublishedVersion: "Selecione uma versão publicada para ver os dados aqui.",
    selectSentVersion: "Selecione uma versão enviada para ver os dados aqui.",
    dueDate: "Data de vencimento",
    emptyPublishedSnapshot: "Não há uma versão publicada de instruções e tarefas disponíveis para o escopo selecionado. <br/>Publique uma versão para ver os dados aqui.",
    emptySentSnapshot: "Instruções e tarefas não foram enviadas para a equipe selecionada. <br/>Publique e envie instruções e tarefas para esta equipe para ver os dados aqui.",
    update: "Atualizar",
    updates: "Atualizações",
    noTeamsPlaceholder: "Nenhum espaço reservado para equipes",
    noTeamSelected: "Selecione pelo menos um escopo ou equipe para continuar.",
    latestVersionAlreadySent: "Nenhuma equipe foi criada ainda. Crie uma ou mais equipes para publicar uma versão de instruções e tarefas.",
    latestHasBeenSended: "A última versão das instruções e tarefas foi enviada para esta equipe",
    noNewVersionToSend: "Os escopos ou equipes selecionados já receberam a versão mais recente de instruções e tarefas. Não há atualizações disponíveis para enviar.",
    notSelectedTask: "Não selecionado",
    assignedTeams: "Equipes atribuídas",
    noTeamsCreatedYet: "Nenhuma equipe foi criada ainda. Crie uma ou mais equipes para publicar uma versão de instruções e tarefas.",
    newersTeamsSended: "A última versão das instruções e tarefas foi enviada aos escopos ou equipes relevantes.",
    LinkRequestNotSent: "Solicitação de link não enviada",
    lastVersionSentInstructionalText: "A versão das tarefas e instruções enviadas para <b>{teamName}</b> em <b>{sentDate}</b> está exibida abaixo. Esta é a última versão enviada para esta equipe.",

    // ReceiveInstructions labels
    receiveInstructionsTitle: "{versionType} versão de instruções e tarefas de grupo",
    receiveInstructionsInstructional: "{primaryEng} enviou {versionType} versão de instruções e tarefas de grupo em {sentDate}. Revise esta versão e selecione se deve aceitá-la ou devolvê-la. Você pode usar a opção <b>Comparar versões</b> para comparar esta versão com as versões anteriores.",
    fromLabel: "De",
    assignedScope: "Escopo atribuído",
    dateSent: "Data enviada",
    acceptVersion: "Aceitar versão",
    returnVersion: "Retornar versão",
    returnPrimaryButton: "Retornar",
    returnVersionDescription: "Tem certeza de que deseja devolver esta versão de instruções e tarefas para a equipe principal? <br>Esta versão não será importada para o seu engagement. Deixe um comentário para a equipe principal explicando seu raciocínio.",
    noContent: "Não há instruções disponíveis no momento, tente novamente mais tarde ou entre em contato com a assistência técnica",
    editorPlaceHolder: "Comente",
    receiveCompareVersionInstructional: "Comparar a versão selecionada de instruções e tarefas recebidas de {primaryEng} com uma versão anterior recebida para identificar diferenças.",
    latestReceiveCompareVersionInstructional: "Compare a última versão das instruções e tarefas recebidas de {primaryEng} com uma versão anterior recebida para identificar as diferenças.",
    latestVersion: "Última versão",
    earlierVersion: "Versão anterior",
    earlierVersionEmpty: "Não há versões anteriores disponíveis para comparação.",
    selectEarlierVersion: "Selecione uma versão anterior para ver os dados aqui.",
    pstName: "Revisar as instruções de projeto de grupo",
    pstDescription: "Revise as instruções de auditoria do grupo. Conclua tarefas de grupo em 'Execução - Geral'. Essas tarefas foram adicionadas à lista de tarefas após a aceitação das instruções de auditoria do grupo.",
    selectedVersion: "Versão selecionada",
    issuingEngagement: "Emitindo Engagement",
    accountsAndDisclosureLink: "Conta e divulgação",
    openRiskAssessmentDocuments: "Abrir documentos de avaliação de risco",
    openRiskAssessmentDocument: "Abrir documento de avaliação de risco",

    //Client engagement name labels
    successQueueMessage: "O nome de exibição do engagement foi atualizado com sucesso no EY Canvas Client Portal.",
    clientEngagementInstructionalText: "Adicione ou edite um nome de exibição do engagement personalizado aqui. Este nome será visível para membros externos da equipe que acessam este engagement no EY Canvas Client Portal.",
    clientEngagementPlaceholder: "Nome de exibição do engagement",
    clientEngagementModalTitle: "Nome de exibição do engagement no EY Canvas Client Portal.",
    clientDisplayName: "Nome de exibição do cliente",
    textExceedsLength: "O texto não pode exceder 100 caracteres.",

    // Manage client access locations
    location: "Localização",
    locationName: "Nome da localização",
    accessLocations: "Locais de acesso",
    inputType: "Tipo de entrada",
    ipAddress: "Endereço IP",
    ipAddresses: "Endereços IP",
    startOfIpRange: "Início do range de IP",
    endOfIpRange: "Fim do range de IP",
    cidrNotation: "Notação de CIDR",
    manageClientAccessLocationsLink: "Adicionar localização",
    manageClientAccessLocationsModalTitle: "Gerenciar locais de acesso ao cliente",
    manageClientAccessLocationsInstructionalText: "Adicione endereços de IP à lista abaixo para permitir o acesso baseado em localização no EY Canvas Client Portal. <br>Se os locais de acesso do cliente estiverem habilitados, apenas membros externos da equipe com os endereços IP listados aqui terão acesso a este engagement. Se nenhum endereço IP for adicionado, os membros externos da equipe poderão acessar esse engagement de qualquer local.<br> Clique <b>aqui<b> para saber mais.",
    manageClientAccessLocationsNoResultFound: "Não há endereços IP adicionados para este compromisso. Os membros da equipe interna e externa podem acessar esse compromisso de qualquer local.",
    deleteAccessLocations: "Excluir locais de acesso",
    deleteAccessLocationsInstructionalText: "Tem certeza que deseja excluir o local de acesso selecionado? <b>Se um membro externo da equipe tentar acessar o Portal do Cliente EY Canvas a partir deste local, ele não poderá mais acessar este compromisso.",
    locationLengthError: "A localização não pode exceder 100 caracteres.",
    oneOrMoreIpAddressFormatError: "Um ou mais endereços de IP fornecido não são válidos.",
    ipAddressFormatError: "O endereço IP fornecido não é válido.",
    ipSuffixError: "O sufixo CIDR para o endereço IP deve ser um decimal ≥ 1 e ≤ 32.",
    ipRangeStartSmallerThanEnd: "O IP inicial deve ser menor que o IP final.",
    ipInputTypeInfo: "Selecione o endereço IP para inserir um endereço IP individual ou uma lista de endereços IP. Apenas endereços IPv4 são suportados. <br> Selecione o intervalo de IP para inserir um intervalo de endereços IP que compartilham o mesmo prefixo de rede (ou seja, os três primeiros segmentos do endereço). <br> Selecione o bloco CIDR para inserir um intervalo de endereços IP com notação CIDR. Apenas endereços CIDR são suportados",
    ipAddressInfo: "Você pode inserir endereços IP individualmente, em uma lista separada por vírgulas ou em uma lista com cada endereço em uma nova linha. <br> Os endereços IPv4 válidos contêm quatro números inteiros de 0 a 255, separados por pontos",
    ipCidrInfo: "Insirer a notação CIDR que representa um intervalo de endereços IP que devem ser capazes de acessar esse projeto. <br>A notação CIDR válida contém um endereço IPv4 válido, uma barra/caractere e um sufixo decimal ≥ 1 e ≤ 32.",
    ipAddressEg: "por exemplo, 192.XXX.X.1 192.XXX.X.2",
    ipRangeStartEg: "por exemplo, 192.XXX.X.1",
    ipRangeEndEg: "por exemplo, 192.XXX.X.2",
    ipCidrEg: "por exemplo, 192.XXX.X.1/22",
    searchIpPlaceholder: "Verifica o endereço IP",
    ipNotAddedMessage: "não foi adicionado à lista permitida.",
    ipIsAllowedMessage: "O endereço IP é permitido.",
    importAccessLocationsLink: "Importar locais de acesso",
    importAccessLocationsInstructionalText: "Os locais de acesso podem ser importados de seu engagement anterior. <br>Tem certeza de que deseja importar os acessos locais?",
    importAccessLocationsCloseButton: "Fechar",
    importAccessLocationsCancelButton: "Cancelar",

    // Export Requests
    exportRequests: "Exportar solicitações",

    // Add custom request labels
    addCustomRequestModal: {
        titleTip: "Nova solicitação",
        titleTipAddButton: "Adicionar novo",
        closeTitleTip: "Fechar",
        modalTitle: "Nova solicitação",
        returnModalTitle: "Solicitação de devolução",
        modalHeader: "Adicione uma nova solicitação para enviar ao Portal do Cliente EY Canvas",
        requiredAssignedTo: "(obrigatório)",
        assignToError: "Atribuído a é obrigatório",
        dueDate: "Data de vencimento (obrigatório)",
        dueDateError: "A data de vencimento é requerida",
        titlePlaceholder: "Título (obrigatório)",
        titleError: "Título é obrigatório",
        description: "Descrição",
        descriptionplaceholder: "Inserir descrição",
        descriptionError: "A descrição da solicitação excede o comprimento máximo (4.000 caracteres)",
        associateDocuments: "Documentos associados",
        emptyAssociatedDocumentsList: "Arraste e solte um ou mais documentos ou clique em Adicionar documento",
        addDocumentButton: "Adicionar documento",
        signOffCheckbox: "Os documentos carregados no Portal do Cliente EY Canvas exigirão aprovação",
        sendRequest: "Enviar solicitação",
        returnRequest: "Solicitação de devolução",
        saveAsDraft: "Salvar como rascunho",
        cancel: "Cancelar",
        copyTitleAndDescription: "Copiar título e descrição da tarefa",
        copyAssociatedDocuments: "Copiar documentos da tarefa",
        priority: "Solicitar prioridade",
        addNewRequestButton: "Adicionar nova solicitação",
        addExistingRequestButton: "Adicionar solicitação(ões) existente(s)",
    },
    addCustomEventModal: {
        titleTip: "Novo evento",
        closeTitleTip: "Fechar",
        modalTitle: "Novo evento",
        eventDate: "Data do evento",
        eventDateError: "A data é obrigatória",
        titlePlaceholder: "Título",
        titleError: "Título é obrigatório",
        description: "Descrição (opcional)",
        descriptionplaceholder: "Inserir descrição",
        descriptionError: "A descrição do evento excede o comprimento máximo (4.000 caracteres)",
        sendEvent: "Enviar evento",
        saveAsDraft: "Salvar evento como rascunho",
        cancel: "Cancelar",
        eyParticipantsCollaborationError: "É necessário pelo menos um participante da EY",
        externalParticipantsCollaborationError: "É necessário pelo menos um participante externo"
    },
    eyHelixInstructionText: "Revise os projetos vinculados da EY Helix e os analisadores sugeridos abaixo. <br/> Clique em qualquer um dos projetos ou analisadores para navegar até sua página específica do EY Helix.",
    smartAutomationInstrText: "Revise as soluções do Smart Automation que você está usando no momento abaixo. <br/> Clique em uma solução para navegar até o Smart Automation Hub.",
    smartAutomationSolutionsNotAvailable: "As soluções de Automação Inteligente não estão disponíveis para o seu engagement no momento.",
    noSmartAutomationAvailable: "Não há soluções de Automação Inteligente disponíveis para o seu compromisso.",
    availableSolutions: "Soluções disponíveis",
    useOfSuggestedSolutions: "Uso de soluções sugeridas",
    useOfOtherSolutions: "Uso de outras soluções",
    suggestedSolutions: "Soluções sugeridas",
    otherSolutions: "Outras soluções",
    currentlyusing: "Atualmente em uso",
    suggested: "sugerido",
    primaryProject: "Projeto principal",
    noLinkedProjects: "Não há projetos vinculados para seu engajamento.",
    noSuggestedAnalyzers: "Não há analisadores sugeridos para seu engajamento.",
    eyHelixNotAvailable: "EY Helix não disponível",
    helixNotAvailableMessage: "A EY Helix não está disponível para o seu envolvimento no momento.",

    noGroupTaskCreatedYet: "Nenhuma tarefa de grupo foi criada ainda.",
    noInstructionsCreatedYet: "Nenhuma instrução foi criada ainda.",
    documentsReceived: "Documentos recebidos",
    documentsPending: "Documentos pendentes",

    teamLabel: "Equipe",
    scopeLabel: "Escopo",

    documentSignOffby: "Documento assinado por",
    documentAddedBy: "Documento adicionado por",
    documentModifiedBy: "Documento modificado por",
    documentDeletedBy: "Documento excluído por",
    commentAddedBy: "Nota adicionada por",
    commentClearedBy: "Nota apagada por",
    commentClosedBy: "Nota fechada por",
    commentReopenedBy: "Nota reaberta por",

    documentAssignedTo: "Documento atribuído a",
    draftDocReceivedFrom: "Rascunho do documento recebido de",
    finalDocReceivedFrom: "Documento final recebido de",
    documentReturnedBy: "Documento devolvido por",
    returnedDocumentClearedBy: "Documento devolvido compensado por",
    documentConflictResolvedBy: "Conflito de documento resolvido por",
    draftDocumentSentBy: "Rascunho de documento enviado por",
    documentReturnedFrom: "Documento devolvido de",
    finalDocumentSentBy: "Documento final enviado por",
    noActivityAvailable: "Não há atividade disponível.",
    allEngagementFilterLabel: "Todos os outros engagements",
    otherEngagementComments: "Outras notas do engagement",
    engagements: "Engagements",
    engagement: "Engagement",
    view: "Visualizar",
    notesModalInstructionalText: "Visualize e responda às notas para o {0} selecionado abaixo.",

    //New collaboration Related Labels
    searchRelateFileNoMatchesFound: "Nenhuma informação encontrada. Por favor, tente novamente.",

    //New collaboration Related tasks
    relatedTasksLabel: "Tarefas relacionadas",
    selectRelatedTasks: "Selecione a tarefa",
    searchAndPressEnter: "Pesquisar e pressionar enter",
    noRelatedTasksSelected: "Sem tarefas relacionadas selecionadas",
    relatedTasksCount: "tarefas relacionadas",
    notFoundTasks: "Tarefa não encontrada",
    dueDateDetailLabel: "Data de Vencimento",
    requestType2MessageTitle: "Esta solicitação será aberta em uma nova guia",
    requestType2MessageSubtitle: "Atualize a página para ver as atualizações feitas.",
    requestType2InTrnasitMessageTitle: "Esta solicitação não pode ser aberta, pois está em trânsito.",
    requestType2InTrnasitMessageSubtitle: "Aguarde a conclusão da sincronização e atualize a página e tente novamente.",

    //New collaboration Time Phase
    selectTimePhase: "Selecione a fase do tempo",
    timePhaseNotFound: "Fase de tempo não encontrada",

    understandITProcess: "Entenda os processos de TI",

    //New collaboration Access Location
    accessLocationLabel: "Local de acesso ativado",
    accessLocationTitle: "Somente os usuários que se conectarem a partir de um local de rede autorizado terão acesso ao EY Canvas Client Portal para este engagement. Os locais permitidos podem ser gerenciados a partir de locais de acesso no menu de opções.",

    // Reporting Labels
    summaryScreenLabel: "Tela de resumo",
    dataExportLabel: "Exportação de dados",
    projectManagementLabel: "Gerencimanento de projetos",
    reportingHeaderName: "Relatórios",
    repAllTasks: "Todas as tarefas",
    repDeletedTasks: "Tarefas excluídas",
    repMultiEntityTasks: "Tarefas de multi-entidades",
    repAllAuditPlan: "Plano de Auditoria",
    repITAppSOSummary: "Resumo do aplicativo/SO de TI",
    repITProcessScotControls: "Processo de TI, SCOT e controles",
    repTaskAssignments: "Atribuições de tarefas",
    repTaskDetails: "Detalhes da tarefa",
    repTaskAnalysis: "Análise de tarefas",
    repTaskSummary: "Resumo da tarefa (Piloto)",
    repExportToExcel: "Exportar dados",
    repExportDate: "Data de exportação",
    repEngInfo: "Informações do projeto",
    repNoRecordMessage: "Sem registros para apresentar",
    dateInUTC: "em UTC",
    repSCOTsControls: "SCOTs e controles",
    repITProcessSummary: "Resumo do processo de TI",
    repCanvasForms: "Formulários do Canvas",
    repControlForms: "Formulários de controle",
    projectInsight: "Project Insight",
    archiveForm: "Formulário de Archive",
    archive: "Arquivar",
    repCanvasFormResponse: "Respostas do Formulário do Canvas",
    repCanvasFormRelatedComments: "Relacionar comentários",
    repControlFormResponse: "Controlar respostas do formulário",
    repNoRecordFound: "Nenhum registro foi encontrado",
    repCanvasFormsIncomplete: "Respostas incompletas",
    repCanvasFormRelatedObjects: "Relacionar objetos",
    voiceNoteLabel: "Nota de voz",
    repComponentTeamGroup: "Equipe de componentes",
    componentTeamCanvasFormExport: "Exportação de formulário do Canvas",

    // Reporting Tasks
    repTaskTitle: "Título da tarefa",
    repTaskDescription: "Descrição da tarefa",
    repTaskSource: "Origem da tarefa",
    repTaskNature: "Natureza da tarefa",
    repTaskCloseEarly: "Cedo",
    repTaskCloseLate: "Tarde",

    // Reporting Documents
    repAllDocuments: "Todos os documentos",
    repSignOffs: "Assinar",
    repDocumentsModified: "Documentos modificados após RRD",

    //Reporting Collaboration
    repRequestsAndTasks: "Solicitações e tarefas",
    repRequestsTasksComments: "Comentários de solicitações/tarefas",

    SCOTSummaryReportHeader: "Resumo por SCOT",
    GroupReportHeader: "Relatório de Grupo",
    SCOTSummaryEffective: "Eficaz",
    GroupInstructionSummary: "Resumo da instrução do Grupo",
    GroupActivity: "Histórico de mapeamento de conta de componente",
    SEMReportHeader: "SEM",
    GroupComponentAccountReportHeader: "Mapeamento de conta de componente de grupo",
    AccountDisclosuresReportHeader: "Contas e divulgações",

    //Reporting Collaboation Details
    collaborationDetails: "Detalhes da colaboração",
    collaborationSummary: "Resumo",
    collaborationActivity: "Detalhes da atividade",
    ReviewNotesReportHeader: "Notas de revisão",

    GroupStructureSummary: "Resumo da Estrutura do Grupo",

    //Reporting CRT Summary
    wcgwSummary: "Resumo do WCGW",
    crtlabel: "Ferramenta de revisão de controles (CRT)",
    assertionSummary: "Resumo por Assertiva",
    scotSummary: "Resumo por SCOT",
    noRecordsToExport: "Nenhum registro para exportar",
    statisticsSummary: "Estatísticas",
    qualityChecks: "Controles de Qualidade",
    controlSummary: "Resumo de Controle",
    filterBySCOT: "Filtrar por SCOT",

    //Reporting manage team
    independenceSummaryReportTabName: "Resumo de independência",

    //MEST dashboard
    viewAllRiskTypesAndAssertions: "Veja todos os tipos de risco e assertivas",
    riskRelatedToAssertion: "Risco relacionado à assertiva",
    higherRiskRelatedToAssertion: "Risco alto relacionado à assertiva",
    noRisksAvailable: "Sem riscos disponíveis",
    relatedEstimates: "Estimativas Relacionadas",
    viewAllAssertions: "Visualizar todas as assertivas",
    wcgwRelatedToAssertion: "WCGW relacionado à assertiva",
    noWcgwsAvailable: "Sem WCGWs disponíveis",
    goTo: "Vá para",
    allItems: "Todos os itens",

    // Create TimePhase Labels
    createTimePhaseLabels: {
        modalTitle: "Adicionar fase de tempo",
        modalDescription: "Adicione os atributos e clique em Salvar & fechar ou Salvar & adicionar.",
        timephaseNameLabel: "Nome da fase de tempo",
        milestoneSelectLabel: "Milestone",
        timephaseLabel: "Fase de tempo",
        startDateLabel: "Data de início",
        endDateLabel: "Data final",
        startDateErrorMessage: "A data de início é requerida.",
        endDateErrorMessage: "A data de término é requerida.",
        timephaseNameErrorMessage: "O nome é necessário.",
        milestoneErrorMessage: "Milestone é requerido.",
        isKeyEvent: "Evento-chave",
        timephaseDescription: "Descrição (opcional)",
        addSuccessMessage: "Fase de tempo adicionada com sucesso."
    },

    AccountListHeaderLabels: {
        pspAndosp: "PSPs/OSPs",
        limitRiskAssertionLabel: "Conta de risco limitado",
        heading: "Contas e divulgações e assuntos relacionados",
        accountsOrDisclosure: "Contas e divulgações",
        psps: "PSPs",
        rejected: "Rejeitado",
        remove: "Remover",
        risks: "Riscos",
        assertions: "Assertivas",
        noRecordsFound: "Nenhuma conta ou divulgação disponível",
        noResultsFound: "Nenhum resultado encontrado",
        responsiveHeading: "Responsivo",
        rejectedPspsHeading: "PSPs rejeitados",
        importPsps: "Importar PSPs",
        importOsps: "Importar OSPs",
        addOsps: "Adicionar OSPs",
        pspEnded: "para começar.",
        noPspsandOsps: "Nenhum {0} disponível.",
        allAreRejected: "Todos os PSPs foram rejeitados.",
        rejectButton: "Rejeitar",
        acceptButton: "Aceitar",
        additionalInfo: "Justificativa:",
        noAssertionsAvailableLabel: "Nenhuma assertiva disponível",
        noAssertionAvailableTooltip: "Nenhuma assertiva disponível. Clique em <strong>Gerenciar contas e divulgações</strong> para adicionar assertivas.",
        importFromKnowledge: "Importar do Conhecimento",
        disabledAddOspTooltip: "Pelo menos uma assertiva deve estar disponível para adicionar uma tarefa substantiva. Clique em <strong>Gerenciar contas e divulgações</strong> para adicionar assertivas.",
        noPsps: "Nenhum PSP disponível. {0} para começar.",
        noOspsPsps: "Não há PSP/OSP disponíveis. {0}, {1} ou {2} para começar.",
        acceptErrorMsg: "Não é possível aceitar a tarefa rejeitada. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
        build7NoPspOrOspAttachedToAssertion: "Cada assertiva deve ter pelo menos um procedimento substantivo responsivo. As seguintes assertivas não têm PSPs/OSPs responsivos: <b>{orphanAssertions}</b>. {0}, {1} ou adicione uma {2} para abordar todas as assertivas da conta ou clique no ícone de edição de PSPs/OSPs existentes responsivos a essa conta para relacioná-los a outras assertivas.",
        build7NoPspOrOsp: "Cada assertiva deve ter pelo menos um procedimento substantivo responsivo. Nenhuma das assertivas tem PSPs/OSPs responsivos. {0}, {1} ou criar um {2} para tratar de todas as assertivas da conta.",
        build7NoOspsAndAllPspAreRejected: "Cada assertiva deve ter pelo menos um procedimento substantivo responsivo. Todos os PSPs foram rejeitados e nenhuma das assertivas tem PSPs/OSPs responsivos. {0} ou crie um {1} para tratar de todas as assertivas da conta.",
        build6And7NoAssertions: "Cada conta significativa ou divulgação significativa deve ter pelo menos uma assertiva relacionada disponível para adicionar um procedimento substantivo. Clique em {0} para adicionar assertiva.",
        build7LimitedAccountNoPspOsp: "Cada conta de risco limitado deve ter pelo menos um procedimento substantivo responsivo. {0} ou criar um {1} para responder aos riscos dessa conta.",
        manageAccountAndDisclosures: "Gerenciar contas & divulgações"
    },

    AddTaskLabels: {
        accountLabel: "Conta:",
        taskSectionLabel: "Seção de Tarefa:",
        ospModelTitle: "Novo OSP",
        ostModelTitle: "Novo OST",
        saveAndClose: "Salvar",
        saveAndCreate: "Salvar e criar outro",
        cancel: "Cancelar",
        prefix: "Prefixo",
        title: "Título",
        suffix: "Sufixo",
        timePhase: "Fase de tempo",
        description: "Descrição personalizada",
        descriptionPlaceholder: "Descrição personalizada da tarefa (obrigatória)",
        assertions: "Assertivas",
        optional: "(opcional)",
        required: "Obrigatório",
        noResultFound: "Nenhum resultado encontrado",
        of: "de",
        characters: "caracteres",
        descriptionMaxLengthError: "O comprimento da descrição excedeu o tamanho máximo permitido",
        noteDiscriptionErrorMessage: "A resposta contém {0} caracteres que excede o máximo de {1} caracteres. Ajuste a descrição reduzindo o texto ou a formatação e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
        customizeDescription: "Descrição personalizada da tarefa (obrigatória)",
        errorMsg: "Falha ao adicionar a OSP. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
        customizeTaskDescription: "Personalizar a descrição da tarefa"
    },

    RemoveTaskLabels: {
        modelOspTitle: "Excluir OSP",
        modelOstTitle: "Excluir OST",
        deleteBtn: "Excluir",
        cancel: "Cancelar",
        confimationOspMsg: "Tem certeza que deseja excluir a OSP selecionada?",
        confimationOstMsg: "Tem certeza que deseja excluir a OST selecionada?",
        warning1Msg: "Evidências relacionadas que não estejam relacionadas com quaisquer outras tarefas deste engagement serão movidas para arquivos temporários.",
        warning2Msg: "Resultados e tarefas de resposta que não estejam relacionadas a nenhuma outra evidência serão excluídas."
    },

    TaskReportHeaderLabels: {
        Tasktype: "Tipo de tarefa",
        Taskstatus: "Status da tarefa",
        Taskassignedto: "Tarefa atribuída a",
        Tasktitleprefix: "Prefixo do título da tarefa",
        Tasktitle: "Título da tarefa",
        Tasktitlesuffix: "Sufixo do título da tarefa",
        Taskdescription: "Descrição da tarefa",
        Knowledgetasktitle: "Título da tarefa de conhecimento",
        Knowledgetaskdescription: "Descrição da tarefa de conhecimento",
        Oldtaskname: "Nome da tarefa antiga",
        Oldtaskdetail: "Detalhe da tarefa antiga",
        Rejected: "Rejeitado",
        Rationalforrejection: "Racional para rejeição",
        Auditphase: "Fase de auditoria",
        Timephasetype: "Marco",
        Timephase: "Fase de tempo",
        Timephasestartdate: "Data de início da fase de tempo",
        Timephaseduedate: "Data de vencimento da fase de tempo",
        Keyevent: "Evento-chave",
        Tasksource: "Origem da tarefa",
        Tasknature: "Natureza da tarefa",
        Lasttaskstatuschangedate: "Data da alteração do status da última tarefa",
        Taggroup: "Grupo de marcações",
        Tags: "Marcações",
        RelatedMESTentities: "Entidades MEST relacionadas",
        Schedulednextwaveservices: "Serviços nextwave agendados",
        Priority: "Prioridade",
        Taskid: "ID da tarefa",
        Roleid: "ID da função",
        Tasktypeid: "ID do tipo de tarefa",
        Taskstatusid: "ID do status da tarefa",
        Auditphaseid: "ID da fase de auditoria",
        Timephasetypeid: "ID do Marco",
        Tasksourceid: "ID da origem da tarefa",
        Tasknatureid: "ID da natureza da tarefa"
    },

    glAccountDocumentLabels: {
        modelTitle: "GL Account",
        modelName: "Relacionar evidência",
        documentName: "Nome do documento",
        documentCounter: "{0} Documento",
        documentsCounter: "{0} Documentos",
        btnCancel: "Cancelar",
        btnSave: "Salvar",
        errorMessage: "Selecione um documento para continuar",
        noResultsFound: "Nenhum resultado encontrado",
        newTickMark: "Novo tickmark",
        bulkModePlaceholder: "Selecione uma evidência para relacionar e selecione <strong>'Salvar'</strong> para finalizar."
    },

    // Edit TimePhase Labels
    editTimePhaseLabels: {
        modalTitle: "Editar fase de tempo",
        modalDescription: "Edite os atributos e clique em <b>Salvar.</b>",
        editSuccessMessage: "Fase de tempo atualizada com sucesso."
    },

    // Delete TimePhase Labels
    deleteTimePhaseLabels: {
        deleteTimePhaseModalTitle: "Excluir fase de tempo",
        deleteDescription: "Tem certeza de que deseja excluir esta fase de tempo?",
        showTimePhaseName: "Fase de tempo",
        showMileStone: "Marco",
        showStartDate: "Data de início",
        showEndDate: "Data final",
        showDescription: "Descrição:",
        showAssignedTasks: "Contagem de tarefas atribuídas",
        showAssignedAssignments: "Contagem de atribuições",
        deleteSuccessMessage: "Fase de tempo excluída com sucesso."
    },

    // Create Tag Labels
    createTagGrouplabels: {
        modalTitle: "Adicionar marcaçãp de grupo",
        modalDescription: "Digite um nome e clique em Salvar & fechar ou Salvar & adicionar para continuar.",
        tagGroupNameLabel: "Grupo de marcação",
        tagGroupNameErrorMessage: "Grupo de marcação obrigatório",
        saveAndClose: "Salvar & fechar",
        saveAndAdd: "Salvar & adicionar",
        addSuccessMessage: "Grupo de marcação adicionado com sucesso."
    },

    // Bulk Tags
    tags: {
        noTagsAvailabel: "Nenhuma marcação disponível",
        deleteTag: "Excluir marcação",
        deleteDescription: "A exclusão da marcação não pode ser desfeita. Tem certeza de que deseja continuar?",
        showDeleteTagName: "Marcação",
        showDeleteTagGroupName: "Grupo de marcação",
        showAssignedTasks: "Tarefas atribuídas",
        deleteSuccessMessage: "Marcação excluída com sucesso.",
        task: "Tarefa",
        tasks: "Tarefas",
        addTagGrouplabels: "Adicionar grupo de marcação",
        addTag: "Adiconar marcação",
        action: "Ação",
		addTagDesc: '<h3>Adicionar marcação</h3><p>Clique em "Adicionar grupo de marcação" para criar um novo grupo de marcação que pode ser utilizado para adicionar marcações.</p>',
		assignTagDesc: "<h3>Atribuir marcações</h3><p>Arraste e solte os itens selecionados na marcação desejada em um grupo de marcações.</p>",
		editTagDesc: '<h3>Editar marcações</h3><p>Clique no menu flutuante (três pontos) e selecione "Editar" para editar as propriedades da marcação.</p>',
		deleteTagDesc: '<h3>Excluir marcações</h3><p>Clique no menu flutuante (três pontos) e selecione "Excluir" para excluir a marcação.</p>',
        removeTagDesc: "<h3>Remover marcação</h3><p>Para remover uma marcação, arraste um ou mais itens com uma marcação existente para o nome da marcação associada em um grupo de marcação.</p>",
        expand: "Expandir",
        collapse: "Quebrar",
        TagName: "Nome da marcação",
        TagGroupName: "Nome do grupo de marcação",
        addTagSuccessMessage: "Marcação adicionada com sucesso.",
        editTagSuccessMessage: "Marcação atualizada com sucesso.",
        addTagModalTitle: "Adicionar marcação para",
        editTagModalTitle: "Editar marcação",
        addTagModalDescription: "Crie uma nova marcação e clique em Salvar & fechar ou Salvar & adicionar para continuar.",
        editTagModalDescription: "Edite os atributos e clique em <b>Salvar.</b>",
        tagSetSuccessMessage: "marcação definida com sucesso.",
        tagsSetSuccessMessage: "marcações definidas com sucesso.",
        tagRemoveSuccessMessage: "marcação removida com sucesso.",
        tagsRemoveSuccessMessage: "marcações removidas com sucesso.",
        tagRemovedSuccessfully: "Marcação removida com sucesso."
    },

    relateEvidenceHeader: "Relacionar evidências que forneçam informações sobre o ajuste.",
    relatedDocumentCounter: "{0} Documento",
    relatedDocumentsCounter: "{0} Documentos",
    documentsLocationLabel: "Localização dos documentos",
    relateTemporaryFilesHeader: "Relacionar um documento temporário deste engagement.",

    // Create Assignment Labels
    addAssignmentlabels: {
        modalTitle: "Adicionar tarefa",
        modalDescription: "Digite um nome e clique em Salvar quando terminar.",
        assignmentNameLabel: "Nome da atribuição",
        assignmentNameErrorMessage: "O nome da atribuição não pode ficar vazio",
        saveAndClose: "Salvar & fechar",
        saveAndAdd: "Salvar & adicionar",
        addSuccessMessage: "Atribuição adicionada com sucesso."
    },
    addUserOrRoleLabelto: "Adicionar usuário ou função a",
    addUserOrRoleheader: "Pesquise o membro da equipe ou a função que você deseja adicionar.",
    saveAndAdd: "Salvar e adicionar",

    // Bulk Assignment
    BulkActionsLabel: "Ações em massa",
    BulkAssignmentAction: "Ação",
    BulkShow: "Mostrar",
    BulkActionsInstructionalText: "Execute operações em massa para agrupamentos de tarefas usando arrastar e soltar. Para visualizar tarefas individuais de um agrupamento de tarefas, passe o mouse sobre o grupo de tarefas e clique no ícone de seta.",
    bulkOperationsModalDescription: "Execute operações em massa para tarefas. Para visualizar tarefas individuais de um agrupamento de tarefas, passe o mouse sobre o grupo de tarefas e clique no ícone de seta.",
    selectRequest: "Selecione uma solicitação para enviar.",
    replaceLabel: "Substituir",
    labelStaff: "staff-",
    addModeLabel: "Adicionar",
    replaceModeLabel: "Substituir",
    dueDateModeLabel: "Atualizar dias de vencimento",
    searchByAssignmentName: "Procurar",
    addTeamMemberLabel: "Adicionar membro da equipe",
    noTeamMembersFound: "Nenhum membro da equipe disponível",
    addMemberSuccessMessage: "Membro da equipe adicionado com sucesso.",
    addAssignmentLabel: "Adicionar tarefa",
    addAssignmentNameLabel: "Adicionar nome de tarefa",
    noAvailableAssignmentsMessage: "Nenhuma atribuição disponível",
    showDuplicateError: "O membro da equipe ou a função selecionada não pode ter uma atribuição duplicada para a(s) tarefa(s) selecionada(s). Escolha uma atribuição, membro da equipe ou função diferente para continuar.",
    infoBulkAssignments: "Atribuições em massa",
    infoBulkAssignmentDesc: "Selecione um ou mais agrupamentos de tarefas para criar novas atribuições ou substituir atribuições existentes. Quando as atribuições são criadas ou editadas, o atual atribuído ao membro da equipe será recalculado como o membro da equipe com a atribuição vencida mais cedo.",
    infoAssignmentsDueDate: "Definição da data de vencimento da(s) tarefa(s)",
	infoAssignmentsDueDateDesc: 'Use o botão "Selecionar data / Calcular data" para definir a data de vencimento da(s) tarefa(s). A alternância pode ser usada para fornecer uma data de vencimento específica para a(s) tarefa(s) ou para fornecer dias antes da data final da fase de tempo.',
    infoAddAssignmentExisting: "Adicionar atribuição a um membro da equipe existente",
    infoAddAssignmentExistingDesc: "Adicionar atribuições requer um número de dias antes da data de vencimento para ser definido. Como alternativa, a data de vencimento exata pode ser definida usando o controle de calendário. Feito isso, arraste e solte os itens selecionados para criar um novo conjunto de atribuições.",
    infoAddAssignmentNew: "Adicionar atribuição ao novo membro da equipe",
    infoAddAssignmentNewDesc: "Se o membro ou função da equipe não for apresentado para a atribuição determinada, clique em adicionar membro da equipe para ver uma lista de membros e funções da equipe disponíveis. Uma vez selecionado, esse membro da equipe será adicionado ao final da lista e poderá ser usado para atribuição de arrastar e soltar.",
    infoRemove: "Remover atribuição",
    infoRemoveDesc: "Para remover uma atribuição, arraste um ou mais itens para um membro da equipe dentro de um nome atribuído. Quaisquer atribuições incompletas para esse membro da equipe serão removidas. As atribuições concluídas não serão removidas.",
    infoReplace: "Substituir atribuição",
    infoReplaceDesc: "Ao substituir uma atribuição, você arrastará um ou mais itens para um membro da equipe sob um nome de atribuição. Quaisquer atribuições existentes com o mesmo nome de atribuição serão reatribuídas ao membro da equipe selecionado. Se vários membros da equipe tiverem atribuições para esse nome de atribuição, eles serão consolidados para o usuário selecionado. A configuração de dias de vencimento anteriores é opcional ao usar a atribuição de substituição. Se nenhum dia de vencimento anterior for definido, os dias de vencimento anteriores existentes serão usados.",
    infoUpdateDueDate: "Atualizar dias de vencimento",
	infoUpdateDueDateDesc: 'Defina os novos "Dias de vencimento", usando "Selecionar data" ou "Calcular data" e, em seguida, arraste e solte no membro da equipe cujos dias de vencimento você deseja alterar. Tarefas abertas e em andamento para esse membro da equipe terão seus dias de vencimento atualizados. As tarefas concluídas não serão alteradas.',
    infoDelete: "Excluir atribuição",
    infoDeleteDesc: "Clique na tarefa no lado direito e uma opção para excluir esse conjunto de tarefas vai aparecer.",
    infoExecutive: "Atribuição executiva",
    infoExecutiveDesc: "Use os filtros e a funcionalidade de pesquisa para filtrar as tarefas aplicáveis ??aos executivos para fazer atribuições mais rapidamente.",
    infoSpecificTask: "Atribuições a tarefas específicas",
    infoSpecificTaskDesc: "Se as atribuições precisarem ser feitas em um nível de tarefa, passe o mouse sobre o agrupamento no lado esquerdo e selecione a opção para visualizar tarefas individuais. Isso apresentará as tarefas individuais para o grupo e permitirá atribuições refinadas.",
    unassignedLabel: "não atribuído",
    replaceSignleSuccessMessage: "tarefa atualizada com sucesso.",
    replaceMultipleSuccessMessage: "tarefas atualizadas com sucesso.",
    dueDateSingleSuccessMessage: "atribuição atualizada com sucesso.",
    dueDateMultipleSuccessMessage: "atribuições atualizadas com sucesso.",
    invalidAssignmentUpdate: "Atribua a tarefa à mesma pessoa para proceder com a atualização dos dias de vencimento.",
    removeSuccessMessage: "atribuição(ões) atualizada com sucesso.",
    colorCode: "Código de cor",
    removeSuccessSingleMessage: "atribuição atualizada com sucesso.",
    removeSuccessMultipleMessage: "atribuições atualizadas com sucesso.",
    assignmentRemovedSuccessfully: "Atribuição removida com sucesso.",

    // Bulk Task
    itemsSelected: "tarefas selecionadas",
    itemSelected: "tarefa selecionada",
    dragAndDrop: "Arraste e solte",
    currentApplication: "Aplicativo atual",
    allAssignmentsClosed: "Todas as atribuições fechadas",
    allAssignmentsCompleted: "Todas atribuições concluídas",

    onOrBeforeCurrentDate: "Na ou antes da data atual",
    withInCurrentWeek: "Esta semana",
    quickFilter: "Filtro rápido",
    suggestedFilters: "Filtros sugeridos",
    showXMore: "Mostrar mais {0}",

    // Task due date Events
    addEventlabels: {
        modalTitle: "Evento adicionado",
        startDateLabel: "Data de início",
        modalDescription: "Adicione os atributos e clique em Salvar & fechar ou Salvar & adicionar.",
        eventNameLabel: "Nome do evento",
        eventType: "Tipo de evento",
        singleDay: "Único dia",
        dateRange: "Período",
        eventDate: "Data do evento",
        eventDescription: "Descrição (opcional)",
        isEvent: "Compartilhar evento com cliente",
        EventNameErrorMessage: "O nome do evento é obrigatório.",
        eventDateErrorMessage: "A data do evento é obrigatória.",
        addSuccessMessage: "Evento adicionado com sucesso."
    },

    // Bulk Notes
    DeleteSomeNotesAreClosed: "<b>Apenas algumas das notas selecionadas têm status fechado e podem ser excluídas.</b> <br /> Se você optar por prosseguir, as notas listadas abaixo serão excluídas.",
    DeleteSomeNotesAreNotClosed: "As notas listadas abaixo não podem ser excluídas porque não foram fechadas.",
    DeleteDontHaveClosedNotes: "As notas listadas abaixo não podem ser excluídas porque não foram fechadas.",
    someNotesAreOpen: "<b>Apenas algumas das notas selecionadas têm status aberto.</b> <br/> Se você optar por prosseguir, as notas listadas abaixo serão atualizadas.",
    someNotesAreNotOpen: "As notas listadas abaixo não serão atualizadas porque já foram limpas ou fechadas.",
    dontHaveOpenNotes: "As notas listadas abaixo não podem ser atualizadas porque já foram limpas ou fechadas.",
    ShowNumberMore: "Mostre {0} mais",

    // Drag and Drop
    assignmentLabel: "atribuição",
    assignmentsLabel: "atribuições",
    singleAssignmentCreatedMessage: "atribuição criada com sucesso.",
    multipleAssignmentCreatedMessage: "atribuições criadas com sucesso.",
    daysPriorWarning: "Defina os dias de vencimento antes de criar atribuições.",



    // Related Tasks - Engagement selector
    selectEngagement: "Selecione o Engagement",
    thisEngagement: "Esse engagement",
    noResultsFoundLabel: "Nenhum resultado encontrado",
    taskLocationLabel: "Local da tarefa",

    // Delete Assginment
    deleteDescription: "A exclusão da tarefa não pode ser desfeita. Tem certeza de que deseja continuar?",
    deleteAssignmentModalTitle: "Excluir atribuição",
    deleteSingleSuccessMessage: "atribuição removida com sucesso.",
    deleteMultipleSuccessMessage: "atribuições removidas com sucesso.",
    teamMemberLabel: "Membro da equipe",
    assignedTasksCountLable: "Tarefas atribuídas",
    deleteAssignmentLabel: "Atribuição",
    selectengagement: "Selecione o engagement",

    //Due Days
    dueDateTitle: "Insira os dias de vencimento",
    dueDatedescription: "Digite o número de dias antes da data de vencimento da fase de tempo que a tarefa deve ser concluída.",
    dueDateAssign: "Atribuir",
    dueDateSelect: "Selecionar",
    dueDateCalculate: "Calcular",

    // Tasklist - bulk markcomplete
    markComplete: "Marca completa",
    markCompleteMessgae1: "Tem certeza de que deseja <b>completar as tarefas selecionadas</b>? <br /> Se você tiver atribuições incompletas para as tarefas selecionadas, elas serão fechadas.",
    markCompleteMessgae2: "Apenas algumas das tarefas que você selecionou podem ser marcadas como concluídas.<br /> Se você optar por continuar, <b>as tarefas listadas abaixo serão marcadas como concluídas</b>. Se você tiver tarefas incompletas, elas serão fechadas.",
    markCompleteMessgae3: "<b>As tarefas listadas abaixo não serão marcadas como concluídas</b> porque não têm nenhuma evidência associada ou a evidência associada não possui aprovações.",
    markCompleteMessgae4: "<b>As tarefas listadas abaixo não podem ser marcadas como concluídas</b> porque não têm nenhuma evidência associada ou a evidência associada não tem aprovações.",

    // Tasklist - bulk handoff
    handOffLabel: "Hand off",
    confirmHandOff: "Confirmar hand off",
    handOffMessgae1: "Tem certeza de que deseja <b>entregar as tarefas selecionadas</b> ao próximo membro da equipe designado? <br /> Se você tiver atribuições incompletas para as tarefas selecionadas, elas serão fechadas.",
    handOffMessgae2: "Apenas algumas das tarefas que você selecionou têm outro membro da equipe atribuído. <br />Se você optar por continuar, <b>as tarefas listadas abaixo serão entregues</b>. Se você tiver atribuições incompletas para as tarefas selecionadas, elas serão fechadas.",
    handOffMessgae3: "<b>As tarefas listadas abaixo não serão entregues</b> porque não possuem atribuições incompletas.",
    handOffMessgae4: "<b>As tarefas listadas abaixo não podem ser entregues</b> porque não possuem atribuições incompletas.",
    closeMyAssignments: "Fechar minhas atribuições",

    saveQuickFilter: "Salvar filtro rápido",
    saveQuickFilterModalHeader: "Salve os chips de filtro que você aplicou como um filtro rápido.",
    saveQuickFilterModalText: "Selecione filtros rápidos salvos e sugeridos para economizar tempo quando acessar este engagement novamente. Você pode criar até cinco filtros rápidos salvos por engagement.",
    quickfiltername: "Nome do filtro rápido",
    taskCategory: "Categoria da tarefa",

    cannotsavefilter: "Não é possível salvar o filtro rápido personalizado",
    cannotsavefiltermodalheadertext: "<b>Você só pode salvar cinco filtros rápidos personalizados por engagement.</b> <br /> Se quiser continuar, exclua um de seus filtros rápidos personalizados existentes e tente novamente.",
    savedFilters: "Filtros salvos",
    taskassignedto: "Tarefa atribuída a",
    noteassignedto: "Nota atribuída a",
    taskPrefix: "Prefixo da tarefa",
    taskSuffix: "Sufixo de tarefa",

    // Mark complete/HandOff Evidences category
    noSignOffs: "Sem aprovações",
    noSignOffsByMe: "Nenhuma assinatura minha",
    myPreparerSignOffs: "Minha assinatura de preparador",
    myReviewerSignOffs: "Minha assunatura de revisor",
    myPreparerAndReviewerSignOffs: "Minhas assinaturas de preparador e revisor",

    notificationDownErrorMessage: "O recurso Notificações está temporariamente indisponível. Atualize a página e tente novamente. Se esta mensagem persistir, entre em contato com o Help Desk.",
    notificationUpbutSomeLoadingErrorMessage: "A Central de Notificações está temporariamente indisponível. Atualize a página e tente novamente - ela estará disponível em breve.",

    timeTrackerErrorFallBackMessage: "O recurso Controle de tempo está temporariamente indisponível. Atualize a página e tente novamente. Se esta mensagem persistir, entre em contato com o Help Desk.",
    timeTrackerLoadingFallbackMessage: "O recurso Controle de tempo está temporariamente indisponível. Em breve estará disponível.",

    signOffOnAllAs: "Assine em todos como",
    accountType: "Tipo de conta",

    openDocumentInstructionalText: "Este documento será aberto automaticamente. <b>Você não precisa clicar para abrí-lo.</b> <br>Depois que o documento for aberto, você poderá fechar esta aba.",
    closeTab: "Fechar aba",

    // Build Step - Add Due Date
    milestones: "Marcos",
    events: "Eventos",
    noTimePhasesHaveBeenIdentified: "Nenhuma fase de tempo foi identificada.",

    wcgws: "WCGWs",
    relatedControls: "Controles Relacionados,",
    relatedControlsWCGWsRatio: "Controles relacionados/WCGWs",
    wcgwsToControlsRatio: "Proporção de WCGWs para controles",
    controlsToWCGWsRatio: "Proporção de controles para WCGWs",
    testedControls: "Controles testados",

    // Collaboration request to Task relation
    CollaborationModalTitle: "Relacionar solicitações a tarefas",
    CollaborationModalDescription: "Para relacionar uma solicitação a uma tarefa, arraste e solte uma ou mais solicitações na tarefa abaixo.",
    noDataFound: "Nenhum dado encontrado",
    taskName: "Tarefa",
    showMessage: "Selecione uma categoria e um grupo de tarefas para começar",
    showCategory: "Categoria",
    showTaskGroup: "Grupo de tarefas",
    optionITProcesses: "Processos de TI",
    optionExecutionGeneral: "Execução geral",
    relatedRequestsLabel: "Solicitações relacionadas",
    relatedRequestsFormatted: "{0} Solicitações relacionadas",
    relatedRequestFormatted: "{0} Solicitação relacionada",
    relatedRequests: "Solicitações relacionadas",
    relatedTasks: "Tarefas relacionadas",
    relatedSuccessSingleMessage: "{0} solicitação foi relacionada à tarefa com sucesso.",
    relatedSuccessMultipleMessage: "{0} solicitações foram relacionadas à tarefa com sucesso.",
    showUnrelated: "Mostrar {0} não relacionado",
    unrelate: "'Não relacionado",
    noRequestsMessage: "Nenhuma solicitação disponível",
    requestNumber: "Número da solicitação",
    sortAscending: "Classificar em ordem crescente",
    sortDescending: "Classificar em ordem decrescente",
    removeSorting: 'Remove sorting',

    // PIC Dashboard
    groupBy: "Agrupar por",
    allTasks: "Todas as tarefas",
    iTSOs: "IT/SOs",
    generalExecution: "Execução geral",
    PICSignOff: "Assinatura de PIC",
    EQRSignOff: "Assinatura de EQR",
    completed: "Concluído",
    allAssigned: "Todos atribuídos",
    picTaskAssignmentLabel: "Suas atribuições",
    assignReadyForReview: "Atual",
    assignUpcomingForReview: "Por vir",
    assignReadyForReviewTasks: "Atribuições atuais",
    assignUpcomingForReviewTasks: "Próximas atribuições",
    picTaskSignoffInComplete: "Tarefas com aprovações <b>PIC</b> incompletas",
    picDocSignoffInComplete: "Documentos com aprovações <b>PIC</b> incompletas",
    eqrTaskSignoffInComplete: "Tarefas com aprovações <b>EQR</b> incompletas",
    eqrDocSignoffInComplete: "Documentos com assinaturas <b>EQR</b> incompletas",
    collapseCards: "Recolher cartões",
    expandCards: "Expandir cartões",
    noUserSelectedPlaceholder1: "O {0} não foi identificado ou convidado para o projeto",
    noUserSelectedPlaceholder2: "Clique aqui",
    noUserSelectedPlaceholder3: "para identificar ou convidar o {0}.",
    notInvitedLabel: "Não convidado",
    noTasksPlaceholder: "Não há tarefas associadas aos <br/>marcos nesta fase de auditoria.",
    noTasksTilesPlaceholder: "Nenhuma tarefa atribuída ao usuário selecionado",
    noAssignmentPlaceholder: "Nenhuma atribuição encontrada",
    dueDateAssignmentPlaceholder: "Atribuições por data de vencimento",
    countAssignmentPlaceholder: "Contagem de atribuições",
    OverduetPlaceholder: "Atrasado",
    TodayPlaceholder: "Hoje",
    tasksView: "Visualização de tarefas",
    documentsView: "Visualização de documentos",
    picAndEqr: "PIC & EQR",
    ResponsiveToSR: "Relacionado a ⚡RS",
    responsiveToFR: "Relacionado a ⚡RF",
    relatedTasksFormatted: "{0} Tarefas relacionadas",
    relatedTaskFormatted: "{0} Tarefa relacionada",
    autoAssignWarning2: "Clique aqui",
    toAssign: "atribuir",
    taskAssignWarning: "tarefa com {0} requisitos de aprovação não atribuídos,",
    tasksAssignWarning: "tarefa com {0} requisitos de aprovação não atribuídos,",
    taskAdditionalFuncText1: "<b>Esta tarefa tem funcionalidade adicional. Por favor </b>",
    taskAdditionalFuncText2: "<b> para navegar até ele.</b><p>Tarefas de Construção não exigem que a evidência seja associada para marcar como concluída, a menos que a tarefa exija revisão de PIC/EQR.</p>",
    taskadditionalfunctionality: "<b>Esta tarefa possui funcionalidades adicionais. Por favor</b> {0} <b>navegue até ela.</b><p>As tarefas criadas não exigem a associação de evidências para serem marcadas como concluídas, a menos que a tarefa exija revisão de PIC/EQR.</p>",
    taskclickhere: "clique aqui",
    taskAutoAssignModalTitle: "Atribuição automática",
	taskAutoAssignModalDescription: 'Há {0} tarefa com um requisito de aprovação EQR que não foi atribuído a {1}. Clique em "Atribuir" para criar atribuição de EQR para {1}.',
	tasksAutoAssignModalDescription: 'Existem {0} tarefas com um requisito de assinatura de EQR que não foram atribuídas a {1}. Clique em "Atribuir" para criar atribuições de EQR para {1}.',
    picTaskAutoAssignSuccessMessage: "tarefa com requisito de assinatura de PIC atribuído a",
    picTasksAutoAssignSuccessMessage: "tarefas com requisito de assinatura de PIC atribuído a",
    eqrTaskAutoAssignSuccessMessage: "tarefa com requisito de assinatura de EQR atribuído a",
    eqrTasksAutoAssignSuccessMessage: "tarefas com requisito de assinatura de EQR atribuído a",
    taskEntityDocumentValidationMsg: "Esta tarefa possui entidades que não possuem nenhuma evidência responsiva. Alterne para visualizar por entidades para ver quais entidades precisam de documentação adicional.",
    // PIC/EQR Sign-Off validation message
    picSignOffValidationMsg: "Esta tarefa requer a assinatura de PIC, mas nenhum documento de PIC está associado. Adicione pelo menos um documento com este requisito.",
    eqrSignOffValidationMsg: "Esta tarefa requer a assinatura de EQR, mas nenhum documento de EQR está associado. Adicione pelo menos um documento com este requisito.",
    picAndEQRSignOffValidationMsg: "Esta tarefa requer a assinatura de PIC/EQR, mas nenhum documento de PIC/EQR está associado. Adicione pelo menos um documento com este requisito.",
    updateDataOnPicEqrDashboardBannerMessage: "As alterações feitas não foram atualizadas abaixo. {0} para atualizar a página.",
    showMissingSignOffByLabel: "Mostrar documentos sem assinatura {0}",

    FindingsReportName: "Descobertas",
    FindingsDeficiencyReportTabName: "Deficiência",
    FindingsMisstatementReportTabName: "Erro",
    FindingsDeficiencyITReportTabName: "Deficiência-TI",
    auditPlanRelatedEvidenceReporLabel: "Plano de auditoria com evidências relacionadas",
    groupStructureSummaryReportReportLabel: "Resumo da estrutura do Grupo",
    auditPlanReportLabel: "Relatório do plano de auditoria",
    itAppSOSummaryReportLabel: "Resumo do aplicativo de TI & SO",
    craSummaryReportLabel: "Resumo do CRA",
    teamMembersLabel: "Membros da equipe",
    ipeLabel: 'Information produced by the entity (IPE)',
    validationChecksReportLabel: "Checks de validação",
    trialBalanceReportLabel: "Balancete",
    trialBalanceReportTabLabel: "Relatório do balancete",
    reportLabelYes: "Sim",
    reportLabelNo: "Não",
    assignedBy: "Atribuído por",
    openInReviewNotesHub: "Abrir no hub de notas de revisão",
    nextNote: "Próximo",
    previousNote: "Anterior",

    //component team group tab names
    accountInfoCanvasFormExport: "Informação da conta",

    //project insight tab names
    projectInsightCanvasFormExport: "Exportação do Formulário do Canvas",
    projectInsightSCOTToWCGWToControl: "SCOT para WCGW para Controle",
    projectInsightControlToITApplication: "Controle para Aplicativo de TI",
    projectInsightControlToAssertion: "Controle para Assertiva",
    projectInsightRiskToWCGW: "Riscos para WCGWs",

    //IPE Report
    ipeControlsReport: 'Controls',
    ipeSubstantiveReport: 'Substantive',
    ipeITGCReport: 'ITGC',

    // Milestone tab names
    milestonesReport: "Relatório de Milestones",
    unmappedTasks: "Tarefas não mapeadas",

    // Effective
    isEffective: "Eficaz",
    inEffective: "Ineficaz",
    nonEffective: "Não efetivo",

    clientRequests: "Solicitações do cliente",
    externalTasks: "Tarefas Externas",
    requestPriority: "Solicitar prioridade",
    scot: "SCOT",
    assertionR: "Assertiva",
    wcgwToControlMappingTotal: "WCGW para mapeamento totais de controles",

    //CRA build step
    buildStep2EntityHeaderText: "Contas significativas e divulgações, assertivas, WCGWs relacionados e controles",
    buildStep4EntityHeaderText: "Contas significativas, divulgações e assertivas relacionadas",
    accountNameHeader: "Contas significativas e divulgações",
    noAssertionsLabel: "Nenhuma assertiva relacionada. Clique em <a>Gerenciar contas e divulgações</a> para começar.",
    noAssertionsBuildStep2text1: "Pelo menos uma assertiva deve estar relacionada a esta conta. Clique em",
    accountWithoutAssertionsBuildStep2text1: "Cada conta ou divulgação significativa deve ter pelo menos uma assertiva relacionada. Clique",
    noAssertionsBuildStep2text2: "Gerenciar contas e divulgações",
	noAccountsLabel: 'Nenhuma conta ou divulgação significativa foi criada. Clique em <span class="bold-text">Gerenciar contas e divulgações</span> para começar.',
	noAccountsLabelPlaceHolder: 'Nenhuma conta ou divulgação significativa foi criada. <span class="bold-text">Gerencie contas e divulgações</span> para começar.',
    noAccountsOrDiscloserPreText: "Nenhuma conta ou divulgação significativa foi criada.",
    noAccountsOrDiscloserText: "Gerenciar contas e divulgações",
    noAccountsOrDiscloserPostText: "para começar.",
    noAssertionsBuildStep1text1: "Pelo menos uma assertiva deve estar relacionada com este risco. Clique em",
    noAssertionsBuildStep1text1Msg: "Cada risco deve ter pelo menos uma assertiva relacionada.",
    noAssertionsBuildStep1text2: "Relacionar assertivas",
    noAssertionsBuildStep1text3: " para começar.",
    editRisk: "Editar risco",
    deleteRisk: "Excluir risco",
    noControlsRelatedWWCGW: "Não há controles relacionados.",
    noControlsRelatedWCGW: "Para cada WCGW relacionado a uma assertiva com risco de Confiança em controle, pelo menos um controle deve ser selecionado para teste. Crie um",
    noControlsRelatedWCGWNewCont: "Novo controle",
    noControlsRelatedWCGWor: " ou",
    noControlsRelatedWCGWRelateCont: "Relacionar um controle existente",
    noControlsForWCGW: "Assertivas com risco de controle de Não Confiança não têm um requisito para identificar controles.",
    noControlsRelatedWCGWFooter: " para começar.",
    relateWCGWs: "<a>Relacionar WCGWs</a>",
    noWCGWs: "Nenhum WCGW relacionado.",
    noWCGWsClick: "Clique",
    noWCGWsFooter: "para começar.",
    showOnlyRisksWithNoAssertion: "Mostre apenas riscos sem quaisquer assertivas relacionadas",
    showIncomplete: "Mostrar apenas assertiva com CRA incompleto",
    showOnlyInvalidBuildStep2: "Mostrar apenas contas faltando detalhes obrigatórios",
    noTestedControlsWithRelyAssertion: "Para cada WCGW relacionado a uma assertiva com risco de controle de Confiança, pelo menos um controle deve ser selecionado para teste.",

    // Account build step
    accountOrDisclosure: "Conta / divulgações",
    relatedAssertions: "Afirmativas relacionadas",
    relatedAccountsAndAssertions: "Contas e assertivas relacionadas",
    pspIndexTitle: "Índice PSP",
    statementTypeTitle: "Tipo de declaração",
    significantAccountLabel: "Significativo",
    limitedRiskLabel: "Risco limitado",
    insignificant: "Insignificante",
    significantDiscloure: "Divulgação Significativa",
	accountAddedMessage: 'A conta "##" foi criada com sucesso',
    accounHeaderText: "Contas e divulgações",

    // Add accounts / disclosures Modal labels
    accountsListTitle: "Contas/divulgações e afirmativas relacionadas",
    addAccountsDisclosures: "Adicionar contas/divulgações",
    editAccountsDisclosures: "Editar contas / divulgações",
    accountNameLabel: "Nome da conta (obrigatório)",
    accountDesignationLabel: "Designação (obrigatório)",
    accountEstimateLabel: "A conta tem uma estimativa",
    accountStatementTypeLabel: "Tipo de declaração (obrigatório)",
    pspIndexDropdownLabel: "Índice PSP (obrigatório)",
    removePSPIndexLabel: "Remover índice PSP",
    assertionsLabel: "Assertivas (obrigatório)",
    noAccounsMessage: "Nenhuma conta encontrada. Adicione contas para começar.",

    //Delete account / disclosure modal labels
    deleteAccountDisclosure: "Excluir conta/divulgação",
    deleteAcConfirmMessage: "Tem certeza de que deseja excluir a conta/divulgação {0}? Todas as declarações relacionadas serão excluídas. Quaisquer tarefas relacionadas apenas à conta/divulgação selecionada também serão excluídas.",

    true: "Verdadeiro",
    false: "Falso",
    taskSummaryReportEngagementInfo: "Múltiplos Engagements",
    viewPriority: "Ver prioridades",
    priorityRequestsSent: "Solicitações prioritárias enviadas",

    //reactive frame
    maxTabsLocked: "Máximo de guias permitidas atingido. Solte e feche uma das guias para abrir uma nova.",
    openInNewTab: "Abrir em nova aba",
    copyLink: "Copiar link",
    copySuccess: "Link copiado para a área de transferência",
    copyFailure: "Falha ao copiar o link para a área de transferência",
    minimize: "Minimizar",

    //Risk status for account cards
    riskStatusLabels: {
        NoAssertionsAvailableLabel: "Nenhuma assertiva disponível",
        SignificanceNotSelectedLabel: "Significância não selecionada",
        InsignificantLabel: "Insignificante"
    },

    lockTab: "Fixar Guia",
    keyDocuments: "Documentos chave",
    suggestedDocuments: "Documentos sugeridos",
    noSuggestedDocuments: "Nenhum documento sugerido",
    exitBulkMode: "Sair do modo em massa",
    bulkLabel: "Volume",

    me: "Meu",
    viewByUser: "Visualizar por usuário",
    unsentDraftCapitalized: "Rascunhos não enviados",
    picSignoffInComplete: "Aprovação do PIC incompleta",
    eqrSignOffIncomplete: "Aprovação do EQR incompleta",

    tableView: "Visualização da tabela",
    noRelatedAssertions: "Nenhuma assertiva relacionada.",

    multiEntityTileMessage1: "Clique",
    multiEntityTileMessage2: "aqui",
    multiEntityTileMessage3: " para ver o status por entidade",
    allItemsMessage: "para ver todos os itens",

    EntitySelector: "Selecione uma entidade para começar",
    allEntities: "Todas as entidades",
    multiEntity: "Multi-entidade",
    ungrouped: "Desagrupado",
    numberSelected: "{0} selecionado",
    allTimePhases: "Tudo",
    timePhases: "Fase temporal",
    noTimePhaseFound: "Nenhuma fase de tempo encontrada",
    unrelatedAssignments: "Tarefas não atribuídas",
    unrelatedRequests: "Solicitações não relacionadas",
    relateRequests: "Solicitações relacionadas",
    taskWithoutAnyAssignments: "Tarefas sem quaisquer atribuições",
    privacyNotice: "Aviso de privacidade",
    lastPublishedAndSent: "Última publicação e envio",
    drafts: "Rascunhos",
    allEntitiesTask: "Esta é uma tarefa que abrange todo o engagement e está relacionada com todas as entidades",
    noRelatedEntities: "Nenhuma entidade relacionada",
    clickNewRisk: "para começar.",
    relatedAccountsDisclosuresAndAssertions: "Relacionar contas significativas, divulgações e assertivas",
    relateAssertion: "Relacionar assertivas",
    taskByEntity: "Tarefa por entidade",
    engagementWideTask: "Tarefa a nivel do engagement",
    componentEngagementPill: "CT",
    primaryAndComponentEngagementPill: "PT/CT",
    // Scot build steps
    scotHeader: "SCOTs",
    searchScot: "Procurar",
    manageScots: "Gerenciar SCOTs",
    superModelStep1ScotMessage: "Contas significativas e divulgações e SCOTs relacionadas",
    scotRelatedITApplicationServiceOrg: "SCOTs e aplicativos de TI e serviços de organização relacionados",
    noScotsAvailable: "Nenhum resultado encontrado",
    searchScotPlaceholder: "Pesquisar",
    searchScotClearHoverText: "Limpar",
    showOnlyUnrelatedScotToggleSwitch: "Mostrar apenas não relacionado",
    newScot: "Nova SCOT",
    importFromKnowledgeScot: "Importar SCOTs",
    importAccountsAndDisclosures: "Importar contas e divulgações",
    showOnlyAccountRelatedScot: "Mostrar apenas SCOTs sem qualquer conta e divulgação significativa relacionada",
    warningMessageEstimateScotNotAssociatedWithEstimatedAccount: "Cada SCOT de estimativa deve estar relacionada a pelo menos uma conta significativa ou divulgação significativa com uma estimativa. Arraste e solte esta SCOT em uma conta relevante ou divulgação significativa.",
    warningMessageScotNotAssociatedWithAccount: "Cada SCOT deve estar relacionado a pelo menos uma conta significativa ou divulgação significativa. Arraste e solte esta SCOT em uma conta relevante ou divulgação significativa.",
    showvalidations: "Mostrar validações",

    scotRelatedWCGWandControls: "SCOTs e WCGWs relacionados e controles",
    newWcgw: "Novo WCGW",
    manageWCGWs: "Gerenciar WCGWs",
    manageControl: "Gerenciar controles",
    importWCGWs: "Importar WCGWs",
    relateWCGWs: "Relacionar WCGWs",
    newControl: "Novo controle",
    importControl: "Importar controle",
    importControls: "Importar Controles",
    relateControl: "Relacionar controles",
    scotStrategyIsControlMessage: "Nenhum controle identificado para este WCGW. A estratégia da SCOT não está definida.",
    scotStrategyIsWCGWMessage: "Nenhum WCGW identificado para esta SCOT. A estratégia da SCOT não está definida.",
    controlsPlaceholderWithNoRelatedWCGWsMessage: "Cada SCOT deve estar relacionada a pelo menos um WCGW. Crie um",
    controlsPlaceholderWithNoRelatedControlsMessage: "Cada WCGW deve estar relacionado a pelo menos um Controle. Crie um",
    noITApplicationSOMessage: "Nenhum aplicativo de TI ou serviços de organização identificado para esta SCOT. Clique",
    relatedItAppSOHeaderMessage: "Aplicações de TI e serviços de organização relacionadas",
    substantivePlaceholderWithNoRelatedControlsMessage: "Nenhum controle identificado para esteaSCOT. Para SCOTs com estratégia substantiva, não é necessário identificar controles.",
    substantivePlaceholderWithNoRelatedWCGWsMessage: "Nenhum WCGW identificado para esta SCOT. Para SCOTs com estratégia substantiva, os WCGWs precisam ser identificados.",
    noITApplicationSOMessageText: "para relacionar quando necessário.",
    notSelected: "Não selecionado",
    or: "ou",

    //WCGWControls
    showOnlyWCGWRelatedControls: "Mostrar apenas relacionados",

    createorRelateControl: "Crie um novo controle ou relacione um controle existente",

    //Accounts Scot build steps
    accountHeader: "Contas",
    searchAccount: "Pesquisar conta",
    searchAccountPlaceholder: "Pesquisar",
    manageAccounts: "Gerenciar contas e divulgações",
    showOnlyUnrelatedAccountToggleSwitch: "Mostrar apenas não relacionado",
    searchAccountClearHoverText: "Limpar",
    noAccountsAvailable: "Nenhum resultado encontrado",
    showOnlyScotRelatedAccount: "Mostrar apenas contas e divulgações significativas sem qualquer SCOT relacionada",
    warningMessageEstimateAccountNotAssociatedWithEstimatedScot: "Cada conta ou divulgação significativa com uma estimativa deve estar relacionada a pelo menos uma SCOT de estimativa. Arraste e solte uma SCOT relevante existente nesta conta significativa ou divulgação significativa",
    warningMessageAccountNotAssociatedWithScot: "Cada conta ou divulgação significativa deve estar relacionada a pelo menos uma SCOT. Arraste e solte uma SCOT relevante existente nesta conta significativa ou divulgação significativa",
    significantAccountsAndDisclosures: "Contas significativas e divulgações",
    // Independence Only

    independenceOnlyStatus: "Apenas independência",

    //Controls
    controlDesignEffectivenessWarningValidation: "Os controles devem ter um desenho efetivo selecionado",
    controlHeader: "SCOT e controles relacionados",
    manageControls: "Gerenciar controles",
    manageITApplications: "Gerenciar aplicativos de TI",
    searchControlClearHoverText: "Limpar",
    searchControlPlaceholder: "Pesquisar",
    noControlsAvailable: "Nenhum resultado encontrado",
    controlName: "Nome do controle",
    frequency: "Frequência",
    type: "Tipo",
    newSO: "Novo SO",
    designEffectiveness: "Efetividade do desenho",
    testing: "Testando",
    strategyTypeName: "Estratégia da SCOT",
    controlTestingYes: "Sim",
    controlTestingNo: "Não",
    effective: "Efetivo",
    ineffective: "Inefetivo",
    noControlsResult: "Nenhum resultado encontrado",
    noControlsLabel: "Nenhum resultado encontrado",
    relatedControl: "Controle relacionado",
    relateControls: "Relacionar controles",
    controlTypeValues: {
        itApplication: "Controles de aplicativos de TI",
        itDependentManual: "Controle Manual Dependente de TI",
        manualPrevent: "Prevenção manual",
        manualDetect: "Detecção manual"
    },
    controlFrequencyTypes: {
        manyTimesPerDay: "Muitas vezes por dia",
        daily: "Diariamente",
        weekly: "Semanalmente",
        monthly: "Mensalmente",
        quarterly: "Trimestralmente",
        annually: "Anualmente",
        iTApplicationControl: "Controle de aplicativos de TI",
        other: "Outro"
    },
    filterTypeOfScots: "SCOTs",
    noScotsAvailable: "Nenhum resultado encontrado",


    onlyShowControlsWithNoDesignEffectiveness: "Mostrar apenas controles sem efetividade do desenho selecionada",

    // control Tasks
    controlCount: "{0} controles",

    //Create and Edit WCGW
    wcgwInputName: "Nome do WCGW",
    editWCGW: "Editar WCGW",
    createNewWCGW: "Criar novo WCGW",
    editTheWCGW: "Editar o WCGW",
    createEditWCGWSave: "Salvar",
    createEditWCGWClose: "Cancelar",
    createEditWCGWModelScot: "SCOT",
    newWCGWTitel: "Novo WCGW",
    wcgwNameIsRequired: "O nome do WCGW é obrigatório",
    deleteWCGW: "Excluir WCGW",


    //Audit Plan
    importPSPButtonText: "Importar PSPs",
    commonContentUpdateSuccessMessage: "Atualização de conteúdo em andamento. Isso pode levar até quinze minutos para ser concluído. Atualize a página para ver os PSPs recém-importados.",
    responsivetoRisks: "Responsivo aos riscos",
    procedures: "Procedimentos",
    toc: "TOC",
    significantandFraudRisksHeading: "Riscos significativos e de fraude e seus procedimentos e controles responsivos",
    risksBeingRespondedToByComponentTeam: "Os riscos estão sendo respondidos pela(s) equipe(s) componente(s).",
    responsivecontrolsandTOCs: "Controles responsivos e TOCs",
    ResponsivePSPOSP: "PSP/OSP responsivo",
    responsivePSPsOSPs: "PSPs/OSPs responsivos",
    responsiveTOC: "TOC responsivo",
    responsiveControl: "Controle responsivo",
    responsivePSPOPSMessage: "Pelo menos um procedimento substantivo deve ser identificado como respondendo a esta assertiva para este risco. Clique em {0} para identificar procedimentos substantivos responsivos.",
    responsiveControlMessage: "Pelo menos um controle (com avaliação completa da efetividade do projeto) deve ser identificado como responsivo a essa assertiva para esse risco. Clique em {0} para identificar os controles responsivos. Clique em {1} para definir a efetividade do desenho ou a estratégia de teste.",
    responsiveTOCMessage: "As assertivas com risco de controle de confirar devem ter pelo menos um TOC que responda ao risco para um controle que (1) não seja designado como de risco mais baixo e (2) tenha uma efetividade do desenho concluída. Clique em <b>TOC responsivo</b> para identificar TOCs responsivos.",
    notcompleted: "Não concluído",
    noResponsiveTOCAvailable: "Nenhum TOCs responsivo foi identificado para este controle.",
    refresh: "Atualizar dados",
    tocHoverOverWhenControlTestingHasNoorNotCompleted: "Este controle não foi selecionado para teste. Use <b>Gerenciar controles</b> para alterar a seleção de testes.",
    noresponsiveTOCIdentified: "Nenhum TOC responsivo foi identificado.",
    taskAssertionnotModified: "As assertivas da tarefa não foram modificadas. Edite o relacionamento da assertiva para prosseguir ou clique em cancelar para sair.",
    failedToEditRelatedAssertions: "Falha ao editar as assertivas relacionadas à tarefa. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    assertionCannotEdited: "As assertivas com caixa de seleção desativada foram definidas pela metodologia da EY e não podem ser editadas.",
    editAssertionInfoMessage: "Adicione ou remova assertivas para a tarefa. Deve haver pelo menos uma assertiva selecionada.",
    editRelatedAssertions: "Editar assertivas relacionadas",
    loweRiskHeader: "Risco mais baixo",
    placeholderWhenControlTestingHasNotCompleted: "Este controle não foi selecionado para teste. Use {0} para alterar a seleção de teste.",
    pspandOSP: "PSPs/OSPs",
    tocs: "TOCs",
    norelatedAssertionPlaceHolder: "Cada risco significativo ou de fraude deve ter pelo menos uma assertiva identificada como relacionada a esse risco. Clique em {0} para identificar assertivas relacionadas.",
    assertionMustHaveOneControlWithCompleteDesignEffectiveness: "Cada assertiva deve ter pelo menos um controle com o desenho efetivo concluído identificado como sendo responsivo ao risco. Clique em {0} para identificar um controle responsivo.",
    controlRiskRelyNotLowerRisk: "Cada assertiva com risco de controle de confiança deve ter pelo menos um controle que (1) não seja designado como de risco mais baixo, (2) projetado de forma efetiva e (3) selecionado para teste. Clique em {0} para identificar o controle responsivo.",
    controlRiskRelyWithDesignEffectively: "Cada assertiva com risco de controle de confiança deve ter pelo menos um controle que seja (1) projetado de forma efetiva e (2) selecionado para teste. Clique em {0} para identificar o controle responsivo.",

    assertionWithControlRiskNotRely: "Assertivas com risco de controle de não confiança não possuem o requisito de identificar um teste de controle.",
    thisControlNotSelectedForTesting: "Este controle não foi selecionado para teste. Clique em {0} para alterar a seleção de teste.",
    testControlRelatedToControlAsLowerRisk: "Um teste de controle relacionado a um controle designado como de risco mais baixo não endereçará o risco para esta assertiva.",
    testControlWithoutCompleteDE: "Um teste de controle relacionado a um controle sem uma avaliação da efetividade do desenho concluída não abordará o risco para esta assertiva. Clique em {0} para definir a efetividade do desenho.",
    testControlrelatedToineffective: "Um teste de controle relacionado a um controle com uma avaliação de efetividade do desenho ineficaz não abordará o risco para esta assertiva. Clique em {0} para alterar a efetividade do desenho.",
    anotherTestControlIdentified: "Foi identificado outro teste de controle que responde ao risco desta assertiva e não é necessário identificar mais testes de controle. Nenhum TOC responsivo foi identificado para este controle.",
    eachControlMustHaveOneToc: "Cada assertiva com risco de controle de confiança deve ter pelo menos um TOC responsivo ao risco de um controle que (1) não seja designado como de risco mais baixo, (2) projetado de forma efetiva e (3) selecionado para teste. Nenhum TOC responsivo foi identificado para este controle. Clique em {0} para identificar TOCs responsivos.",
    eachAssertionControlHaveAtleasetOneTOC: "Cada assertiva com risco de controle de confiança deve ter pelo menos um TOC responsivo ao risco para um controle que seja (1) projetado de forma efetiva e (2) selecionado para teste. Nenhum TOC responsivo foi identificado para este controle. Clique em {0} para identificar TOCs responsivos.",
    norepsonsivePSPOSPplaceholder: "Cada assertiva deve ter pelo menos um procedimento substantivo identificado como responsivo a esse risco. Clique em {0} para identificar um procedimento substantivo responsivo.",

    //Reject Task
    rejectPspModalTitle: "Rejeitar PSP",
    rationaleRequired: "Obrigatório",
    rationaleTextEditorLabel: "Justificativa para rejeitar o PSP",
    rejectTaskErrorMessage: "Não é possível rejeitar a tarefa. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    rejectTaskModalHeader: "Tem certeza de que deseja rejeitar o PSP selecionado?",
    rejectTaskModaWarningText: "As evidências relacionadas que não estejam relacionadas a quaisquer outros engagement deste trabalho serão movidas para arquivos temporários.",
    rejectTaskRationaleLabel: "Justificativa (obrigatório)",

    // Adobe Analytics
    aaCookieConsentTitle: "Bem-vindo ao",
    aaCookieContentPrompt: "Você deseja permitir cookies?",
	aaCookieConsentExplanation: '<p>Em adição aos cookies que são estritamente necessários para operar este website, utilizamos os seguintes tipos de cookies para melhorar a sua experiência e os nossos serviços: <strong>Cookies funcionais</strong> para melhorar a sua experiência (por exemplo, lembrar configurações), <strong>Cookies de desempenho</strong> para medir o desempenho do site e melhorar sua experiência, <strong>cookies de publicidade/segmentação</strong>, que são definidos por terceiros com quem executamos campanhas publicitárias e nos permitem fornecer anúncios relevantes para você.</p><p>Revise nossa <a target="_blank" href="https://www.ey.com/en_us/cookie-policy">política de cookies</a> para obter mais informações.</p>',
	aaCookieConsentExplanationWithDoNotTrack: '<p>Em adição aos cookies que são estritamente necessários para operar este site, utilizamos os seguintes tipos de cookies para melhorar a sua experiência e os nossos serviços: <strong>Cookies funcionais</strong> para melhorar a sua experiência (por exemplo, lembrar configurações), <strong>Cookies de desempenho</strong> para medir o desempenho do site e melhorar sua experiência, <strong>cookies de publicidade/segmentação</strong>, que são definidos por terceiros com quem executamos campanhas publicitárias e nos permitem fornecer anúncios relevantes para você.</p><p>Detectamos que você ativou a configuração Não Rastrear em seu navegador; como resultado, os cookies de publicidade/segmentação são desativados automaticamente.</p><p>Revise nossa <a target="_blank" href="https://www.ey.com/en_us/cookie-policy">política de cookies </a> para obter mais informações.</p>',
    aaCookieConsentDeclineOptionalAction: "Eu recuso cookies opcionais",
    aaCookieConsentAcceptAllAction: "Eu aceito todos os cookies",
    aaCookieConsentCustomizeAction: "Personalizar cookies",
    aaCookieConsentCustomizeURL: 'https://www.ey.com/en_us/cookie-settings',

    //Task Sections
    taskSectionLabels: {
        taskSectionHeader: "Grupos de tarefas e tarefas relacionadas",
        manageTaskSections: "Gerenciar grupos de tarefas",
        taskSectionsAccordionHeader: "Grupos de tarefas",
        phaseAccordionHeader: "Fase",
        tasksAccordionHeader: "Tarefas",
        rejectedAccordionHeader: "Rejeitado",
        noRelatedTasksMessage: "Não há PSTs/OSTs disponíveis. Crie um {0} para começar.",
        taskSectionTaskHeader: "Tarefas",
        newOSTButtonText: "Nova OST",
        cutomTaskSectionBadgeText: "Personalizado",
        rejectedTasksLabel: "PSTs rejeitados",
        additionalInfo: "Racional",
        rejectButton: "Rejeitar",
        acceptButton: "Aceitar",
        removeButton: "Remover",
        addButton: "Adicionar",
        allPSTsRejectedMessage: "Todas as PSTs foram rejeitadas.",
        rejectModalTitle: "Rejeitar PST",
        rationaleTextEditorLabel: "Justificativa para rejeitar a PST",
        rejectTaskModalHeader: "Tem certeza que deseja rejeitar a PST selecionada?",
        noResultsMessage: "Nenhum resultado encontrado",
        noTaskSetionsAvailableMessage: "Nenhuma seção de tarefa disponível",
        rejectTaskModaWarningText: "As evidências relacionadas que não estão relacionadas a nenhuma outra tarefa neste trabalho serão movidas para arquivos temporários. PSTs com documentos entregues pelo EY Canvas não podem ser rejeitados.",
        rejectTaskRationaleLabel: "Justificativa (obrigatório)"
    },

    // Cookie Settings
    cookieSettings: {
        title: "Configurações de cookies",
        explanation: "Por favor forneça seu consentimento para o uso de cookies em ey.com e na plataforma My EY. Selecione um ou mais dos tipos de cookies listados abaixo e salve sua(s) seleção(ões). Consulte a lista abaixo para obter detalhes sobre os tipos de cookies e sua finalidade.",
        emptyCookieListNotice: "Cookies desta categoria não são usados neste aplicativo",
        nameTableHeader: "Nome do cookie",
        providerTableHeader: "Provedor de cookies",
        purposeTableHeader: "Finalidade do cookie",
        typeTableHeader: "Tipo de cookie",
        durationTableHeader: "Duração do cookie",
        formSubmit: "Salvar minha seleção",
        requiredCookieListTitle: "Cookies necessários",
        functionalCookieListTitle: "Cookies Funcionais",
        functionalCookieAcceptance: "Aceito os cookies funcionais abaixo",
        functionalCookieExplanation: "Cookies de funcionalidade, que nos permitem melhorar a sua experiência (por exemplo, lembrando quaisquer configurações que você tenha selecionado).",
        performanceCookieListTitle: "Cookies de desempenho",
        performanceCookieAcceptance: "Aceito os cookies de desempenho abaixo",
        performanceCookieExplanation: "Cookies de desempenho, que nos ajudam a medir o desempenho do site e a melhorar a sua experiência. Ao utilizar cookies de desempenho não armazenamos quaisquer dados pessoais, apenas utilizamos a informação recolhida através destes cookies de forma agregada e anonimizada.",
        advertisingCookieListTitle: "Cookies de segmentação",
        advertisingCookieAcceptance: "Aceito os cookies de publicidade/segmentação abaixo",
        advertisingCookieExplanation: "Cookies de publicidade/segmentação, que utilizamos para rastrear a atividade e as sessões do usuário, para que possamos oferecer um serviço mais personalizado e (no caso de cookies de publicidade) que são definidos por terceiros com quem executamos campanhas publicitárias e nos permitem fornecer anúncios relevantes para você.",
        doNotTrackNotice: "Detectamos que você ativou a configuração Do Not Track em seu navegador; como resultado, os cookies de publicidade/segmentação são automaticamente desativados.",
    },

    //Task Sections and related Tasks
    taskSectionAndRelatedTask: "Seções de tarefas e tarefas relacionadas",
    manageTaskSections: "Gerenciar seções de tarefas",

    // Financial Statments
    financialStatementLabels: {
        financialStatements: "Demonstrações financeiras",
        trialBalance: "Balancete",
        okButton: "OK",
        leadSheet: "Folha mestra",
        balanceSheet: "Balanço patrimonial",
        incomeStatement: "Demonstração do resultado",
        eyreferences: "Referência",
        currenPeriod: "Data de análise",
        comparativePeriod: "Data comparativa",
        changeFrom: "Mudar de",
        percentageChangeFrom: "% Alteração de",
        notesColumn: "Notas",
        viewTrialBalanceType: "Visualizar por tipo de balancete",
        multiEntity: "Multi-entidade",
        placeHolderText: "Pesquisar classes de conta",
        currencyType: "Tipo de moeda",
        currencyCode: "Código da moeda",
        businessUnit: "Unidade de negócios",
        periodEnded: "data de término",
        periodsEnded: "datas terminadas",
        searchGLAccountPlaceholder: "Pesquisar contas contábeis",
        eyReferenceDocuments: "{0} documentos",
        relatedNotes: "Notas relacionadas",
        notAvailable: "Não disponível",
        significantDisclosures: "Divulgações significativas",
        noResultFound: "Nenhum resultado encontrado",
        openEYHelixProjects: "Abra projetos do EY Helix",
        openAdjustmentModule: "Módulo de ajuste aberto",
        goToSubstantiveProcedureLink: "Ir para procedimentos substantivos",
        cancel: "Cancelar",
        remove: "Remover"
    },

    financialStatementsClassView: {
        bulk: "Volume",
        eyAccount: "Conta EY",
        placeHolderText: "Pesquisar contas GL",
        noAccountDesignation: "A designação da conta não foi definida.",
        insignificantLeadSheetMessage: "Folhas mestra não são apresentadas para contas insignificantes",
        unmappedGLAccounts: "As folhas mestras não são apresentadas para contas não mapeadas",
        unmappedAccountText: 'Unmapped'
    },
	financialStatementTypeIds: [{
		id: 1,
		label: "Ativos"
	},
	{
		id: 4,
		label: "Passivos"
	},
	{
		id: 7,
		label: "Patrimônio líquido"
	},
	{
		id: 8,
		label: "Receita"
	},
	{
		id: 9,
		label: "Despesas"
	},
	{
		id: 17,
		label: "Resultado líquido"
	}
	],
    copyrightMessage: "Copyright © <ano> todos os direitos reservados",
    createNotes: {
        notesPlaceholderText: "Adicione notas clicando em {0} ou {1}.",
        newNote: "Adicionar nota",
        relateNote: "Relacionar nota",
        addNewNotesHeader: "Insira os detalhes da nota abaixo e selecione <b>\'Salvar e fechar\'</b> para finalizar. Para criar outra nota, selecione <b>\'Salvar e criar outra\'</b>.",
        noteIndex: "Índice",
        noteIndexRequired: "Índice (obrigatório)",
        noteDescription: "Descrição",
        noteDescriptionRequired: "Descrição (obrigatório)",
        saveAndClose: "Salvar e fechar",
        newTickmarkDescription: "Selecione o motivo pelo qual não há evidência referenciada para esta conta GL.",
        newTickmarkBulkModalDescription: " Selecione o motivo pelo qual não há nenhuma evidência referenciada às contas contábeis selecionadas."
    },
    deleteNotes: {
        deleteNote: "Excluir nota",
        deleteNoteTitle: "Tem certeza de que deseja excluir a nota selecionada?",
        delete: "Excluir",
        cancel: "Cancelar"
    },
    editNotes: {
        editNote: "Editar nota",
        editNotesHeader: "Edite os detalhes da nota abaixo e selecione <b>'Salvar e fechar'</b> para finalizar.",
        edit: "Editar",
        cancel: "Cancelar"
    },
    notesListLabels: {
        actions: "Ações",
        noteCount: "{0} nota",
        notesCount: "{0} notas"
    },
    relateNotes: {
        relateNoteLabel: "Relacionar nota",
        searchPlaceholder: "Procurar",
        accountLabel: "Conta",
        indexLabel: "Índice",
        descriptionLabel: "Descrição",
        addedLabel: "Adicionado",
        showOnlyRelatedLabel: "Mostrar apenas relacionados",
        noResultsFoundMessage: "Nenhum resultado encontrado",
        noteCount: "{0} Nota",
        notesCount: "{0} Notas",
        closeBtnTitle: "Fechar"
    },
    uploadEvidenceDocuments: {
        addnewEvidencesPlaceholderandLinks: "Adicionar evidência clicando em {0}, {1} ou designar nenhuma evidência necessária clicando em {2}.",
        newEvidence: "Novas evidências",
        relateEvidence: "Relacionar evidência",
        newTickMark: "Novo tickmark",
        relateTasks: 'Relate task',
        noTasksSeleted: "Selecione uma tarefa para continuar.",
        relateTaskPlaceholder: "Novas referências devem estar relacionadas a pelo menos uma tarefa. Selecione uma tarefa à qual este documento deve ser adicionado como evidência.",
        confirmButtonTitle: "Continuar",
        closeButtonTitle: "Cancelar",
        noResultsFound: "Nenhum resultado encontrado",
        taskType: "Tipo",
        taskName: "Nome da tarefa",
        taskCount: "{0} tarefa",
        tasksCount: "{0} tarefas",
        title: "Referência",
        removeReference: "Remover referência"
    },
    glAccountAssociatedNotes: {
        aggregatedNotesPlaceholder: "Nenhuma nota disponível. Selecione uma conta GL para criar uma nota.",
        notes: "Notas",
        relatedGlAccountPlaceholder: "Contas GL relacionadas"

    },
    finacialStatementsBulkOperations: {
        relateEvidenceLabel: "Relacionar evidência",
        selectedCountGLAccount: "{0} conta GL selecionada",
        selectedCountGLAccounts: "{0} contas GL selecionadas",
        selectAll: "Selecionar tudo",
        deselectAll: "Desmarcar tudo",
        exitBulkMode: "Sair do modo em massa",
        noGLAccountsSelectedValidationMessageEvidence: "Selecione pelo menos uma conta contábil para relacionar evidências ou clique em Sair do modo em massa.",
        noGLAccountsSelectedValidationMessageTickmark: "Selecione pelo menos uma conta GL para o novo tickmark ou clique em Sair do modo em massa.",
        noGLAccountsSelectedValidationMessageRemoveReference: "Selecione pelo menos uma conta GL para remover a referência ou clique em Sair do modo em massa.",
        relateTickmarkLabel: "Novo tickmark",
        removeReferenceLabel: "Remover referência",
        removeReferenceConfirmationMsg: "Confirme se deseja remover referências de todas as contas contábeis selecionadas."

    },
    financialStatementsFilters: {
        referenceFilterKey: "Contas GL sem referências",
        accountFilterKey: "Contas GL sem mapeamento",
        noResultsPlaceholder: "Nenhum resultado encontrado",
        trialBalance: "Balancete",
        noneAvailable: "Nenhum disponível",
        search: "Procurar",
        multityEntity: "Multi-entidade",
        placeHolderMessageWhenHelixMappingIsTrue: "Nenhum balancete de verificação importado. Clique em {0} para relacionar um novo analyzer.",
        placeHolderMessageWhenHelixMappingIsFalse: "A integração com o EY Helix não está disponível. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
		eyHelixIntegrationLinkText: "Integração do EY Helix",
        noEntitiesAvailablePlaceholder: "Nenhuma entidade criada. Crie entidades para começar."
    },
    //Group instructions
    assertionTabButton: "Assertivas",
    inherentRiskFactorButton: "Fatores de risco inerentes",
    accountsAndDisclosure: "Contas/Divulgações",
    assertions: "Assertivas",
    assertionC: "C",
    assertionEO: "E/S",
    assertionMV: "M/V",
    assertionRO: "R&O",
    assertionPO: "P&D",

    complexity: "Complexidade",
    subjUncertainty: "Incerteza do Assunto",
    fraudOrError: "Fraude ou erro",
    change: "Mudar",
    natureOfAccount: "Natureza da conta",
    relatedParties: "Partes Relacionadas",
    higherInherentRiskLabel: "Risco inerente mais alto",
    lowerInherentRiskLabel: "Risco inerente mais baixo",
    relevantLabel: "Risco associado",
    relevantContributeLabel: "Risco associado e contribui para o risco inerente mais alto",
    incompleteInherentRiskTooltip: "Risco inerente incompleto",
    estimateLabel: "Estimativa",
    riskAssociatedLabel: "Risco associado",
    greaterExtentLabel: "Maior extensão",
    lesserExtentLabel: "Menor extensão",
    accordionNoRiskLabel: "Nenhum risco relacionado a esta assertiva da conta.",
    accordionNoRiskAccountLabel: "Nenhum risco relacionado a esta conta",
    accordionNoAssertionsLabel: "Nenhuma assertiva relacionada a esta conta.",
    accordionLimitedRiskLabel: "A conta foi identificada como risco limitado.",

    maps: "Mapas",
    financialStatements: "Demonstrações Financeiras",
    serviceGatewayAutomation: "Gateway de Serviço & Automação",
    manageTaskGroups: "Gerenciar grupos de tarefas",
    openAssignmentsLabel: "Tarefas abertas",
    inProgressAssignmentsLabel: "Tarefas em andamento",
    // My Progress collaboration view.
	calendarDays: [
		"Domingo",
		"Segunda-feira",
		"Terça-feira",
		"Quarta-feira",
		"Quinta-feira",
		"Sexta-feira",
		"Sábado"
	],
	calendarMonths: [
		"Janeiro",
		"Fevereiro",
		"Março",
		"Abril",
		"Maio",
		"Junho",
		"Julho",
		"Agosto",
		"Setembro",
		"Outubro",
		"Novembro",
		"Dezembro"
	],
    myProgressToday: "Hoje",
    noDueDateAssignedGroup: "Nenhuma data de vencimento atribuída",
    myProgressStatusTile: {
        yourRequests: "Seus pedidos",
        totalCount: "Contagem total",
        requestStatus: "Status do pedido",
        draft: "Rascunho",
        pending: "Pendente",
        received: "Recebido",
        accepted: "Aceito",
        overdue: "Atrasado",
        noRelatedTasks: "{0} sem tarefas relacionadas",
        oneNoRelatedTask: "1 tarefa não relacionada",
        addRequest: "Nova solicitação",

        //Requests dues tile 2
        pendingRequestsByDueDate: "Solicitações pendentes por data de vencimento",
        requestsYAxisLabel: "Solicitações",
        requestsXAxisLabel: "Dias",
        tooltipDaysLabel: "dias",
        tooltipTotalLabel: "Total:",
        normalLabel: "Normal",
        highLabel: "Alta",
        criticalLabel: "Crítica",
        overdueLabel: "Atrasado",
        overDueCatFirst: "Vencido > 90",
        overDueCatSecond: "Atrasado 31-90",
        overDueCatThird: "Atrasado 10-30",
        overDueCatFourth: 'Overdue 1-9',
        catFifth: '1-9',
        catSixth: '10-30',
        catSeventh: '31-90',
        catEighth: '> 90',
        noRequestsFound: "Nenhuma solicitação encontrada",
        daysOverdue: 'Days overdue',
        daysComingDue: 'Days coming due'
    },
    documentAttributeReference: {
        name: "Nome",
        notes: "Notas",
        signOffs: "Assinaturas",
        tasks: "Tarefas relacionadas",
        open: "Abrir",
        openReadOnly: "Abrir somente leitura",
        delete: "Excluir",
        rename: "Renomear",
        signOffRequirements: "Requisitos de aprovação",
        confidentiality: "Confidencialidade",
        unlink: "Desvincular",
        relateTasks: "Relacionar tarefas"
    },
    aiChatbot: 'EYQ Assurance Knowledge',
    selectDueDate: "Selecione uma data de vencimento",
    daysOverdue: 'Days overdue',
    daysComingdue: 'Days coming due',
    loadingDataMessage: 'Loading data... this may take a few seconds'
};

/*RBAC Errors*/
export const RbacErrors = {
    106: "Funções insuficientes para editar conteúdo. Trabalhe com um administrador do engagement para obter direitos suficientes."
};

/*Errors*/
export const Errors = {
    /*Doc Helper Custom Messages */
    0: "Conexão perdida. Reconecte e tente novamente. Se o problema persistir, entre em contato com o suporte técnico.",
    101: "Status de engagament inválido.",
    102: "Usuário de engagament válido não encontrado.",
    103: "Falta de conformidade com a independência do usuário do Engagement.",
    104: "Escopos do Azure AD necessários ausentes",
    105: "Ocorreu um erro ao obter permissões do engagement. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    106: "Você não tem as permissões necessárias para realizar esta ação.",
    107: "Usuário do engagement válido não encontrado. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    108: "O perfil de engagement está incompleto. Por favor, acesse a página de destino e o perfil completo..",
    303: "Um documento com o mesmo nome está sendo carregado no momento.",
    401: "Não foi possível concluir a operação. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    403: "é um formato de arquivo incompatível e não foi carregado. Salve novamente o documento em um formato de arquivo válido e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    410: "Este documento foi excluído e, portanto, não pode ser aberto.",
    411: "Documentos vazios não são permitidos.",
    412: "Já existe um documento com o mesmo nome neste engagement.",
    413: "O documento excede o tamanho máximo permitido de arquivo (250 MB) e não pode ser carregado. Reduza o tamanho do arquivo e tente novamente.",
    500: "Conexão perdida. Reconecte e tente novamente. Se o problema persistir, entre em contato com o suporte técnico.",
    414: "O nome excede o comprimento máximo ({0} caracteres).",
    600: "A operação não pode ser concluída neste momento. Atualize a página e tente novamente. Se o problema persistir entre em contato com o Help Desk.",
    601: "Existe documento com o mesmo nome.",
    602: "O documento já está na colaboração",
    603: "Documento não encontrado.",
    'zip': "O arquivo .zip não pode ser carregado porque contém um ou mais tipos de arquivos não suportados ou contém mais do que a quantidade máxima de arquivos .zip incorporados.",
    401000: "A alteração de rede foi detectada e por favor atualize a página para continuar",

    /*Accounts*/
    1001: "Falha na solicitação ao criar a Conta.",
    1002: "Nome da conta ausente.",
    1003: 'The selected Account has been deleted. Close this modal to see the updated list.',
    1004: "Nenhum resultado encontrado. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    1005: "ID do engagement inválido.",
    1006: "Tipo de conta inválido.",
    1007: "Tipo de instrução inválido.",
    1008: 'The selected Account has been deleted. Close this modal to see the updated list.',
    1009: "Falha na solicitação ao obter a conta por ID.",
    1010: "Falha na solicitação ao obter a conta por ID do engagement.",
    1011: "Falha na obtenção do resumo Matriz de avaliação substantiva (SEM) para uma conta devido a uma solicitação inválida.",
    1012: "Tipo de resumo inválido.",
    1013: "A solicitação Criar Revisão de conta falhou.",
    1014: "A solicitação de revisão de conta de exclusão falhou.",
    1015: "Solicitação de criação de revisão de conta inválida.",
    1016: "ID de revisão de conta inválida.",
    1017: "A conta não faz parte deste engagament ou foi excluída.",
    1018: "O Revisor de conta foi criado por outro usuário.",
    1019: "A conta foi excluída por outro usuário. Atualize a página e tente novamente.",
    1020: "A conta precisa de PSP para atualizar",
    1024: "O nome da conta tem mais de 500 caracteres.",
    1025: "Risco limitado ou a conta insignificante não podem ser estimados",
    1026: "A conta não pode ter assertivas duplicadas",
    1027: "ID da assertiva inválido",
    1037: "Não é possível ter índices PSP duplicados",
    1039: 'The selected Account has been deleted. Close this modal to see the updated list.',
    1048: "A conta tem um tipo de execução inválido.",
    1053: "A conta tem Risco ou Estimativa associada, não pode ser definida como Conta de Risco Limitado ou Conta Insignificante.",
    1054: "As assertivas a serem excluídas estão associadas com Risco ou Estimativa",
    1065: "Você não pode fazer alterações em afirmações que tenham um risco significativo, ou risco de fraude, ou risco de distorção relevante ou uma estimativa relacionada. Você precisa remover essas relações primeiro.",

    1266: 'Engagement has reached maximum number of multi-edit mode documents.  Check some documents back in and try again.  If the issue persists contact the Help Desk.',
    1267: 'Document is conflicted. Resolve conflicts and try again.  If the issue persists, contact the Help Desk.',
    1268: 'Document is already in co-edit mode. end co-edit mode and try again.  If the issue persists, contact the Help Desk.',
    1269: 'Document is a shared evidence. Unlink and try again.  If the issue persists, contact the Help Desk.',

    /*Assertions*/
    2001: "Solicitação de criação inválido.",
    2002: "Nome da assertiva ausente.",
    2003: "Assertiva ausente.",
    2004: "Falha na solicitação ao obter a assertiva.",
    2005: "ID do Engagement inválido.",
    2006: "Falha na solicitação ao obter a assertiva por ID.",
    2007: "Falha na solicitação ao obter a assertiva de WCGWs.",
    2050: "Assertiva não encontrada. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    /*Tags*/
    5120: "Identificação de tag não encontrada.",
    5121: "Identificação de tag faltando.",
    5123: "Assoicação de etiqueta duplicada",
    5124: "Assoicação de etiqueta não encontrada",


    /*Risks*/
    4001: "A operação não pôde ser concluída neste momento. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help desk.",
    4002: "Nome do risco ausente.",
    4003: "Risco ausente.",
    4004: "Falha na solicitação ao obter o risco.",
    4005: "ID do Engagement inválido.",
    4006: "Falha na solicitação ao obter o risco por ID.",
    4007: "Solicitação de consulta inválido.",
    4008: 'The selected Risk has been deleted. Close this modal to see the updated list.',
    4009: "Pedido de atualização inválido.",
    4010: "WCGW específico já atribuído a este risco",
    4011: "A lista WCGW não pode ser nula.",
    4012: "Falha ao obter tipos de risco.",
    4013: "Pedido de criação inválido.",
    4014: "A assertiva relacionada não é válida. Atualize a página e tente novamente. Se esse erro persistir, entre em contato com o Suporte Técnico.",
    4015: "O WCGW não é válido. Atualize a página e tente novamente. Se esse erro persistir, entre em contato com o Suporte Técnico.",
    4016: 'The selected Risk has been deleted. Close this modal to see the updated list.',
    4017: "A assertiva não é válida para o risco. Atualize a página e tente novamente. Se esse erro persistir, entre em contato com o Suporte Técnico.",
    4018: "Falha na validação do banco de dados devido ao ID do tipo de risco inválido.",
    4019: "Nome do risco não é válido.",
    4020: "ID do documento inválido.",
    4021: "Nome do risco não deve ter mais de 500 caracteres.",
    4023: "A lista IDs das assertivas não pode ser nula.",
    4024: "O formulário de documentação de risco limitado não pôde ser criado devido a um erro. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    4025: "ID de conta inválido.",
    4026: "ID de assertiva inválido.",
    4027: "O modelo de Risco da Assertiva não pode estar vazio",
    4031: "Opção Risco ou Corpo do Formulário inválida.",

    4035: "Não é possível editar É Risco Mais Alto para Riscos significativos ou de Fraude.",
    4036: "ID de Conhecimento da Assertiva não pode ficar vazio se nenhum ID da Assertiva for passado. ID de Conhecimento da Assertiva deve estar em enums",
    4037: "ID de Conhecimento da Assertiva já existe para esta conta.",
    4038: "ID do Tipo de Risco não corresponde às opções permitidas.",
    4040: "Esta ação não pode ser tomada. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",

    /*TASK*/
    5001: "Falha ao obter tudo.",
    5002: "Esta tarefa não está mais disponível neste engagement.",
    5003: "Falha ao obter documentos para a tarefa. Parâmetros de solicitação inválidos.",
    5004: "Falha na tarefa ao obter documentos relacionados. Parâmetros de solicitação inválidos.",
    5005: "Falha ao obter tarefa por ID.",
    5006: "Falha na solicitação ao obter categorias de tarefas.",
    5007: "Falha na solicitação ao obter a subcategorias de tarefas.",
    5008: "Falha na solicitação ao obter a descrição de tarefas.",
    5009: "Falha na solicitação ao obter solicitações das tarefas do cliente.",
    5010: "Falha ao salvar solicitações das tarefas do cliente.",
    5011: "A tarefa que você está tentando relacionar aos itens foi excluída ou rejeitada.",
    5012: "O item que você está tentando relacionar foi excluído.",
    5013: "A tarefa que você está tentando relacionar aos itens foi excluída ou rejeitada.",
    5014: "O documento que você está tentando relacionar foi excluído.",
    5015: "Falha na solicitação ao obter Evidências da Tarefa.",
    5016: "Falha na solicitação ao obter tarefa de WCGW.",
    5017: "O ID do engagement deve ser maior que zero.",
    5018: "Esta ação não pode ser tomada. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    5019: "A descrição da tarefa está vazia",
    5020: "A tarefa selecionada foi excluída ou rejeitada. Sendo assim esta ação não pode ser concluída no momento.",
    5021: "O ID do Engagement de origem está ausente.",
    5022: "Falha ao salvar a anotação",
    5023: "Usuário do engagement não encontrado.",
    5024: "Falha na solicitação ao excluir tarefa.",
    5025: "Falha na solicitação ao excluir tarefas.",
    5026: "A lista de tarefas está vazia",
    5027: "Revisão não encontrada.",
    5028: "O nome do arquivo é requerido.",
    5029: "A extensão do arquivo é requerida.",
    5030: "O nome do arquivo não pode incluir: * /: <> \\? | \"",
    5031: "Erro ao atualizar o nome do documento.",
    5032: "ID do documento inválido.",
    5033: "Tipo de operação não encontrado.",
    5034: "Falha ao alterar o  status da tarefa",
    5035: "A ação que você está tentando executar não pode ser concluída no momento. Por favor, tente novamente mais tarde. Entre em contato com o suporte técnico se esse erro persistir.",
    5036: "O texto não pode ser nulo ou vazio na solicitação",
    5037: "A solicitação não pode ser nula na solicitação.",
    5038: "Digite um nome de arquivo único para continuar.",
    5039: "O nome do arquivo é requerido.",
    5040: "O nome do arquivo é limitado a 100 caracteres.",
	5041: 'O nome do arquivo não pode incluir: * /: <> \\? | \"',
    5042: "A tarefa selecionada foi rejeitada.",
    5043: "A Tarefa é uma tarefa da etapa de criação.",
    5044: "A Tarefa é uma tarefa do milestone.",
    5045: "A Tarefa não é do tipo PSP ou OSP.",
    5046: "O limite de caracteres foi excedido.",
    5047: "O limite de caracteres foi excedido.",
    5048: "Campo requerido.",
    5049: "O documento selecionado não pode ser removido desta tarefa. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Suporte Técnico.",
    5050: "O ID do grupo de tarefas não deve ser zero ou inválido",
    5051: "O ID da seção de tarefas não deve ser zero ou inválido",
    5052: "Erro ao tentar adicionar este documento à tarefa atual. Falha na solicitação.",
    5053: "Erro ao tentar atualizar este documento na tarefa atual. Falha na solicitação.",
    5054: "Erro ao tentar adicionar uma cópia deste documento na tarefa atual. Falha na solicitação.",
    5055: "Erro ao tentar renomear o documento. Falha na solicitação.",
    5056: "Não é possível editar o título da tarefa pela ferramenta de gerenciamento de conteúdo ou grupo de tarefa",
    5057: "O tipo de tarefa deve ser do tipo de Outra Tarefa Padrão",
    5058: "Este documento não pode ser removido da tarefa porque está associado ao sistema.",
    5059: "Referência incorreta da fase de tempo",
    5060: "Erro de inclusão de evidência. Falha na solicitação",
    5061: "Outro usuário atualizou as informações apresentadas. Atualize a página e tente novamente. Se o erro persistir, entre em contato com o Suporte Técnico.",
    5062: "O documento solicitado não está disponível para o canal selecionado do seu engagement no Atlas EY. Por favor, entre em contato com o Help Desk para que informações sejam fornecidas aos autores do conteúdo para futura inclusão.",
    5063: "Operação de patch inválida.",
    5064: "A tarefa selecionada foi excluída ou rejeitada. Como tal, esta ação não pode ser concluída no momento.",
    5065: "Não foi possível atualizar o tipo da tarefa. A solicitação é inválida.",
    5066: "Falha ao obter erro de orientação.",
    5067: "Não foi possível atualizar o tipo de natureza da tarefa. A solicitação é inválida.",
    5068: "Não foi possível atualizar o tipo de natureza da tarefa. A solicitação é inválida.",
    5069: "Falha na solicitação de atribuição de tarefa de exclusão.",
    5070: "Uma ou mais tarefas selecionadas foram excluídas. Tente novamente ou entre em contato com o suporte técnico se o erro persistir.",
    5071: "Não foi possível atualizar a atribuição. A solicitação é inválida.",
    5072: "Preparador não localizado. A solicitação é inválida.",
    5073: "Atribuição de tarefa não localizada.",
    5074: "Falha ao salvar a atribuição de tarefa",
    5075: "O membro ou função da equipe selecionada não pode ter uma atribuição duplicada para as tarefas selecionadas. Escolha uma tarefa diferente, membro da equipe ou função para continuar. Entre em contato com o Help Desk se o erro persistir.",
    5076: "O membro da equipe selecionado não é um membro ativo deste trabalho. Tente novamente ou entre em contato com o suporte técnico se o erro persistir.",
    5077: "Uma ou mais tarefas selecionadas foram excluídas. Tente novamente ou entre em contato com o suporte técnico se o erro persistir.",
    5078: "A atribuição de tarefa selecionada foi removida. Tente novamente ou entre em contato com o suporte técnico se o erro persistir.",
    5079: "Uma ou mais tarefas selecionadas foram excluídas. Por favor, tente novamente ou entre em contato com o Help Desk se o erro persistir.",
    5080: "A versão do documento não existe",
    5081: "O usuário que está atualmente designado para esta tarefa não pode ser reatribuído como preparador. Por favor, tente novamente ou entre em contato com o Help Desk se o erro persistir.",
    5082: "Falha na atualização. O nome do documento deve ser único para um engagement. Atualize a página para remover esta mensagem.",
    5083: "O limite de caracteres de Detalhes da tarefa foi excedido.",
    5084: "Falha na criação do documento da tarefa.",
    5085: "Falha na exclusão do documento da tarefa.",
    5086: "Falha na criação de tarefas concluídas",
    5087: "Falha na chamada do patch da tarefa.",
    5088: "Esta tarefa deve conter evidências para concluir. Tente novamente ou entre em contato com o suporte técnico.",
    5089: "Todas as evidências associadas a esta tarefa (com exceção dos documentos físicos) devem ter pelo menos um preparador e revisor para marcar como concluído. Tente novamente e entre em contato com o suporte técnico se o erro persistir.",
    5091: "O nome do documento físico já existe no engagement.",
    5092: "O nome não pode conter nenhum dos seguintes caracteres: * /: <> \\? | \\",
    5093: "O nome do documento físico excede o comprimento máximo (100 caracteres).",
    5101: "Falha ao criar tarefa.",
    5102: "A descrição da tarefa está faltando.",
    5103: "Título da tarefa está faltando.",
    5104: "Fase de tempo da tarefa está faltando.",
    5105: "A relação da tarefa não pode ser editada. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    5106: "Fase de auditoria é inválida.",
    5107: "Fase de auditoria deve ser 'Escopo e Estratégia' ou 'Execução'.",
    5108: "Descrição da tarefa é muito longa.",
    5109: "Parâmetro de tipo de função inválido.",
    5110: "ID da atribuição deve ser maior que zero.",
    5111: "O item que você está tentando relacionar tarefas foi excluído. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    5112: "O item que você está tentando relacionar tarefas foi excluído. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    5113: "O item que você está tentando relacionar tarefas foi excluído. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    5116: "O tipo de documento é inválido.",
    5119: "O status para uma ou mais tarefas selecionadas não foi atualizado. Atualize a página e tente novamente. Contate o helpdesk caso o erro permaneça",
    5127: "Não foi possível concluir a associação. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    5129: "Não foi possível concluir a associação. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    5133: "Não foi possível concluir a associação. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    5137: "A relação da tarefa não pode ser editada. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    5138: "A relação da tarefa não pode ser editada. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    5140: "A relação da tarefa não pode ser editada. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    5146: "Para marcar uma tarefa como concluída, todas as evidências associadas (com exceção dos perfis em papel) devem ter a aprovação de pelo menos um preparador e um revisor. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    5150: "Uma ou mais automações não poderiam estar relacionadas à tarefa selecionada neste momento. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    5156: "A relação da tarefa não pode ser editada. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    5157: "A relação da tarefa não pode ser editada. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    5159: "Tipo de documento compartilhado não é válido.",
    5160: "Ocorreu um erro ao tentar vincular o documento. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    5174: "A tarefa deve estar relacionada a uma ou mais entidades. Para tornar o engagement da tarefa abrangente, altere as Tarefas por entidade.",
    5184: "O tipo de tarefa não é uma Tarefa Padrão Primária ou uma Tarefa de Procedimento Substantivo Primário.",
    5185: "Tarefa com documentos entregues pelo EY Canvas não pode ser rejeitada.",
    5188: "Documento inválido ou desvinculação em andamento.",
    5189: "Tarefa tem documentos que são evidências vinculadas ou respostas vinculadas.",
    5190: "Tarefa deve ter pelo menos uma assertiva.",
    5191: "Não é possível concluir a associação. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    5192: "O item que você está tentando relacionar tarefas foi excluído. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    5193: "O item selecionado foi excluído. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",


    /*WCGW*/
    6001: "Falha na solicitação de criação do WCGW .",
    6002: "Nome do WCGW ausente.",
    6003: "WCGW ausente.",
    6004: "Falha na obtenção do WCGW.",
    6005: "ID do Engagement inválido.",
    6006: "Não foi possível concluir a ação solicitada porque o ID da assertiva é inválido ou foi excluído. Atualize a página e tente novamente.",
    6007: "Ao obter WCGW pelo ID a solicitação falhou.",
    6008: "Solicitação inválida.",
    6009: "Não foi possível concluir a ação solicitada porque o ID do  WCGW é inválido ou foi excluído. Atualize a página e tente novamente.",
    6010: "A tarefa não poderia estar associada ao WCGW.",
    6011: "O WCGW selecionado foi excluído.",
    6012: "A tarefa e o WCGW não estão relacionados com a mesma assertiva.",
    6013: "A Tarefa selecionada não pertence ao mesmo Engagement.",
    6014: "A tarefa não poderia ser dissociada do WCGW.",
    6015: "A tarefa não pôde ser associada do WCGW.",
    6016: "A tarefa está rejeitada e não pode ser associada ao WCGW.",
    6017: "A tarefa não é uma tarefa dos Milestones e não pode ser associada ao WCGW.",
    6018: "A tarefa não é uma tarefa de etapa de construção e não pode ser associada ao WCGW.",
    6019: "A tarefa não é um PSP ou OSP e não pode ser associada ao WCGW.",
    6020: "A tarefa e o WCGW estão associados à mesma afirmação e não podem ser associados ao WCGW.",
    6027: "Id do WCGW ou Id do Controle inválido.",
    6028: "Não é possível concluir a associação. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    6029: "Não é possível concluir a remoção. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",

    /*Engagement*/
    7001: "Rescultado por ID não encontrado.",
    7002: "Falha ao obter engagements do ID da área de trabalho.",
    7003: "Falha ao obter todas entidades do engagement.",
    7004: "Falha ao obter o engagement por ID",
    7005: "Falha ao obter os usuários do engagement.",
    7006: "O sobrenome não deve exceder 250 caracteres.",
    7007: "Erro do tipo usuário inválido.",
    7008: "O nome não deve exceder 250 caracteres.",
    7009: "GUI do usuário não pode ser nula.",
    7010: "Erro de status usuário inválido.",
    7011: "Falha ao criar solicitação de usuário de engagement.",
    7012: "{0} {1} não pode ser convidado porque já é um membro ativo ou pendente da equipe.",
    7013: "As iniciais não devem exceder 3 caracteres.",
    7014: "A Página inicial do EY Canvas não está acessível no momento. Tente novamente e se o problema persistir, entre em contato com o Help Desk.",
    7015: "{0} {1} não podem ser convidados como os seguintes grupos de acesso: {2} foram excluídos do engagement. Refrescar e tentar de novo.",
    7016: "{0} {1} não pode ser convidado, pois o usuário já é um membro ativo da equipe no seguinte grupo de acesso: {2}",
    7017: "O domínio não é permitido para grupos selecionados: {0}",
    7018: "O endereço de e-mail não deve ser nulo.",
    7019: "O primeiro nome não deve ser nulo.",
    7020: "Sobrenome não deve ser nulo",
    7021: "A Inicial do Usuário não deve ser nula.",
    7022: "O escritório principal do usuário não deve ser nulo.",
    7023: "O Nome de Login de Usuário não deve ser nulo.",
    7024: "A função EY do usuário não deve ser nulo.",
    7025: "A função do usuário no engagement não deve ser nula.",
    7026: "Incapaz de completar a operação. Tente novamente e se o problema persistir, entre em contato com o Help Desk.",
    7027: "Endereço de e-mail inválido",
    7028: "A solicitação de correção do usuário do engagement falhou.",
    7029: "Usuários do engagement - ID de status do usuário do engagement inválido.",
    7030: "Usuários de engagement - ID de função de usuário do engagement inválido",
    7031: "Um ou mais usuários do engagement não foram encontrados.",
    7032: "O e-mail não deve ser maior que 250 caracteres.",
    7033: "O Usuário solicitado não pode ser Nulo.",
    7034: "Falha na fila do processador de mensagens universal.",
    7035: "As iniciais não devem exceder 3 caracteres.",
    7036: "O nome não deve exceder 250 caracteres.",
    7037: "O sobrenome não deve exceder 250 caracteres.",
    7038: "Criar solicitação de usuário externo falhou.",
    7039: "Um ou mais usuários não podem ser convidados porque já são um membro ativo ou pendente da equipe. Atualize a página e tente novamente, se o problema persistir entre em contato com o Help Desk",
    7040: "O nome não deve exceder 250 caracteres.",
    7041: "O sobrenome não deve exceder 250 caracteres.",
    7042: "As iniciais não devem exceder 3 caracteres.",
    7043: "GPN não deve ser maior que 250 caracteres.",
    7044: "GUI não deve ser maior que 250 caracteres.",
    7045: "Falha ao obter usuário externo por ID.",
    7046: "O usuário não deve ser nulo.",
    7047: "Não é possível salvar as alterações no momento. Tente novamente e se o problema persistir, entre em contato com o Help Desk.",
    7048: "A página inicial do EY Canvas não está acessível no momento e é necessária para edição. Tente novamente e se o problema persistir, entre em contato com o Help Desk.",
    7049: "A solicitação de atualização do usuário do engagement falhou.",
    7050: "Os membros não podem ser desativados. O engagement deve ter pelo menos um membro que tenha permissões para administrar o engagement. Atualize sua seleção e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    7051: "Falha ao obter usuário interno por ID.",
    7052: "Usuário não encontrado.",
    7053: "Obter por ID não encontrado.",
    7054: "Obtenha links rápidos por falha na chamada de ID do engagement.",
    7055: "Direitos insuficientes para adicionar membros anteriores. Fale com um membro da equipe de trabalho com os direitos apropriados para realizar esta ação.",
    7056: "EY Canvas não poderia salvar mudanças neste momento. Tente novamente e se o problema persistir, entre em contato com o Help Desk.",
    7057: "Direitos insuficientes para adicionar membros anteriores. Fale com um membro do engagement com os direitos apropriados para realizar esta ação.",
    7058: "O status do usuário mudou. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    7062: "O EY Canvas Client Portal não está acessível no momento e é necessário atualizar as informações dos membros existentes. Tente novamente e se o problema persistir, entre em contato com o Help Desk.",
    7063: "Não é possível desativar membros externos. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    7064: "Operação inválida de patch.",
    7065: "{0} {1} não pode ser ativado em um ou mais grupos de acesso. O domínio não é permitido para o (s) grupo (s) selecionado (s): {2}.",
    7066: "{0} não é um usuário válido.",
    7067: "A chamada do usuário externo falhou.",
    7068: "O EY Canvas Client Portal não está acessível no momento e é necessário atualizar as informações dos membros existentes. Tente novamente e se o problema persistir, entre em contato com o Help Desk.",
    7069: "Os grupos de acesso selecionados não estão ativos: {0}. Remova e tente novamente.",
    7072: "Ocorreu um erro durante o processo de desvinculação de engagament. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    7074: "As alterações não podem ser salvas. O engagement deve ter pelo menos um membro ativo que tenha permissão para administrar o engagement e tenha independência resolvida. Se o problema persistir, entre em contato com o Help Desk.",
    7075: "{0} {1} não pode ser convidado porque já é um membro ativo da equipe.",
    7077: "Um ou mais usuários não podem ser desativados. Atualize a página e tente de novo, se o problema persisitir entre em contato com o help desk.',",
    7079: "Domínio não é permitido. Tente novamente e se o problema persistir, entre em contato com o Help Desk.",
    7080: "Você não tem permissão para convidar membros terceiros. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk para obter permissão, se for apropriado.",
    7094: "O membro da equipe selecionado assinou documentos neste engagement e não pode ser removido.",
    7100: "Não é possível processar edições em campos restritos. Atualize e tente novamente.",

    /*SCOT*/
    8001: "Falha na solicitação ao criar a Scot.",
    8002: "Nome da Scot ausente.",
    8003: "Scot ausente.",
    8004: "Falha na solicitação ao obter a Scot.",
    8005: "ID do Engagement inválido.",
    8006: "ID da Assertiva inválido.",
    8007: "Ao obter Scot pelo ID a solicitação falhou.",
    8008: "Solicitação inválida.",
    8009: 'The selected SCOT has been deleted. Close this modal to see the updated list.',
    8028: 'The selected SCOT has been deleted. Close this modal to see the updated list.',

    /*User*/
    10001: "Registro de Preferências do usuário não encontradas.",
    10002: "Falha ao obter todos os usuários.",
    10003: "Falha ao obter Presença do usuário",

    /*Risk Type*/
    11001: "Solicitação de criação inválido.",
    11002: "Nome do Tipo de Risco ausente.",
    11003: "Tipo de risco ausente.",
    11004: "Falha na solicitação ao obter o Tipo de Risco.",
    11005: "ID do Engagement inválido.",

    /* Annotation Errors*/
    12001: "Parâmetros de solicitação inválidos.",
    12002: "Falha ao criar anotação.",
    12003: "Falha na obtenção da anotação.",
    12004: "ID do engagement inválido.",
    12005: "Os IDs na coleção devem ser maiores que zero.",
    12006: "A coleção de ID não pode estar vazia.",
    12007: "ID de tarefa inválido.",
    12008: "ID do documento inválido.",
    12009: "Deve ter um ID de documento ou ID de tarefa ou ID de demonstrativo financeiro válido.",
    12010: "É requerido respostas principais",
    12011: "ID de status inválido.",
    12012: "O tipo de documento deve ser 440GL.",
    12013: "Tipo de anotação inválido.",
    12014: "Usuário do engagement inválido.",
    12015: "Este documento foi excluído por outro usuário.",
    12016: "Falha ao atualizar a anotação.",
    12017: "A nota que você está respondendo foi excluída por outro membro da equipe. Atualize a página e tente novamente.",
    12018: "O tipo de ação de alteração de anotação não deve ser nulo.",
    12019: "Nota de revisão excluída.",
    12020: "Ação inválida para executar.",
    12021: "O usuário não é autor da anotação.",
    12022: "Usuário de criação ausente.",
    12023: "O usuário autor não existe ou pertence ao engagement.",
    12024: "Usuário atribuído obrigatório.",
    12025: "O usuário designado não existe ou pertence ao engagement.",
    12026: "Notas inválidas.",
    12027: "As notas não devem estar vazias.",
    12028: "Data de vencimento exigida.",
    12029: "Prioridade válida necessária.",
    12030: "O status dessa nota mudou. Não pode mais editar ou responder à nota. Por favor, feche e reabra a janela para visualizar os dados atualizados e continue a editar.",
    12031: "A anotação deve ser de nível superior.",
    12032: "A anotação não deve ser de nível superior.",
    12033: "Pelo menos um dos seguintes valores não deve estar vazio: tipo de prioridade, data de vencimento, status ou usuário atribuído.",
    12034: "As notas excedem o comprimento máximo (4.000 caracteres).",
    12035: "A linha de pesquisa excede o comprimento máximo (500 caracteres).",
    12036: "Somente o ID da tarefa ou Id do documento devem ser aceitos, ambos não são permitidos.",
    12037: "Operação inválida.",
    12038: "Está tentando editar uma nota que já não existe. Atualize a página e tente novamente.",
    12039: "Você está tentando editar a mesma nota que outro membro da equipe. Atualize a página e tente novamente.",
    12040: "Falha ao obter anotação dos usuários.",
    12041: "Falha ao obter anotação dos usuários. Valor inválido.",
    12042: "Tipo de documento não é válido para criar uma anotação.",
    12043: "Você está tentando adicionar uma nota a uma tarefa ou documento que não existe mais. Atualize a página e tente novamente.",
    12044: "Você está tentando editar uma resposta a uma nota que não existe mais. Atualize a página e tente novamente.",
    12045: "Nota de revisão não encontrada.",
    12046: "Você está tentando excluir uma nota que já foi excluída por outro membro da equipe. Atualize a página e tente novamente.",
    12047: "Você só pode excluir respostas para notas que estão em status Aberto. Atualize a página e tente novamente.",
    12048: "Você está tentando mudar o status de uma nota que não existe mais. Atualize a página e tente novamente.",
    12049: "Você está tentando excluir uma resposta a uma nota que já foi excluída por outro membro da equipe. Atualize a página e tente novamente.",
    12050: "Você só pode excluir notas que estão em status Fechado.",
    12059: "As notas de revisão só podem ser excluídas pelo usuário que criou a nota.",
    12066: "Você só pode responder a notas abertas.",
    12067: "Você está tentando excluir uma resposta a um comentário que já foi excluído por outro membro da equipe. Atualize a página e tente novamente.",
    12068: "Não foi possível adicionar o comentário. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    12070: "Você só pode adicionar um comentário por demonstração financeira. Por favor, edite o existente.",
    12071: "Falha ao excluir as informações. Por favor, tente novamente. Se o problema persistir, entre em contato com o help desk.",

    /*Configuration*/
    13001: "Configurações não encontradas.",
    13002: "solicitação para obter configurações API  falhou.",

    /*Documents*/
    14001: "Não foi possível concluir a solicitação porque a solicitação está nula.",
    14002: "Documento não encontrado. Falha na solicitação.",
    14003: "O ID do engagement deve ser maior que zero.",
    14004: "O ID do documento não deve ser nulo ou vazio.",
    14005: "Erro ao tentar obter tarefas associadas. A solicitação falhou.",
    14006: "O documento selecionado não pode ser excluído. Tente mais tarde. Se o problema persistir, entre em contato com o Suporte Técnico.",
    14007: "Ocorreu um erro inesperado.",
    14008: "Um erro inesperado ocorreu durante a assinatura.",
    14009: "Ocorreu um erro ao adicionar uma assinatura.",
    14010: "A ID de aprovação deve ser maior que zero.",
    14011: "Ocorreu um erro ao excluir uma assinatura.",
    14012: "O texto não pode ser nulo.",
    14013: "O documento selecionado não pode ser desvinculado. Tente novamente mais tarde. Se o problema persistir, entre em contato com o Help Desk.",
    14014: "Obter conta por solicitação de identificação de documento falhou.",
    14015: "Entidade relacionada inválida.",
    14016: "Falha ao obter aprovação de documento.",
    14017: "Falha ao obter o Document Findings.",
    14018: "Falha ao obter documentos.",
    14019: "Assinatura não encontrada.",
    14020: "ação inválida.",
    14021: "Tipo de assunto inválido.",
    14022: "O documento não pertence ao trabalho.",
    14023: "O tipo de alteração do documento não é válido.",
    14024: "Falha ao importar todos documentos. O parâmetro não é válido.",
    14025: "Ocorreu um erro ao criar a revisão do documento. A solicitação da API falhou.",
    14026: "Ocorreu um erro ao excluir a revisão do documento. A solicitação da API falhou.",
    14027: "O ID do engagement não deve ser nulo ou vazio.",
    14028: "O ID do usuário é inválido.",
    14029: "O Usuário não está autorizado a realizar esta ação.",
    14030: "Nenhum documento com o ID passado foi encontrado neste Engagement.",
    14031: "O ID de revisão de documentos não é válido.",
    14032: "A Revisão de Documentos não foi encontrada.",
    14033: "O Documento já foi aprovado.",
    14034: "Um processo de desvinculação está em andamento para outro engagement no espaço de trabalho ou este documento já foi desvinculado. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    14035: "O documento não é compartilhado com o engagement dado.",
    14036: "O número da versão deve ser maior que zero.",
    14037: "A operação não pode ser concluída neste momento. Atualize a página e tente novamente. Se o problema persistir entre em contato com o Help Desk",
    14038: "Falha ao obter motivos de mudança do documento",
    14039: "Falha ao obter o motivo da alteração do documento pelo ID.",
    14040: "Falha ao atualizar o motivo da mudança.",
    14041: "Razão de mudança inválida.",
    14042: "A atualização da razão da mudança falhou.",
    14043: "Falha ao criar motivo de mudança.",
    14044: "Falha ao excluir o motivo da mudança.",
    14045: "Identificação de mudança inválida.",
    14046: "O documento não está disponível. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    14047: "O documento já tem um motivo de mudança atribuído.",
    14048: "O documento está em conflito, resolva antes de continuar.",
    14049: "Dados inválidos para verificar se o documento foi adicionado à equipe ou usuário.",
    14050: "Erro ao remover documento de referência.",
    14051: "Desvincular todas as listas de verificação de evidências compartilhadas não encontradas.",
    14052: "O texto da pesquisa excede o comprimento máximo permitido (500 caracteres).",
    14053: "Não é possível realizar a chamada porque o pedido é nulo.",
    14054: "Operação inválida de patch.",
    14055: "A chamada de histórico do resolver documento falhou.",
    14056: "Ocorreu um erro ao tentar encaminhar a mensagem.",
    14057: "Já existe um documento com o mesmo nome no engagement",
    14058: 'More than one document version with the same number has been found. Please contact Help Desk for further assistance.',
    14059: 'The selected document version couldnt be found. Please refresh the page and try again. If the issue persists, please contact Help Desk for further assistance.',
    14060: 'The operation couldnt be completed at the time. Please try again later. If the issue persists, please contact Help Desk for further assistance.',
    14061: 'Document is not shared, cant unlink the document. If the issue persists, please contact Help Desk for further assistance.',
    14062: 'The document confidentiality type id is not valid.',
    14063: 'Cannot change confidentiality type of this document type.',
    14064: 'User doesnt have permission.',
    14065: 'Invalid custom description.',
    14066: 'Failed to update extension.',
    14067: 'Invalid extension.',
    14068: 'Failed to get document extensions.',
    14069: "Este documento já foi desvinculado por outro membro da equipe. Atualize a página e entre em contato com o Help Desk se o erro persistir.",
    14070: "Tipo de arquivo inválido.",
    14071: "A versão do documento selecionado não está mais disponível. Feche e reabra esta janela para ver o conjunto mais recente de versões históricas do documento.",
    14072: 'Source document Id should not be null or empty.',
    14073: 'Canvas form ids should not be null or empty.',
    14074: "Canvas form ID's should not be duplicates.",
    14075: 'Failed to associate document to canvas forms.',
    14076: "Formulários Canvas associados ao documento de origem não foram encontrados.",
    14077: 'Source document not found. Call failed.',
    14078: 'Current document is already associated with given canvas forms.',
    14079: "Este documento foi excluído e, portanto, não pode ser aberto.",
    14080: 'The source approval user id is invalid.',
    14081: 'The source approval user id should valid GUID and must not be empty GUID.',
    14082: 'The modify user id is invalid.',
    14083: 'The modify user id should be a valid GUID and must not be empty GUID.',
    14084: 'File name cannot include: */:<>\\?|""',
    14085: 'The document name exceeded maximum length allowed.',
    14086: 'DocService failed while updating document details.',
    14087: 'The input is not valid.',
    14088: 'A input has duplicate document names.',
    14089: "Observação do marcador não é válida.",
    14090: "Status da solicitação mudou. Atualize a página e tente novamente, se necessário. Se o problema persistir, entre em contato com o help desk.",
    14091: "Esta solicitação foi excluída. Atualize a página para visualizar os dados atualizados. Se o problema persistir, entre em contato com o Help Desk.",
    14092: 'Document not eligible for update. Refresh the page and try again.  If the issue persists, contact the Help Desk.',

    /*SEM*/
    15001: "Falha ao obter o resumo Matriz de avaliação substantiva da identificação da conta devido a uma solicitação inválida.",
    15002: "ID de conta inválido.",
    15003: "ID do Engagement inválido.",
    15004: "Tipo de resumo inválido.",
    15005: "Conta relacionada não encontrada. Atualize a página e tente novamente. Entre em contato com o suporte técnico se o problema persistir.",

    /*Timephase*/
    16001: "Falha ao obter fases de tempo.",
    16002: "O engagement deve ser maior que zero.",
    16003: "A fase de tempo deve ser maior que zero.",
    16004: "Valor de ID de tarefa inválido.",
    16005: "Referência incorreta da fase de tempo",

    /*Validations*/
    17001: "ID da etapa de criação ou ID do tipo de documento ausente.",

    /*TaskGroupSection*/
    18001: "Falha na chamada Obter todas as taredas do grupo.",
    18005: "Este grupo de tarefas não está mais disponível neste engagement.",
    18006: 'This task group is no longer available. Refresh the page and try again. If the issue persists, contact the Help Desk.',
    18016: "Os grupos de tarefas só podem ser excluídos quando não houver tarefas relacionadas. Exclua ou mova as tarefas relacionadas e tente novamente.",
    18019: "O grupo de tarefas que você está tentando atualizar já foi excluído.",

    /*Assignments*/
    19001: "Falha na criação de atribuição.",
    19002: "Falha ao obter atribuição.",
    19003: "O nome da atribuição deve ser único",
    19004: "Nome de atribuição inválido",
    19005: "O comprimento do nome da atribuição excede mais de 100 caracteres",
    19006: "Tipo de atribuição inválida",
    19007: "Extensão da atribuição de pesquisa excede mais de 500 caracteres.",
    19008: "Esta atribuição de nome foi excluída por outro membro da equipe. Atualize a página e tente novamente.",

    19012: "As tarefas não podem ser repetidas.",
    19013: "Os campos Função e Usuário não podem ter valores ao mesmo tempo.",
    19014: "O usuário não pode ter o valor padrão.",
    19016: "Usuário PIC inválido ou usuário PIC não convidado.",
    19017: "Usuário EQR inválido ou usuário EQR não convidado.",
    19018: "O valor dos dias de vencimento deve ser maior que 0 e menor que 1000.",
    19019: "Falha ao criar chamada de atribuição automática de tarefa.",

    /*Client Request*/
    21001: "A solicitação não pôde ser enviada ao EY Canvas Client Portal. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    21002: "Esta solicitação foi excluída. Atualize a página para ver os dados atualizados. Se o problema persistir, entre em contato com o Help Desk",
    21009: "Erro ao eliminar a chamada de documento de solicitação de cliente.",
    21010: "O comentário que você está respondendo foi excluído por outro membro da equipe. Atualize a página e tente novamente.",
    21011: "O documento de solicitação do cliente foi excluído.",
    21012: "O documento de solicitação do cliente não foi encontrado.",
    21013: "Pedido de documento está vazio.",
    21014: "ID do documento está vazio.",
    21015: "O ID do pedido do cliente está vazio.",
    21016: "Erro ao criar a chamada do documento de solicitação do cliente.",
    21017: "Um ou mais dos documentos associados foram excluídos do engagement. Por favor remova o(s) documento(s) excluído(s) desta solicitação ou atualize a página e tente novamente.",
    21018: "Documento não encontrado.",
    21019: "O status da solicitação do cliente mudou.",
    21030: "O ID do grupo de clientes não corresponde.",
    21031: "O status da solicitação mudou. Atualize a página e tente novamente, se necessário. Se o problema persistir, entre em contato com o Help Desk.",
    21032: "O usuário de contato do Grupo de clientes não está ativo.",
    21033: "Grupo de clientes não está ativo.",
    21034: "Grupo de clientes não contém nenhum usuário ativo.",
    21045: "O status da solicitação mudou. Atualize a página para ver as alterações mais recentes.",
    21046: "A solicitação não pôde ser enviada ao EY Canvas Client Portal. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    21050: "As solicitações não puderam ser excluídas. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk",
    21053: "A tarefa não está mais disponível no engagement. Atualize a página para atualizar a lista.",
    21057: "O EY Contact não pôde ser designado. Atualize a página e tente novamente.",
    21028: "A data de vencimento é obrigatória.",
    21036: "A fase do tempo não foi encontrada",
    21064: "A tarefa não pode ser associada à solicitação. As solicitações podem ser associadas para até 25 tarefas. Remova uma ou mais tarefas associadas para associar uma nova.",
    21065: "Um ou mais documentos confidenciais foram adicionados à solicitação. Você não possui o nível de confidencialidade adequado para enviar um ou mais desses documentos ao Portal do Cliente do EY Canvas. Remova todos os documentos confidenciais aos quais você não tem acesso para continuar.",
    21066: "Ocorreu um erro ao recuperar os dados. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    21067: "Não foi possível atualizar a prioridade. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk",
    21035: "Solicitação do cliente não encontrada.",
    21074: "Solicitação recebida não permite alterações de Título, Descrição, Prioridade.",
    21075: "A solicitação aceita não permite alterações em Título, Descrição, Atribuído a (grupo), Atribuído a (usuário), Data de vencimento, Prioridade.",
    21077: "A data de vencimento é necessária para solicitações de clientes com status Recebido e Pendente.",
    21039: "ID do grupo de clientes não encontrado.",
    21078: "Grupo e usuário são necessários, ao atualizar o grupo atribuído ou o usuário atribuído.",
    21079: "O formato da data é inválido.",
    21027: "O título da solicitação é obrigatório.",
    21041: "O comprimento do título da solicitação excede o máximo de caracteres permitidos.",
    21042: "O comprimento da descrição da solicitação excede o máximo de caracteres permitidos.",
    21060: "O ID do usuário do cliente está vazio.",
    21076: "O tipo de prioridade não é permitido.",

    /* Group Components*/
    22001: "Falha ao obter componentes relacionados.",
    22002: "Falha na chamada de obtenção de componentes do grupo.",
    22003: "Falha na chamada de criação de componentes do grupo.",
    22004: "ID de componente pai inválido, o componente pai especificado não existe.",
    22005: "O nome da equipe excedeu os comprimentos máximos.",
    22006: "O nome legal da equipe excedeu o comprimento máximo.",
    22008: "O escopo especificado não existe.",
    22009: "Nome curto do componente inválido.",
    22010: "Nome legal do componente inválido.",
    22011: "ID de escopo de componente inválido.",
    22012: "Se o e-mail de ponto do contato foi fornecido, então o ponto de contato guid não pode ser nulo ou vazio.",
    22013: "Se o e-mail do ponto de contato foi fornecido, então o texto do ponto de contato não pode ser nulo ou vazio.",
    22016: "Esta equipe já foi excluída por outro membro da equipe. Atualize a página e tente novamente.",
    22022: "O nome da equipe já existe neste compromisso.",
    22043: "A chamada de envio de instruções falhou.",

    /*User Presence*/
    23001: "A presença do usuário conectado não foi encontrada.",
    23002: "Falha ao obter a presença do usuário.",
    23003: "Falha na validação da presenção do documento do usuário.",
    23004: "Falha na exclusão da presença do usuário.",
    23005: "O documento não é mais aberto por outros usuários. Atualize a página e tente novamente. Entre em contato com o Help Desk se o problema persistir.",

    /* Forms */
    24001: "Falha ao obter formulário.",
    24002: "ID de engagement inválido.",
    24003: "ID do documento não deve ser nulo ou vazio.",
    24004: "ID do documento inválido.",
    24005: "ID do cabeçalho do formulário inválido.",
    24006: "ID da seção do formulário inválido.",
    24007: "Parâmetros de solicitação inválidos.",
    24008: "ID do cabeçalho não deve ser nulo ou vazio.",
    24009: "O ID da seção não deve ser nulo ou vazio.",
    24010: "Falha na operação de atualização da resposta do texto do formulário.",
    24011: "Solicitação inválida para atualização da resposta do texto do formulário.",
    24012: "ID de texto inválido.",
    24013: "ID da opção de texto de formulário inválido.",
    24014: "ID do tipo de texto do formulário inválido.",
    24015: "Texto de solicitação inválido para o ID do tipo de texto especificado.",
    24016: "Texto livre inválido para o ID do tipo de texto específico.",
    24017: "Caracteres máximos, inclui tags de formato de texto ricos. Reduza o comprimento ou remova a formatação desnecessária e tente novamente.",
    24018: "Para uma resposta dada ao ID do tipo de texto não é permitida.",
    24019: "A ID do texto não deve ser nula ou vazia.",
    24020: "Pedido Inválido de texto.",
    24021: "O texto está apagado.",
    24038: "O documento não é válido ou não existe.",
    24049: "Os objetos selecionados foram excluídos. Atualize a página e tente novamente. Se o erro persistir, entre em contato com o Help Desk.",
    24057: "Falha na validação do Formulário do Documento.",
    24063: "A identidade do país é inválida.",
    24064: "A identidade do idioma é inválida.",

    /*Document Change Types*/
    25001: "Falha na solicitação Tipos de Mudança",
    25002: "ID do engagament inválido.",
    25003: "Pedido inválido.",

    /* Manage team */
    26001: "Falha na solicitação ClientUserGroups GetAll",
    26002: "Falha na criação de um novo grupo de clientes / solicitação de domínio de email",
    26003: "O nome do grupo não deve ser nulo.",
    26004: "O domínio de e-mail não deve ser nulo.",
    26005: "{0} O rótulo do domínio de e-mail não deve ter mais de 263 caracteres",
    26006: "{0} O domínio de e-mail não deve ter mais de 263 caracteres.",
    26007: "{0} A primeira parte do domínio do e-mail pode ser * ou alfanumérico, outros caracteres especiais não são permitidos.",
    26008: "{0} Se a primeira parte é um curinga, então deve ter 2 ou mais parte seguidas.",
    26009: "{0} A primeira parte pode ser * ou alfanumérica; caracteres especiais de outras partes do domínio não são permitidos.",
    26010: "O domínio de e-mail deve ser Exclusivo.",
    26011: "O ID do grupo de acesso do cliente fornecido não é válido.",
    26012: "Ocorreu um erro ao excluir o grupo de acesso. Certifique-se de que não há solicitações/tarefas externas atribuídas a este grupo ou aos membros deste grupo e tente novamente",
    26013: "O grupo de acesso já foi excluído, atualize a página para obter os dados mais recentes",
    26014: "É necessário pelo menos um domínio de email.",
    26015: "O EY Canvas Client Portal não está acessível no momento e é necessário atualizar as informações dos membros existentes. Tente novamente e se o problema persistir, entre em contato com o Help Desk.",
    26016: "Erro durante a operação de exclusão.",
    26017: "Obter falha na operação de dados.",
    26018: "Acesso ao grupo não permitido. Atualize a página e tente novamente",
    26019: "Falha na operação de salvamento.",
    26020: "Os domínios de e-mail não podem ser removidos quando têm usuários ativos atribuídos. As mudanças não foram salvas.",


    /* TimePhaseTypes - Milestones */
    27001: "Obter detalhes de 'Milestones' falhou.",

    /*Client Request Counts*/
    28001: "A solicitação Obter solicitação de clientes não obteve nenhum resultado.",

    /*Content updates Error messages*/
    29001: "Obter por ID não encontrado.",
    29002: "Tipo de ação não encontrada.",
    29003: "IDs de conteúdo não encontrados.",
    29004: "A solicitação de API de atualização de conteúdo falhou.",
    29005: "Atualização de conteúdo em andamento. Tente novamente mais tarde e se o problema persistir, entre em contato com o Help Desk.",
    29006: "Parâmetros de solicitação inválidos.",
    29010: "O conteúdo está sendo atualizado. Tente de novo mais tarde. Se o problema persistir por um tempo prolongado, contate o IT Help Desk.",
    29012: "O engajament não tem uma pergunta de perfil de padrões aplicáveis. Entre em contato com o Help Desk de TI.",
    29013: "Primary standard tasks (PSTs) e atualizações de conteúdo de perfil não são permitidas quando há atividades de habilitação do EY Canvas FIT que são compartilhadas. Para atualizar as PSTs ou o conteúdo do Perfil, desvincule essas atividades. Se vários tipos de atualização de conteúdo tiverem sido selecionados, desmarque as Primary standard tasks (PSTs) e/ou Perfil e reinicie a Atualização.",
    /*IT Process*/
    30001: "Obter todos os processos de TI falhou.",
    30002: "Obtenha todo o ITProcess - ID do engagament inválido.",
    30003: "O nome do ITProcess não pode estar vazio.",
    30004: "ITProcessName não deve ter mais de 500 caracteres.",
    30005: "ItProcessID é inválido.",
    30006: "Obter itprocess by id call falhou.",
    30007: "Pedido inválido.",
    30008: "O processo de TI não é válido.",
    30009: "Documento não encontrado.",
    30010: "Falha na exclusão de ITProcess.",
    30012: "ITRrisk inválido.",

    /*Checklist*/
    31001: "Falha na solicitação Obter todas as listas de verificação.",
    31002: "Falha na solicitação Colocar listas de verificação",
    31003: "Parâmetro de lista de verificação inválido.",
    31004: "Erro de engagement inválido.",
    31005: "Erro de parâmetros de solicitação inválido.",
    31006: "Erro de parâmetro de solicitação inválido está verificado.",

    /*Archive*/
    32001: "O status do engagement é inválido, resolva a validação e tente novamente o processo de arquivamento. Entre em contato com o Help Desk se o erro persistir.",
    32002: "O arquivamento falhou ao atualizar o status de exibição de corpos do formulário, por favor tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    32003: "O arquivamento falhou ao atualizar o status do engagement, por favor tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    32004: "O arquivamento falhou ao invalidar o cache do engagement, por favor tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    32005: "A Atualização de Conteúdo está em andamento. Você não pode arquivar este engagement até que a atualização de conteúdo esteja concluída. Tente novamente mais tarde e entre em contato com o Help Desk se o erro persistir.",
    32006: "Há validações não resolvidas neste engagement. Atualize a página, resolva as validações e tente novamente o processo de arquivamento. Entre em contato com o Help Desks se o erro persistir.",
    32007: "O arquivamento falhou durante a construção do MODELO DE SOLICITAÇÃO ARC, por favor tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    32008: "O arquivamento falhou ao obter URL de API arc, por favor tente novamente.  Entre em contato com o Help Desk se o erro persistir.",
    32009: "O arquivamento falhou ao fazer a chamada da API arc, por favor tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    32010: "O arquivamento falhou devido à falta de dados na Resposta do API arc, por favor tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    32011: "O arquivamento falhou ao salvar os detalhes do formulário arc, por favor tente novamente.  Entre em contato com o Help Desk se o erro persistir.",
    32012: "O arquivamento falhou ao atualizar o status do engagement para nova tentativa, por favor, tente novamente. Entre em contato com a Central de Ajuda se o erro persistir.",
    32013: "O arquivamento falhou durante a fila da Mensagem de Arquivamento, por favor tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    32014: "O arquivamento foi bem sucedido, mas ocorreu um erro durante a fila da mensagem de atualização de status Universal. Entre em contato com o Help Desk se o erro persistir.",
    32015: "O arquivamento foi bem sucedido, mas ocorreu um erro durante a fila da mensagem de atualização de status do CCP. Entre em contato com o Help Desk se o erro persistir.",
    32016: "O status do engagement deve estar no status Erro de arquivamento para tentar novamente o processo de arquivamento.",
    32017: "Engagement não encontrado, por favor, tente novamente. Entre em contato com a Central de Ajuda se o erro persistir.",
    32019: "Não podemos processar sua solicitação neste momento. Por favor, tente novamente. Se o problema persistir, entre em contato com o suporte da EY.",
    32020: "A URL ARC não está configurada, tente novamente. Entre em contato com o Help Desk se o erro persistir.",
	32200: 'Existem validações não resolvidas em seu engagement. Execute o relatório de Verificações de validação em Relatórios ou consulte o link "Ajuda de validações" no menu "Mais" para obter mais detalhes. Se o erro persistir, entre em contato com o Help Desk.',
    32400: "Os seguintes erros ocorreram durante a comunicação com o sistema ARC. Entre em contato com o Help Desk e mostre a eles esta mensagem de erro para continuar.",

    /*RBAC*/
    33001: "ID do engagament não encontrado.",
    33002: "ID do usuário não encontrado.",

    /*Helix Linked Projects*/
    34001: "O projeto EY Helix já foi desvinculado, atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    34002: "O ID do engagament não deve ser nulo ou vazio.",
    34003: "O texto não pode ser nulo ou vazio na solicitação.",
    34004: "O ID do projeto não deve ser nulo ou vazio.",
    34005: "O Nome do Projeto não pode ser nulo ou vazio.",
    34006: "O projeto EY Helix já foi vinculado, atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    34007: "Falha na solicitação Get All Helix Projects.",
    34008: "O ID do engagement deve ser maior que zero.",
    34009: "A operação não pôde ser concluída. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    34020: "Não foi possível vincular o Projeto Helix. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    34024: "Não foi possível enviar uma notificação para o Helix. Faltam informações de região para o projeto.",
    34029: "Projeto não vinculado porque sua localização não corresponde à localização do Engagement no EY Canvas.",
    34030: "O analyzer não pode ser vinculado. Você não é um membro autorizado da equipe do analyzer selecionado. Entre em contato com o administrador do projeto EY Helix para obter acesso e tente novamente.",
    34031: "Parece que você não acessou o aplicativo EY Helix antes.",
    34038: "A análise selecionada não está mais disponível. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    34043: "`O projeto EY Helix selecionado não está mais disponível. Clique em 'Vincular projeto' para vincular um projeto diferente.",
    34044: "O projeto EY Helix selecionado está marcado para exclusão. Clique em 'Vincular projeto' para vincular um projeto diferente.",
    34045: "O projeto EY Helix selecionado está marcado para armazenamento. Clique em 'Vincular projeto' para vincular um projeto diferente.",
    34046: "`Analyzer inválido ou analyzer no EY Helix faltando. Atualize a página e tente novamente. Se o problema persistir entre em contato com o Help Desk.",
    34047: "`O analyzer selecionado não está disponível no EY Helix. Atualize a página e tente novamente. Se o problema persistir entre em contato com o Help Desk.",
    34048: "`Os analytics não estão disponíveis no projeto vinculado. Acesse EY Helix e conclua as etapas de processamento de dados e analytics para continuar.",
    34080: "O número máximo de conexões do Engagement Helix foi excedido.",

    /* PAANS */
    35001: "A política da EY para aprovação e notificações não está disponível nesse momento.  Não podemos confirmar se todas as políticas relevantes foram concluídas. Se você não revisou as políticas relevantes, atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",

    /*Engagement Comments*/
    38001: "Criar engagement Falha na chamada de comentários",
    38002: "Falha na chamada Obter todos os comentários de engagement",
    38003: "Não é possível concluir esta ação. Atualize a página e tente novamente. Se o erro persistir entre em contato com o Help Desk",
    38004: "Não é possível concluir esta ação. Atualize a página e tente novamente. Se o erro persistir entre em contato com o Help Desk",
    38005: "Não é possível concluir esta ação. Atualize a página e tente novamente. Se o erro persistir entre em contato com o Help Desk",
    38006: "Não é possível concluir esta ação. Atualize a página e tente novamente. Se o erro persistir entre em contato com o Help Desk",
    38007: "Não é possível concluir esta ação. Atualize a página e tente novamente. Se o erro persistir entre em contato com o Help Desk",
    38008: "Não é possível concluir esta ação. Atualize a página e tente novamente. Se o erro persistir entre em contato com o Help Desk",
    38009: "Não é possível concluir esta ação. Atualize a página e tente novamente. Se o erro persistir entre em contato com o Help Desk",
    38010: "O corpo não deve ser nulo",
    38011: "O texto do comentário não deve ser nulo ou vazio",
    38012: "A entidade não existe em determinado engagement",
    38013: "O ID do status do comentário de engagement deve ser maior que 0",
    38014: "O ID do comentário de engagement pai deve ser maior que 0",
    38015: "Não havia nenhum corpo de formulário do Canvas correspondente aos critérios especificados",
    38016: "A nota que você está respondendo foi excluída por outro membro da equipe. Atualize a página e tente novamente",
    38017: "O comentário de engagement pai fornecido foi apagado",
    38018: "O comentário do engagement pai fornecido é uma resposta em si",
    38019: "O texto do comentário fornecido não deve ser menor que 1 e não maior que 4000 caracteres",
    38020: "O uid da entidade fornecido é inválido",
    38021: "O uid da entidade pai fornecido é inválido",
    38022: "Falha ao excluir a chamada de comentários de engagement",
    38023: "O id do comentário não deve estar vazio",
    38024: "A ação deve ser uma ação válida",
    38025: "O status da nota mudou. Atualize a página e tente novamente.",
    38026: "As notas de revisão só podem ser excluídas pelo usuário que criou a nota.",
    38027: "Você está tentando editar um comentário que não existe mais. Atualize a página e tente novamente.",
    38028: "Atualizações em comentários limpos não são permitidas",
    38029: "Apenas o autor pode alterar o texto do comentário",
    38030: "O ID do comentário de engagement é inválido",
    38031: "O ID do status do comentário não deve estar vazio",
    38032: "Não houve registro de relacionamento entre o usuário solicitado e o engagement. Atualize a página e tente novamente. Se o erro persistir entre em contato com o Help Desk",
    38033: "A ação de atualização é inválida",
    38034: "O ID do comentário solicitado já está sendo usado por outro comentário",
    38035: "O ID do comentário fornecido é inválido",
    38036: "O ID do documento não deve ser nulo ou vazio",
    38037: "O ID do usuário ao qual o comentário será atribuído não deve ser nulo",
    38038: "O comentário não deve ser reatribuído ao abri-lo ou fechá-lo",
    38039: "A nota da qual você está excluindo uma resposta já foi excluída. Atualize a página e tente novamente",
    38040: "A resposta não deve ter data de vencimento",
    38041: "A resposta não deve ter prioridade",
    38042: "O comentário deve ter data de vencimento",
    38043: "Comentário deve ter prioridade",
    38044: "Você está tentando editar uma resposta a um comentário que não existe mais. Atualize a página e tente novamente",
    38045: "Não é permitido editar o ID do status de engagement e seu conteúdo, atribuído ao usuário ou prioridade",
    38046: "A chamada de atualização de comentários de engagement falhou",
    38047: "Você pode apenas responder as notas abertas",

    /*Tags*/
    39004: "O grupo de tags que você está editando foi excluído por outro membro da equipe. Atualize a página e tente novamente.",
    40003: "O grupo de tags selecionado foi excluído por outro membro da equipe. Selecione outro grupo de tags para continuar.",
    40007: "Uma ou mais notas selecionadas foram excluídas. Atualize a página e tente novamente. Entre em contato com o suporte técnico se o erro persistir.",
    40011: 'Note index cannot exceed 5 characters.',
    40012: "O código da cor da tag é inválido. Atualize a página e tente novamente.",
    40014: "O grupo de tags que contém a tag que você está editando foi excluído por outro membro da equipe. Atualize a página e tente novamente.",
    40016: "As tags não podem ser adicionadas ou removidas de uma ou mais das tarefas selecionadas. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    40019: "Uma ou mais tags que você está editando foram excluídas por outro membro da equipe. Atualize a página e tente novamente.",
    40020: "Uma ou mais tags não podem ser sincronizadas agora. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    40021: "Uma ou mais das tags que você selecionou foram deletadas. Atualize a página e tente novamente.",
    40022: "Adicione um ou mais membros da equipe externa a este compromisso e tente esta operação novamente. Entre em contato com o Help Desk se o erro persistir.",
    40027: 'Description is too long.',

    // Scheduler request
    70022: "Não há tarefas associadas a esta solicitação de serviço. Atualize a página e selecione uma ou mais tarefas não excluídas para continuar. Entre em contato com a Central de Ajuda se o erro persistir.",
    70024: "Serviços centralizados não estão disponíveis para o seu engagement. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    70025: "Serviços centralizados não estão disponíveis no momento para o seu país. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",

    /* TaskDocumnet */
    80001: "Criar associação de documentos de tarefa falhou.",
    80002: "A solicitação deve ter pelo menos uma tarefa.",
    80003: "O documento de identidade deve estar presente.",
    80004: "A tarefa(s) selecionada foi excluída. Atualize a página e tente novamente. Se o erro persistir, entre em contato com o Help Desk.",
    80005: "A identificação do documento é inválida.",
    80006: "O usuário não tem permissões suficientes para realizar a operação.",
    80007: "A associação de documentos da tarefa falhou.",
    80008: "Após a associação de documentos da tarefa, a mudança de status da tarefa falhou.",
    80011: "Documentos confidenciais não são elegíveis para serem compartilhados.",
    80012: "Carga de solicitação inválida ou vazia.",
    80013: "Limite de tarefas excedido. Selecione 300 ou menos tarefas por vez.",
    80014: "Ocorreu um erro ao tentar vincular o documento. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",

    /* ITApplication / SO */
    81001: "Falha ao obter todos os aplicativos ITA.",
    81002: "Obtenha todos os aplicativos ITA - ID de compromisso inválido.",
    81003: "A aplicação de TI selecionada foi excluída. Feche este modal para ver a lista atualizada.",
    81004: "O nome não deve estar vazio.",
    81005: "O nome não deve ter mais de 500 caracteres.",
    81006: "StrategyTypeId inválido.",
    81007: "ID de documento inválida.",
    81008: "Falha ao obter ITApplication por ID.",
    81009: "Classificação inválida.",
    81010: "SCOT inválido.",
    81011: "Controle inválido.",
    81012: "ITApplicationID não deve ser nulo ou vazio.",
    81013: "Aplicativo ITA não encontrado.",
    81014: "Falha na exclusão da chamada ITApplicationITProcess.",
    81015: "ITApplicationITProcessId não deve estar vazio.",
    81016: "ITApplicationITProcessId inválido.",
    81017: "ITApplicationITProcess não encontrado.",
    81018: "Falha ao criar chamada ITApplicationITProcess.",
    81019: "Organização de serviço aprovada em vez de ITApplication.",

    /* Controls */
    83001: "Falha ao obter controles.",
    83002: "Esta ação não pode ser tomada. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    83003: "O ID do controle é nulo ou vazio.",
    83004: 'The selected Control has been deleted. Close this modal to see the updated list.',
    83005: "ID do documento é inválido.",
    83006: "Faltando nome do controle.",
    83007: "Comprimento do nome de controle inválido.",
    83008: "Solicitação inválida.",
    83009: "Id da frequência de controle inválido.",
    83010: "Id do tipo de controle inválido.",
    83011: "Controle de Aplicativo de TI inválido.",
    83012: "Id do Tipo de Controle com Desenho Efetivo inválido.",
    83013: "Aplicações de TI inválidas.",
    83014: "Apenas Aplicativo de TI do tipo SO são permitidos, se o tipo de controle for prevenção manual ou detecção manual.",
    83015: "Somente o ITDM pode ter o teste manual de IPE selecionado.",
    83016: "Controles de risco baixo não são permitidos para trabalhos com este perfil.",
    83017: "Filtros de SCOTs duplicados",
    83018: "O nome do controle tem mais de 500 caracteres.",
    83019: "Ids dos WCGW inválidos.",
    83020: "Ids dos WCGW duplicados não são permitidos.",
    83021: "IDs de Aplicativos e TI duplicados não são permitidos.",
    83023: "Página atual inválida.",
    83024: "Tamanho de página inválido.",
    83025: "Pesquisa string não deve ter mais de 100 caracteres.",
    83026: "APP de TI sem serviços de organização só pode ser associado a controle do tipo Controle Manual Dependente de TI ou Controle Aplicativo de TI.",
    83027: "Filtros de WCGWs duplicados.",
    83028: "Id de controle de conhecimento inválido.",

    /* ITControl */
    84001: "Falha ao obter controles de TI.",
    84002: "Falha ao obter controle de TI por id.",
    84003: "A ID de controle de TI é nula ou vazia.",
    84004: "ID de controle de TI inválido.",
    84005: "A ID do documento é inválida.",
    84006: "Falta o nome do controle de TI.",
    84007: "Comprimento do nome do controle de TI inválido.",
    84008: "FrequencyId de controle de TI inválido.",
    84009: "ApprochTypeId de controle de TI inválido.",
    84010: "DesignEffectivenessTypeId de controle de TI inválido.",
    84011: "Valor de teste de controle de TI inválido.",
    84012: "Controle de TI inválido OperatingEffectivenessTypeId.",
    84013: "Frequência de controle de TI ausente.",
    84014: "Falha ao excluir o controle de TI.",
    84015: "A string de pesquisa não deve ter mais de 100 caracteres.",

    /*GroupTasks*/
    85001: "A operação selecionada não pôde ser concluída neste momento. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    85002: "A operação selecionada não pôde ser concluída neste momento. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    85003: "A operação selecionada não pôde ser concluída neste momento. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    85004: "A operação selecionada não pôde ser concluída neste momento. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    85005: "A operação selecionada não pôde ser concluída neste momento. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    85006: "A operação selecionada não pôde ser concluída neste momento. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    85007: "A operação selecionada não pôde ser concluída neste momento. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    85008: "A operação selecionada não pôde ser concluída neste momento. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    85009: "A operação selecionada não pôde ser concluída neste momento. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    85010: "A operação selecionada não pôde ser concluída neste momento. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    85011: "A operação selecionada não pôde ser concluída neste momento. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    85012: "O documento selecionado já foi atribuído a outra região ou componente. Portanto, não está disponível para atribuição. Atualize a página e tente novamente.",
    85013: "A operação selecionada não pôde ser concluída neste momento. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    85014: "A operação selecionada não pôde ser concluída neste momento. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    85015: "A operação selecionada não pôde ser concluída neste momento. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    85016: "O ID de Projeto deve ser maior que zero.",
    85017: "Esta tarefa não está mais disponível neste projeto.",
    85018: "ID do documento inválido.",
    85019: "Você não tem o nível de confidencialidade adequado para enviar esses documentos. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    85020: "Um ou mais documentos que você está tentando enviar não estão mais disponíveis para envio. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    85021: "Formulários não disponíveis para envio à Equipe Primária.",
    85022: "Um ou mais documentos não foram enviados. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",

    /* ITRisk */
    86001: "O nome ITRisco não pode estar vazio.",
    86002: "O nome do ITRisk não deve ter mais de 500 caracteres.",
    86003: "ID de ITRisco inválido.",
    86004: "Obter itrisk by id call falhou.",
    86005: "ITRisco não encontrado.",
    86006: "Falha na criação da chamada ITRriskITControl.",
    86007: "ID de ITControl inválida.",
    86008: "Falha na exclusão da chamada ITRriskITControl.",
    86009: "ID ITRriskITControl inválida.",
    86010: "Falha ao excluir risco de TI.",


    /*Copyhub*/
    88017: "O serviço de processo de exportação caiu - a criação do pacote foi parcialmente bem sucedida",
    88018: "O usuário selecionado para envio das informações não é válido (e-mail inválido, Gui ou nome completo)",
    88033: "Status do pacote de cópia inválido para importação.",
    88042: "Você não tem permissão para exportação em massa.",
    88045: "Você não tem permissão para criar engagement de modelo.",
    88048: "O pacote está sendo importado por outro usuário. Por favor, tente novamente mais tarde.",
    88049: "O pacote não existe mais. Por favor, atualize a aba.",
    88050: "Outra cópia de engagement está em andamento no momento.",
    88051: "O engagement tem muitas cópias em andamento. Aguarde até que as cópias sejam concluídas antes de iniciar outra.",
    88056: "A ação não pode ser concluída. Atualize a página e tente novamente. Se o problema persistir entre em contato com o Help Desk.",
    88057: "Alguns documentos selecionados contêm evidências relacionadas no modo de edição de multi-usuário ativo. Por favor, verifique as evidências relacionadas para prosseguir. Se o erro persistir, entre em contato com o suporte técnico.",

    /* Group Scopes */
    92001: "Obtenção de todas as chamadas de escopos de grupo falhou.",
    92002: "Criação da chamada de escopo de grupo falhou.",
    92003: "Solicitação de atualização de escopos de grupo inválidos.",
    92004: "Nome de escopo inválido.",
    92005: "ID de escopo de pai inválido.",
    92006: "O escopo dos pais não existe.",
    92007: "Descrição do escopo inválido.",
    92008: "O comprimento do nome do escopo do grupo excede mais de 100 caracteres.",
    92009: "O comprimento de descrição do escopo do grupo excede mais de 500 caracteres.",
    92010: "Excluir escopos de grupo chamada falha.",
    92011: "O sub-escopo personalizado que você está editando foi excluído por outro membro da equipe. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    92012: "O id de escopo especificado não é válido.",
    92013: "Este sub-escopo personalizado foi atribuído a uma ou mais equipes e não pode ser excluído.",
    92014: "O sub-escopo personalizado que você está tentando excluir já foi excluído por outro membro da equipe. Atualize a página e tente novamente.",
    92015: "O usuário não tem permissões para realizar a operação.",
    92016: "O nome do escopo já existe neste engagement",
    92017: "Falha na chamada de escopos do grupo de ID.",

    /* Group Sections */
    101001: "Falha na chamada Criar Seções de Grupo.",
    101002: "O nome do Grupo não pode estar vazio ou nulo.",
    101003: "O comprimento do nome da seção do grupo excede mais de 100 caracteres.",
    101004: "O nome da seção já existe neste compromisso.",
    101005: "Falha na chamada Editar Seções do Grupo.",
    101006: "ID de seção inválido.",
    101007: "A seção do grupo não existe.",
    101008: "ID do projeto inválido.",
    101009: "Seção de Conhecimento de Grupo Inválida.",

    /* Group Documents */
    110001: "ID de projeto inválido.",
    110002: "Status de instrução inválido.",
    110003: "Falha ao obter projeto por chamada de identificação.",

    /* ClientEngagement */
    93001: "Descrição do engagement do cliente não encontrada.",
    93002: "A descrição do engagement do cliente não deve ser superior a 100 caracteres.",
    93003: "A solicitação de engagement do cliente está vazia.",
    93004: "A chamada do engajgement do cliente falhou.",
    93005: "Falha na chamada de atualização do engagement do cliente.",
    93006: "O nome do exibição do engagement não pôde ser atualizado no momento. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",

    /*IP FIltering */
    96005: "{0} não foi adicionado à lista permitida.",
    96015: "Não há locais de acesso disponíveis para importação do engagement de origem.",
    96016: "Não há locais de acesso disponíveis para importação do engagement de origem.",

    /*RBAC SchedulerRequests */
    'permissionIssueForScheduler': "Você não tem permissão para solicitar serviços. Entre em contato com um administrador do engagement e solicite permissão para tomar esta ação.",

    /* GroupInstructions */
    98001: "Falha na chamada de instruções do grupo.",
    98002: "Um ou mais dos IDs da seção de instrução de conhecimento não são válidos.",
    98003: "Falha ao criar a chamada de instruções do grupo.",
    98004: "O nome da instrução não pode ficar vazio.",
    98005: "O nome da instrução não pode exceder 500 caracteres.",
    98006: "A descrição da instrução não pode estar vazia.",
    98007: "A descrição da instrução não pode exceder 4.000 caracteres.",
    98008: "A instrução deve ser atribuída a escopos ou equipes.",
    98009: "O nome de instrução já existe neste engagement.",
    98011: "Esta instrução de grupo já foi excluída por outro membro da equipe. Atualize a página e tente novamente. Entre em contato com o suporte técnico se o erro persistir.",
    98012: "Esta instrução de grupo foi excluída por outro membro da equipe. Atualize a página e tente novamente. Entre em contato com o suporte técnico se o erro persistir.",
    98016: "A instrução de grupo que você está editando foi excluída por outro membro da equipe. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    98017: "Esta tarefa de grupo já foi excluída por outro membro da equipe. Atualize a página e tente novamente. Entre em contato com o suporte técnico se o erro persistir.",
    98018: "Esta tarefa de grupo foi excluída por outro membro da equipe. Atualize a página e tente novamente. Entre em contato com o suporte técnico se o erro persistir.",
    98019: "Entidade não encontrada",

    /* Group Snapshots */
    102001: "Falha na chamada de criação de instantâneo de instrução de grupo.",
    102002: "Erro de parâmetros de solicitação inválidos.",
    102003: "Erro de engagement inválido.",
    102004: "Falha na chamada de todos os snapshtos de grupo.",
    102005: "Falha na chamada de instantâneo do grupo Obter por ID.",
    102006: "Snapshots não encontrado.",
    102007: "Instantâneo inválido selecionado.",

    /* Group Links - Send link request */
    106001: "Falha ao enviar ligação de grupo.",
    106002: "A lista de equipes não pode estar vazia.",
    106003: "Uma ou mais equipes selecionadas são inválidas.",
    106004: "A mensagem de link do grupo de fila falhou.",
    106005: "As equipes não podem ser repetidas.",
    106006: "Os tokens de simultaneidade não podem ser repetidos.",

    /* GroupInstructions - Send Version request */
    22019: "A equipe foi eliminada.",
    22023: "Falha na chamada de envio de instruções.",
    22024: "O componente para o qual você está tentando enviar instruções não está disponível ou já foi excluído.",
    22025: "O ID do engagement não pode estar vazio.",
    22026: "O ID do componente não pode estar vazio.",
    22027: "Instrução de grupo encontrada sem data de vencimento.",
    22028: "A instrução de escopo ainda não foi publicada para o componente.",
    22029: "Nenhuma nova instrução publicada para o componente enviar",
    22030: "Esta versão de instruções e tarefas já foi aceita por outro membro da equipe. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",

    22031: "Versão de chamada de grupo falhou.",

    /* GroupVersion */
    22032: "As instruções não existem.",

    22034: "Versão de grupo obtida pela chamada de ID falhou.",
    22035: "O ID de configuração da instrução não pode estar vazio.",

    /* Return instruction concurrency scenario*/
    22036: "Uma nova versão de instruções e tarefas está disponível. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    22037: "Esta versão de instruções e tarefas já foi aceita por outro membro da equipe. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    22038: "Esta versão de instruções e tarefas já foi devolvida por outro membro da equipe. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir",

    37018: "Esta conta GL não está mais disponível. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    37019: "A relação do documento não pode ser editada. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    37030: "Esta conta GL não está mais disponível. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    37032: "A relação do documento não pode ser editada. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    37033: "A relação do documento não pode ser editada. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    37034: "A relação do documento não pode ser editada. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    37037: "Este ajuste não está mais disponível. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",

    /* EngagementReports */
    111001: "Falha ao obter relatório por chamada de tipo de relatório.",
    113015: "Balancete de verificação indisponível. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    113025: "É necessário filtrar o ID da classe da conta ou filtrar o ID da conta. Não é possível prosseguir.",
    113050: "O Balancete de Verificação ou a Demonstração Financeira não pertence a este engagement ou pode ter sido excluído, não é possível prosseguir.",

    /*Information Security */
    200001: "A ação tomada foi proibida pela Segurança da Informação da EY. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",

    /*GL account concurrency scenario*/
    113043: "Esta conta de reconciliação não está mais disponível. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    113019: "Esta conta de reconciliação não está mais disponível. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    113022: "A ação não pode ser concluída. Atualize a página e tente novamente. Se o problema persistir entre em contato com o Help Desk.",
    113039: "Uma referência já está associada a esta conta GL. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    113021: "This GL account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
    113035: "Uma referência já está associada a esta conta GL. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    113020: "Esta evidência não está mais disponível. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    113037: "Esta conta GL não está mais disponível. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
    40029: "Esta conta GL não está mais disponível. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",

    /*Trial balance*/
    113060: "Multi-entidade necessária para engagement MEST.",
    113061: "Multi-entidade não é necessária para nenhum engagement MEST.",
    113057: "Engagement Helix não encontrado.",
    113094: "O balancete a ser atualizado deve ser do Planejamento e o balancete verdadeiro.",
    113095: "O balancete a ser atualizado não deve ser Planejamento e o balancete verdadeiro quando o tipo financeiro for o balancete.",
    113069: "Já existe escopo e estratégia para o engagement.",
    113009: "ID de balancete inválido, não é possível prosseguir.",
    113092: "O balancete é tanto planejamento quanto demonstrações financeiras. Não é possível prosseguir com a exclusão reversível.",
    114033: "All business units mapped to a given entity must share at least one currency type and currency code. Please re-map your data and try again."

};

export const controlRiskTypeStep2 = [{
        id: 1,
        name: "Confiar"
    },
    {
        id: 2,
        name: "Não confiar"
    },
    {
        id: 3,
        name: "Testar MP"
    }
];

/*Label Collections */
//Canvas Forms Statuses
export const canvasFormStatus = [{
        id: 1,
        value: "Atualização em andamento"
    },
    {
        id: 3,
        value: "Erro"
    },
    {
        id: 5,
        value: "Atualização em andamento"
    },
    {
        id: 6,
        value: "Erro"
    }
];

export const riskTypes = [{
        id: 1,
        name: "Riscos significativos",
        abbrev: "RS",
        title: "Risco significativo"
    },
    {
        id: 2,
        name: "Riscos de fraude",
        abbrev: "RF",
        title: "Risco de fraude"
    },
    {
        id: 3,
        name: "Riscos de distorção material",
        abbrev: "R",
        title: "RDM/risco inerente"
    }
];

export const riskTypesToolTip = [{
        id: 1,
        name: "Riscos significativos",
        abbrev: 'SR',
        label: "Significativo",
        title: "Risco significativo"
    },
    {
        id: 2,
        name: "Riscos de fraude",
        abbrev: "RF",
        label: "Fraude",
        title: "Risco de fraude"
    },
    {
        id: 3,
        name: "Risco de distorção material",
        abbrev: "R",
        label: "Risco de distorção material",
        title: "Risco de distorção material"
    }
];

export const risksTypes = [{
        id: 1,
        name: "Riscos significativos",
        abbrev: "RS",
        title: "Riscos significativos"
    },
    {
        id: 2,
        name: "Riscos de fraude",
        abbrev: "RF",
        title: "Riscos de fraude"
    },
    {
        id: 3,
        name: "Riscos de distorção material",
        abbrev: "R",
        title: "Riscos de distorção material"
    }
];

export const emptyRiskTypes = [{
        id: 1,
        label: "Nenhum risco significativo foi identificado"
    },
    {
        id: 2,
        label: "Nenhum risco de fraude foi identificado"
    },
    {
        id: 3,
        label: "Não foram identificados riscos de distorção material"
    }
];

export const controlRiskType = [{
        id: 1,
        name: "Confiar"
    },
    {
        id: 2,
        name: "Não confiar"
    },
    {
        id: 3,
        name: "Teste MP"
    }
];
export const inherentRiskType = [{
        id: 1,
        name: "Mais alto"
    },
    {
        id: 2,
        name: "Mais baixo"
    }
];
export const CRAStrings = {
    Minimal: "Mínimo",
    Low: "Baixo",
    'Low +SC': "Baixo + SC",
    Moderate: "Moderado",
    High: "Alto",
    'High +SC': "Alto + SC"
};
export const priorityType = [{
        id: 1,
        name: "Baixo",
        className: 'Low',
        label: "L"
    },
    {
        id: 2,
        name: "Médio",
        className: 'Medium',
        label: "M"
    },
    {
        id: 3,
        name: "Alto",
        className: 'High',
        label: "H"
    },
    {
        id: 4,
        name: "Crítico",
        className: 'Critical',
        label: "C"
    }
];
export const reviewNoteFilterTypes = [{
        value: 0,
        label: "Todos"
    },
    {
        value: 1,
        label: "Aberto"
    },
    {
        value: 2,
        label: "Esclarecido"
    },
    {
        value: 3,
        label: "Fechado"
    }
];
export const reviewStatus = [{
        id: 1,
        name: "Aberto"
    },
    {
        id: 2,
        name: "Esclarecido"
    },
    {
        id: 3,
        name: "Fechado"
    }
];
export const reviewNoteOpenStatusOption = [{
        value: 2,
        label: "Eliminar"
    },
    {
        value: 3,
        label: "Fechar"
    }
];
export const reviewNoteClearedStatusOption = [{
        value: 1,
        label: "Reabrir"
    },
    {
        value: 3,
        label: "Fechar"
    }
];
export const reviewNoteBulkClearedStatusOption = [{
        value: 1,
        label: "Reabrir"
    },
    {
        value: 2,
        label: "Limpar"
    },
    {
        value: 3,
        label: "Fechar"
    }
];
export const reviewNoteClosedStatusOption = [{
    value: 1,
    label: "Reabrir"
}];
export const signOffTypes = [{
        value: 0,
        label: "Preparador"
    },
    {
        value: 1,
        label: "Revisor"
    },
    {
        value: 2,
        label: "Nenhum"
    }
];
export const RNHNoteStatusOptions = [{
        value: 1,
        label: "Aberto"
    },
    {
        value: 2,
        label: "Fechado"
    },
    {
        value: 3,
        label: "Esclarecido"
    }
];
export const assertions = [{
        id: 1,
        assertionname: "Completude",
        assertionabbreviation: "C",
        statementtypeid: 2,
        displayorder: 1
    },
    {
        id: 2,
        assertionname: "Existência",
        assertionabbreviation: "E",
        statementtypeid: 2,
        displayorder: 2
    },
    {
        id: 3,
        assertionname: "Valorização",
        assertionabbreviation: "V",
        statementtypeid: 2,
        displayorder: 3
    },
    {
        id: 4,
        assertionname: "Direitos e obrigações",
        assertionabbreviation: "R&O",
        statementtypeid: 2,
        displayorder: 4
    },
    {
        id: 5,
        assertionname: "Apresentação e Divulgação",
        assertionabbreviation: "P&D",
        statementtypeid: 2,
        displayorder: 5
    },
    {
        id: 6,
        assertionname: "Completude",
        assertionabbreviation: "C",
        statementtypeid: 1,
        displayorder: 6
    },
    {
        id: 7,
        assertionname: "Ocorrência",
        assertionabbreviation: "O",
        statementtypeid: 1,
        displayorder: 7
    },
    {
        id: 8,
        assertionname: "Mensuração",
        assertionabbreviation: "M",
        statementtypeid: 1,
        displayorder: 8
    },
    {
        id: 9,
        assertionname: "Apresentação e Divulgação",
        assertionabbreviation: "P&D",
        statementtypeid: 1,
        displayorder: 9
    },
    {
        id: 10,
        assertionname: "Completude",
        assertionabbreviation: "C",
        statementtypeid: 3,
        displayorder: 10
    },
    {
        id: 11,
        assertionname: "Existência/Ocorrência",
        assertionabbreviation: "E/O",
        statementtypeid: 3,
        displayorder: 11
    },
    {
        id: 12,
        assertionname: "Mensuração/Valorização",
        assertionabbreviation: "M/V",
        statementtypeid: 3,
        displayorder: 12
    },
    {
        id: 13,
        assertionname: "Direitos e obrigações",
        assertionabbreviation: "R&O",
        statementtypeid: 3,
        displayorder: 13
    },
    {
        id: 14,
        assertionname: "Apresentação e Divulgação",
        assertionabbreviation: "P&D",
        statementtypeid: 3,
        displayorder: 14
    }
];
//Add Review Note
export const priorityTypes = [{
        value: 1,
        label: "Baixo"
    },
    {
        value: 2,
        label: "Médio"
    },
    {
        value: 3,
        label: "Alto"
    },
    {
        value: 4,
        label: "Crítico"
    }
];
/*Cog Menu*/
export const cogMenuOptions = {
    Open: "Aberto",
    'Start Co-edit mode': "Iniciar edição de multi-usuário",
    'End Co-edit mode': "Encerrar a edição de multi-usuário",
    'Open read-only': "Abrir somente para leitura",
    'View history': "Ver histórico",
    CopyLink: "Copiar link",
    Rename: "Renomear",
    Delete: "Excluir",
    'Remove from task': "Remover da tarefa",
    Remove: "Remover",
    Unlink: "Desvinculado",
    RelateTasks: "Relacionar tarefas",
    RelateEntities: "Relacionar entidades",
    Restore: "Restaurar",
    PermanentlyDelete: "Excluir permanentemente",
    ChangeReason: "Editar razão",
    Confidentiality: "Confidencialidade",
    SignoffRequirements: "Requisitos de assinatura",
    AssignRegionComponent: "Atribuir a região ou componente",
    UnassignRegionComponent: "Cancelar atribuição de região ou componente",
    ReturnToRegionComponent: "Retornar à região ou componente",
    ClearReturnToRegionComponent: "Limpar retorno à região ou componente",
    OverwriteForm: "Formulário de substituição",
    Finalize: "Finalizar documento"
};

export const pagingSvgHoverText = {
    first: "Primeira página",
    previous: "Página anterior",
    next: "Próxima página",
    last: "Última página"
};
export const controlFrequencyType = {
    1: "Muitas vezes por dia",
    2: "Diário",
    3: "Semanal",
    4: "Mensal",
    5: "Trimestral",
    6: "Anual",
    7: "Controle de aplicação de TI",
    8: "Outro"
};
export const itApproachType = {
    1: "Controles",
    2: "Substantivo"
};
export const controlType = {
    1: "Aplicação de TI",
    2: "Manual Dependente de TI",
    3: "Prevenção manual",
    4: "Detecção manual"
};
export const aggregateITEvaluationType = {
    1: "Suporte",
    2: "Não suporte",
    3: "Suporte FS e ICFR",
    4: "Suporte somente FS"
};
export const entityType = {
    'ENTITY3': "Conta",
    'ENTITY4': "SCOT",
    'ENTITY5': "Processo de TI",
    'ENTITY7': "Risco",
    'ENTITY18': "WCGW",
    'ENTITY19': "Controle",
    'ENTITY20': "Aplicação ITSO",
    'ENTITY24': "Assertiva",
    'ENTITY34': "Controle de TI",
    'ENTITY35': "Risco de TI"
};
export const trueFalseToYesNo = {
    'true': "Sim",
    'false': "Não"
}
export const trueFalseToYesOnly = {
    'true': "Sim"
}
export const yesNoLocalized = {
    'Yes': "Sim",
    'No': "Não"
}
export const iTProcessEvaluationType = {
    1: "Eficaz",
    2: "Ineficaz",
    3: "Confiável",
    4: "Não testado"
};

export const strategyType = {
    1: "Controles",
    2: "Substantivo",
    3: "Confiar",
    4: "Não confiar"
};
export const accountType = {
    1: "Contas significativas",
    2: "Conta de risco limitado"
};

export const scotTypes = {
    1: "Rotineira",
    2: "Não rotineira",
    3: "Estimativa"
};
export const taskNavigation = {
    1: "Minhas tarefas",
    2: "Todas as tarefas",
    3: "Escopo e Estratégia",
    4: "SCOTs",
    5: "TI/Sos",
    6: "Contas",
    7: "Execução geral",
    8: "Conclusão",
    9: "Resumo da equipe",
    10: "Riscos"
};
export const subCategoty = {
    1: "Mostre tudo",
    2: "Para preparar",
    3: "Para revisar"
};
export const subCategoryType = {
    AllTasks: {
        id: 1,
        title: "Mostrar tudo",
        label: "Mostrar tudo"
    },
    ToPrepare: {
        id: 2,
        title: "Para Preparação",
        label: "Para Preparação"
    },
    ToReview: {
        id: 3,
        title: "Para revisão",
        label: "Para revisão"
    },
    Preparers: {
        id: 2,
        title: "Preparadores",
        label: "Preparadores"
    },
    Reviewers: {
        id: 3,
        title: "Revisores",
        label: "Revisores"
    }
};
/*Task Types*/
export const taskType = {
    1: "Tarefa Padrão",
    2: "Tarefa Padrão Primária",
    3: "Tarefa de Walkthrough",
    4: "Tarefa de Controle",
    5: "Tarefa Substantiva",
    6: "Tarefa de Procedimento Substantivo Primário",
    7: "Tarefa de Resposta",
    8: "Tarefa de Grupo"
};

export const taskTypesForAddTask = {
    importfromknowledge: "Importar do informação",
    custom: "Personalizar",
    account: "Conta",
    itsubstantive: "Procedimento substantivo de TI",
    scotwalkthroughtask: "Walkthrough da SCOT",
    scotcontroltask: "Controle SCOT",
    itwalkthroughtask: "Walkthrough de TI",
    itcontroltask: "Controle de TI"
};

export const taskTypeBadge = {
    1: "OST",
    2: "PST",
    3: "WT",
    4: "TOC",
    5: "OSP",
    6: "PSP",
    7: "RT",
    8: "GT",
    9: "PIC",
    10: "EQR",
    11: "PIC/EQR",
    22: "ACT",
    23: "UDP"
};
/*Task Types*/
export const taskTypeAbbreviation = {
    1: "TOC",
    2: "TOC",
    3: "TOC",
    4: "TOC",
    5: "TOC",
    6: "TOC",
    7: "RT",
    8: "RT",
    9: "RT",
    10: "RT",
    11: "RT",
    13: "OST",
    14: "PST",
    16: "OSP",
    17: "PSP",
    18: "WT",
    19: "UDP",
    20: "WT",
    22: "Ato",
    23: "GT",
    24: "GT",
    25: "GT",
    26: "OSP",
    27: "GT"
};
export const auditPhase = {
    1: "Escopo e Estratégia",
    2: "Execução",
    3: "Conclusão"
};
export const ProfileActionType = {
    1: "Envio do perfil - Primeira Vez",
    2: "Envio do perfil - RollForward",
    3: "Edição de perfil",
    4: "Atualização global de conteúdo",
    5: "Importar PSPs",
    6: "Importar PSTs",
    7: "Atualização de conteúdo do formulário do Canvas",
    8: "Instruções de Importação GA",
    9: "Adicionar formulário manual",
    10: "Entrega de perfil",
    11: "Atualização obrigatória de conteúdos",
    12: "Sincronização de perfil de formulário do Canvas"
};

export const taskGroup = {
    1: "Executar procedimentos gerais de planejamento",
    2: "Fluxo de contas",
    3: "Fluxo de classe de transações significativas (SCOTs)",
    4: "Fluxo de aplicativos e organizações de serviços de TI",
    5: "Fluxo de avaliação de risco combinado (ARC)",
    6: "Fluxo de plano de auditoria",
    7: "Concluir os procedimentos do engagement",
    8: "Resumo das diferenças de auditoria (SAD)",
    9: "Avaliar os resultados da auditoria",
    10: "Executar procedimentos gerais de auditoria",
    11: "Fluxo de Estrutura da Auditoria de Grupo",
    12: "Criar Fluxo de Instruções da Auditoria de Grupo",
    13: "Tarefas do grupo principal",
    14: "Tarefas do grupo de componente",
    15: "Criar Fluxo do Programa de Trabalho",
    16: "Accounts Flow - MEST",
    17: "Executar procedimentos de revisão",
    18: "Concluir atividades preliminares do engagement",
    19: "Planejamento do engagement",
    20: "Habilitar o engagement com dados",
    21: "Executar procedimentos analíticos de RA e determinar a materialidade",
    22: "Identify significant accounts - MEST",
    23: "Procedimentos adicionais para informar nossas avaliações de risco",
    24: "Identificar fontes",
    25: "Identificar contas significativas",
    26: "Identificar e entender as SCOTs",
    27: "Identificar e entender os processos de TI e as organizações de serviços",
    28: "Confirmar a estratégia e o CRA",
    29: "Executar procedimentos adicionais necessários de identificação de riscos",
    30: "Considerar o uso da auditoria interna",
    31: "Responder a avaliações de risco",
    32: "Finalizar estratégia",
    33: "Procedimentos do EQR",
    34: "Desenhar procedimentos",
    35: "Avaliar e concluir sobre a evidência de auditoria",
    36: "Emitir comunicações e relatórios",
    37: "Procedimentos do EQR",
    38: "Preparar e emitir o relatório de auditoria",
    39: "Finalizar a documentação e efetuar o arquivamento do engagement",
    40: "Testar controles ao nível da entidade",
    41: "Avaliar dados utilizados ​​em técnicas automatizadas",
    42: "Executar procedimentos requeridos para fraude",
    43: "Executar procedimentos de auditoria interna e especialistas",
    44: "Avaliar processos de TI",
    45: "Revisar atas, contratos e documentos legais",
    46: "Procedimentos das demonstrações financeiras",
    47: "Executar procedimentos relacionados a partes relacionadas (RPTs), continuidade operacional e leis e regulamentos",
    48: "Discutir revisões da estratégia de auditoria",
    49: "Conclusão da Execução",
    50: "Procedimentos do EQR",
    51: "Complete as atividades de qualidade do escopo e estratégia",
    52: "Executar procedimentos de auditoria inicial",
    53: "Executar procedimentos de avaliação de risco",
    54: "Identificar organizações de serviços",
    55: "Digital - Grupo de tarefas 5",
    56: "Identifique e entenda os processos de TI",
    57: "Execute procedimentos de planejamento",
    58: "Estrutura do Grupo, Instruções e Envolvimento",
    59: "Identifique divulgações significativas",
    60: "Identifique e compreenda processos de relatórios significativos",
    61: "Digital - Grupo de Tarefas 11",
    62: "Digital - Grupo de tarefas 12",
    63: "Digital - Grupo de tarefas 13",
    64: "Digital - Grupo de tarefas 14",
    65: "Digital - Grupo de tarefas 15",
    66: "Digital - Grupo de tarefas 16",
    67: "Digital - Grupo de tarefas 17",
    68: "Atividades concluídas de check-in para gerenciamento de projetos",
    69: 'Execute substantive procedures - Governance',
    70: 'Execute substantive procedures - Strategy',
    71: 'Execute substantive procedures - Risk Management',
    72: 'Execute substantive procedures - Metrics and Targets',
    73: "Executar procedimentos substantivos - Outros",
    74: "Avalie o trabalho de outras pessoas",
    75: "Digital - Grupo de tarefas 25",
    76: "Digital - Grupo de tarefas 26",
    77: "Digital - Grupo de tarefas 27",
    78: "Digital - Grupo de tarefas 28",
    79: "Digital - Grupo de tarefas 29",
    80: "Digital - Grupo de tarefas 30",
    81: "Digital - Grupo de tarefas 31",
    82: "Digital - Grupo de tarefas 32",
    83: "Digital - Grupo de tarefas 33",
    84: "Digital - Grupo de tarefas 34",
    85: "Evaluate and conclude on review evidence",
    86: "Executar procedimentos gerais de auditoria",
    87: "Avalie e conclua com base nas evidências",
    88: "Digital - Grupo de tarefas 38",
    89: "Digital - Grupo de tarefas 39",
    90: "Digital - Grupo de tarefas 40",
    91: "Digital - Grupo de tarefas 41",
    92: "Digital - Grupo de tarefas 42",
    93: "Digital - Grupo de tarefas 43",
    94: "Digital - Grupo de tarefas 44",
    95: "Digital - Grupo de tarefas 45",
    96: "Digital - Grupo de tarefas 46",
    97: "Digital - Grupo de Tarefas 47",
    98: "Digital - Grupo de tarefas 48",
    99: "Digital - Grupo de tarefas 49",
    100: "Digital - Grupo de tarefas 50"
};
export const AutomationHubRequestStatus = {
    Draft: "Rascunho",
    Submitted: "Enviado",
    Sent: "Envio em andamento",
    InProgress: "Em processamento",
    Failed: "Erro de processamento",
    Completed: "Concluído",
    FailedToSendToBP: "Erro de processamento",
    QueueingFailed: "Falha no envio",
    ActionRequired: "Ação requerida"
};
export const milestonesLabels = {
    1: "Escopo",
    2: "Estratégia",
    3: "Walkthroughs",
    4: "Teste de Controle interino",
    5: "Teste Substantivo Interino",
    6: "Walkthroughs (processos de final de ano)",
    7: "Teste de Controle de Final de Ano",
    8: "Teste Substantivo de Final de Ano",
    9: "Conclusão",
    10: "Não aplicável",
    11: "Execução",
    12: "Atividades de qualidade do escopo e estratégia",
    13: "Outro escopo e estratégia",
    14: "CRA",
    15: "Avaliação de Risco e Materialidade",
    16: "Finalizar escopo e estratégia",
    17: "Gerenciamento de projetos realizados em data interina"
};

export const TasksFilterGroups = {
    Tasks: "Tarefas",
    Assignments: "Alocações",
    ReviewNotes: "Notas de revisão",
    ProjectManagement: "Gerenciamento de projetos",
    Other: "Outro"
};

export const TasksFilterTypes = {
    TaskStatus: "Status da tarefa",
    TaskType: "Tipo de tarefa",
    AssignedTo: "Atribuído a",
    OpenAssignments: "Atribuições abertas",
    ReviewNotesStatus: "Status de notas de revisão",
    ReviewNotesAssignedTo: "Notas de revisão atribuídas a",
    ReviewNotesCreatedBy: "Notas de revisão criadas por",
    TimePhase: "Fase de tempo",
    Milestone: "Milestone",
    AuditPhase: "Fase de auditoria",
    DocumentConflict: "Conflito de documentos",
    Findings: "Findings",
    Entity: "Entidade",
    IsBookmarked: "Baixado para offline"
};

export const quickFilterTaskStatus = [{
        value: '1',
        label: "Aberto"
    },
    {
        value: '2',
        label: "Em andamento"
    },
    {
        value: '3',
        label: "Em revisão"
    },
    {
        value: '4',
        label: "Completo"
    }
];

export const quickFilterAssignmentStatus = [{
        value: '1',
        label: "Aberto"
    },
    {
        value: '2',
        label: "Em andamento"
    },
    {
        value: '3',
        label: "Fechado"
    },
    {
        value: '4',
        label: "Não assinado"
    }
];

export const dataExport = [
	// 'Archive Form',
	// 'Canvas Forms',
	"Colaboração",
	// 'Control Forms',
	"Documentos",
	"Tarefas",
	"Resumo da SCOT",
	// 'Team Members',
	// 'Trial Balance'
];
export const dataExportReportNames = {
    'Archive Form': "Formulário de arquivamento",
    'Canvas Forms': "Relatório de formulário do Canvas",
    'Collaboration': "Colaboração",
    'Control Forms': "Relatório de Controle",
    'Documents': "Relatório de todos os documentos",
    'Tasks': "Relatório de todas as tarefas",
    'Team Members': "Membros do time",
    'Trial Balance': "Relatório de Números"
};
export const projectManagement = [
	"Detalhes da colaboração",
	// 'Digital scorecard',
	// 'Milestones',
	// 'Review Notes',
	// 'Validation Checks'
];

export const projectManagementReportNames = {
    'Collaboration Details': "Painel de Colaboração do Cliente",
    'Milestones': "Relatório de Marco",
    'Review Notes': "Revisar Relatório de Notas",
    'Validation Checks': "Relatório de verificações de validação"
};

export const taskQuickFilterOptions = [{
        id: 'taskToPreparer',
        label: "Tarefas para preparar",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'tasksReadyForReview',
        label: "Tarefas prontas para revisão",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'allAssignedTasks',
        label: "Todas as tarefas atribuídas",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'allOverdueTasks',
        label: "Tarefas atrasadas",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'allTasksDueThisWeek',
        label: "Tarefas que vencem esta semana",
        uiViewId: uiViews.taskSystemSuggestedFilter
    }
];

export const noDefaultFilter = {
    id: 'noDefaultFilter',
    label: "Sem filtro padrão"
};

export const taskTypes = [{
        id: '1',
        label: "Tarefa de controle"
    },
    {
        id: '2',
        label: "Tarefa de Controle - Controle"
    },
    {
        id: '3',
        label: "Tarefa de Controle - ELC"
    },
    {
        id: '4',
        label: "Tarefa de Controle - TI/SO"
    },
    {
        id: '5',
        label: "Tarefa de Controle - MP"
    },
    {
        id: '6',
        label: "Tarefa de Controle - SO"
    },
    {
        id: '7',
        label: "Tarefa de Resposta"
    },
    {
        id: '8',
        label: "Tarefa de Resposta a Distorções de Fluxo de caixa"
    },
    {
        id: '9',
        label: "Tarefa de Resposta a Deficiências"
    },
    {
        id: '10',
        label: "Tarefa de Resposta a Distorções de Divulgação"
    },
    {
        id: '11',
        label: "Tarefa de Resposta a Distorções"
    },
    {
        id: '12',
        label: "Tarefa Padrão"
    },
    {
        id: '13',
        label: "Outra Tarefa Padrão"
    },
    {
        id: '14',
        label: "Tarefa Padrão Primária"
    },
    {
        id: '15',
        label: "Tarefa Substantiva"
    },
    {
        id: '16',
        label: "Outra Tarefa de Procedimento Substantivo"
    },
    {
        id: '17',
        label: "Tarefa de Procedimento Substantivo Primário"
    },
    {
        id: '18',
        label: "Tarefa de Walkthrough"
    },
    {
        id: '19',
        label: "Tarefa de Walkthrough - TI/SO"
    },
    {
        id: '20',
        label: "Tarefa de Walkthrough - SCOT"
    },
    {
        id: '21',
        label: "A fazer "
    },
    {
        id: '22',
        label: "Tarefa de Conclusão de Conta"
    },
    {
        id: '23',
        label: "Tarefa do Grupo"
    },
    {
        id: '24',
        label: "Tarefa do Grupo Primário"
    },
    {
        id: '25',
        label: "Tarefa do Component do Grupo "
    },
    {
        id: '26',
        label: "Outra Tarefa de Procedimento Substantivo de TI/SO"
    },
    {
        id: '27',
        label: "Tarefa de Componente de Grupo desvinculada"
    }
];

export const filterAssignmentType = [{
        value: '1',
        label: "Preparador"
    },
    {
        value: '2',
        label: "Revisor de detalhes"
    },
    {
        value: '3',
        label: "Revisor geral"
    },
    {
        value: '4',
        label: "Sócio"
    },
    {
        value: '5',
        label: "EQR"
    },
    {
        value: '6',
        label: "Outros"
    }
];

export const filterTaskStatus = [{
        value: '1',
        label: "Abrir"
    },
    {
        value: '2',
        label: "Em progresso"
    },
    {
        value: '3',
        label: "Em revisão"
    },
    {
        value: '4',
        label: "Completo"
    },
    {
        value: '5',
        label: "Sem evidência"
    }
];

export const filterAssignmentStatus = [{
        value: '1',
        label: "Abrir"
    },
    {
        value: '2',
        label: "Em andamento"
    },
    {
        value: '3',
        label: "Fechado"
    },
    {
        value: '4',
        label: "Não atribuído"
    }
];

export const filterTaskType = [{
        value: '1',
        label: "Control task"
    },
    {
        value: '7',
        label: "Response task"
    },
    {
        value: '13',
        label: "Other standard task"
    },
    {
        value: '14',
        label: "Primary standard task"
    },
    {
        value: '16',
        label: "Other substantive procedure task"
    },
    {
        value: '17',
        label: "Primary substantive procedure task"
    },
    {
        value: '18',
        label: "Passo a passo/ tarefa UDP "
    },
    {
        value: '22',
        label: "Tarefa de conclusão da conta"
    },
    {
        value: '999',
        label: "Assinatura de PIC requerida"
    },
    {
        value: '1000',
        label: "EQR sign-off required"
    }
];

export const filterTaskTypeGroupEngagement = [{
        value: '1',
        label: "Tarefa de controle"
    },
    {
        value: '7',
        label: "Tarefa de resposta"
    },
    {
        value: '13',
        label: "Other standard task"
    },
    {
        value: '14',
        label: "Primary standard task"
    },
    {
        value: '16',
        label: "Other substantive procedure task"
    },
    {
        value: '17',
        label: "Primary substantive procedure task"
    },
    {
        value: '18',
        label: "Walkthrough/ Tarefa UDP"
    },
    {
        value: '22',
        label: "Tarefa de conclusão da conta"
    },
    {
        value: '23',
        label: "Tarefa de grupo"
    },
    {
        value: '999',
        label: "Assinatura de PIC requerida"
    },
    {
        value: '1000',
        label: "EQR sign-off requerido"
    }
];

export const filterTaskTypeInterimEngagement = [{
        value: '14',
        label: "Primary standard task"
    },
    {
        value: '13',
        label: "Other standard task"
    },
    {
        value: '23',
        label: "Tarefa de grupo"
    },
    {
        value: '999',
        label: "Assinatura de PIC requerida"
    },
    {
        value: '1000',
        label: "EQR sign-off requerido"
    }
];

export const filterMilestones = [{
        value: '1',
        label: "Escopo",
        hideFromMenu: true
    },
    {
        value: '2',
        label: "Estratégia",
        hideFromMenu: true
    },
    {
        value: '12',
        label: "Atividades de qualidade do escopo e estratégia"
    },
    {
        value: '13',
        label: "Outro escopo e estratégia"
    },
    {
        value: '14',
        label: "CRA"
    },
    {
        value: '15',
        label: "Avaliação de risco e materialidade"
    },
    {
        value: '16',
        label: "Finalizar escopo e estratégia"
    },
    {
        value: '17',
        label: "Gerenciamento de projeto pós interino"
    },
    {
        value: '3',
        label: "Walkthroughs"
    },
    {
        value: '4',
        label: "Teste de controle interino"
    },
    {
        value: '5',
        label: "Teste substantivo interino"
    },
    {
        value: '6',
        label: "Walkthrough (processo de final de ano)"
    },
    {
        value: '7',
        label: "Teste de controle de final de ano"
    },
    {
        value: '8',
        label: "Teste substantivo de final de ano"
    },
    {
        value: '11',
        label: "Execução"
    },
    {
        value: '9',
        label: "Conclusão"
    },
    {
        value: '10',
        label: "N/A"
    },
    {
        value: '0',
        label: "Sem milestone"
    }
];

export const documentListMilestones = [{
        value: '1',
        label: "Escopo"
    },
    {
        value: '12',
        label: "Gerenciamento de escopo e estratégia de projetos"
    },
    {
        value: '13',
        label: "Outro escopo e estratégia"
    },
    {
        value: '2',
        label: "Estratégia"
    },
    {
        value: '14',
        label: "CRA"
    },
    {
        value: '15',
        label: "Avaliação de risco e materialidade"
    },
    {
        value: '16',
        label: "Finalizar escopo e estratégia"
    },
    {
        value: '17',
        label: "Gerenciamento de projetos pós-interino"
    },
    {
        value: '3',
        label: "Passo a passo"
    },
    {
        value: '4',
        label: "Teste de controle interino"
    },
    {
        value: '5',
        label: "Teste substantivo interino"
    },
    {
        value: '6',
        label: "Passo a passo (processos de final de ano)"
    },
    {
        value: '7',
        label: "Teste de controle de final de ano"
    },
    {
        value: '8',
        label: "Teste substantivo de fim de ano"
    },
    {
        value: '11',
        label: "Execução"
    },
    {
        value: '9',
        label: "Conclusão"
    },
    {
        value: '10',
        label: "N/A"
    }
];

export const filterAuditPhases = [{
        value: '1',
        label: "Escopo & Estratégia"
    },
    {
        value: '2',
        label: "Execução"
    },
    {
        value: '3',
        label: "Conclusão"
    }
];


export const filterDocListReviewNoteStatus = [{
        value: 1,
        label: "Abrir"
    },
    {
        value: 5,
        label: "Limpo"
    },
    {
        value: 2,
        label: "Fechado"
    }
];

export const filterDocumentConflicts = [{
    value: '1',
    label: "Sim"
}, {
    value: '0',
    label: "Não"
}];
export const filterDownloadedForOffline = [{
    value: '1',
    label: "Sim"
}, {
    value: '2',
    label: "Não"
}];

export const missingEntityDocuments = [{
    value: 10034,
    label: "Sim"
}]


export const filterTaskFindings = [{
        value: '1',
        label: "Deficiência"
    },
    {
        value: '2',
        label: "Distorção"
    }
];

export const ConfidentialityTypes = [{
        id: 1,
        Name: "Padrão"
    },
    {
        id: 2,
        Name: "Baixo"
    },
    {
        id: 3,
        Name: "Moderado"
    },
    {
        id: 4,
        Name: "Alto"
    },
    {
        id: 5,
        Name: "Confidencial"
    }
];

export const RoleForMember = [{
        id: 1,
        role: "Sócio encarregado",
        roleAbbreviation: "PIC",
        displayOrder: 9
    },
    {
        id: 2,
        role: "Sócio do trabalho",
        roleAbbreviation: "EP",
        displayOrder: 8
    },
    {
        id: 3,
        role: "Diretor executivo",
        roleAbbreviation: "ED",
        displayOrder: 5
    },
    {
        id: 4,
        role: "Sócio",
        roleAbbreviation: "Sócio",
        displayOrder: 6
    },
    {
        id: 5,
        role: "Gerente senior",
        roleAbbreviation: "Gerente Senior",
        displayOrder: 4
    },
    {
        id: 6,
        role: "Gerente",
        roleAbbreviation: "Gerente",
        displayOrder: 3
    },
    {
        id: 7,
        role: "Senior",
        roleAbbreviation: "Senior",
        displayOrder: 2
    },
    {
        id: 8,
        role: "Staff",
        roleAbbreviation: "Staff",
        displayOrder: 1
    },
    {
        id: 9,
        role: "Intern",
        roleAbbreviation: "Intrn"
    },
    {
        id: 10,
        role: "Revisor de qualidade do trabalho",
        roleAbbreviation: "EQR",
        displayOrder: 10
    },
    {
        id: 11,
        role: "Outro Sócio",
        roleAbbreviation: "Outro Sócio",
        displayOrder: 7
    },
    {
        id: 12,
        role: "GDS - Staff",
        roleAbbreviation: "GDS Staff",
        displayOrder: 13
    },
    {
        id: 13,
        role: "Advisory (ITRA,TAS,Human Capital or Other)",
        roleAbbreviation: "ADV"
    },
    {
        id: 14,
        role: "Tax",
        roleAbbreviation: "Tax"
    },
    {
        id: 15,
        role: "Serviços de Apoio Executivo",
        roleAbbreviation: "ESS"
    },
    {
        id: 16,
        role: "Conselho Geral",
        roleAbbreviation: "GCO",
        displayOrder: 12
    },
    {
        id: 17,
        role: "Revisor de Qualidade de Auditoria",
        roleAbbreviation: "AQR",
        displayOrder: 11
    },
    {
        id: 18,
        role: "Equipe componente ML",
        roleAbbreviation: "MCT"
    },
    {
        id: 19,
        role: "Supervisor de Clientes",
        roleAbbreviation: "C. Supervisor'"
    },
    {
        id: 20,
        role: "Client Staff",
        roleAbbreviation: "C. Staff"
    },
    {
        id: 21,
        role: "Supervisor da Auditoria Interna",
        roleAbbreviation: "IA Supervisor"
    },
    {
        id: 22,
        role: "Staff da Auditoria Interna",
        roleAbbreviation: "IA Staff"
    },
    {
        id: 23,
        role: "Regulador",
        roleAbbreviation: "Regulador"
    },
    {
        id: 24,
        role: "Outros (por exemplo, revisão de due diligence",
        roleAbbreviation: "Outro"
    },
    {
        id: 25,
        role: "Escritório",
        roleAbbreviation: "Escritório"
    },
    {
        id: 26,
        role: "Area",
        roleAbbreviation: "Area"
    },
    {
        id: 27,
        role: "Indústria",
        roleAbbreviation: "IND"
    },
    {
        id: 28,
        role: "Nacional",
        roleAbbreviation: "NAT"
    },
    {
        id: 29,
        role: "Global",
        roleAbbreviation: "GBL"
    },
    {
        id: 30,
        role: "GDS - Senior",
        roleAbbreviation: "GDS Senior",
        displayOrder: 14
    },
    {
        id: 31,
        role: "GDS - Manager",
        roleAbbreviation: "Gerente de GDS",
        displayOrder: 15
    }
];

export const SubServiceLines = [{
        subServiceLineId: 1,
        subServiceLineName: "Auditoria",
        displayOrder: 1
    },
    {
        subServiceLineId: 2,
        subServiceLineName: "FIDS",
        displayOrder: 2
    },
    {
        subServiceLineId: 9,
        subServiceLineName: "FAAS",
        displayOrder: 3
    },
    {
        subServiceLineId: 11,
        subServiceLineName: "CCaSS",
        displayOrder: 4
    },
    {
        subServiceLineId: 12,
        subServiceLineName: "BTS",
        displayOrder: 5
    },
    {
        subServiceLineId: 13,
        subServiceLineName: "Human Capital",
        displayOrder: 6
    },
    {
        subServiceLineId: 14,
        subServiceLineName: "Lei",
        displayOrder: 7
    },
    {
        subServiceLineId: 15,
        subServiceLineName: "Impostos Indiretos",
        displayOrder: 8
    },
    {
        subServiceLineId: 16,
        subServiceLineName: "GCR",
        displayOrder: 9
    },
    {
        subServiceLineId: 17,
        subServiceLineName: "Imposto sobre Transações",
        displayOrder: 10
    },
    {
        subServiceLineId: 18,
        subServiceLineName: "ITS",
        displayOrder: 11
    },
    {
        subServiceLineId: 19,
        subServiceLineName: "GCO",
        displayOrder: 12
    },
    {
        subServiceLineId: 20,
        subServiceLineName: "Consultoria empresarial",
        displayOrder: 13
    },
    {
        subServiceLineId: 21,
        subServiceLineName: "Consultoria em tecnologia da informação",
        displayOrder: 14
    },
    {
        subServiceLineId: 22,
        subServiceLineName: "Transações e Finanças Corporativas",
        displayOrder: 15
    },
    {
        subServiceLineId: 23,
        subServiceLineName: "EY Parthenon",
        displayOrder: 16
    },
    {
        subServiceLineId: 24,
        subServiceLineName: "Outro",
        displayOrder: 17
    },
    {
        subServiceLineId: 25,
        subServiceLineName: "Risco Tecnológico",
        displayOrder: 18
    }
];

export const SchedulerRequestRole = [{
        id: 31,
        userTypeId: 4,
        label: "Gerente do GDS"
    },
    {
        id: 31,
        userTypeId: 3,
        label: "Gestor de Pedidos"
    }
];

/* Task Status */
export const TaskStatus = [{
        id: 1,
        label: "aberto"
    },
    {
        id: 2,
        label: "em progresso"
    },
    {
        id: 3,
        label: "em revisão"
    },
    {
        id: 4,
        label: "completo"
    },
    {
        id: 5,
        label: "Removido"
    },
    {
        id: 6,
        label: "Assinatura de PIC/EQR concluída"
    }
];
/* GATaskSendStatus*/
export const GATaskSendStatus = [{
        id: 1,
        label: "Não enviado"
    },
    {
        id: 2,
        label: "Em andamento"
    },
    {
        id: 3,
        label: "Enviado"
    },
    {
        id: 4,
        label: "Devolvido"
    }
];
// 9 - Return error (UI value, doesn't exist in database)
export const GAComponentDocumentStatusLabels = [{
        id: GAComponentDocumentStatus.Open,
        label: "Aberto"
    },
    {
        id: GAComponentDocumentStatus.InProgress,
        label: "Recebido"
    },
    {
        id: GAComponentDocumentStatus.Submitted,
        label: "Enviada"
    },
    {
        id: GAComponentDocumentStatus.Returned,
        label: "Devolvido"
    },
    {
        id: GAComponentDocumentStatus.InReview,
        label: "Preparado"
    },
    {
        id: GAComponentDocumentStatus.Complete,
        label: "Revisado"
    },
    {
        id: GAComponentDocumentStatus.Dismissed,
        label: "Descartado"
    },
    {
        id: GAComponentDocumentStatus.RejectInTransit,
        label: "Retorno em andamento"
    },
    {
        id: GAComponentDocumentStatus.ReturnError,
        label: "Erro de retorno"
    }
];
export const TeamSummaryPreparerTaskStatus = [{
        id: 1,
        label: "Aberto"
    },
    {
        id: 2,
        label: "Em andamento"
    },
    {
        id: 3,
        label: "Fechado"
    }
];
export const TeamSummaryReviewerTaskStatus = [{
        id: 1,
        label: "Aberto"
    },
    {
        id: 2,
        label: "Em andamento"
    },
    {
        id: 3,
        label: "Fechado"
    }
];

export const DocumentHelper = {
    401: "Incapaz de completar a operação. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    413: "O documento excede o tamanho máximo do arquivo permitido (250mb) e não pode ser carregado. Reduza o tamanho do arquivo e tente novamente.",
    412: "Um documento com o mesmo nome já existe neste engagament",
    414: "O nome excede o comprimento máximo ({0} caracteres).",
    410: "Este documento foi excluído e, portanto, não pode ser aberto.",
    411: "Documentos vazios não são permitidos."
};

export const reviewNoteCategories = [{
        value: reviewNoteRoutes.path.all.id,
        path: reviewNoteRoutes.path.all.path,
        label: "Todas as notas"
    },
    {
        value: reviewNoteRoutes.path.document.id,
        path: reviewNoteRoutes.path.document.path,
        label: "Notas do documento"
    },
    {
        value: reviewNoteRoutes.path.task.id,
        path: reviewNoteRoutes.path.task.path,
        label: "Notas de tarefa"
    },
    {
        value: reviewNoteRoutes.path.form.id,
        path: reviewNoteRoutes.path.form.path,
        label: "Comentários do formulário de tela"
    }
];

export const reviewNoteStatus = [{
        value: '1',
        label: "Aberto"
    },
    {
        value: '2',
        label: "Esclarecido"
    },
    {
        value: '3',
        label: "Fechado"
    }
];

/* RNH Review note hub */
export const reviewNoteTypes = [{
        id: 1,
        type: 'document',
        label: "Nota do documento"
    },
    {
        id: 2,
        type: 'task',
        label: "Nota de tarefa"
    }
];

export const accountConclusionTabs = {
    details: "Detalhes",
    conclusions: "Conclusões"
};


export const rnhFilterType = [{
        id: 0,
        filterType: rnhFilterTypeQuery.annotationStatusIds,
        name: "ID do status da nota",
        inDropDown: false
    },
    {
        id: 1,
        filterType: rnhFilterTypeQuery.authoredBy,
        name: "De autoria de",
        inDropDown: true
    },
    {
        id: 2,
        filterType: rnhFilterTypeQuery.assignedTo,
        name: "Atribuído a",
        inDropDown: true
    },
    {
        id: 3,
        filterType: rnhFilterTypeQuery.priority,
        name: "Prioridade",
        inDropDown: true,
        filterOptions: [{
            id: "1",
            label: "Baixo"
        }, {
            id: "2",
            label: "Médio"
        }, {
            id: "3",
            label: "Alto"
        }, {
            id: "4",
            label: "Crítico"
        }]
    },
    {
        id: 4,
        filterType: rnhFilterTypeQuery.dueBefore,
        name: "Vencimento em ou antes",
        inDropDown: true,
        isDateTime: true
    },
    {
        id: 5,
        filterType: rnhFilterTypeQuery.dueAfter,
        name: "Vence em ou depois",
        inDropDown: true,
        isDateTime: true
    }
];

export const rnhSortingOptions = [{
        id: 'Number',
        label: '#'
    },
    {
        id: 'DueDate',
        label: "Vencimento"
    },
    {
        id: 'Priority',
        label: "Prioridade"
    },
    {
        id: 'Status',
        label: "Status"
    }
];

export const userConfidentiality = [{
        id: 1,
        value: "Geral"
    },
    {
        id: 2,
        value: "Baixo"
    },
    {
        id: 3,
        value: "Médio"
    },
    {
        id: 4,
        value: "Alto"
    },
    {
        id: 5,
        value: "Restrito"
    },
    {
        id: 6,
        value: "Confidencial"
    }
];

export const externalUserStatus = {
    active: "Ativo",
    inactive: "Inativo"
};

export const engagementStatus = {
    1: "Ativo",
    2: "Pendente",
    3: "Rejeitado",
    4: "Inativo",
    13: "Agendado - Inativo"
};

export const copyRequestStatus = {
    0: "Expirado",
    1: "Pronto",
    2: "Enviado",
    3: "Recebido",
    4: "Exportação em andamento",
    5: "Sucesso na exportação",
    6: "Erro de exportação",
    7: "Importação em andamento",
    8: "Sucesso na importação",
    9: "Erro de importação",
    10: "Recusado",
    11: "Cópia em andamento",
    13: "Rascunho",
    14: "Envio em andamento",
    15: "Entrega em andamento",
    16: "Erro de entrega"
}

export const copyObjectGrouptype = {
    21: "Noivado",
    22: "Contas",
    23: "Escocês",
    20: "Evidência",
    24: "Avance a partir do existente",
    25: "Modelo",
    26: "Exportação em massa",
    27: "Documento externo",
    28: "Fluxos de trabalho guiados",
    29: "Engagement por entidade"
}

export const independenceStatus = {
    0: labels.undefined,
    1: labels.incomplete,
    2: labels.nomattersidentified,
    3: labels.matteridentifiedpendingaction,
    4: labels.matterresolveddeniedaccess,
    5: labels.matterresolvedgrantedaccess,
    6: labels.notapplicable,
    7: labels.restored,
    8: labels.overriden,
    9: labels.priornomattersidentified,
    10: labels.priormatteridentifiedpendingaction,
    11: labels.priormatterresolvedgrantedaccess,
    12: labels.priormatterresolveddeniedaccess
};

export const independenceStatusFilterOptions = [{
        value: 3,
        label: labels.matteridentifiedpendingaction
    },
    {
        value: 4,
        label: labels.matterresolveddeniedaccess
    },
    {
        value: 5,
        label: labels.matterresolvedgrantedaccess
    },
    {
        value: 8,
        label: labels.override
    },
    {
        value: 1,
        label: labels.incomplete
    },
    {
        value: 2,
        label: labels.nomattersidentified
    },
    {
        value: 7,
        label: labels.restored
    },
    {
        value: 6,
        label: labels.notapplicable
    }
];

export const independenceConfirmationStatus = {
    0: labels.undefined,
    1: labels.incomplete,
    2: labels.nomattersidentified,
    3: labels.matteridentifiedpendingaction,
    4: labels.matterresolveddeniedaccess,
    5: labels.matterresolvedgrantedaccess,
    6: labels.notapplicable,
    7: labels.restored,
    8: labels.override,
    9: labels.priornomattersidentified,
    10: labels.priormatteridentifiedpendingaction,
    11: labels.priormatterresolvedgrantedaccess,
    12: labels.priormatterresolveddeniedaccess
};

export const timePhaseTypes = {
    1: "Escopo",
    2: "Estratégia",
    3: "Walkthrough",
    4: "Teste de Controle Interino",
    5: "Teste Substantivo Interino",
    6: "Walkthrough (processos de final de ano)",
    7: "Teste de controle de final de ano",
    8: "Testes substantivos no final do ano",
    9: "Conclusão",
    10: "N/A",
    11: "Execução",
    12: "Atividades de qualidade do escopo e estratégia",
    13: "Outro escopo e estratégia",
    14: "CRA",
    15: "Avaliação de riscos e materialidade",
    16: "Finalizar escopo e estratégia",
    17: "Gerenciamento de projeto realizados em data interina"
};

export const engagementMetricsComingDueOptions = [{
        value: 1,
        label: "Amanhã"
    },
    {
        value: 3,
        label: "Próximos 3 dias"
    },
    {
        value: 5,
        label: "Próximos 5 dias",
        isDefault: true
    },
    {
        value: 10,
        label: "Próximos 10 dias"
    },
    {
        value: 30,
        label: "Próximos 30 dias",
        isMax: true
    }
];

export const engagementMetricsWhatsNewOptions = [{
        value: 1,
        label: "Ontem"
    },
    {
        value: 3,
        label: "Últimos 3 dias"
    },
    {
        value: 5,
        label: "Últimos 5 dias",
        isDefault: true
    },
    {
        value: 10,
        label: "Últimos 10 dias",
        isMax: true
    }
];

export const engagementMetricsDisplayedAttributes = {
    preparer: "Para se preparar",
    forMyReview: "Para revisar",
    upcomingReview: "Próxima revisão",
    reviewNotesAssigned: "Notas para mim",
    reviewNotesAuthored: "Minhas notas",
    partnerTasks: "Tarefas do Sócio",
    eqrTasks: "Tarefas do EQR",
    timephases: "Fases de trabalho",
    groupTasks: "Tarefas do grupo",
    groupDeliverables: "Deliverables do grupo",
    automation: "Automation",
    requests: "Solicitações"
};

export const quickLinks = {
    linkAccountSummary: "Resumo de contas",
    linkScotSummary: "Resumo de SCOTs",
    linkITSummary: "Resumo de TI",
    linkCRASummary: "Resumo do CRA",
    linkGAStructureSummary: "Resumo da estrutura do grupo",
    linkGAInstrcutionSummary: "Resumo das instruções do grupo",
    linkSEM: "Matriz de avaliação substantiva",
    linkAuditPlan: "Plano de auditoria",
    linkWorkPlan: "Plano de trabalho",
    linkITProcessEvaluation: "Avaliações de TI",

    linkGeneral: "Geral",
    linkScots: "SCOTs",
    linkITSO: "TI/SO",
    linkAccounts: "Contas",
    linkResponseTask: "Tarefas de resposta",
    linkWrapupEngagement: "Encerrameno do trabalho",
    linkArchive: "Archive checklist"
};

export const customKeyEvents = {
    reportDate: "Data do relatório",
    endDatePeriodCovered: "Data de fim do período coberto",
    archiveDeadlineDate: "Data do prazo de arquivamento"
};

export const filterReviewNoteStatus = [{
        value: filters.reviewNoteStatus.open,
        label: "Abrir"
    },
    {
        value: filters.reviewNoteStatus.cleared,
        label: "Limpo"
    },
    {
        value: filters.reviewNoteStatus.closed,
        label: "Fechado"
    }
];

export const filterFileExtension = [{
        value: filters.fileExtension.canvasForm,
        label: "Formulário do Canvas"
    },
    {
        value: filters.fileExtension.email,
        label: "Email"
    },
    {
        value: filters.fileExtension.excel,
        label: "Excel"
    },
    {
        value: filters.fileExtension.paperProfile,
        label: "Perfil do papel"
    },
    {
        value: filters.fileExtension.pdf,
        label: "PDF"
    },
    {
        value: filters.fileExtension.powerPoint,
        label: 'PowerPoint'
    },
    {
        value: filters.fileExtension.smartAutomation,
		label: "Automação Inteligente"
    },
    {
        value: filters.fileExtension.visio,
        label: "Visio"
    },
    {
        value: filters.fileExtension.word,
        label: "Word"
    },
    {
        value: filters.fileExtension.zip,
        label: "Zip"
    },
    {
        value: filters.fileExtension.other,
        label: "Outro"
    }
];

export const filterDocumentContent = [{
        value: filters.documentContent.trackedChanges,
        label: "Exibição de alterações"
    },
    {
        value: filters.documentContent.comments,
        label: "Comentários"
    },
    {
        value: filters.documentContent.formulaError,
        label: "Erros de fórmula (somente arquivos do Excel)"
    },
    {
        value: filters.documentContent.highlightsWordFilesOnly,
        label: "Destaques (somente arquivos do Word)"
    },
    {
        value: filters.documentContent.hiddenSheets,
        label: "Abas ocultas"
    },
    {
        value: filters.documentContent.embeddedFiles,
        label: "Arquivos incorporados"
    },
    {
        value: filters.documentContent.ProtectedFiles,
        label: "Protegida"
    },
    {
        value: filters.documentContent.DocumentContentNotAvailable,
        label: "Conteúdo do documento não disponível"
    },
    {
        value: filters.documentContent.DocumentsInCollaborationMode,
        label: "Documentos em modo de edição multi-usuário"
    },
];

export const filterSharedEvidence = [{
        value: filters.sharedEvidence.source,
        label: "Fonte"
    },
    {
        value: filters.sharedEvidence.target,
        label: "Alvo"
    }
];

export const filterFindings = [{
        value: filters.findings.misstatement,
        label: "Distorção"
    },
    {
        value: filters.findings.deficiency,
        label: "Deficiência"
    }
];

export const filterSignoffRequirements = [{
        value: filters.signoffRequirements.picMandatory,
        label: "Obrigatório PIC"
    },
    {
        value: filters.signoffRequirements.picTeamAssigned,
        label: "Equipe PIC designada"
    },
    {
        value: filters.signoffRequirements.eqrMandatory,
        label: "EQR obrigatório"
    },
    {
        value: filters.signoffRequirements.eqrTeamAssigned,
        label: "Equipe EQR designada"
    }
];

export const filterResponsiveToRisks = [{
        value: filters.responsiveToRisk.responsiveToSignificantRisk,
        label: "Riscos significativos"
    },
    {
        value: filters.responsiveToRisk.responsiveToFraudRisk,
        label: "Riscos de fraude"
    },
    {
        value: filters.responsiveToRisk.responsiveToHigherInherentRisk,
        label: "Riscos inerentes mais altos"
    }
];

export const filterMissingRelatedTask = [{
        value: filters.missingRelatedTask.picSignoffRequired,
        label: "Assinatura do PIC necessária"
    },
    {
        value: filters.missingRelatedTask.eqrSignoffRequired,
        label: "Assinatura do EQR necessária"
    }
];

export const filterCanvasForms = [{
        value: filters.canvasForms.incompleteResponses,
        label: "Respostas incompletas"
    },
    {
        value: filters.canvasForms.unresolvedComments,
        label: "Comentários não resolvidos"
    }
];

export const documentChangeTypes = {
    0: "Nenhuma razão para a mudança selecionada",
    1: "Alteração não-adminstrativa",
    2: "Aceitando revisões quando a funcionalidade de alterações (track changes) foi utilizada",
    3: "Adicionando referências cruzadas adicionais às evidências que já existem",
    4: "Adicionando uma resposta de confirmação original previamente recebida via fax ou e-mail",
    5: "Mudança estética",
    6: "Preenchimento do Formulário AP e avaliação substancial da função",
    7: "Eliminando ou descatando a documentação substituída",
    8: "Preparando a Carta da Administração",
    9: "Assinar as listas de verificação de conclusão relativas ao processo de archive",
    10: "Triagem, colagem e referência cruzada de documentos finais",
    11: "Quando ajustado para o fuso horário local, a modificação é na data do relatório ou antes dela (apenas para  Américas)"
};

export const documentChangeTypesOptions = [{
        value: 1,
        label: "Mudança não administrativa"
    },
    {
        value: 2,
        label: "Aceitar revisões/comentários quando tais funcionalidades foram usadas"
    },
    {
        value: 3,
        label: "Adicionando referências cruzadas adicionais a evidências que já existem"
    },
    {
        value: 4,
        label: "Adicionando uma resposta de confirmação original previamente recebida via fax ou e-mail"
    },
    {
        value: 5,
        label: "Mudança meramente administrativa"
    },
    {
        value: 6,
        label: "Preenchimento do Formulário AP e avaliação substancial da função"
    },
    {
        value: 7,
        label: "Excluir ou descartar documentação que não constitua evidência de auditoria"
    },
    {
        value: 8,
        label: "Preparar ou adicionar documentos que não apoiam a nossa opinião"
    },
    {
        value: 9,
        label: "Assinatura de listas de verificação de conclusão relativas ao processo de arquivamento"
    },
    {
        value: 10,
        label: "Triagem, colagem e referência cruzada de documentos finais"
    },
    {
        value: 12,
        label: "Somente MEST. Modificação em evidencia relacionada com uma ou mais entidade após a data do relatório do EY Canvas"
    },
    {
        value: 11,
        label: "Quando ajustada ao fuso horário local, a modificação está em ou antes da data do relatório (somente para Américas)"
    }
];

export const FourFortyFilterTypes = [{
        id: 0,
        filterType: 'QuickFilter',
        name: "Filtros rápidos",
        hasChild: false
    },
    {
        id: 1,
        filterType: 'TaskStatus',
        name: "Status da tarefa",
        hasChild: false
    },
    {
        id: 2,
        filterType: 'TaskType',
        name: "Tipo de tarefa",
        hasChild: false
    },
    {
        id: 3,
        filterType: 'AssignedTo',
        name: "Atribuído a",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 4,
        filterType: 'OpenAssignment',
        name: "Atribuição aberta",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 5,
        filterType: 'AssignmentsUsersEngagementRoles',
        name: "Atribuição aberta",
        hideDisplay: true,
        loadOptionsFromServer: true
    },
    {
        id: 6,
        filterType: 'ReviewNotesStatus',
        name: "Status das notas de revisão",
        hasChild: false
    },
    {
        id: 7,
        filterType: 'ReviewNotesAssignedTo',
        name: "Notas de revisão atribuídas a",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 8,
        filterType: 'ReviewNotesCreatedBy',
        name: "Notas de revisão criadas por",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 9,
        filterType: 'TimePhase',
        name: "Fase do tempo",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 10,
        filterType: 'Milestone',
        name: "Milestone",
        hasChild: false
    },
    {
        id: 11,
        filterType: 'AuditPhase',
        name: "Fase de auditoria",
        altName: "Fase do Engagement",
        hasChild: false
    },
    {
        id: 12,
        filterType: 'DocumentConflict',
        name: "Conflito de documentos",
        hasChild: false
    },
    {
        id: 13,
        filterType: 'Findings',
        name: "Findings",
        hasChild: false,
        hideForNonAudit: true
    },
    {
        id: 14,
        filterType: 'Entity',
        name: "Entidade",
        hasChild: false,
        loadOptionsFromServer: true,
        hideForNonMest: true
    },
    {
        id: 15,
        filterType: 'IsBookmarked',
        name: "Descarregado para offline",
        hasChild: false
    }
];

/* Arc Timeline */
export const arcValidationGroups = [{
        id: 1,
        label: "Construir o passo 29 ???"
    },
    {
        id: 2,
        label: "Construir o passo 30 ???"
    },
    {
        id: 3,
        label: "SEM (Matriz de Avaliação) ???"
    },
    {
        id: ArcTimelineGroups.FinalizeEvidence,
        label: "Finalizar evidências"
    },
    {
        id: ArcTimelineGroups.CompleteRemainingTasks,
        label: "Complete as tarefas restantes"
    },
    {
        id: ArcTimelineGroups.ResolveValidations,
        label: "Resolver as validações restantes"
    },
    {
        id: 7,
        label: "Prepare-se para o archive"
    },
    {
        id: 8,
        label: "Painel do Engagement"
    },
    {
        id: 9,
        label: "Formulário do Canvas (individual)"
    },
    {
        id: 10,
        label: "Formulário do Canvas (Todos)"
    }
];

export const checkListTypes = [{
        id: 7,
        label: "Finalize arquivos e pastas impressos"
    },
    {
        id: 13,
        label: "Confirme a precisão das principais datas do engagement"
    },
    {
        id: 14,
        label: "Confirme a precisão dos códigos do engagement"
    },
    {
        id: 15,
        label: "Confirme a exatidão do código do cliente"
    },
    {
        id: 10,
        label: "Desvincular este engagement do grupo"
    },
    {
        id: 16,
        label: "Validar o tipo de relatório"
    },
    {
        id: 17,
        label: "Revise arquivos temporários para aqueles modificados após a data de emissão do relatório"
    },
    {
        id: 18,
        label: "Revise arquivos excluídos para aqueles modificados após a data de emissão do relatório"
    },
    {
        id: 19,
        label: "Certifique-se de que as alterações no perfil de engagement sejam submetidas"
    },
    {
        id: 20,
        label: "Revise os documentos protegidos"
    },
    {
        id: 95,
        label: "Designar o responsável geral"
    }
];

export const arcValidationTypes = [{
        id: ArcTimeLineValidationTypes.DocumentConflict,
        label: "Resolver os conflitos de documentos restantes"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentsInMultiUserEditMode,
        label: "Documentos em edição de multi-usuário"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentsWithIsProtected,
        label: "Revise os documentos protegidos"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentIsNotFinalized,
        label: "Conteúdo do documento não disponível"
    },
    {
        id: ArcTimeLineValidationTypes.AddressAllOpenReviewNotes,
        label: "Feche todas as notas de revisão não resolvidas"
    },
    {
        id: ArcTimeLineValidationTypes.RemoveTrackedChangesFromEvidence,
        label: "Remova track changes das evidências"
    },
    {
        id: ArcTimeLineValidationTypes.FinalizeSmartAutomationEvidenceFiles,
        label: "Finalize os arquivos de evidência do Smart Automation"
    },
    {
        id: ArcTimeLineValidationTypes.FinalizeCompleteAllPICSignoffRequirements,
        label: "Conclua todos os requisitos de assinatura de PIC"
    },
    {
        id: ArcTimeLineValidationTypes.FinalizeCompleteAllEQRSignoffRequirements,
        label: "Conclua todos os requisitos de assinatura de EQR"
    },
    {
        id: ArcTimeLineValidationTypes.PICEvidenceWithoutAtLeastOneRelatedPICTask,
        label: "Relacionar documentos PIC com tarefas PIC"
    },
    {
        id: ArcTimeLineValidationTypes.EQREvidenceWithoutAtLeastOneRelatedEQRTask,
        label: "Relacionar documentos EQR com tarefas EQR"
    },
    {
        id: ArcTimeLineValidationTypes.EvidencemissingSignoffs,
        label: "Assinar todas as evidências"
    },
    {
        id: ArcTimeLineValidationTypes.CanvasFormComment,
        label: "Resolver os comentários do formulário Canvas"
    },
    {
        id: ArcTimeLineValidationTypes.UnlinkedSharedEvidence,
        label: "Link removido das Evidências compartilhadas"
    },
    {
        id: ArcTimeLineValidationTypes.TaskswithoutEvidence,
        label: "Adicionar evidências para tarefas abertas"
    },
    {
        id: ArcTimeLineValidationTypes.PICTaskWithoutAtLeastOneRelatedPICEvidence,
        label: "Verifique se todas as tarefas PIC contêm documentos PIC"
    },
    {
        id: ArcTimeLineValidationTypes.EQRTaskWithoutAtLeastOneRelatedEQREvidence,
        label: "Verifique se todas as tarefas EQR contêm documentos EQR"
    },
    {
        id: ArcTimeLineValidationTypes.RelateEvidenceToEntityTask,
        label: "Relacionar evidências à tarefa da entidade"
    },
    {
        id: ArcTimeLineValidationTypes.MarkTasksComplete,
        label: "Marcar tarefas completas"
    },
    {
        id: ArcTimeLineValidationTypes.AccountsSummary,
        label: "Resumo das contas"
    },
    {
        id: ArcTimeLineValidationTypes.ScotSummary,
        label: "Resumo dos SCOTs"
    },
    {
        id: ArcTimeLineValidationTypes.CraSummary,
        label: "Resumo do CRA"
    },
    {
        id: ArcTimeLineValidationTypes.ITSummary,
        label: "Resumo de TI"
    },
    {
        id: ArcTimeLineValidationTypes.ConfirmAccuracyOfAuditorReport,
        label: "Confirme a acurácia dos dados do relatório dos auditores"
    },
    {
        id: ArcTimeLineValidationTypes.CompleteArchiveForm,
        label: "Completar Formulário de archive"
    },
    {
        id: ArcTimeLineValidationTypes.CompleteArchiveTask,
        label: "Competer Tarefa de archive"
    },
    {
        id: ArcTimeLineValidationTypes.UnlinkGroupSharedEvidence,
        label: "remover Link da evidência compartilhada do grupo"
    },
    {
        id: ArcTimeLineValidationTypes.AuditPlan,
        label: "Plano de auditoria"
    },
    {
        id: ArcTimeLineValidationTypes.UnassociateFinding,
        label: "Findings não associados"
    },
    {
        id: ArcTimeLineValidationTypes.IndependenceCompliance,
        label: "Compliance com independência"
    },
    {
        id: ArcTimeLineValidationTypes.IncompleteCanvasFormResponses,
        label: "Finalizar respostas incompletas do formulário Canvas"
    },
    {
        id: ArcTimeLineValidationTypes.WCGWwithNoRelatedsubstantivetask,
        label: "Substantive evaluation matrix"
    },
    {
        id: ArcTimeLineValidationTypes.ITEvaluation,
        label: "Avaliações de TI"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentModifiedAfterReportReleaseDate,
        label: "Documentos modificados após a data de emissão do relatório"
    },
    {
        id: ArcTimeLineValidationTypes.DuplicateFileNames,
        label: "Renomear arquivos de evidência com nomes de arquivo duplicados"
    },
    {
        id: ArcTimeLineValidationTypes.ITFlowCanvasForm,
        label: "Fluxo de TI"
    },
    {
        id: ArcTimeLineValidationTypes.AdjustmentsModule,
        label: "Ajustes "
    },
    {
        id: ArcTimeLineValidationTypes.CanvasFormsWithNoContent,
        label: "Revise os formulários do Canvas sem conteúdo"
    },
    {
        id: ArcTimeLineValidationTypes.PersonInCharge,
        label: "Pessoa encarregada"
    },
    {
        id: ArcTimeLineValidationTypes.EstimateAccountWithoutEstimatePSPindex,
        label: ''
    },
    {
        id: ArcTimeLineValidationTypes.TempFilesWithPreparerAndReviewerSignoffsError,
        label: "Revise os arquivos temporários que têm aprovações do preparador e do revisor para arquivos que devem ser incluídos na evidência ou excluídos"
    },
    {
        id: ArcTimeLineValidationTypes.TemporaryFilesWithPICRequirementUserOrKnowledge,
        label: "Revise os arquivos temporários que possuem tags PIC para arquivos que devem ser incluídos em evidências ou tags excluídas"
    },
    {
        id: ArcTimeLineValidationTypes.TemporaryFileWithEQRRequirementUserOrKnowledge,
        label: "Revise os arquivos temporários que possuem tags EQR para arquivos que devem ser incluídos em evidências ou tags excluídas"
    },
    {
        id: ArcTimeLineValidationTypes.DeletedFilesWithPICRequirementUserOnly,
        label: "Revise os arquivos excluídos que possuem tags PIC para arquivos que devem ser incluídos em evidências ou tags excluídas"
    },
    {
        id: ArcTimeLineValidationTypes.DeletedFilesWithEQRRequirementUserOnly,
        label: "Revise os arquivos excluídos que possuem tags EQR para arquivos que devem ser incluídos em evidências ou tags excluídas"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentAssociatedToInvalidObject,
        label: "Documentos relacionados a objetos que não estão mais disponíveis no engagement"
    }
];

export const ArchiveErrors = {
    32204: "O engagement tem Tarefa sem Evidências.",
    32209: "O engagement tem formulários do Canvas com respostas incompletas.",
    32210: "O engagement tem Notas de Revisão em aberto.",
    32212: "O engagement tem tarefas incompletas.",

    32402: "A ID do arquivo é nulo ou vazio.",
    32403: "O arquivo GUID é nulo ou vazio.",
    32404: "Arc FileStoreHost é nulo ou vazio.",
    32424: "O código do engagement primário está ausente ou é inválido.",
    32425: "A data de lançamento do relatório não pode ser uma data futura.",
    32426: "A data de lançamento do relatório deve ser após a data de término do engagement.",
    32427: "Um sócio deve ser convidado para o engagement.",
    32428: "Faltam dados no ARC sobre o tipo de papel de trabalho.",
    32429: "Uma seleção é necessária no formulário de arquivamento para o tipo de relatório.",
    32430: "Uma seleção é necessária no formulário de arquivamento para relatórios qualificados.",
    32431: "Ocorreu um erro durante o processo de arquivamento devido à integração com a base ARC. Entre em contato com o Help Desk para relatar este erro."
};

export const validationTypes = [{
        id: 1,
        label: "Compliance de independência pendente",
        altLabel: "Formulário incompleto",
        errorLabel: "Conformidade de independência pendente"
    },
    {
        id: 2,
        label: "A versão do formulário de independência não é atual",
        altLabel: "Formulário desatualizado",
        errorLabel: "Versão do formulário de independência não atual"
    },
    {
        id: 3,
        label: "Acesso concedido por função inelegível",
        altLabel: "Não aprovado pelo PPEDD",
        errorLabel: "Acesso concedido por função inelegível"
    },
    {
        id: 4,
        label: "Substituir por função inelegível",
        altLabel: "Não substituído pelo PPEDD",
        errorLabel: "Substituir por função inelegível"
    },
    {
        id: 5,
        label: "SCOTs não relacionados (sem conta)",
        errorLabel: "SCOTs não relacionadas"
    },
    {
        id: 6,
        label: "Controles não relacionados (sem WCGW)",
        errorLabel: "Controles não relacionados"
    },
    {
        id: 7,
        label: "Estratégia de controles selecionada sem WCGWs relacionados",
        errorLabel: "Estratégia de controles sem WCGWs relacionados"
    },
    {
        id: 8,
        label: "Estratégia de controles selecionada sem controles relacionados",
        errorLabel: "Estratégia de controles selecionada sem controles relacionados"
    },
    {
        id: 9,
        label: "Estratégia de controles selecionada sem controles relacionados selecionados para testes",
        errorLabel: "Estratégia de controles selecionada sem controles relacionados selecionados para testes"
    },
    {
        id: 10,
        label: "Estratégia de controles selecionado e há um WCGW sem controles relacionados selecionados para testes",
        errorLabel: "Estratégia de controles selecionada e há um WCGW sem controles relacionados selecionados para testes"
    },
    {
        id: 11,
        label: "Riscos Não Relacionados",
        errorLabel: "Riscos não relacionados"
    },
    {
        id: 12,
        label: "Completar CRA para esta assertiva",
        errorLabel: "CRA completo para esta assertiva"
    },
    {
        id: 13,
        label: "WCGWs não relacionados",
        errorLabel: "WCGWs não relacionados"
    },
    {
        id: 14,
        label: "A Conta Significativa não tem SCOTs relacionados",
        errorLabel: "A conta significativa não tem SCOTs relacionadas"
    },
    {
        id: 15,
        label: "Estratégia de confiança  selecionada sem WCGWs relacionados",
        errorLabel: "Estratégia de confiança selecionada sem WCGWs relacionados"
    },
    {
        id: 16,
        label: "Estratégia de confiança selecionada sem controles relacionados",
        errorLabel: "Estratégia de confiança selecionada sem controles relacionados"
    },
    {
        id: 17,
        label: "Estratégia de confiança selecionada sem controles relacionados selecionados para testes",
        errorLabel: "Estratégia de confiança selecionada sem controles relacionados selecionados para teste"
    },
    {
        id: 18,
        label: "Estratégia de confiança selecionada e há um WCGW sem controles relacionados selecionados para testes",
        errorLabel: "Estratégia de confiança selecionada e há um WCGW sem controles relacionados selecionados para teste"
    },
    {
        id: 19,
        label: "Aplicativo de TI/SO não relacionado",
        errorLabel: "Aplicativo/So de TI não relacionado"
    },
    {
        id: 20,
        label: "Controle/ Procedimento Substantivo de TI não relacionado",
        errorLabel: "Procedimentos substantivos de controle/TI não relacionados"
    },
    {
        id: 21,
        label: "Nenhum aplicativo de TI/SO  relacionado",
        errorLabel: "Nenhum aplicativo/SO de TI relacionado"
    },
    {
        id: 22,
        label: "Nenhum risco relacionado",
        errorLabel: "Sem riscos relacionados"
    },
    {
        id: 23,
        label: "Sem controles/procedimentos substantivos de TI relacionados",
        errorLabel: "Sem controles/procedimentos substantivos de TI relacionados"
    },
    {
        id: 24,
        label: "Sem controles/Procedimentos Substantivos de TI  relacionados selecionados para testes",
        errorLabel: "Nenhum controle relacionado/procedimentos substantivos de TI selecionados para teste"
    },
    {
        id: 25,
        label: "Há um Risco sem controles relacionados / Procedimentos Substantivos de TI selecionados para testes",
        errorLabel: "Existe um risco sem controles relacionados/procedimentos substantivos de TI selecionados para teste"
    },
    {
        id: 26,
        label: "A Conta de Risco Limitado não tem nenhuma tarefa substantiva relacionada",
        errorLabel: "A conta de risco limitado não possui tarefas substantivas relacionadas"
    },
    {
        id: 27,
        label: "Nenhuma tarefa substantiva está relacionada com a Assertiva",
        errorLabel: "Nenhuma tarefa substantiva está relacionada à assertiva"
    },
    {
        id: 28,
        label: "TOC não relacionado",
        errorLabel: "TOC não relacionado"
    },
    {
        id: 29,
        label: "Walkthrough não relacionado",
        errorLabel: "Walkthrough não relacionado"
    },
    {
        id: 30,
        label: "Nenhuma tarefa de Walkthrough está relacionada com a SCOT",
        errorLabel: "Nenhuma tarefa de walkthrouch está relacionada com a SCOT"
    },
    {
        id: 31,
        label: "Nenhuma tarefa de controle está relacionada a um controle selecionado para testes",
        errorLabel: "Nenhuma tarefa de controle está relacionada a um controle selecionado para teste"
    },
    {
        id: 32,
        label: "Walkthrough  de TI/SO não relacionado",
        errorLabel: "Walkthrough de TI/SO não relacionado"
    },
    {
        id: 33,
        label: "TOC de TI/SO não relacionado",
        errorLabel: "TOC de TI/SO  não relacionado"
    },
    {
        id: 34,
        label: "OSP de TI/SO não relacionado",
        errorLabel: "OSP de TI/SO não relacionado"
    },
    {
        id: 35,
        label: "O processo de TI/SO não tem uma tarefa de walkthrough relacionada",
        errorLabel: "O processo de TI/SO não tem uma tarefa de walkthrough relacionada"
    },
    {
        id: 36,
        label: "Um Controle não tem um TOC relacionado",
        errorLabel: "Um Controle não possui um TOC relacionado"
    },
    {
        id: 37,
        label: "Um Procedimento Substantivo de TI não tem um OSP relacionado",
        errorLabel: "Um procedimento substantivo de TI não tem um OSP relacionado"
    },
    {
        id: 38,
        label: "Conflito de documentos",
        errorLabel: "Conflitos não resolvidos"
    },
    {
        id: 39,
        label: "Conflito de sincronização - Evidência compartilhada - Não exibido na contagem de validação do Canvas",
        errorLabel: "Evidência compartilhada - Conflito de sincronização"
    },
    {
        id: 40,
        label: "Evidências faltando Assinaturas",
        errorLabel: "Assinatura em todas as evidências"
    },
    {
        id: 41,
        label: "Tarefas sem Evidência",
        errorLabel: "Adicionar evidências para tarefas abertas"
    },
    {
        id: 42,
        label: "Código de engagament inválido",
        errorLabel: "Código do engagement inválido"
    },
    {
        id: 43,
        label: "Código do cliente inválido",
        errorLabel: "Código do cliente inválido"
    },
    {
        id: 44,
        label: "Nomes de arquivos duplicados",
        errorLabel: "Nomes de arquivos duplicados"
    },
    {
        id: 45,
        label: "Avaliação de TI inconsistente",
        errorLabel: "Avaliação incompleta do processo de TI"
    },
    {
        id: 46,
        label: "Avaliação incompleta do processo de TI",
        errorLabel: "Avaliação incompleta do processo de TI"
    },
    {
        id: 47,
        label: "Avaliação agregada de TI incompleta",
        errorLabel: "Avaliação de TI agregada incompleta"
    },
    {
        id: 48,
        label: "Resposta incompleta",
        errorLabel: "Racional de suporte incompleto"
    },
    {
        id: 49,
        label: "Diferença de auditoria não relacionada",
        errorLabel: "Distorções não relacionadas"
    },
    {
        id: 50,
        label: "Deficiência não associada",
        errorLabel: "Deficiências não associadas"
    },
    {
        id: 51,
        label: "WCGW sem nenhuma tarefa substantiva relacionada",
        errorLabel: "WCGW sem nenhuma tarefa substantiva relacionada"
    },
    {
        id: 52,
        label: "Risco sem WCGW relacionado",
        errorLabel: "Risco sem WCGW"
    },
    {
        id: 53,
        label: "Conta de Estimativa sem índice de PSP de estimativa",
        errorLabel: "Conta de Estimativa sem índice de PSP de estimativa"
    },
    {
        id: 54,
        label: "Conta de estimativa sem SCOT de estimativa",
        errorLabel: "Conta de estimativa sem SCOT de estimativa"
    },
    {
        id: 55,
        label: "SCOT de estimativa  sem conta de estimativa",
        errorLabel: "SCOT de estimativa sem Conta de estimativa"
    },
    {
        id: 56,
        label: "Assertiva com risco de controle com estratégia de confiança em controle sem TOC",
        errorLabel: "Assertiva com risco de controle de confiança sem um TOC responsivo"
    },
    {
        id: 57,
        label: "Assertiva com risco de controle com estratégia de confiança em controle sem pelo menos um TOC responsivo associado a um controle efetivamente desenhado que não é risco Lower que seja responsivo ao risco",
        errorLabel: "Assertiva com risco de controle de confiança sem pelo menos um TOC responsivo associado a um controle efetivamente projetado que não seja de menor risco que seja responsivo ao risco"
    },
    {
        id: 58,
        label: "Assertiva sem uma tarefa substantiva responsiva",
        errorLabel: "Assertiva sem uma tarefa substantiva responsiva"
    },
    {
        id: 59,
        label: "Assertiva sem um controle responsivo",
        errorLabel: "Assertiva sem um controle responsivo"
    },
    {
        id: 60,
        label: "Comentário do formulário do Canvas",
        errorLabel: "Comentário do formulário do Canvas"
    },
    {
        id: 61,
        label: "Respostas incompletas do Formulário do Canvas",
        errorLabel: "Respostas incompletas do Formulário do Canvas"
    },
    {
        id: 62,
        label: "Notas de revisão abertas ou limpas que devem ser fechadas ou excluídas",
        errorLabel: "Notas de revisão abertas ou limpas que devem ser fechadas ou excluídas"
    },
    {
        id: 63,
        label: "Evidências com controle de alterações",
        errorLabel: "Evidências com controle de alterações"
    },
    {
        id: 64,
        label: "Tarefas não marcadas como completas",
        errorLabel: "Marque tarefas completas"
    },
    {
        id: 65,
        label: "Evidências compartilhadas não desvinculadas",
        errorLabel: "Evidências compartilhadas não linkadas"
    },
    {
        id: 66,
        label: "Documentos sem um tipo de modificação selecionado",
        errorLabel: "Documentos sem um tipo de modificação selecionado"
    },
    {
        id: 67,
        label: "Alterações não administrativas sem motivo da alteração (justificativa)",
        errorLabel: "Alterações não administrativas sem motivo da alteração (justificativa)"
    },
    {
        id: 68,
        label: "Modificações não aprovadas para mudanças não administrativas por função apropriada",
        errorLabel: "Modificações não aprovadas para alterações não administrativas por função apropriada"
    },
    {
        id: 69,
        label: "440 GL faltando aprovação do revisor executivo",
        errorLabel: "440 GL Falta de aprovação do revisor executivo"
    },
    {
        id: 70,
        label: "Projeto de grupo que não foi desvinculado",
        errorLabel: "Desvincular este engagement do grupo"
    },
    {
        id: 71,
        label: "Formulário do Canvas sem cabeçalhos",
        altLabel: "Formulário do Canvas sem cabeçalhos",
        errorLabel: "Formulário do Canvas sem cabeçalhos"
    },
    {
        id: 72,
        label: "Conteúdo ausente do documento de resumo do componente do grupo",
        errorLabel: "Conteúdo ausente do documento de resumo do componente do grupo"
    },
    {
        id: 73,
        label: "Respostas incompletas do formulário Canvas, independentemente da aprovação",
        errorLabel: "Formulário do Canvas incompleto"
    },
    {
        id: 74,
        label: "Alteração do perfil V2 não enviada",
        errorLabel: "Alteração de perfil não submetida"
    },
    {
        id: 75,
        label: "arquivos eletrônicos de 0 bytes",
        errorLabel: "arquivos eletrônicos de 0 bytes"
    },
    {
        id: 76,
        label: "Formulário de independência editado após submissão",
        altLabel: "Formulário não submetido",
        errorLabel: "Formulário de independência editado após submissão"
    },
    {
        id: 77,
        label: "Modelo de independência diferente do individual",
        altLabel: "Modelo de independência diferente do individual",
        errorLabel: "Modelo de independência diferente do individual"
    },
    {
        id: 78,
        label: "Aplicativo de TI (não SO) sem pelo menos um Processo de TI relacionado",
        errorLabel: "Aplicativo de TI não relacionado"
    },
    {
        id: 79,
        label: "ITGC não tem itrisk relacionado ou está relacionado a um ITRisk onde HasNoITGC = 1",
        errorLabel: "ITGC não relacionado"
    },
    {
        id: 80,
        label: "ITSP não tem ITRisk relacionado",
        errorLabel: "ITSP não relacionado"
    },
    {
        id: 81,
        label: "O ITProcess não tem nenhum aplicativo de TI relacionado",
        errorLabel: "Processo de TI não relacionado"
    },
    {
        id: 82,
        label: "ItProcesso sem ITRisk onde há um ITAC ou ITDM (sem exceção) relacionado via ITApplication",
        errorLabel: "Risco de TI ausente"
    },
    {
        id: 83,
        label: "ITRisk (HasNoITGC = 0) não tem ITGC relacionado",
        errorLabel: "Falta ITGC ou marca que não existe"
    },
    {
        id: 84,
        label: "ITDM/ITAC sem aplicativo de TI relacionado",
        errorLabel: "Controle de aplicativos/ITDM sem aplicativo de TI"
    },
    {
        id: 85,
        label: "ITSP não excluído quando o corpo correspondente não é exibido",
        errorLabel: "ITSP a ser excluído"
    },
    {
        id: 86,
        label: "ITGC não excluído quando o corpo correspondente não é exibido",
        errorLabel: "ITGC a ser excluído"
    },
    {
        id: 87,
        label: "ITRisk não é excluído quando o corpo correspondente não é exibido",
        errorLabel: "Risco de TI a ser excluído"
    },
    {
        id: 88,
        label: "ITGC com HasITControlTesting = 1 existe quando o corpo correspondente não é exibido",
        errorLabel: "ITGC com estratégia de teste inválida"
    },
    {
        id: 89,
        label: "ITGC sem uma eficácia de design selecionada",
        errorLabel: "Avaliação de design ITGC ausente"
    },
    {
        id: 90,
        label: "Controle sem uma eficácia de design selecionada",
        errorLabel: "Controle sem uma eficácia de design selecionada"
    },
    {
        id: 91,
        label: "SCOT sem aplicativos de TI onde HasNoITApplication = 0",
        errorLabel: "SCOT não relacionada"
    },
    {
        id: 92,
        label: "Procedimentos substantivos e testes de controles que respondem a um risco significativo, mas não ao WCGW relacionado ao risco",
        errorLabel: "Inconsistência entre Relação Tarefa Risco x Risco > WCGW > Tarefas relacionadas"
    },
    {
        id: 93,
        label: "Resposta inconsistente para teste de controle",
        errorLabel: "Resposta inconsistente para teste de controle"
    },
    {
        id: 94,
        label: "SCOT com HasNoITApplication = 0 tem controles ITDM ou App",
        errorLabel: "Aplicativo de TI em SCOT ausente"
    },
    {
        id: 95,
        label: "Nenhum membro da equipe foi designado com responsabilidade geral",
        altLabel: "Nenhum membro da equipe foi designado com responsabilidade geral",
        errorLabel: "Nenhum membro da equipe foi designado com responsabilidade geral"
    },
    {
        id: 96,
        label: "Fatores de risco não relacionados a um risco ou não marcados como não ROMM",
        errorLabel: "Fatores de risco não relacionados a um risco ou não marcados como não ROMM"
    },
    {
        id: 97,
        label: "Risks unrelated to an Assertion",
        errorLabel: "Risks unrelated to an Assertion"
    },
    {
        id: 98,
        label: "Valor da previsão da base de medição incompleta",
        errorLabel: "Valor da previsão da base de medição incompleta"
    },
    {
        id: 99,
        label: "Racional do valor da previsão da base de medição incompleta",
        errorLabel: "Racional do valor da previsão da base de medição incompleta"
    },
    {
        id: 100,
        label: "Valor ajustado da base de medição incompleta",
        errorLabel: "Valor ajustado da base de medição incompleta"
    },
    {
        id: 101,
        label: "Materialidade de planejamento incompleta",
        errorLabel: "Materialidade de planejamento incompleta"
    },
    {
        id: 102,
        label: "Materialidade do planejamento maior que o valor máximo",
        errorLabel: "Materialidade do planejamento maior que o valor máximo"
    },
    {
        id: 103,
        label: "Racional de materialidade de planejamento incompleto",
        errorLabel: "Racional de materialidade de planejamento incompleto"
    },
    {
        id: 104,
        label: "Erro tolerável incompleto",
        errorLabel: "Erro tolerável incompleto"
    },
    {
        id: 105,
        label: "TE fora do intervalo de valores permitidos",
        errorLabel: "TE fora do intervalo de valores permitidos"
    },
    {
        id: 106,
        label: "Racional do erro tolerável incompleto",
        errorLabel: "Racional do erro tolerável incompleto"
    },
    {
        id: 107,
        label: "SAD incompleto",
        errorLabel: "SAD incompleto"
    },
    {
        id: 108,
        label: "SAD maior que o máximo",
        errorLabel: "SAD maior que o máximo"
    },
    {
        id: 109,
        label: "Racional do SAD incompleto",
        errorLabel: "Racional do SAD incompleto"
    },
    {
        id: 110,
        label: "Seleção incompleta do PACE",
        errorLabel: "Seleção incompleta do PACE"
    },
    {
        id: 111,
        label: "Nenhum documento relacionado",
        errorLabel: "Nenhum documento relacionado"
    },
    {
        id: 112,
        label: "Tarefa de PIC sem pelo menos uma evidência de PIC relacionada",
        errorLabel: "Tarefa de PIC sem pelo menos uma evidência de PIC relacionada"
    },
    {
        id: 113,
        label: "Tarefa de EQR sem pelo menos uma evidência de EQR relacionada",
        errorLabel: "Tarefa de EQR sem pelo menos uma evidência de EQR relacionada"
    },
    {
        id: 114,
        label: "Evidência de PIC sem pelo menos uma tarefa de PIC relacionada",
        errorLabel: "Evidência de PIC sem pelo menos uma tarefa de PIC relacionada"
    },
    {
        id: 115,
        label: "Evidência de EQR sem pelo menos uma tarefa de EQR relacionada",
        errorLabel: "Evidência de EQR sem pelo menos uma tarefa de EQR relacionada"
    },
    {
        id: 116,
        label: "Evidência de PIC sem pelo menos uma assinatura de PIC",
        errorLabel: "Evidência de PIC sem pelo menos uma assinatura de PIC"
    },
    {
        id: 117,
        label: "Evidência de EQR sem pelo menos uma assinatura de EQR",
        errorLabel: "Evidência de EQR sem pelo menos uma assinatura de EQR"
    },
    {
        id: 118,
        label: "Evidência que não deve ser arquivada ainda está presente",
        errorLabel: "Evidência que não deve ser arquivada ainda está presente"
    },
    {
        id: 119,
        label: "Arquivos temporários com assinaturas de preparador e revisor",
        errorLabel: "Arquivos temporários com assinaturas de preparador e revisor"
    },
    {
        id: 120,
        label: "Todos os comentários abertos ou limpos do formulário do Canvas",
        errorLabel: "Todos os comentários abertos ou limpos do formulário do Canvas "
    },
    {
        id: 121,
        label: "Arquivos temporários que possuem um requerimento de PIC",
        errorLabel: "Arquivos temporários que possuem um requerimento de PIC"
    },
    {
        id: 122,
        label: "Arquivo temporário que possui um requerimento de EQR",
        errorLabel: "Arquivo temporário que possui um requerimento de EQR"
    },
    {
        id: 123,
        label: "Arquivos excluídos que possuem requerimento de PIC",
        errorLabel: "Arquivos excluídos que possuem requerimento de PIC"
    },
    {
        id: 124,
        label: "Arquivos excluídos que possuem requerimento de EQR",
        errorLabel: "Arquivos excluídos que possuem requerimento de EQR"
    },
    {
        id: 125,
        label: "Revisar documentos protegidos",
        errorLabel: "Revisar documentos protegidos"
    },
    {
        id: 126,
        label: "Conteúdo do documento não disponível",
        errorLabel: "Conteúdo do documento não disponível"
    },
    {
        id: 127,
        label: "Corpo das Demonstrações do Resultado sem dados",
        errorLabel: "Corpo das Demonstrações do Resultado sem dados"
    },
    {
        id: 128,
        label: "Corpo do balanço patrimonial sem dados",
        errorLabel: "Corpo do balanço patrimonial sem dados"
    },
    {
        id: 129,
        label: "Multi-Entidade - Multi-Entidade não relacionada a todos os PSP/ACT para conta(s) relacionada(s)",
        errorLabel: "Multi-Entidade - Multi-Entidade não relacionada a todos os PSP/ACT para conta(s) relacionada(s)"
    },
    {
        id: 130,
        label: "Formulário de Conta sem Formulário de Avaliação de Risco Individual",
        errorLabel: "Formulário de Conta sem Formulário de Avaliação de Risco Individual"
    },
    {
        id: 131,
        label: "Estimativa sem documentação de estimativa",
        errorLabel: "Estimativa sem documentação de estimativa"
    },
    {
        id: 132,
        label: "Conta sem Formulário Analítico Individual",
        errorLabel: "Conta sem Formulário Analítico Individual"
    },
    {
        id: 133,
        label: "Multi-Entidade sem Formulário de Perfil Individual",
        errorLabel: "Multi-Entidade sem Formulário de Perfil Individual"
    },
    {
        id: 134,
        label: "Conta - ID do tipo de conta não corresponde à ação",
        errorLabel: "Conta - ID do tipo de conta não corresponde à ação"
    },
    {
        id: 135,
        label: "Conta - TemEstimativa não corresponde à ação",
        errorLabel: "Conta - TemEstimativa não corresponde à ação"
    },
    {
        id: 136,
        label: "Conta - Opção de formulário de conta tem riscos relacionados não associados à conta",
        errorLabel: "Conta - Opção de formulário de conta tem riscos relacionados não associados à conta"
    },
    {
        id: 137,
        label: "Conta - Assertiva de risco inerente mais alto sem risco de É Risco Mais Alto relacionado",
        errorLabel: "Conta - Assertiva de risco inerente mais alto sem risco de É Risco Mais Alto relacionado"
    },
    {
        id: 138,
        label: "Multi-Entidade - MultiEntidade sem nenhum procedimentos substantivos relacionados para conta(s) relacionada(s)",
        errorLabel: "Multi-Entidade - MultiEntidade sem nenhum procedimentos substantivos relacionados para conta(s) relacionada(s)"
    },
    {
        id: 139,
        label: "Componente sem formulário de envolvimento de grupo (Excluindo apenas Componentes  de Referência)",
        errorLabel: "Componente sem formulário de envolvimento de grupo (Excluindo apenas Componentes  de Referência)"
    },
    {
        id: 140,
        label: "Componente (Completo/Específico) sem uma instrução de avaliação de risco de grupo relacionada (Excluindo apenas Componentes de Referência)",
        errorLabel: "Componente (Completo/Específico) sem uma instrução de avaliação de risco de grupo relacionada (Excluindo apenas Componentes de Referência)"
    },
    {
        id: 141,
        label: "Multi-Entidade - Conta sem qualquer Multi-Entidade relacionada",
        errorLabel: "Multi-Entidade - Conta sem qualquer Multi-Entidade relacionada"
    },
	{
		id: 142,
		label: "ID da fonte da evidência inteligente do documento associado a um objeto inválido",
		errorLabel: "ID da fonte da evidência inteligente do documento associado a um objeto inválido"
	},
    {
        id: 143,
        label: "Conta - Assertiva de risco inerente mais alto sem risco de É Risco Mais Alto relacionado",
        errorLabel: "Conta - Assertiva de risco inerente mais alto sem risco de É Risco Mais Alto relacionado"
    },
    {
        id: 144,
        label: "Grupo - Contas (Executadas em outros engagements) sem Componente relacionada",
        errorLabel: "Grupo - Contas (Executadas em outros engagements) sem Componente relacionada"
    },
    {
        id: 145,
        label: "Conta - Conta de estimativa sem PSP de estimativa indexado",
        errorLabel: "Conta - Conta de estimativa sem PSP de estimativa indexado"
    },
    {
        id: 146,
        label: "Multi-Entidade - Alteração de perfil individual Multi-Entidade não enviada (documento individual)",
        errorLabel: "Multi-Entidade - Alteração de perfil individual Multi-Entidade não enviada (documento individual)"
    },
    {
        id: 147,
        label: "Multi-Entidade - Alteração de perfil individual Multi-Entidade não enviada (documento individual)",
        errorLabel: "Multi-Entidade - Alteração de perfil individual Multi-Entidade não enviada (documento individual)"
    },
    {
        id: 148,
        label: "Conta - Propriedades da conta incompletas ou inválidas",
        errorLabel: "Conta - Propriedades da conta incompletas ou inválidas"
    },
    {
        id: 149,
        label: "Upload de documento - Faltando assinaturas obrigatórias de PIC/EQR",
        errorLabel: "Upload de documento - Faltando assinaturas obrigatórias de PIC/EQR "
    },
    {
        id: 150,
        label: "Upload de documento - Faltando assinatura obrigatórias de PIC/EQR",
        errorLabel: "Upload de documento - Faltando assinatura obrigatórias de PIC/EQR"
    },
    {
        id: 151,
        label: "Conta - Conta significativa / Divulgação sem qualquer assertiva relacionada",
        errorLabel: "Conta - Conta significativa / Divulgação sem qualquer assertiva relacionada"
    },
    {
        id: 152,
        label: "Upload do documento - Faltando assinaturas de preparador ou revisor",
        errorLabel: "Upload do documento - Faltando assinaturas de preparador ou revisor"
    },
    {
        id: 153,
        label: "Ajuste sem qualquer evidência",
        errorLabel: "Ajuste sem qualquer evidência"
    },
    {
        id: 154,
        label: "Estimativa sem conta relacionada",
        errorLabel: "Estimativa sem conta relacionada"
    },
    {
        id: 155,
        label: "Estimativa de risco mais alto/mais baixo relacionada à conta de não-estimativa",
        errorLabel: "Estimativa de risco mais alto/mais baixo relacionada à conta de não-estimativa"
    },
    {
        id: 156,
        label: "A resposta da categoria da estimativa não está alinhada com a designação em 'Editar estimativa'",
        errorLabel: "A resposta da categoria da estimativa não está alinhada com a designação em 'Editar estimativa'"
    },
    {
        id: 157,
        label: "Estimativa sem SCOT válida",
        errorLabel: "Estimativa sem SCOT válida"
    },
    {
        id: 158,
        label: "Account without valid estimate",
        errorLabel: "Account without valid estimate"
    },
    {
        id: 159,
        label: "Conta estimada sem estimativa de risco mais alto ou mais baixo",
        errorLabel: "Conta estimada sem estimativa de risco mais alto ou mais baixo"
    },
    {
        id: 160,
        label: "Estimar SCOT sem estimativa de risco mais alto ou mais baixo",
        errorLabel: "Estimar SCOT sem estimativa de risco mais alto ou mais baixo"
    },
    {
        id: 161,
        label: "Ajustes que não compensam",
        errorLabel: "Ajustes que não compensam"
    },
    {
        id: 162,
        label: "Estimativa de risco mais alto sem risco válido relacionado",
        errorLabel: "Estimativa de risco mais alto sem risco válido relacionado"
    },
    {
        id: 163,
        label: "Documento - Documento retirado ou em processo de retirada para colaboração",
        errorLabel: "Documento - Documento retirado ou em processo de retirada para colaboração"
    },
    {
        id: 164,
        label: "Tarefas amplas não relacionadas ao engagement faltando evidências",
        errorLabel: "Tarefas amplas não relacionadas ao engagement faltando evidências"
    },
    {
        id: 165,
        label: "O requisito de aprovação do EP ou EQR não corresponde à resposta",
        errorLabel: "O requisito de aprovação do EP ou EQR não corresponde à resposta"
    } ,{
        id: 166,
        label: "Risco significativo/de fraude relacionado a uma estimativa que não é um risco mais alto",
        errorLabel: "Risco significativo/de fraude relacionado a uma estimativa que não é um risco mais alto"
    }
];

export const contentType = {
    1: "Tarefas de padrão primárias (PSTs)",
    2: "Índice de procedimentos substantivos primários (índice PSP)",
    3: "Procedimentos substantivos primários (PSPs)",
    4: "Instruções de auditoria de grupo",
    5: "Formulários do Canvas requeridos pela metodologia",
    6: "Formulários do Canvas criados pelos usuários (exemplo: formulário SCOT)",
    7: "Independência",
    9: "Perfil",
    10: "Mapas do Canvas"
};

export const contentTypeByName = {
    'PST': "Primary standard tasks (PSTs)",
    'PSPIndex': "Índice de procedimentos substantivos primários (índice PSP)",
    'PSP': "Primary substantive procedures (PSPs)",
    'GAInstructions': "Instruções de auditoria de grupo",
    'CanvasFormKnowledge': "Formulários do Canvas do knowledge",
    'CanvasFormUserAdded': "Formulários do Canvas criados pelos usuários (exemplo: formulário SCOT)",
    'IndependenceForm': "Independência",
    'Profile': "Perfil",
    'Maps': "Mapas do Canvas"
};

export const reportTypes = {
    1: "Não qualificado - com parágrofo de ênfase",
    2: "Não qualificado - sem parágrofo de ênfase",
    3: "Qualificado - com parágrofo de ênfase",
    4: "Qualificado - sem parágrofo de ênfase",
    5: "Opinião adversa - com parágrofo de ênfase",
    6: "Opinião adversa - sem parágrofo de ênfase",
    7: "Isenção de opinião - com parágrofo de ênfase",
    8: "Isenção de opinião - sem parágrofo de ênfase",
    100: "Não",
    101: "N/A",
    102: "Ainda não selecionado"
};

export const internalUserRoles = [{
        roleKey: 3,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "Permissões",
        roleNameUI: "Archive engagement",
        displayName: "Archive engagement",
        roleDisplayOrder: 2,
        tooltipText: "Habilidade de arquivar o engagement"
    },
    {
        roleKey: 4,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "Permissões",
        roleNameUI: "Administrar o engagement",
        displayName: "Administrar o engagement",
        roleDisplayOrder: 1,
        tooltipText: "Capacidade de convidar membros internos e externos e atribuir permissões a membros internos"
    },
    {
        roleKey: 5,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "Permissões",
        roleNameUI: "Atualizar conteúdo",
        displayName: "Atualizar conteúdo",
        roleDisplayOrder: 6,
        tooltipText: "Habilidade de editar o perfil e aceitar uma atualização de conteúdo"
    },
    {
        roleKey: 7,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "Permissões",
        roleNameUI: "Criar solicitação de serviço",
        displayName: "Gerenciar solicitações de serviços",
        roleDisplayOrder: 4,
        tooltipText: "Capacidade de criar solicitações de serviço e marcar solicitações de serviço concluídas"
    },
    {
        roleKey: 8,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "Permissões",
        roleNameUI: "Gerenciar o grupo",
        displayName: "Gerenciar o grupo",
        roleDisplayOrder: 5,
        tooltipText: "Aceitar ou rejeitar instruções de grupos recebidas da equipe Primária ou Regional"
    },
    {
        roleKey: 9,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "Permissões",
        roleNameUI: "Copiar, Roll-foward, Restaurar engagements",
        displayName: "Copiar, roll-forward, restaurar engagements",
        roleDisplayOrder: 3,
        tooltipText: "Capacidade de copiar o engagement e de avançar e restaurar seu archive",
    },
    {
        roleKey: 0,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "Confidencialidade",
        roleNameUI: "Padrão",
        displayName: "Nenhum (Padrão)",
        roleDisplayOrder: 1,
        tooltipText: "Função padrÃo de documentos confidenciais"
    },
    {
        roleKey: 10,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "Confidencialidade",
        roleNameUI: "Baixo",
        displayName: "Baixo",
        roleDisplayOrder: 8,
        tooltipText: "Função de documentos de baixa confidencialidade"
    },
    {
        roleKey: 11,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "Confidencialidade",
        roleNameUI: "Alta",
        displayName: "Alta",
        roleDisplayOrder: 10,
        tooltipText: "Função de documentos altamente confidenciais"
    },
    {
        roleKey: 12,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "Confidencialidade",
        roleNameUI: "Moderada",
        displayName: "Moderada",
        roleDisplayOrder: 9,
        tooltipText: "Função de documentos moderadamente confidenciais"
    },
    // {
    // roleKey: 13,
    // sectionId:1,
    // groupDisplayOrder: 200,
    // groupName: "Confidencialidade",
    // roleNameUI: "Confidencial",
    // displayName: "Confidencial",
    // roleDisplayOrder: 11,
    // tooltipText: "Função de documentos estritamente confidenciais"
    // },
    {
        roleKey: 14,
        sectionId: 3,
        groupDisplayOrder: 100,
        groupName: "Restrições",
        roleNameUI: "Somente leitura",
        displayName: "Somente leitura",
        roleDisplayOrder: 12,
        tooltipText: "Esta funcionalidade só deve ser usada para conceder acesso a revisores terceiros a este engagement do EY Canvas. As aprovações e autorizações apropriadas devem ser obtidas pelo Grupo de Prática Profissional (PPG)."
    },
    {
        roleKey: 16,
        sectionId: 3,
        groupDisplayOrder: 100,
        groupName: "Restrições",
        roleNameUI: "Somente revisão",
        displayName: "Somente revisão",
        roleDisplayOrder: 13,
        tooltipText: "A revisão só dá a este usuário a capacidade de visualizar informações no engagement do EY Canvas, assinar e usar a funcionalidade de nota de revisão. Isso deve ser usado quando outros usuários da EY precisam revisar este engagement, mas não podem fazer edições."
    },
    {
        roleKey: 37,
        sectionId: 3,
        groupDisplayOrder: 100,
        groupName: "Restrições",
        roleNameUI: "Apenas independência",
        displayName: "Apenas independência",
        roleDisplayOrder: 14,
        tooltipText: "A independência apenas dá a este usuário a capacidade de preencher seu formulário de independência para o engagement, mas não permitirá que o usuário acesse totalmente o engagement do EY Canvas. Deve ser utilizado quando um usuário realizou trabalho para o engagement, mas não precisa ter acesso ao EY Canvas.",
    },
    {
        roleKey: 6,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "Permissões",
        roleNameUI: "Desfazer edições",
        displayName: "Reverter/excluir documento em massa",
        roleDisplayOrder: 7,
        tooltipText: "Capacidade de reverter documentos se alterações foram feitas acidentalmente após a data de liberação do relatório e removê-los do formulário 440 do EY Canvas "
    },
    {
        roleKey: 35,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "Permissões",
        roleNameUI: "Gerencie o compartilhamento da hablitação do EY Canvas FIT",
        displayName: "Fluxos de trabalho guiados pelo administrador",
        roleDisplayOrder: 14,
        tooltipText: "Capacidade de compartilhar Fluxos de trabalho Guiados entre engagements do EY Canvas"
    },
    {
        roleKey: 36,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "Permissões",
        roleNameUI: "Importar dados do EY Helix",
        displayName: "Importar dados do EY Helix",
        roleDisplayOrder: 15,
        tooltipText: "Capacidade de importar dados do EY Helix"
    }
];

export const ValidationSubGroups = [{
        id: 9008,
        label: "Compliance com independência"
    },
    {
        id: 9001,
        label: "Resumo por Conta"
    },
    {
        id: 9002,
        label: "Resumo por SCOT"
    },
    {
        id: 9004,
        label: "Resumo de TI"
    },
    {
        id: 9003,
        label: "Resumo do CRA"
    },
    {
        id: 9005,
        label: "Plano de auditoria"
    },
    {
        id: 9011,
        label: "Substantive evaluation matrix"
    },
    {
        id: 9012,
        label: "Validações por formulário Canvas"
    },
    {
        id: 9009,
        label: "Avaliação de TI"
    },
    {
        id: 49,
        label: "Diferenças de auditoria não relacionadas"
    },
    {
        id: 50,
        label: "Deficiências não relacionadas"
    },
    {
        id: 44,
        label: "Nomes de arquivos duplicados"
    },
    {
        id: 38,
        label: "Conflitos não resolvidos"
    },
    {
        id: 9013,
        label: "Modificações após a data de emissão do relatório"
    },
    {
        id: 9014,
        label: "Fluxo de TI"
    },
    {
        id: 9015,
        label: "Ativação do EY Canvas FIT"
    },
    {
        id: 71,
        label: "Formulários sem conteúdo"
    },
    {
        id: 9016,
        label: 'Incomplete canvas form response'
    },
    {
        id: 9017,
        label: 'Adjustment module'
    },
];

export const engagementIndustry = {
    116: "Não específico do setor",
    61: "Aerospace and Defense – Aerospace Manufacturing",
    112: "Aerospace and Defense – Defense Contracts Manufacturing",
    59: "Airlines – Air Transportation",
    92: "Asset Management – Commodity Funds",
    57: "Asset Management – Other Funds",
    43: "Asset Management – Private Equity / Venture Capital",
    85: "Asset Management – Registered / Listed Funds",
    53: "Asset Management – Structured Products",
    60: "Asset Management – Unregulated Hedge Funds",
    10: "Asset Management – Unregulated Segregated Accounts",
    90: "Audit of Compliance Management Systems",
    51: "Automotive – Automotive Dealers and Repairs",
    101: "Automotive – Automotive Manufacturing",
    5: "Automotive – Automotive Suppliers",
    71: "Banking and Capital Markets – Banks",
    89: "Banking and Capital Markets – Broker Dealers",
    27: "Banking and Capital Markets – Credit Unions",
    54: "Banking and Capital Markets – Diversified and Other Financial Institutions",
    32: "Banking and Capital Markets – Investment Banking",
    4: "Biotechnology – Biotech – Emerging Growth Markets",
    109: "Biotechnology – Health Research and Testing",
    66: "Chemicals – Chemicals Manufacturing",
    41: "Cleantech",
    37: "Consolidations",
    130: "Construction – Engineering and Architectural Services",
    68: "Construction – Highway and Heavy Construction",
    65: "Construction – Specialty Contractors",
    82: "Consumer Products – Consumer Non– Durable Goods Manufacturing",
    17: "Consumer Products – Food and Beverages Manufacturing",
    35: "Consumer Products – Food Crops, Livestock, Fishing",
    33: "Consumer Products – Household Appliances and Electronics Manufacturing",
    75: "Consumer Products – Other Consumer Durable Goods Manufacturing",
    39: "Consumer Products – Textiles and Apparel Manufacturing",
    21: "Diversified Industrial Products – Fabricated Metals",
    31: "Diversified Industrial Products – Forestry, Pulp, and Paper",
    29: "Diversified Industrial Products – Industrial Instruments Manufacturing",
    40: "Diversified Industrial Products – Industrial Machines Manufacturing",
    26: "Diversified Industrial Products – Industrial Packaging",
    42: "Diversified Industrial Products – Lumber and Wood Manufacturing",
    105: "Diversified Industrial Products – Other Industrial Products",
    100: "Diversified Industrial Products – Primary Metals",
    45: "Diversified Industrial Products – Printing",
    1: "Diversified Industrial Products – Rubber and Plastics Manufacturing",
    118: "Diversified Industrial Products – Stone, Clay, and Glass Manufacturing",
    76: "General",
    79: "Government and Public Sector – Education",
    78: "Government and Public Sector – Federal, National, and International Governments",
    131: "Government and Public Sector – Health Commissioner",
    132: "Government and Public Sector – Health Provider",
    97: "Government and Public Sector – Local government, including State or other levels below National",
    2: "Health – Academic Medical Centers",
    72: "Health – Government Hospitals",
    74: "Health – Managed Health Care",
    8: "Health – Multi Hospital Systems",
    128: "Health – Non System Hospitals",
    94: "Health – Other Health Care Entities",
    73: "Health – Physician Groups",
    121: "Health – Post Acute Care",
    58: "Health – Specialty Hospitals",
    16: "Hospitality and Leisure – Gaming and Gambling",
    7: "Hospitality and Leisure – Hotels, Motels, and Lodging",
    126: "Hospitality – Restaurants / Eating and Drinking Establishments",
    84: "IFRS",
    55: "Insurance – Health Insurance",
    111: "Insurance – Insurance Agents and Brokers",
    69: "Insurance – Life Insurers",
    96: "Insurance – Other Insurance",
    11: "Insurance – Property and Casualty Insurers",
    117: "Insurance – Reinsurers",
    23: "Life Sciences – Medical Technology",
    48: "Media and Entertainment – Advertising",
    14: "Media and Entertainment – Broadcast, Cable Network, Online Video",
    18: "Media and Entertainment – Cable Provider, Satellite, MVPD",
    86: "Media and Entertainment – Film",
    46: "Media and Entertainment – Integrated Media and Entertainment",
    15: "Media and Entertainment – Music Industry",
    25: "Media and Entertainment – Other Media and Entertainment",
    20: "Media and Entertainment – Publishing",
    30: "Media and Entertainment – Sports",
    28: "Mining – Mining Operations",
    3: "Non-complex SMEs",
    120: "Not for Profit – Foundations and Charitable Trusts",
    107: "Not for Profit – Other Not For Profit Organizations",
    70: "Oil and Gas – Energy Trading",
    22: "Oil and Gas – Exploration and Production",
    67: "Oil and Gas – Refining",
    113: "Other Transportation – Local and Urban Transportation",
    38: "Other Transportation – Other Transportation",
    83: "Other Transportation – Rail Transportation",
    88: "Other Transportation – Road Transport and Warehousing",
    6: "Other Transportation – Water Transportation",
    87: "Pension Funds / Benefit Plans",
    95: "Pharmaceutical – Medical Devices Manufacturing",
    123: "Pharmaceutical – Pharmaceuticals Manufacturing and Wholesale",
    115: "Power and Utilities – Electricity",
    119: "Power and Utilities – Natural Gas",
    110: "Power and Utilities – Other Utilities",
    102: "Power and Utilities – Waste and Water",
    125: "Professional Firms and Services – Business Services",
    34: "Professional Firms and Services – Other Services",
    47: "Professional Firms and Services – Personal Services",
    124: "Professional Firms and Services – Professional Service Firms",
    127: "Professional Firms and Services – Rental and Leasing Services",
    108: "Professional Firms and Services – Travel Services",
    49: "Real Estate – Commercial Real Estate Owners/ Developers",
    56: "Real Estate – Other Real Estate Owners/ Developers",
    62: "Real Estate – Real Estate Investment Trusts",
    122: "Real Estate – Real Estate Investors",
    12: "Real Estate – Real Estate Service Companies",
    91: "Real Estate – Residential Real Estate Owners/ Developers",
    24: "Retail and Wholesale – Department Stores",
    93: "Retail and Wholesale – Internet Retail and Mail Order",
    80: "Retail and Wholesale – Mass Merchandisers / Discount Stores",
    9: "Retail and Wholesale – Other Specialty Retailers",
    77: "Retail and Wholesale – Retail Apparel and Accessory Stores",
    114: "Retail and Wholesale – Supermarkets, Grocery, and Convenience Stores",
    36: "Retail and Wholesale – Wholesale Durable Goods",
    64: "Retail and Wholesale – Wholesale Non– Durable Goods",
    104: "Sustainability",
    63: "Technology – Communication and Networking Equipment",
    52: "Technology – Computers and Electronics",
    138: "Technology – Internet and Social Commerce",
    103: "Technology – IT Services",
    19: "Technology – Other Technology",
    98: "Technology – Semiconductors",
    13: "Technology – Software / SaaS / Apps",
    81: "Telecommunications – Cable Communications Services",
    106: "Telecommunications – Integrated Communications Providers",
    129: "Telecommunications – Internet Service Providers",
    99: "Telecommunications – Mobile Wireless Communications Services",
    50: "Telecommunications – Other Communications",
    44: "Telecommunications – Satellite Communications Services"
};

export const rnhQuickFilterLabel = [{
        id: rnhQuickFilter.all,
        label: "Mostrar tudo"
    },
    {
        id: rnhQuickFilter.assigned,
        filterType: rnhFilterTypeQuery.assignedTo,
        label: "Atribuído a mim"
    },
    {
        id: rnhQuickFilter.authored,
        filterType: rnhFilterTypeQuery.authoredBy,
        label: "Criadas por mim"
    }
];

export const relatedItemStatus = [{
        id: 1,
        label: "Rascunho"
    },
    {
        id: 2,
        label: "Nenhum contato com o cliente"
    },
    {
        id: 3,
        label: "Enviado"
    },
    {
        id: 4,
        label: "Erro do sistema"
    },
    {
        id: 5,
        label: "Contato do cliente inválido"
    },
    {
        id: 6,
        label: "Resposta pendente"
    },
    {
        id: 7,
        label: "Recebido"
    },
    {
        id: 8,
        label: "Aceito"
    },
    {
        id: 9,
        label: "Retornado"
    },
    {
        id: 10,
        label: "Retirado"
    },
    {
        id: 11,
        label: "Envio em andamento"
    },
    {
        id: 12,
        label: "Aceitar em progresso"
    },
    {
        id: 13,
        label: "Retirada em andamento"
    },
    {
        id: 14,
        label: "Excluir em andamento"
    },
    {
        id: 15,
        label: "Retorno em andamento"
    },
    {
        id: 16,
        label: "Resposta em andamento"
    },
    {
        id: 17,
        label: "Excluído"
    },
    {
        id: 18,
        label: "Contato inválido do cliente retornado"
    },
    {
        id: 19,
        label: "Recall em andamento"
    },
    {
        id: 20,
        label: "Recuperado"
    },
    {
        id: 21,
        label: "Conclusão em andamento"
    },
    {
        id: 22,
        label: "Recall em andamento"
    }
];

export const GroupDocuments = [{
        id: 33,
        label: "Instruções de grupo enviadas pela equipe primária"
    },
    {
        id: 37,
        label: "Documentos devolvidos pela equipe primária"
    }
];

export const engagementUserStatus = {
    1: "Ativo",
    2: "Pendente",
    3: "Rejeição",
    4: "Desativado",
    5: "Solicitação de acesso ao archive",
    6: "Rejeitar acesso ao archive",
    7: "Engagement de cópia - Inativo",
    8: "Desvinculado-Inativo",
    9: "Modelo - Inativo",
    10: "Roll Forward - Inativo",
    11: "Localizado para Universal Isolado",
    12: "Convite em Andamento",
    13: "Agendado - Inativo"
};
export const CGTTaskSendStatus = [{
        id: 1,
        label: "Não enviado"
    },
    {
        id: 2,
        label: "Documento em trânsito"
    },
    {
        id: 3,
        label: "Versão de rascunho enviada"
    },
    {
        id: 4,
        label: "Retornado"
    },
    {
        id: 5,
        label: "Em revisão"
    },
    {
        id: 6,
        label: "Completo"
    },
    {
        id: 7,
        label: "Dispensado"
    },
    {
        id: 8,
        label: "Rejeitado em trânsito"
    },
    {
        id: 9,
        label: "Versão final enviada"
    },
    {
        id: 999,
        label: "Envio falhou"
    }
];

export const ServiceRequestStatus = [{
        id: 11,
        cssClass: 'accepted-text',
        statusLabel: "Aceito"
    },
    {
        id: 12,
        cssClass: 'pending-text',
        statusLabel: "Enviado"
    },
    {
        id: 13,
        cssClass: 'rejected-text',
        statusLabel: "Cancelado"
    },
    {
        id: 14,
        statusLabel: "Rascunho"
    },
    {
        id: 15,
        cssClass: 'completed-text',
        statusLabel: "Completo"
    },
    {
        id: 16,
        statusLabel: "Período anterior completo"
    },
    {
        id: 17,
        statusLabel: "Erro de submissão"
    },
    {
        id: 22,
        statusLabel: "N/A"
    },
    {
        id: 24,
        statusLabel: "Ação requerida"
    }
];

export const assignmentsSectionLabels = [{
        id: bulkAssignment.assign,
        label: "Atribuições"
    },
    {
        id: bulkAssignment.timephase,
        label: "Fases de tempo"
    },
    {
        id: bulkAssignment.tag,
        label: "Marcações"
    }
];

export const assignmentsSectionLabelsNew = [{
        id: bulkAssignment.assign,
        label: "Atribuições"
    },
    {
        id: bulkAssignment.timephase,
        label: "Fases de tempo"
    }
];

export const assignmentTypeLabels = [{
        id: assignmentTypes.preparer,
        label: "Preparador"
    },
    {
        id: assignmentTypes.detailReviewer,
        label: "Revisor de detalhes"
    },
    {
        id: assignmentTypes.generalReviewer,
        label: "Revisor geral"
    },
    {
        id: assignmentTypes.partner,
        label: "Sócio"
    },
    {
        id: assignmentTypes.eqr,
        label: "EQR"
    },
    {
        id: assignmentTypes.other,
        label: "Outros"
    }
];

export const assignmentActionsLabels = [{
        id: bulkAssignmentConstants.actionIds.add,
        label: "Adicionar"
    },
    {
        id: bulkAssignmentConstants.actionIds.remove,
        label: "Remover"
    },
    {
        id: bulkAssignmentConstants.actionIds.replace,
        label: "Substituir"
    },
    {
        id: bulkAssignmentConstants.actionIds.updateDueDays,
        label: "Atualizar dias atrasados"
    }
];

export const tagActionsLabels = [{
        id: bulkAssignmentConstants.actionIds.add,
        label: "Adicionar"
    },
    {
        id: bulkAssignmentConstants.actionIds.remove,
        label: "Remover"
    }
];

export const manageAssigmentsActionTypeLabel = [{
        id: actionTypes.edit,
        label: "Editar"
    },
    {
        id: actionTypes.delete,
        label: "Excluir"
    }
];

export const confidentialityLevels = {
    [confidentialityTypes.DEFAULT]: "Padrão",
    [confidentialityTypes.LOW]: "Baixo",
    [confidentialityTypes.MODERATE]: "Moderado",
    [confidentialityTypes.HIGH]: "Alto"
};

export const milestoneTaskLabels = [{
        id: milestoneBuildTaskIds.accounts,
        label: "Tarefas de fluxo de contas"
    },
    {
        id: milestoneBuildTaskIds.scots,
        label: "Tarefas de fluxo de SCOTs"
    },
    {
        id: milestoneBuildTaskIds.itso,
        label: "Tarefas de fluxo de TI/SO"
    },
    {
        id: milestoneBuildTaskIds.cra,
        label: "Tarefas de fluxo de CRA"
    },
    {
        id: milestoneBuildTaskIds.auditPlan,
        label: "Tarefas de fluxo de plano de auditoria"
    },
    {
        id: milestoneBuildTaskIds.groupStructure,
        label: "Tarefas de fluxo da estrutura de grupo"
    },
    {
        id: milestoneBuildTaskIds.groupInstructions,
        label: "Tarefas de fluxo das instruções de grupo"
    },
    {
        id: milestoneBuildTaskIds.review,
        label: "Revisar tarefas de fluxo"
    }
];

//Filters for RegionComponentEvidence
export const gaDocFilters = {
    scope: "Escopo",
    teamName: "Nome da equipe",
    groupStructure: "Estrutura do grupo",
    region: "Região",
    component: "Componente"
};

export const filterSourceOfForm = [{
        value: '1',
        label: "Personalizado"
    },
    {
        value: '2',
        label: "Conhecimento"
    },
    {
        value: '3',
        label: "Independência"
    }
];

export const independenceActions = [{
        id: independenceActionIds.createIndependenceForm,
        label: "Criar formulário de independência"
    },
    {
        id: independenceActionIds.removeTeamMember,
        label: "Remover membro da equipe"
    },
    {
        id: independenceActionIds.removeOverride,
        label: "Remover a substituição"
    }
];


export const reviewNoteModalLabels = {
    /*Review Notes*/
    commentThread: "Tópico de nota",
    singleNoteInstructionalText: "Visualize e responda ao comentário selecionado abaixo.",
    emptyNoteDetailsMessage: "Selecione uma nota para visualizar detalhes. Para ativar controles em massa, use a tecla control ou shift e selecione vários comentários de revisão. Se você quiser trabalhar em um comentário individual, selecione esse comentário na lista.",
    documentReviewNotesLabel: "Notas do documento",
    addNewReviewNoteButtonText: "Nova nota",
    noNotesAssociatedWithDocumentLabel: "Deixe uma nota usando as entradas abaixo. Atribua a nota a um usuário e especifique a prioridade e a data de vencimento.",
    noNotesFound: "Nenhuma nota encontrada",
    noNotesAssociatedWithTaskLabel: "Não há notas {0} associadas à tarefa.",
    allNotesLabel: "Todas as notas",
    charactersLabel: "caracteres",
    myNotesLabel: "Minhas notas",
    showClearedLabel: "Mostrar apagado",
    showClosedLabel: "Mostras fechado",
    assignedToLabel: "Atribuído a",

    ofLabel: "de",
    enterNoteText: "Digite a nota",
    addNewNoteModalClose: "Fechar",
    addNewNoteModalTitleLabel: "Adicionar nova nota",
    editNoteModalTitleLabel: "Editar nota",
    deleteIconHoverText: "Excluir",
    deleteIconModalAcceptText: "Excluir",
    deleteIconModalConfirmMessage: "Tem certeza que deseja excluir sua resposta a este comentário?",
    deleteIconModalConfirmMessageParent: "Tem certeza de que deseja excluir o comentário selecionado?",
    deleteIconModalTitleLabel: "Excluir nota",
    deleteReplyIconModalTitle: "Eliminar resposta",
    emptyRepliesMessage: "Ainda não há respostas.",
    replyInputPlaceholder: "Responda a esta nota",
    replyInputPlaceholderEdit: "Editar resposta para a nota de revisão",
    noteInputPlaceholderEdit: "Editar nota de revisão",
    replyText: "Texto de resposta",
    editReplyModelTitle: "Edição resposta",
    editReplyPlaceholder: "Digite resposta",
    noteDueDateLabel: "Vencimento",

    priorityLabel: "Prioridade",
    dueDateLabel: "Data de vencimento",
    dueLabel: "Vencimento",
    status: "Status",
    noteModifiedDateLabel: "Modificado",
    cancelLabel: "Cancelar",
    saveLabel: "Salvar",
    clearedBy: "Apagado por",
    closedBy: "Fechado por",
    reopenedBy: "Reaberto por",
    reply: "Resposta",
    editIconHoverTextLabel: "Editar",
    required: "Necessário",
    closeTitle: "Fechar",
    otherEngagementNotes: "Outras notas do engagement",
    closeLabel: "Fechar",
    showMore: "Mostrar mais",
    showLess: "Mostrar menos",
    showMoreEllipsis: "Mostrar mais...",
    showLessEllipsis: "Mostrar menos...",
    noResultFound: "Não foram encontrados resultados",
    engagementNameLabel: "Nome do engagement:",
    taskReviewNotesLabel: "Notas da tarefa",
    fromUserLabel: labels.fromUserLabel,
    toUserLabel: labels.toUserLabel
};

//Copyhub create package
export const createPackageLabels = {
    packageType: "Tipo de pacote",
    categories: "Categorias",
    itemsToCopy: "Itens para copiar",
    createPackage: "Criar pacote",
    selectPackageType: "Selecione tipo de pacote",
    selectPackageTypeTitle: "Selecione tipo de pacote",
    selectCategoriesTitle: "Selecione categorias",
    selectEntitiesTitle: "Selecionar entidades",
    relateCanvasFormsTitle: "Relacionar documentos",
    relateAnObjectTitle: "Relacionar um objeto",
    step1InstructionalText: "Selecione o tipo de pacote, nomeie-o e selecione o destinatário. Garantir o cumprimento de todas as leis, regulamentos e políticas EY aplicáveis em matéria de privacidade de dados, transferência de dados entre jurisdições e proteção de informações confidenciais antes de criar ou enviar um Pacote de Cópia.",
    packageTypes: [{
        value: 21,
        text: "Projeto"
    }, {
        value: 20,
        text: "Evidencia"
    }, {
        value: 24,
        text: "Rollforward a partir da existencia"
    }, {
        value: 22,
        text: "Conta"
    }, {
        value: 23,
        text: "Classe de transação significativa"
    }, {
        value: 26,
        text: "Exportação em massa"
    }, {
        value: 25,
        text: "Modelo"
    }, {
        value: 27,
        text: "Documentos externos"
    }, {
        value: 28,
        text: "Fluxos de trabalho guiados"
    }, {
        value: 29,
        text: "Engagement por entidade"
    }],

    packageName: "Nome do pacote",
    packageDetailsText: "Detalhes do pacote",
    required: "Requerido",
    sendTo: "Enviar para",
    nameOrEmail: "Nome ou e-mail",
    sendToName: "Nome",
    sendToEmail: "Email",
    clearAllValues: "Limpar todos os valores",
    engagementIdErrorMessage: "O ID de engagement não está especificado.",
    emptyCategoriesStep2Text: '...',
    insufficientPermissionsMessage: "Permissões insuficientes para criar pacote de cópia. Entre em contato com seu administrador do engagement e solicite permissão para criar pacote de cópia.",
    CopyHubCanvasFormTooltip: "Somente para formulários do EY Canvas",
    CopyEngagementInProgress: "Apenas uma cópia do Engagement pode ser processada por vez.",

    //Step 3 labels
    step3Header: "Selecione {0} para copiar",
    selectAllText: "Selecione todos",
    delectAllText: "Desmarque todos",
    documentsSelectedText: "documentos selecionados",
    scotsSelectedText: "SCOTs selecionados",
    accountsSelectedText: "Contas selecionadas",
    entitiesSelectedText: "entidades selecionadas",
    step3InstructionText: "Certifique-se de cumprir todas as leis, regulamentos e políticas EY aplicáveis sobre privacidade de dados, transferência de dados entre jurisdições e proteção de informações confidenciais antes de criar ou enviar um Pacote de Dados.",
    step3InstructionTextEvidence: "Certifique-se de conformidade com todas as leis, regulamentos e políticas EY aplicáveis sobre privacidade de dados, transferência de dados entre jurisdições e proteção de informações confidenciais antes de enviar dados de engajamento.",
    step3InstructionTextWarning: "Os formulários do EY Canvas não incluirão objetos relacionados (por exemplo, SCOTs, Controles).",
    step3InstructionTextWarningFIT: "A cópia dos Fluxos de Trabalho Guiados pode incluir Eventos e Condições Relevantes identificados e suas descrições relacionadas. Eles não incluirão outros objetos relacionados (por exemplo, Contas, Riscos).",
    availableCanvasFormsColumnName: "Documentos disponíveis",
    availableFITDocuments: "Fluxos de trabalho guiados disponíveis",
    availableAccountsColumnName: "Contas disponíveis",
    availableSCOTsColumnName: "SCOTs disponíveis",
    availableExternalDocumentsColumnName: "Documentos externos disponíveis",
    step3NoItemeSelectedError: "Selecione pelo menos um item para prosseguir",
    searchPackagePlaceholder: "procurar",
    searchPackageClearHoverText: "claro",

    //step2:
    step2Header: "Selecione categorias para {0} pacote",
    step2AccountsHdr: "Selecione categorias para incluir no pacote de cópia. O pacote principal inclui todas as afirmações relacionadas, PSPs e OSPs.",
    step2scotshdr: "Selecione categorias para incluir no pacote de cópia. O pacote principal inclui todos os WCGWs, controles e tarefas relacionados",
    step2canformhdr: "Selecione categorias para incluir no pacote de cópia",
    step2InstructionTextEngagementByEntity: "Selecione Entidades para incluir no pacote de cópias",
    availableEntitiesColumnName: "Entidades disponíveis",
    step2HeaderEntities: "Selecione {0} para Pacote de engagement",
    entitiesLabel: "Entidades",

    scots: "scots",
    itso: "Estrutura de aplicação/estrutura SO",
    evidence: "evidência",
    realtedevidence: "Evidências Relacionadas",
    signoffs: "Aprovações",
    tempfiles: "Arquivos Temporários",
    priorperiodevidence: "Evidências de período anterior",
    recentlydeletedfiles: "Arquivos recentemente excluídos",
    historyfiles: "Arquivos de história",
    extgrp: "Grupos externos e membros da equipe externa",
    eydocument: "Documentos EY",
    extdoc: "Documentos Externos",
    totalfilesize: "O tamanho total do arquivo de todas as seleções é",
    requestandexernaltasks: "Solicitações e Tarefas Externas",
    rollForwardFromExisting: "Rollforward a partir da existencia",
    template: "Modelo",
    bulkExport: "Exportação em massa",

    fileSizeWaring: "As categorias selecionadas incluem arquivos que {0}. O EY Canvas não suporta pacotes de cópia que excedam esse limite.",
    fileSizeWarningline2: "Considere remover categorias de documentos para reduzir o tamanho total do arquivo do pacote de cópia.",
    coloredExceedLable: "exceder {0} GB",
    step2EngHdr: "Selecione categorias para incluir no pacote de cópias. O pacote básico inclui perfil do engagement, todos os documentos de conhecimento, tarefas padrão primárias, outras tarefas padrão, fase de tempo; contas/divulgações, assertivas e suas tarefas relacionadas; SCOTs, WCGWs, Controles e suas tarefas relacionadas; Aplicativos de TI/Serviços de Organização, Riscos, ITGCs/ITSPs e tarefas relacionadas. Se for um engagement de Auditoria de Grupo, o pacote incluirá também dados de auditoria de grupo.",
    step2EngByEntityHdr: "Selecione categorias para incluir no pacote de cópias. O pacote básico inclui perfil de engagement, todos os documentos de conhecimento, tarefas primárias padrão, outras tarefas padrão, fases de tempo; contas/ divulgações, assertivas e suas tarefas relacionadas; SCOTs, WCGWs, Controles e suas tarefas relacionadas; Aplicativos de TI/organizações de serviços, riscos, ITGCs/ITSPs e tarefas relacionadas; Mapas. Se houver engagement de auditoria de grupo, o pacote incluirá também dados de auditoria de grupo.",
    step2BulkExpHdr: "Selecione as categorias de documentos a serem exportadas.",
    gb: "GB",
    step2And: "e",
    step2Files: "documento(s)",
    lessThanMinGB: "menos de 0,01 GB",
    CategoryFileSizeCount: "  {0} GB e {0} documento(s)",

    cancelLabel: "Cancelar",
    showSelected: "Mostrar selecionado",
    showSelectedDocuments: "Mostrar {0} documento(s) selecionado(s)",
    showSelectedEntities: "Mostrar {0} entidades selecionadas",
    showSelectedGuidedWorflows: "Mostrar {0} fluxos de trabalho guiados selecionados",
    showSelectedAccounts: "Mostrar {0} contas selecionadas",
    showSelectedSCOTs: "Mostrar {0} SCOT(s) selecionados",
    noDataFoundLabel: "Nenhum dado encontrado",
    copyPackageSuccessMessage: "{0} a exportação de dados foi iniciada.",
    copyPackageWarningLabel: "Aviso : O pacote não pôde ser enviado aos membros abaixo devido a informações inválidas :- {0}",
    noResultFound: "Nenhum resultado encontrado",
    canvasForms: "Formulários do EY Canvas",
    canvasFormsInformationText: "Os formulários do EY Canvas só podem ser exportados como Evidências e/ou Arquivos Temporários.<br/>Por favor, selecione uma dessas opções para habilitar o download dos formulários do EY Canvas.",
    coEditSelectAllWarningMessage: "Alguns documentos estão atualmente no modo de edição de multi-usuário ativo e não podem ser incluídos no pacote de cópia",
    coEditDocumentTooltip: "O documento está no modo de edição de multi-usuário ativo e não pode ser copiado. Faça check-in do documento para copiá-lo como parte deste pacote",
    coEditCopyWarningMessage: "{0} documentos estão no modo de edição multi-usuário ativo dentro da(s) categoria(s) {1}. Por favor, verifique todos os documentos dentro de cada categoria para incluí-los como parte deste pacote"
};

export const documentTypes = [{
        id: 1,
        label: "Evidência"
    },
    {
        id: 2,
        label: "Temporário"
    },
    {
        id: 3,
        label: "Evidência do ano anterior"
    },
    {
        id: 4,
        label: "Arquivos do cliente"
    },
    {
        id: 5,
        label: "Instantâneo"
    },
    {
        id: 6,
        label: "Smartform"
    },
    {
        id: 29,
        label: "Perfil do papel"
    },
    {
        id: 47,
        label: "Exportação de documentos em massa"
    },
    {
        id: 48,
        label: "Formulário de tela"
    },
    {
        id: 51,
        label: "Central de automação"
    },
    {
        id: 59,
        label: "Pacotes"
    },
    {
        id: 72,
        label: "Papel de Trabalho Inteligente"
    }
];

export const activityTypes = [{
        id: activityType.primaryLinkAccept,
        label: "Solicitação de link aceita por {0}"
    },
    {
        id: activityType.primaryLinkReject,
        label: "Pedido de link rejeitado por {0}"
    },
    {
        id: activityType.primaryUnlink,
        label: "Engagement desvinculado do grupo por {0}"
    },
    {
        id: activityType.primaryComponentUnlink,
        label: "Engagement desvinculado do grupo por {0}"
    },
    {
        id: activityType.componentPrimaryUnlink,
        label: "Engagement desvinculado do grupo por {0}"
    },
    {
        id: activityType.primarySendLink,
        label: "Solicitação de link enviada por {0} para {1}"
    },
    {
        id: activityType.documentsReceived,
        label: "Documentos recebidos por {0}"
    },
    {
        id: activityType.primarySendInstruction,
        label: "Instruções enviadas de {0} para {1}"
    },
    {
        id: activityType.primaryRejectInstruction,
        label: "Instruções devolvidas por {0}"
    },
    {
        id: activityType.primaryAcceptInstruction,
        label: "Instruções aceitas por {0}"
    },
    {
        id: activityType.componentReceivedInstruction,
        label: "Instruções recebidas"
    },
    {
        id: activityType.componentAcceptInstruction,
        label: "Instruções aceitas por {0}"
    },
    {
        id: activityType.componentRejectInstruction,
        label: "Instruções devolvidas por {0}"
    },
    {
        id: activityType.componentAcceptUpdatetInstruction,
        label: "Instruções aceitas por {0}"
    },
    {
        id: activityType.componentRejectUpdateInstruction,
        label: "Instruções devolvidas por {0}"
    },
    {
        id: activityType.primaryEvidenceReceived,
        label: "Versão recebida por {0}"
    },
    {
        id: activityType.documentVersionConflictResolved,
        label: "Conflito resolvido por {0}"
    },
    {
        id: activityType.documentOverwrite,
        label: "Conteúdo do documento substituído por {0}"
    },

    {
        id: activityType.primaryAssignComponent,
        label: "Documento atribuído ao {0}"
    },
    {
        id: activityType.componentUnassigned,
        label: "Documento não assinado de {0}"
    },
    {
        id: activityType.clearDocumentReturnedtoComponent,
        label: "Versão finalizada por {0}"
    },
    {
        id: activityType.componentClearReturnedDocument,
        label: "Versão resolvida por {0}"
    },
    {
        id: activityType.primaryReturnEvidence,
        label: "Versão devolvida por {0}"
    },
    {
        id: activityType.componentEvidenceSent,
        label: "Versão enviada por {0}"
    },
    {
        id: activityType.componentReturnEvidence,
        label: "Versão devolvida por {0}"
    },
    {
        id: activityType.createReviewNote,
        label: "Nota aberta por {0}"
    },
    {
        id: activityType.openReviewNote,
        label: "Nota aberta por {0}"
    },
    {
        id: activityType.clearReviewNote,
        label: "Nota liberada por {0}"
    },
    {
        id: activityType.closeReviewNote,
        label: "Nota fechada por {0}"
    },
    {
        id: activityType.reviewerSignOff,
        label: "Assinado por {0}"
    },
    {
        id: activityType.preparerSignOff,
        label: "Assinado por {0}"
    },
    {
        id: activityType.canvasSendClientRequest,
        label: labels.sent
    },
    {
        id: activityType.clientRespondToClientRequest,
        label: "Respondeu"
    },
    {
        id: activityType.canvasRejectClientRequest,
        label: labels.rejected
    },
    {
        id: activityType.canvasWithdrawClientRequest,
        label: labels.WithdrawLabel
    },
    {
        id: activityType.canvasDeleteClientRequest,
        label: "Excluído"
    },
    {
        id: activityType.canvasAcceptClientRequest,
        label: labels.accepted
    },
    {
        id: activityType.CEARecallClientRequest,
        label: "Recuperado"
    },
    {
        id: activityType.canvasCompleteClientRequest,
        label: labels.completed
    }
];


export const gaLinkStatus = [{
        id: GALinkStatus.Undefined,
        label: "indefinido"
    },
    {
        id: GALinkStatus.NoPointOfContact,
        label: "Nenhum ponto de contato"
    },
    {
        id: GALinkStatus.Pending,
        label: "pendente"
    },
    {
        id: GALinkStatus.Accepted,
        label: "aceitado"
    },
    {
        id: GALinkStatus.Rejected,
        label: "rejeitado"
    },
    {
        id: GALinkStatus.Expired,
        label: "Expirado"
    },
    {
        id: GALinkStatus.Unlinked,
        label: "Desvinculado"
    },
    {
        id: GALinkStatus.Delegated,
        label: "Delegada"
    },
    {
        id: GALinkStatus.SystemError,
        label: "Erro do sistema"
    },
    {
        id: GALinkStatus.Sent,
        label: "enviado"
    },
    {
        id: GALinkStatus.InvalidPointOfContact,
        label: "Ponto de contato inválido"
    },
    {
        id: GALinkStatus.ComponentNotUsingCanvas,
        label: "O componente não usa Canvas"
    }
];

export const gaInstructionStatus = [{
        id: 0,
        label: labels.notApplicable
    },
    {
        id: instructionStatus.notSent,
        label: "Não enviado"
    },
    {
        id: instructionStatus.pending,
        label: "pendente"
    },
    {
        id: instructionStatus.accepted,
        label: "aceitado"
    },
    {
        id: instructionStatus.rejected,
        label: "Retornado"
    },
    {
        id: instructionStatus.systemError,
        label: "Erro do sistema"
    },
    {
        id: instructionStatus.expired,
        label: "Expirado"
    },
    {
        id: instructionStatus.sent,
        label: "enviado"
    },
    {
        id: instructionStatus.unlinked,
        label: "Desvinculado"
    },
    {
        id: instructionStatus.queued,
        label: "Em fila"
    }
];

export const gsSnapshotComparisonStatus = [{
        id: snapshotComparisonIds.noChange,
        value: "nulo"
    },
    {
        id: snapshotComparisonIds.new,
        value: "Novo"
    },
    {
        id: snapshotComparisonIds.added,
        value: "Adicionado"
    },
    {
        id: snapshotComparisonIds.modified,
        value: "Modificado"
    },
    {
        id: snapshotComparisonIds.updated,
        value: "Atualizada"
    },
    {
        id: snapshotComparisonIds.removed,
        value: "Removido"
    },
    {
        id: snapshotComparisonIds.itemsRemoved,
        value: "Itens removidos"
    },
]

export const gaRoleType = [{
        id: GARoleTypeId.Primary,
        label: "primário"
    },
    {
        id: GARoleTypeId.Region,
        label: "região"
    },
    {
        id: GARoleTypeId.Component,
        label: "componente"
    }
];

export const linkRequestTypes = [{
        id: linkType.sent,
        label: "enviado"
    },
    {
        id: linkType.unlinked,
        label: "Desvinculado"
    },
    {
        id: linkType.accepted,
        label: "aceitado"
    }
];

export const instructionTypes = [{
        id: instructionType.sent,
        label: "enviado"
    },
    {
        id: instructionType.rejected,
        label: "Retornado"
    },
    {
        id: instructionType.received,
        label: "recebido"
    },
    {
        id: instructionType.accepted,
        label: "aceitado"
    }
];

export const syncStatusLabels = [{
        id: syncStatus.notSynchronized,
        label: "Não sincronizado"
    },
    {
        id: syncStatus.syncInTransit,
        label: "Sincronização em trânsito"
    },
    {
        id: syncStatus.syncInProcess,
        label: "Sincronização em processo"
    },
    {
        id: syncStatus.synchronized,
        label: "Sincronizado"
    },
    {
        id: syncStatus.deleteInTransit,
        label: "Exclusão em trânsito"
    },
    {
        id: syncStatus.deleteInProcess,
        label: "Exclusão em processo"
    },
    {
        id: syncStatus.deleted,
        label: "Excluído"
    },
    {
        id: syncStatus.noHostEngagement,
        label: "Sem host no engagement "
    },
    {
        id: syncStatus.syncError,
        label: "Erro de sincronização"
    }
];

export const colorOptionsLabels = {
    Red: "Vermelho",
    Orange: "Laranja",
    Teal: "Azul-petróleo",
    Blue: "Azul",
    Purple: "Roxo",
    Green: "Verde",
    Yellow: "Amarelo",
    Gray: "Cinza"
};

export const todoListTimeFrameLabels = [{
        id: todoListTimeframeOptions.byDay,
        label: "Por dia"
    },
    {
        id: todoListTimeframeOptions.byWeek,
        label: "Por semana"
    },
    {
        id: todoListTimeframeOptions.byMonth,
        label: "Por mês"
    },
    {
        id: todoListTimeframeOptions.all,
        label: "Todo"
    },
    {
        id: todoListTimeframeOptions.overdue,
        label: "Atrasado"
    }
];

export const clientRequestsStatusFilter = [{
        value: 'Draft',
        label: "Rascunho"
    },
    {
        value: 'Pending',
        label: "Resposta pendente"
    },
    {
        value: 'Received',
        label: "Recebido"
    },
    {
        value: 'Accepted',
        label: "Aceito"
    }
];

export const clientRequestsTypeFilter = [{
        value: 'Required',
        label: "Aprovação necessária"
    },
    {
        value: 'NotRequired',
        label: "Aprovação não necessária"
    }
];

export const clientRequestsPriorityFilter = [{
        value: 'Normal',
        label: "Normal"
    },
    {
        value: 'High',
        label: "Alto"
    },
    {
        value: 'Critical',
        label: "Crítico"
    }
];

export const clientRequestsAttachmentsFilter = [{
        value: 'Analytics',
        label: "Analytics"
    },
    {
        value: 'ExternalAttachments',
        label: "Anexos externos"
    },
    {
        value: 'EyAttachments',
        label: "Anexos EY"
    },
    {
        value: 'None',
        label: "Nenhum"
    }
];

export const clientRequestsCreatedByFilter = [{
        value: 'Client',
        label: "Cliente"
    },
    {
        value: 'EY',
        label: "EY"
    }
];

export const filterTimePhase = [{
    value: -1,
    label: "Sem fase de tempo"
}];

export const clientRequestsBooleanFilters = [{
        value: 1,
        label: "Sim"
    },
    {
        value: 0,
        label: "Não"
    }
]

export const bulkClientRequestsNoRelatedTaskFilter = [{
        value: false,
        label: "Sim"
    },
    {
        value: true,
        label: "Não"
    }
]

export const controlsTestingFilters = [{
        value: 'true',
        label: "Sim"
    },
    {
        value: 'false',
        label: "Não"
    },
    {
        value: 'null',
        label: "Não selecionado"
    }
];

export const controlsDesignEffectivenessFilters = [{
        value: '1',
        label: "Efetivo"
    },
    {
        value: '2',
        label: "Inefetivo"
    },
    {
        value: '0',
        label: "Não selecionado"
    }
];

export const clientRequestAnnotationTabs = [{
        id: clientRequestNoteTab.comments,
        label: "Comentários"
    },
    {
        id: clientRequestNoteTab.history,
        label: "História"
    }
];

export const riskTypeOptions = [{
        id: 1,
        name: "Riscos significativos"
    },
    {
        id: 2,
        name: "Riscos de fraude"
    },
    {
        id: 3,
        name: "Risco de distorção material"
    }
];

export const months = ['Janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
export const longDays = ['Domingos', 'Segundas', 'Terças', 'Quartas', 'Quintas', 'Sextas', 'Sábados'];
export const shortDays = ['DO', 'SE', 'TE', 'QU', 'QU', 'SE', 'SA'];

// GA Scopes
export const gaScopesResource = [{
        id: gaScopes.full,
        label: "Cheio"
    },
    {
        id: gaScopes.specific,
        label: "Específico"
    },
    {
        id: gaScopes.specificAuditProcedures,
        label: "Procedimentos de auditoria especificados"
    },
    {
        id: gaScopes.review,
        label: "Revisar"
    }
]

// GA Instructions
export const gaRecommendationTypeResource = [{
        id: gaRecommendationType.required,
        label: "Requerido"
    },
    {
        id: gaRecommendationType.optional,
        label: "Opcional"
    },
    {
        id: gaRecommendationType.notApplicable,
        label: "Não aplicável"
    }
]

// GS Group Summary
export const gsTabsResource = [{
        id: groupSummaryTabs.assignedTeams,
        label: "Equipes atribuídas"
    },
    {
        id: groupSummaryTabs.instructions,
        label: "Instruções"
    },
    {
        id: groupSummaryTabs.tasks,
        label: "Tarefas"
    }
]

export const receiveInstructionsTypeResource = {
    true: {
        title: "Novo",
        instructional: "um novo"
    },
    false: {
        title: "Atualizado",
        instructional: "uma atualização"
    }
}

export const clientRequestSystemGeneratedMessages = {
    sent: "Solicitação enviada para",
    accepted: "Pedido aceito",
    received: "Pedido recebido",
    returned: "Pedido retornado",
    withdrawn: "Pedido retirado",
    complete: "Solicitação foi concluída pela EY",
    recalled: "Pedido recuperado",
    notification_submit: "Solicitação submetida à automação",
    notification_success: "Solicitação submetida com sucesso à automação",
    notification_error: "Ocorreu um erro submetendo-se à automação. Clique em Enviar para automação para tentar novamente.",
    restore_document: "Documento restaurado -",
    delete_document: "Documento excluído -",
    assignedto: "Item reatribuído para",
    editrequest: "Solicitação editada",
    prioritychange: "Prioridade de solicitação atualizada para"
};

export const externalTaskSystemGeneratedMessages = {
    sent: "Tarefa Externa enviada para",
    accepted: "Tarefa Externa aceita",
    received: "Resposta recebida",
    returned: "Tarefa externa retornada",
    withdrawn: "Tarefa externa retirada",
    complete: "A Tarefa externa foi concluída a partir do EY Canva",
    recalled: "Tarefa externa recuperada",
    restore_document: "Documento restaurado -",
    delete_document: "Documento excluído -",
    assignedto: "Item reatribuído para",
    editrequest: "Tarefa externa editada",
    prioritychange: "Prioridade de tarefa externa atualizada para"
};

export const ipInputLabels = [{
        id: ipInputType.ipAddress,
        label: "Endereço IP"
    },
    {
        id: ipInputType.ipRange,
        label: "Alcance IP"
    },
    {
        id: ipInputType.cidrBlock,
        label: "Bloco CIDR"
    }
];

export const ipFilterTypeLabels = {
    [ipFilterType.ipAddress]: "Endereço IP",
    [ipFilterType.ipRange]: "Alcance IP",
    [ipFilterType.cidrBlock]: "Bloco CIDR"
};

export const gaLinkStatusObj = {
    [GALinkStatus.Undefined]: "Indefinido",
    [GALinkStatus.NoPointOfContact]: "Nenhum ponto de contato",
    [GALinkStatus.NotSent]: "Não enviado",
    [GALinkStatus.Pending]: "Solicitação de link pendente",
    [GALinkStatus.Accepted]: "Solicitação de link aceita",
    [GALinkStatus.Rejected]: "Rejeitado",
    [GALinkStatus.Expired]: "Expirado",
    [GALinkStatus.Unlinked]: "Desvinculado",
    [GALinkStatus.Delegated]: "Delegada",
    [GALinkStatus.SystemError]: "Erro no sistema",
    [GALinkStatus.Sent]: "Enviado",
    [GALinkStatus.InvalidPointOfContact]: "Ponto de contato inválido",
    [GALinkStatus.ComponentNotUsingCanvas]: "Não está usando o EY Canvas",
    [GALinkStatus.ComponentReferenceOnly]: "Somente referência"
};

export const epTasksObj = [{
        value: '3',
        label: "Nenhum documento assinado"
    },
    {
        value: '2',
        label: "Alguns documentos assinados"
    },
    {
        value: '1',
        label: "Todos os documentos assinados"
    }
];

export const eqrTasksObj = [{
        value: '6',
        label: "Nenhum documento assinado"
    },
    {
        value: '5',
        label: "Alguns documentos assinados"
    },
    {
        value: '4',
        label: "Todos os documentos assinados"
    }
];

export const groupsFilterEntity = [{
        id: 1,
        label: "Tarefas"
    },
    {
        id: 2,
        label: "Documentos"
    }
];

export const scopesFilterEntity = [{
        id: 1,
        label: "Cheio"
    },
    {
        id: 2,
        label: "Específico"
    },
    {
        id: 3,
        label: "Procedimentos de auditoria especificados"
    },
    {
        id: 4,
        label: "Revisão"
    }
];

export const notesFilterLabels = [{
        id: notesFilter.allNotes,
        label: "Todas as notas"
    },
    {
        id: notesFilter.myNotes,
        label: "Minhas notas"
    },
    {
        id: notesFilter.authoredByMeNotes,
        label: "Atribuído a mim"
    }
];

//Client Request Advanvce Search
export const advancedSearchValues = [{
        id: 1,
        value: labels.advancedSearchTitleCheck
    },
    {
        id: 2,
        value: labels.advancedSearchRefereceNumberCheck
    },
    {
        id: 3,
        value: labels.advancedSearchDocumentsCheck
    },
    {
        id: 4,
        value: labels.advancedSearchCommentsCheck
    }
];


export const TaskTypeLabels = [{
        id: TaskListTypes.ScopeAndStrategy,
        label: taskNavigation[TaskListTypes.ScopeAndStrategy]
    },
    {
        id: TaskListTypes.SCOTs,
        label: taskNavigation[TaskListTypes.SCOTs]
    },
    {
        id: TaskListTypes.ITSOs,
        label: taskNavigation[TaskListTypes.ITSOs]
    },
    {
        id: TaskListTypes.Accounts,
        label: taskNavigation[TaskListTypes.Accounts]
    },
    {
        id: TaskListTypes.GeneralExecution,
        label: taskNavigation[TaskListTypes.GeneralExecution]
    },
    {
        id: TaskListTypes.Conclusion,
        label: taskNavigation[TaskListTypes.Conclusion]
    }
];

export const TaskCategoryLabels = [{
        id: TaskListTypes.ScopeAndStrategy,
        label: taskNavigation[TaskListTypes.ScopeAndStrategy],
        displayOrder: 1
    },
    {
        id: TaskListTypes.Risks,
        label: taskNavigation[TaskListTypes.Risks],
        displayOrder: 2
    },
    {
        id: TaskListTypes.SCOTs,
        label: taskNavigation[TaskListTypes.SCOTs],
        displayOrder: 3
    },
    {
        id: TaskListTypes.ITSOs,
        label: taskNavigation[TaskListTypes.ITSOs],
        displayOrder: 4
    },
    {
        id: TaskListTypes.Accounts,
        label: taskNavigation[TaskListTypes.Accounts],
        displayOrder: 5
    },
    {
        id: TaskListTypes.GeneralExecution,
        label: taskNavigation[TaskListTypes.GeneralExecution],
        displayOrder: 6
    },
    {
        id: TaskListTypes.Conclusion,
        label: taskNavigation[TaskListTypes.Conclusion],
        displayOrder: 7
    },
];

export const kendoLabels = {
    alignLeft: "Justificar à esquerda",
    alignRight: "Justificar à direita",
    alignCenter: "Justificar o centro",
    alignFull: "Justificar completo",
    addComment: "Adicionar um comentário",
    addColumnBefore: "Adicionar a coluna à esquerda",
    addColumnAfter: "Adicionar a coluna à direita",
    addRowAbove: "Adicionar linha acima",
    addRowBelow: "Adicionar linha abaixo",
    bulletList: "Inserir lista não ordenada",
    bold: "Negrito",
    backColor: "Destacar",
    createLink: "Inserir hiperlink",
    createTable: "Criar tabela",
    cleanFormatting: "Formatação limpa",
    deleteRow: "Excluir a linha",
    deleteColumn: "Excluir coluna",
    deleteTable: "Excluir tabela",
    fontSizeInherit: "Tamanho da fonte",
    foreColor: "Cor",
    format: "Formato",
    fontSize: "Tamanho da fonte",
    hyperlink: "Inserir link da web",
    italic: "Itálico",
    indent: "Indent",
    insertTableHint: "Crie uma {0} por {1} tabela",
    'hyperlink-dialog-content-address': "Endereço web",
    "hyperlink-dialog-title": "Inserir hiperlink",
    "hyperlink-dialog-content-title": "Título",
    "hyperlink-dialog-content-newwindow": "Abrir link em nova janela",
    "hyperlink-dialog-cancel": "Cancelar",
    "hyperlink-dialog-insert": "Inserir",
    outdent: "Outdent",
    orderedList: "Inserir lista ordenada",
    print: "Imprimir",
    pdf: "exportação para pdf",
    redo: "refazer",
    strikethrough: "Strikethrough",
    subscript: "Subscrito",
    superscript: "Sobrescrito",
    underline: "Sublinhar",
    undo: "Desfazer"
};

export const kendoFormatOptions = [{
        text: "Parágrafo",
        value: "p"
    },
    {
        text: "Cabeçallho 1",
        value: "h1"
    },
    {
        text: "Cabeçallho 2",
        value: "h2"
    },
    {
        text: "Cabeçallho 3",
        value: "h3"
    },
    {
        text: "Cabeçallho 4",
        value: "h4"
    },
    {
        text: "Cabeçallho 5",
        value: "h5"
    },
    {
        text: "Cabeçallho 6",
        value: "h6"
    }
];

export const kendoFontSize = [{
        text: '8',
        value: '8px'
    },
    {
        text: '9',
        value: '9px'
    },
    {
        text: '10',
        value: '10px'
    },
    {
        text: '11',
        value: '11px'
    },
    {
        text: '12',
        value: '12px'
    },
    {
        text: '14',
        value: '14px'
    },
    {
        text: '16',
        value: '16px'
    },
    {
        text: '18',
        value: '18px'
    },
    {
        text: '20',
        value: '20px'
    },
    {
        text: '22',
        value: '22px'
    },
    {
        text: '24',
        value: '24px'
    },
    {
        text: '26',
        value: '26px'
    },
    {
        text: '28',
        value: '28px'
    },
    {
        text: '36',
        value: '36px'
    },
    {
        text: '48',
        value: '48px'
    },
    {
        text: '72',
        value: '72px'
    }
];

export const monthsList = [
	"Janeiro",
	"Fevereiro",
	"Março",
	"Abril",
	"Maio",
	"Junho",
	"Julho",
	"Agosto",
	"Setembro",
	"Outubro",
	"Novembro",
	"Dezembro"
];

export const pspContentStatus = {
    1: "Atualização necessária",
    2: "Atualização em andamento",
    3: "Atualização completa",
    4: "Erro de atualização"
}

export const handOffLabels = {
    handoff: "Transferir",
    handOffTitleTip: "Transferir para revisão",
    markCompleteTitleTip: "Marcar como concluído",
    handoffModalTitle: "Transferir para o próximo membro da equipe",
    handoffConfirmButtonText: "Transferir",
    return: "Retornar",
    handModalDescription: "Para assinar um arquivo de evidência, selecione uma das opções abaixo.",
    markCompleteTextLine1: "Transferir esta tarefa para o próximo membro da equipe",
    markCompleteTextLine2: "Para assinar um arquivo de evidência, selecione uma das opções abaixo. Se você tiver uma atribuição para esta tarefa e a tiver concluído, selecione <b>Sim</b> para fechá-la. Se esta tarefa exigir assinatura de PIC ou EQR, selecione uma das opções abaixo.",
    closeLabel: "Fechar",
    handoffto: "Tranferir para",
    missingToUserError: "Requerido",
    markCompleteConfirm: "Marcar como concluído",
    markCompleteModalHeaderTextPart1: "Esta tarefa será marcada como concluída.",
    markCompleteModalHeaderTextPart2: "Para assinar um arquivo de evidência, selecione uma das opções abaixo. Se você tiver uma atribuição para esta tarefa e a tiver concluído, selecione <b>Sim</b> para fechá-la. Se esta tarefa exigir assinatura de PIC ou EQR, selecione uma das opções abaixo.",
    signOffOnAllAs: "Assinar em todos como",
    preparer: "Preparador",
    reviewer: "Revisor",
    none: "Nenhum",
    noSignOffsByMe: "Nenhum assinado por mim",
    myPreparerSignOffs: "Minhas aprovações do preparador",
    myReviewerSignOffs: "Minhas aprovações do revisor",
    myPreparerAndReviewerSignOffs: "Minhas assinaturas de preparador e revisor",
    preparerTitle: "Assinaturas do preparador",
    reviewerTitle: "Assinaturas do revisor",
    autoAssignmentMessage: "Este membro da equipe não tem uma atribuição. {0} ​atribuição com uma data de vencimento de {1} será criada. Para editar esta atribuição {2}.",
    clickHere: "clique aqui",
    noTaskEvidencesHandoffModal: "Não há arquivos de evidências associados a esta tarefa.",
    // Create Assignment
    createAssignment: "Criar atribuição",
    create: "Criar",
    cancelLabel: "Cancelar",
    createassignmentheader1: "O membro da equipe selecionado não tem uma atribuição para esta tarefa.",
    createassignmentheader2: "Crie uma atribuição aqui.",
    dueDate: "Data de vencimento",
    teamMemberAssigmentLabel: "Membro do time",
    daysPriorToEndDate: "Dias antes da data final",
    // Add Assignment
    addAssignmentTitle: "Adicionar nome da atribuição",
    confirmButtonLabel: "Adicionar",
    cancelButtonLabel: "Cancelar",
    assignmentTypeInstructionalText: "Selecione um tipo de atribuição e insira um nome abaixo. Clique em <b>Adicionar</b> quando terminar.",
    assignmentType: "Tipo de atribuição",
    required: "Requerido",
    clearHoverText: "Limpar",
    unmarkcomplete: "Desmarcar como concluído",
    markCompleteErrorMessage: "A tarefa não pode ser marcada como concluída. Atualize a página e tente novamente. Se o problema persistir entre em contato com o Help Desk.",
    // Assignment Dropdown
    noResultFound: "Nenhum resultado encontrado",
    addTaskGroupLabel: "Adicionar grupo de tarefas",
    addAssignmentName: "Adicionar nome da atribuição",
    assignmentName: "Nome da atribuição",
    additionalSignOff: "Assinaturas adicionais necessárias",
    signoffRequirementsModalPICLabel: "PIC",
    signoffRequirementsModalEQRLabel: "EQR",
    closeMyAssignment: "Fechar minha atribuição",
    filterYes: "Sim",
    filterNo: "Não",
    assignmentTypeLabels: [{
            id: assignmentTypes.preparer,
            label: "Preparador"
        },
        {
            id: assignmentTypes.detailReviewer,
            label: "Revisor de detalhe"
        },
        {
            id: assignmentTypes.generalReviewer,
            label: "Revisor geral"
        },
        {
            id: assignmentTypes.partner,
            label: "Sócio"
        },
        {
            id: assignmentTypes.eqr,
            label: "EQR"
        },
        {
            id: assignmentTypes.other,
            label: "Outro"
        }
    ]
};

export const displayedOn = {
    "Account": "Conta",
    "SCOT": "SCOT",
    "IT/SO": "IT/SO",
    "Scope & Strategy": "Escopo e Estratégia",
    "Execution": "Execução",
    "Conclusion": "Conclusão"
}

export const auditPlanReportLabels = {
    adc: "Objeto Relacionado",
    secondaryObject: "Objeto Secundário Relacionado",
    taskTypeColumn: "Tipo de tarefa",
    taskNamePrefix: "Prefixo da tarefa",
    taskName: "Título da tarefa",
    taskNameSuffix: "Sufixo de tarefa",
    taskDescription: "Descrição da tarefa",
    auditTaskStatus: "Status da tarefa",
    rationaleForRejection: "Racional para Rejeição",
    knowledgeTaskTitle: "Título da tarefa de conhecimento",
    knowledgeTaskDescription: "Descrição da tarefa de conhecimento",
    assignedTo: "Atribuído a",
    engagementTagGroupName: "Grupo de etiqueta",
    engagementTagName: "Etiquetas",
    prioritized: "Priorizado",
    viewDisplayedOn: "Exibir exibido em",
    engagementPhase: "Fase do engagement",
    milestone: "Marco",
    periodName: "Fase de tempo",
    riskTypeAbbr: "Tipo de Risco Relacionado",
    riskName: "Nome do Risco Relacionado",
    relatedMESTEntityName: "Entidades MEST Relacionadas",
    scheduledNextWaveservices: "Serviços centralizados",
    taskID: "ID da tarefa",
    timephaseID: "ID da fase de tempo",
    taskTypeID: "ID do Tipo de tarefa",
    timephaseTypeID: "ID do tipo de fase de tempo"
}

export const reportingTaskAll = {
    taskType: labels.taskType,
    taskStatus: labels.taskStatusLabel,
    taskAssignedTo: labels.taskassignedto,
    taskNamePrefix: labels.taskPrefix,
    task_Name: labels.repTaskTitle,
    taskNameSuffix: labels.taskSuffix,
    taskDescription: labels.repTaskDescription,
    knowledge_Task_Title: "Título da tarefa de conhecimento",
    knowledge_Task_Description: "Descrição da tarefa de conhecimento",
    rejected: labels.rejected,
    rationale_for_Rejection: "Justificativa para rejeição",
    audit_Phase: labels.auditPhasesLabel,
    milestonename: labels.filterMilestoneLabel,
    periodName: labels.timephase,
    timephasestartdateinutc: "Data de início da fase de tempo (em UTC)",
    timephaseduedateinutc: "Data de vencimento da fase de tempo (em UTC)",
    taskSourceType: labels.repTaskSource,
    taskNatureType: labels.repTaskNature,
    lastTaskChangeDateInUTC: "Data de alteração do status da última tarefa (em UTC)",
    engagementTagGroupName: labels.manageTagGroupName,
    engagementTagName: labels.tagsLabel,
    mesT_Entity_Name: "Entidades MEST Relacionadas",
    multiEntityType: "Tipo de entidade múltipla",
    taskID: "ID da tarefa",
    taskTypeID: "ID do Tipo de tarefa",
    taskStatusID: "ID do status da tarefa",
    auditPhaseID: "ID da fase de auditoria",
    timephaseTypeID: "ID do marco",
    taskSourceTypeID: "ID da origem da tarefa",
    taskNatureTypeID: "ID da natureza da tarefa",
    cgTaskID: "ID da tarefa de conhecimento",
    knowledgeContentID: "ID do conteúdo de conhecimento"
}

export const reportTaskAssignments = {
    taskNamePrefix: labels.taskPrefix,
    taskName: labels.repTaskTitle,
    taskNameSuffix: labels.taskSuffix,
    taskDescription: labels.repTaskDescription,
    taskTypeName: labels.taskType,
    taskSourceType: labels.repTaskSource,
    taskNatureType: labels.repTaskNature,
    auditPhaseName: labels.engagementPhase,
    milestones: labels.filterMilestoneLabel,
    periodName: labels.timephase,
    PICSignoffRequired: "Aprovação de PIC necessária",
    EQRSignoffRequired: "Aprovação EQR necessária",
    taskStatusName: labels.taskStatusLabel,
    taskDueDateInUTC: "Data de vencimento da tarefa (em UTC)",
    engagementTagGroupName: labels.manageTagGroupName,
    engagementTagName: labels.tagsLabel,
    completedAssignment: labels.completedAssignments,
    totalAssignment: "Total de atribuições",
    closedTaskAssignmentPercent: "Atribuição de tarefa fechada %",
    assignmentOrder: "Ordem de atribuição",
    firstNameVal: "Nome do membro da equipe de atribuição de tarefas",
    lastNameVal: "Sobrenome do membro da equipe de atribuição de tarefas",
    assignmentName: labels.assignmentName,
    assignmentTypeName: labels.filterAssignmentTypeLabel,
    roleName: "Papel do usuário do engagement",
    assignmentStatusVal: "Status de atribuição de tarefa",
    dueDays: "Dias de vencimento",
    completedDateInUTC: "Data de conclusão (em UTC)",
    assignmentDueDateInUTC: "Data de vencimento da atribuição (em UTC)",
    daysCompleteBeforeDueDate: "Dias restantes antes da data de vencimento da atribuição da tarefa",
    daysCompleteAfterDueDate: "Dias de atraso após a data de vencimento da atribuição da tarefa",
    closedEarlyOrLate: "Fechado cedo/atrasado",
    closedDaysEarly: "Fechado dias mais cedo",
    closedDaysLate: "Fechado com dias de atraso",
    oldTaskName: "Título da tarefa do legado",
    oldTaskDetail: "Descrição da tarefa do legado",
    taskID: "ID da tarefa",
    assignmentID: "ID da atribuição",
    roleID: "ID da função",
    userID: "ID do usuário"
}

export const reportingMultiEntityTask = {
    engagementID: "ID de Engagement",
    taskID: "ID da tarefa",
    taskNamePrefix: labels.taskPrefix,
    task_Name: labels.repTaskTitle,
    taskNameSuffix: labels.taskSuffix,
    taskDescription: labels.repTaskDescription,
    mesT_Entity_Name: "Entidade relacionada",
    multiEntityType: "Tipo de Multi-entidade",
    taskTypeID: "ID do tipo da tarefa",
    taskStatusID: "ID de status da tarefa"
}

export const reportingManageteamInternal = {
    firstName: labels.firstnameLabel,
    lastName: labels.lastnameLabel,
    userInitials: labels.initialsLabel,
    emailAddress: labels.editExternalEmailLabel,
    gui: "GUI",
    engagementRole: labels.engagementrole,
    hasOverallResponsability: "Tem responsabilidade geral",
    userStatus: "Status",
    independenceStatus: "Status de independência",
    grantedAccess: "Acesso concedido após arquivar",
    primaryOffice: "Escritório principal",
    preferredContactPhone: "Número de telefone",
    engagementUserStatusID: "ID de status do usuário de engagement",
    engagementRoleID: "ID da função do engagmeent",
    independenceStatusID: "ID de status de independência"
}

export const reportingManageteamExternal = {
    clientGroupName: "Nome do grupo",
    firstName: labels.firstnameLabel,
    lastName: labels.lastnameLabel,
    userInitials: labels.initialsLabel,
    emailAddress: labels.editExternalEmailLabel,
    domain: "Domínio do usuário",
    validDomainWithinGroup: "Domínio válido dentro do grupo",
    userStatus: "Status do usuário",
    preferredContactPhone: "Número de telefone preferido"
};

export const controlDesignEffectivenessType = {
    1: "Eficaz",
    2: "Ineficaz"
};

export const itAppSOSummaryReportLabels = {
    itApplicationName: "Organização de aplicativos/serviços de TI",
    strategyTypeName: "Estratégia de TI",
    typeName: "Tipo",
    itProcessName: "Processo de TI",
    itRiskName: "Risco de TI",
    itControlName: "ITGCs/ITSPs",
    natureOfTest: "Natureza do Teste",
    controlFrequencyTypeNameColumn: "Frequência",
    testing: "Teste",
    designEffectiveness: "Eficácia do projeto",
    evaluation: "Avaliação de processos de TI"
};

export const ArchiveReportLabels = {
    engagementDescription: "Descrição do engagement",
    archiveReportQualifiedNameSection: "Relatório qualificado",
    archiveReportQualifiedTypeNameSection: "Tipo de relatório qualificado",
    archiveFolderDescription: "Descrição da pasta de arquivamento",
    archiveFolderTypeNameSection: "Tipo de pasta",
    location: "Localização",
    archiveComments: "Arquivar comentários",
    engagementID: "ID do Engagement",
    archiveCountryOfficeRegionID: "ID de arquivamento do país escritório regional",
    archiveReportQualifiedID: "ID do arquivamento do relatório qualificado",
    archiveReportQualifiedTypeID: "ID de arquivamento do tipo do relatório qualificado"
};

export const canvasFormRelatedCommentsLabels = {
    canvasFormName: "Nome do formulário do Canvas",
    order1: "Ordem do cabeçalho",
    formHeaderName: "Cabeçalho",
    order2: "Ordem da Seção",
    order3: "Ordem de conteúdo",
    formBodyResponseValue: "Resposta",
    commentNumber: "Número do comentário",
    author: "Autor",
    assignedTo: "Atribuído a",
    createDateSection: "Data de criação",
    commentStatusSection: "Status",
    commentText: "Comentário",
    commentVoiceNote: "Tem nota de voz",
    reply: "Responder",
    replyVoiceNote: "Tem nota de voz"
};

export const canvasFormRelatedObjectsLabels = {
    canvasFormName: "Nome do formulário do Canvas",
    order1: "Ordem do cabeçalho",
    formHeaderName: "Cabeçalho",
    formHeaderID: "ID do cabeçalho do formulário",
    order2: "Ordem da Seção",
    formSectionID: "ID da seção do formulário",
    formSectionName: "Seção",
    firstLevelEntityColumn: "Entidade de primeiro nível",
    firstLevelRelatedObject: "Objeto relacionado de primeiro nível",
    secondLevelEntityColumn: "Entidade de segundo nível",
    secondLevelRelatedObject: "Objeto relacionado de segundo nível"
};

export const canvasFormResponseLabels = {
    canvasFormName: "Nome do formulário do Canvas",
    order1: "Ordem do cabeçalho",
    formHeaderName: "Cabeçalho",
    knowledgeFormHeaderID: "ID do conhecimento do cabeçalho",
    headerKnowledgeContentID: "ID do conteúdo de conhecimento do cabeçalho",
    order2: "Ordem da Seção",
    formSectionName: "Seção",
    knowledgeFormSectionID: "ID de Conhecimento da Seção",
    sectionKnowledgeContentID: "ID do conteúdo de conhecimento da seção",
    order3: "Ordem do Corpo",
    formBody: "Corpo",
    knowledgeFormBodyID: "ID de conhecimento do corpo",
    bodyKnowledgeContentID: "ID do conteúdo do conhecimento do corpo",
    formBodyResponse_Value: "Resposta"
};

export const CanvasFormsIncompleteLabels = {
    canvasFormName: "Nome do formulário do Canvas",
    header: "Cabeçalho",
    headerOrder: "Ordem do cabeçalho",
    sectionOrder: "Ordem da Seção",
    bodyOrder: "Ordem de conteúdo",
    body: "Contéudo",
    formHeaderID: "ID do cabeçalho do formulário",
    formSectionID: "ID da seção do formulário",
    formBodyID: "ID do Conteúdo do formulário"
};

export const controlFormResponseLabels = {
    controlName: "Controle",
    documentName: "Documento",
    engagementDescription: "Descrição do engagement",
    formHeader: "Cabeçalho",
    headerKnowledgeDisplayOrder: "Ordem de exibição do conhecimento do cabeçalho",
    formSection: "Seção",
    sectionKnowledgeDisplayOrder: "Ordem de exibição do conhecimento da seção",
    formBodyVal: "Contéudo",
    bodyKnowledgeDisplayOrder: "Ordem de exibição do conhecimento do conteúdo",
    ControlTesting: "Possui testes de controle",
    controlFrequencyType: "Frequência do controle",
    Effective: "É efetivo",
    formBodyOptionVal: "Valor do conteúdo da opção de formulário",
    controlType: "Tipo de controle",
    controlDesignEffectivenessType: "Tipo de eficácia do desenho do controle"
};

export const itProcessSummaryLabels = {
    itProcessName: "Processo de TI",
    itProcessEvaluation: "Avaliação de processos de TI",
    itProcesSupportingRationale: "Racional de apoio",
    itRiskName: "Risco de TI",
    itControlName: "ITGCs/ITSPs",
    natureOfTest: "Natureza do Teste",
    controlFrequencyTypeId: "Frequência",
    testing: "Teste",
    designEffectiveness: "Eficácia do projeto",
    operatingEffectiveness: "Eficácia operacional"
}

export const itProcessScotControlsLabels = {
    itProcessName: "Processo de TI",
    scotName: "SCOT",
    controlName: "Controle",
    controlDesignEffectivenessTypeName: "Eficácia do projeto",
    testing: "Teste",
    operatingEffectiveness: "Eficácia Operacional",
    controlTypeName: "Tipo de controle",
    isIPEManuallyTestedName: "IPE é testado manualmente",
    itApplicationName: "Aplicativo de TI",
    aggregateITEvaluationTypeName: "Avaliação agregada de TI"
};

export const scotsControlsReportLabels = {
    scotName: "SCOT",
    controlName: "Controle",
    operatingEffectiveness: "Eficácia Operacional",
    itApplicationName: "Aplicativo de TI",
    aggregateITEvaluation: "Avaliação agregada de TI",
    supportingRationaleControlLabel: "Racional de apoio"
}

export const sCOTSummaryReportHeaderLabels = {
    scotName: "SCOT",
    scotTypeName: "Tipo de transação",
    strategyTypeName: "Estratégia da SCOT",
    itApplicationName: "SCOT IT App / SO",
    wcgwName: labels.wcgw,
    controlName: labels.control,
    controlFrequencyTypeName: labels.frequencyLabel,
    controlTypeName: "Tipo de controle",
    testing: "Teste",
    operatingEffectiveness: "Eficácia Operacional",
    controlITApplication: "Aplicativo de TI de controle / SO",
    aggregateITEvaluationTypeName: "Avaliação agregada de TI",
    supportingRationale: "Racional de apoio",
    scotId: "ID da SCOT",
    strategyTypeID: "ID do tipo de estratégia",
    scotTypeID: "ID do tipo SCOT",
    wcgwid: "ID do WCGW",
    controlID: "ID de controle",
    controlFrequencyTypeID: "ID do tipo de frequência de controle",
    controlTypeID: "ID do tipo de controle",
    aggregateITEvaluationTypeID: "ID do tipo de avaliação de TI agregada"
};

export const findingsDeficiencyHeaderLabels = {
    description: "Descrição da Deficiência",
    controls: "Controles",
    controlsIsEffective: "Eficácia operacional dos controles",
    type: "Tipo de Deficiência",
    magnitude: "Magnitude",
    responseText: "Texto de resposta",
    remediatedAtYearEnd: "Remediado no final do ano",
    mitigatingControls: "Controle de Compensação",
    mitigatingControlsIsEffective: "Eficácia Operacional do Controle de Compensação",
    mitigatingTasks: "Tarefas Mitigadoras",
    foundIn: "Encontrado no Documento",
    accountsAndAssertions: "Contas e Assertivas",
    scoTs: "SCOTs",
    deficiencyID: "ID da deficiência",
    controlID: "ID de controle",
    mitigatedControlID: "ID de controle de mitigação",
    mitigatedTaskID: "ID de tarefa de mitigação",
    documentID: "Eficácia do projeto",
    accountID: "ID da conta",
    scotID: "ID da SCOT"
};

export const findingsMisstatementHeaderLabels = {
    description: "Descrição incorreta do erro",
    type: "Tipo de distorção",
    trialBalance: "Balancete",
    period: "Período",
    accountNumber: "Número de conta",
    accountName: "Nome de conta",
    accountType: "Tipo de conta",
    debit: "Débito",
    credit: "Crédito",
    responseText: "Texto de resposta",
    correctedUncorrected: "Corrigido/não corrigido",
    mitigatingTasks: "Tarefas Mitigadoras",
    foundInDocument: "Encontrado no Documento",
    accountsAndAssertions: "Contas e Assertivas",
    misstatementID: "ID do erro",
    trialBalanceID: "ID do balancete",
    misstatementAdjustmentID: "ID de ajuste do erro"
};

export const findingsDeficiencyITHeaderLabels = {
    itApplicationName: "Nome do aplicativo de TI",
    itProcessName: "Nome do processo de TI",
    itControlName: "Nome do controle de TI",
    itApproachTypeName: "Tipo de Abordagem de TI",
    isEffective: "Eficácia do Controle",
    referenceNumber: "Número de referência",
    description: "Descrição da Deficiência",
    deficiencyMagnitudeName: "Magnitude da Deficiência",
    deficiencyTypeName: "Tipo de Deficiência"
};

export const auditPlanRelatedEvidenceReportHeaderLabels = {
    adc: "Objeto Relacionado",
    secondaryObject: "Controle Relacionado / Procedimento Substantivo",
    taskName: "Título da tarefa",
    taskDescription: "Descrição da tarefa",
    taskTypeColumn: "Tipo de tarefa",
    taskStatusValue: "Status da tarefa",
    rationaleForRejection: "Racional para Rejeição",
    engagementPhase: "Fase do engagement",
    milestone: "Marco",
    periodName: "Fase de tempo",
    assignedTo: "Atribuído a",
    engagementTagGroupName: "Grupo de etiqueta",
    engagementTagName: "Etiquetas",
    displayedOn: "Exibir exibido em",
    documentName: "Nome do Documento",
    preparersValue: "Preparadores (data em UTC)",
    reviewersValue: "Revisores (data em UTC)",
    openReviewNotes: "Abrir notas de revisão",
    closedReviewNotes: "Notas de Revisão Limpas",
    trackChangesValue: "Alterações de percurso",
    lastModifiedBy: "Última modificação por",
    lastModifiedDateValue: "Datas da última modificação (em UTC)",
    taskID: "ID da tarefa",
    timephaseID: "ID da fase de tempo",
    taskTypeID: "ID do Tipo de tarefa",
    documentTypeID: "ID do tipo de documento",
    parentDocumentTypeID: "ID do tipo de documento pai",
    timePhaseTypeID: "ID do tipo de fase de tempo"
};

// group instruction summary
export const groupInstructionSummaryReportHeaderLabels = {
    sectionName: "Seção",
    gaInstructionName: "Título da Instrução",
    gaInstructionDescription: "Descrição da instrução",
    documents: "Nome do Documento",
    knowledgeInstructionName: "Título da Instrução de Conhecimento",
    knowledgeInstructionDescription: "Descrição da Instrução de Conhecimento",
    gaScopeName: "Escopos / Sub-Escopos Relacionados",
    componentOnly: "Escopo / Instrução Individual",
    shortName: "Nome da região/componente",
    cSection: "Seção personalizada",
    customInstruction: "Instrução personalizada",
    gAinstructionID: "ID de instrução GA"
};

// GIS last publish and send
export const gIsLastPublishAndSendReportHeaderLabels = {
    primaryEngagementID: "ID do engagement",
    gaScopeID: "ID do escopo GA",
    gaScopeName: "Escopo",
    gaComponentID: "ID do componente GA",
    shortName: "Nome do componente",
    lastPublishedDateInUTC: "Última data publicada",
    lastSentDateInUTC: "Data do último envio",
    gaLinkStatusId: "Status do link",
    gaInstructionStatusId: "Status da instrução"
};

// Group Activity
export const groupActivityReportHeaderLabels = {
    engagementID: "ID do engagement",
    gaScopeID: "ID do escopo GA",
    gaScopeName: "Escopo",
    gaComponentID: "ID do componente GA",
    shortName: "Nome do componente",
    gaLinkStatusId: "Status do link",
    accountID: "ID da conta",
    accountName: "Nome da conta",
    accountType: "Designação de conta",
    activityTypeID: "ID do tipo de atividade",
    activityTypeText: "Tipo de atividade",
    modifyDateInUTC: "Modificar data",
    modifyUser: "Modificar usuário",
};

export const AccountDisclosuresReportHeadeLabels = {
    engagementID: "ID do engagement",
    accountID: "ID da conta",
    accountName: "Nome da conta",
    accountTypeID: "ID do tipo de conta",
    accountTypeId: "Designação de conta",
    knowledgeAssertionId: "Abreviatura de assertiva",
    inherentRiskTypeId: "Avaliação de risco inerente",
    controlRiskTypeId: "Avaliação de risco de controle",
    craValue: "CRA",
    riskID: "ID do risco",
    riskTypeID: "ID do tipo de risco",
    riskType: "Tipo de risco",
    riskName: "Nome do risco",
    isHigherRiskValue: "É um risco mais alto",
};

// CRA summary
export const craSummaryReportHeaderLabels = {
    accountName: "Conta",
    accountTypeName: "Tipo de conta",
    rationale: "Racional",
    pspIndex: "PSP indexado",
    conclusionStatement: "Declaração de conclusão de conta",
    scotName: "SCOTs",
    transactionType: "Tipo de transação",
    strategyTypeName: "Estratégia da SCOT",
    wcgwName: "WCGW",
    controlName: "Controle",
    controlFrequencyTypeName: "Frequência",
    controlTypeName: "Tipo de controle",
    testing: "Teste",
    operatingEffectiveness: "Eficácia Operacional",
    itApplicationName: "SCOT IT App/ SO",
    controlITApplication: "Controle IT App/SO"
};

export const craSummaryAssertionReportHeaderLabels = {
    accountName: "Conta",
    accountTypeName: "Tipo de conta",
    rationale: "Racional",
    pspIndex: "PSP indexado",
    assertionAbbreviation: "Assertiva",
    riskName: "Risco",
    inherentRiskTypeName: "Avaliação de risco inerente",
    controlRiskTypeName: "Avaliação de risco de controle",
    craValue: "CRA",
    wcgwName: "WCGW",
    controlName: "Controle",
    controLFrequencyTypeName: "Frequência",
    controlTypeName: "Tipo de controle",
    testing: "Teste",
    isLowerR: "É de risco menor",
    operatingEffectiveness: "Eficácia Operacional",
    itApplicationName: "IT App/ SO"
};

export const craSummaryDataReportHeaderLabels = {
    wcgwName: "WCGW",
    controlName: "Controle",
    controLFrequencyTypeName: "Frequência do controle",
    controlTypeName: "Tipo de controle",
    itApplicationName: "Aplicativo de TI",
    assertionName: "Assertiva",
    statementTypeName: "Tipo de demonstrativo",
    accountTypeName: "Tipo de conta",
    assertionAbbreviation: "Abreviatura da assertiva",
    inherentRiskTypeName: "Risco inerente",
    controlRiskTypeName: "Risco de controle",
    craValue: "CRA",
    riskTypeAbbreviation: "Abreviação do risco",
    frequency: "Frequência",
    accountName: "Conta",
    riskName: "Risco",
    pspIndex: "PSP indexado",
    testing: "Teste",
    operatingEffectiveness: "Eficácia operacional",
    isLowerRiskColumn: "É  risco menor",
    scotName: "SCOT",
    controlitApplicationName: "Controle do aplicativo de TI",
    rationale: "Justificativa",
    accountID: "ID da conta",
    riskID: "ID do risco",
    scotid: "ID da SCOT",
    wcgwid: "ID do WCGW",
    controlID: "ID do controle",
    itApplicationID: "ID do aplicativo de TI",
    knowledgeAssertionID: "ID de conhecimento da assertiva",
    controlTypeID: "ID do tipo de controle",
    controlFrequencyTypeID: "ID do tipo de frequência de controle",
    accountTypeID: "ID do tipo de conta",
    riskTypeID: "ID do tipo de risco",
    inherentRiskTypeID: "ID do tipo de risco inerente",
    controlRiskTypeID: "ID do tipo de risco de controle",
    statementTypeID: "ID do tipo de demonstrativo",
    conclusionStatement: "Conclusão do demonstrativo da conta"
};

export const reportingRequestsAndTasks = {
    requestTitle: "Título da solicitação/tarefa",
    request_Description: "Descrição da solicitação/tarefa",
    type: "Tipo",
    tasks: "Título da tarefa",
    engagementTagName: "Etiquetas",
    eyAssigned: "Usuário atribuído EY",
    clientGroupName: "Grupo externo",
    externalAssignedUser: "Usuário externo atribuído",
    periodName: "Fase de tempo",
    dueDateInUTC: "Data de vencimento (em UTC)",
    requestStatus: "Status da solicitação/tarefa",
    documentType: "Tipo de documento",
    documentName: "Nome do documento do ano atual",
    priorYearDocumentName: "Nome do documento do ano anterior",
    externalDocumentSignOffInUTC: "Aprovações de documentos externos (em UTC)",
    clientRequestReferenceNumber: "Número de referência do pedido do cliente"
};

export const reportingRequestComment = {
    requestTitle: "Título da solicitação/tarefa",
    request_Description: "Descrição da solicitação/tarefa",
    type: "Tipo",
    tasks: "Título da tarefa",
    engagementTagName: "Etiquetas",
    eyAssigned: "Usuário atribuído EY",
    clientGroupName: "Grupo externo",
    externalAssignedUser: "Usuário externo atribuído",
    periodName: "Fase de tempo",
    dueDateInUTC: "Data de vencimento (em UTC)",
    requestStatus: "Status da solicitação/tarefa",
    externalDocumentSignOffInUTC: "Aprovações de documentos externos (em UTC)",
    annotationTextData: "Comentários",
    createDateInUTC: "Data dos comentários (em UTC)",
    annotationUserInitials: "Comentado por"
};

export const reportingAllDocuments = {
    documentName: "Nome do Documento",
    fileExt: "Extensão de arquivo",
    canvasFormType: "Tipo do formulário do Canvas",
    docType: "Tipo de documento",
    confidentiality: "Confidencialidade",
    docFileSize: "Tamanho do arquivo (KB)",
    preparers: "Preparadores (em UTC)",
    reviewers: "Revisores (em UTC)",
    relatedTask: "Tarefas relacionadas",
    openReviewNote: "Abrir notas de revisão",
    clearedReviewNote: "Notas de Revisão Limpas",
    trackChanges: "Alterações de percurso",
    hiddenSheets: "Planilhas ocultas",
    comments: "Comentários",
    highlighted: "Destaques",
    conflicted: "Conflitos",
    docModifyUser: "Última modificação por",
    docModifyDateInUTC: "Data da última modificação (em UTC)",
    documentID: "ID do documento"
};

export const signOffDocuments = {
    documentName: "Nome do Documento",
    fileExt: "Extensão de arquivo",
    canvasFormType: "Tipo do formulário do Canvas",
    docType: "Tipo de documento",
    confidentiality: "Confidencialidade",
    docFileSize: "Tamanho do arquivo (KB)",
    docModifyUser: "Última modificação por",
    docModifyDateInUTC: "Data da última modificação (em UTC)",
    signOffDate: "Data de assinatura (em UTC)",
    signedOffBy: "Assinado por",
    role: "Função",
    preparerReviewer: "Preparador/Revisor"
};

export const reportingDocumentsModified = {
    documentName: "Nome do Documento",
    lastModifiedDateInUTC: "Data da última modificação (em UTC)",
    lastModifiedUser: "Último usuário modificado",
    reason: "Razão",
    documentChangeComment: "Racional",
    preparersInUTC: "Preparadores (em UTC)",
    reviewersInUTC: "Revisores (em UTC)",
    approver: "Aprovações (em UTC)"
};

export const reportingDeletedTaskReport = {
    taskNamePrefix: labels.taskPrefix,
    taskName: "Título da tarefa",
    taskNameSuffix: labels.taskSuffix,
    taskDescription: "Descrição da tarefa",
    taskTypeAbbreviation: "Tipo de tarefa",
    taskSourceType: "Origem da tarefa",
    taskNatureType: "Natureza da tarefa",
    last_Modified_By: "Última modificação por",
    modifyDateInUTC: "Data da última modificação (em UTC)",
    oldTaskName: "Título da tarefa do legado",
    oldTaskDetail: "Descrição da tarefa do legado"
};

export const SEMReportHeaderLabel = {
    accountAssertion: "Conta/Assertiva",
    craValue: "CRA",
    riskOfMaterialMisstatements: labels.riskOfMaterialMisstatement,
    relatedRisks: "Riscos Relacionados",
    taskType: "Tipo de tarefa",
    taskTitle: "Título da tarefa",
    taskSource: labels.source,
    taskNature: labels.nature,
    taskTypeID: "ID do Tipo de tarefa",
    taskSourceTypeID: "ID do tipo de origem da tarefa",
    taskNatureTypeID: "ID do tipo de natureza da tarefa"
}

export const MilestonesReportHeaderLabels = {
    taskName: labels.repTaskTitle,
    taskType: labels.taskType,
    taskStatus: labels.taskStatusLabel,
    auditPhase: labels.auditPhasesLabel,
    periodName: labels.timephase,
    timephase: "Marco atual",
    correctTimephase: "Marco correto"
}

export const MilestonesReportHeader = {
    milestone: "Milestone",
    status: "Status do Milestone",
    taskStatus: "Status da tarefa",
    taskTitle: "Título da tarefa",
    taskTypeAbbreviationColumn: "Abreviação do tipo de tarefa",
    taskType: "Tipo de tarefa",
    timePhase: "Fase do tempo",
    assignedTo: "Atribuído a",
    taskName: "Nome da tarefa",
    task_Detail: "Detalhe da tarefa",
    due_Date: "Data de vencimento",
    documentName: "Nome do Documento",
    preparers: "Preparadores",
    reviewers: "Revisores",
    tagGroup: "Grupo de tags",
    tags: "Tags",
    engagementID: "ID do Engagement",
    taskID: "ID da tarefa",
    taskTypeID: "ID do tipo de tarefa",
    taskStatusID: "ID de status da tarefa",
    timephaseID: "ID da fase do tempo",
    timephaseTypeID: "ID do tipo da fase do tempo",
    documentID: "ID do Documento"
}

export const groupStructureSummaryReportHeaderLabels = {
    gaScopeName: "Descrição do Escopo",
    gaScopeDescription: "Escopo / Nome do Sub-Escopo",
    shortName: "Nome da região/componente",
    legalName: "Nome legal",
    gaRoleTypeName: "Função do grupo",
    relatedRegion: "Região Relacionada",
    pocText: "Ponto de contato",
    gaLinkStatusName: "Status do link",
    gaInstructionStatusName: "Status da Instrução",
    engagementID: "ID do engagement",
    gaRoleTypeID: "ID do tipo de função do GA",
    gaLinkStatusID: "ID de status do link do GA",
    gaInstructionStatusID: "ID do status da instrução do GA"
}

export const collaborationSummary = {
    clientRequestID: "Número da solicitação",
    requestTitle: "Título",
    requestType: "Tipo",
    engagementTagName: "Etiquetas",
    clientUser: "Atribuído a",
    clientEmail: "E-mail do cliente",
    clientStatusName: "Status",
    isOverDue: "Atrasado",
    dueDateInUTC: "Data de vencimento (em UTC)",
    eySentDateInUTC: "Data de envio da EY (em UTC)",
    eyReceivedDateInUTC: "Data de recebimento (em UTC)",
    deliveredLate: "Entregue com atraso",
    daysLate: "Dias de atraso",
    timesReturned: "Tempos devolvidos"
}

export const collaborationActivity = {
    clientRequestID: "Número da solicitação",
    requestTitle: "Título",
    requestType: "Tipo",
    engagementTagName: "Etiquetas",
    clientUser: "Atribuído a",
    clientEmail: "E-mail do cliente",
    clientStatusName: "Status",
    isOverDue: "Atrasado",
    dueDateInUTC: "Data de vencimento (em UTC)",
    eySentDateInUTC: "Data de envio da EY (em UTC)",
    eyReceivedDateInUTC: "Data de recebimento (em UTC)",
    deliveredLate: "Entregue com atraso",
    daysLate: "Dias de atraso",
    timesReturned: "Tempos devolvidos",
    activity: "Atividade",
    activityDateInUTC: "Data da atividade (em UTC)",
    historicalDueDateInUTC: "Data de vencimento histórica (em UTC)"
}

export const groupReportHeaderLabels = {
    gaInstructionName: "Nome da Instrução",
    gascopeTypeIDName: labels.scope,
    componentName: "Nome do componente",
    pointOfContact: labels.pointOfContact,
    dueDateValue: "Data de vencimento (em UTC)",
    overdueValue: labels.overdueLabel,
    gaStatusIdName: labels.status,
    documentName: labels.documents,
    createDateValue: "Data de assinatura (em UTC)",
    signoffBy: labels.signedOffBy,
    engagementRoleIDName: labels.role,
    isPreparerText: "Preparador/Revisor",
    documentID: "Eficácia do projeto",
    gaStatusID: "ID de status do GA",
    engagementRoleID: "ID da função do engagmeent"
}

export const wcgwSummaryHeaders = {
    wcgwName: "WCGW",
    scotName: "SCOT",
    controlName: "Controles relacionados",
    itApplications: "Aplicativo/SO de TI relacionado",
    testing: "Seleção de teste",
    isLowerR: "É de risco menor",
    controlFrequencyTypeName: "Frequência de controle",
    controlTypeName: "Tipo de controle",
    wcgwCount: "Contagem de outros WCGWs relacionados"
}

export const allControlsHeaders = {
    engagementID: "ID do Engagement",
    scotid: "ID da SCOT",
    controlID: "ID do Controle",
    scotName: "Nome da SCOT",
    controlName: "Descrição do controle",
    hasControlTesting: "Seleção de teste",
    isLowerRisk: "É Risco mais Baixo",
    controlTypeID: "Tipo de controle",
    relatedITApplicationNames: "Aplicativo/SO de TI relacionado",
    responsiveToSR: "Responsivo a um risco significativo",
    IPE: "IPE"
}


export const qualityChecksHeaders = {
    itemID: "ID do item",
    itemName: "Nome do item",
    qualityChecks: "Verificação de qualidade",
    validationDescription: "Descrição da validação",
    buildGroup: "Criar grupo",
    impactedItem: "Item impactado",
    type: "Tipo"
}

export const statisticsHeaders = {
    scotname: "SCOT",
    strategyTypeId: "Estratégia da SCOT",
    wcgwName: "WCGW",
    controlName: "Controle",
    operatingEvaluation: "Avaliação operacional",
    itApplicationName: "Aplicativo de TI / SO relacionado",
    assertions: "Assertivas",
    controlTypeId: "Tipo de controle",
    testingSelection: "Seleção de teste",
    controlFrequencyTypeId: "Frequência",
    itApplications: "Aplicativos de TI",
    scotTypeId: "Tipo de SCOT",
    itType: "Tipo de aplicativo de TI",
    isLowerR: "É  risco menor",
    engagementID: "ID do Engagement",
    workspaceID: "ID da Área de trabalho",
    scotID: "ID da SCOT",
    scotTypeID: "ID do tipo de SCOT",
    wcgwid: "ID do WCGW",
    controlID: "ID do controle"
}

export const CRTAssertionCountSummaryHeaders = {
    accountName: "Conta",
    assertion: "Assertiva",
    controlName: "Controle",
    ControlTypeName: "Tipo de controle",
    ControlFrequencyTypeName: "Frequência",
    Testing: "Teste",
    OperatingEvaluation: "Avaliação operacional",
    assertionControlCount: "Contagem de controle de assertiva",
    assertionAbbreviation: "Abreviação da assertiva",
    wcgwName: "WCGW",
    engagementID: "ID do Engagement",
    workspaceID: "ID da Área de trabalho",
    assertionID: "ID da assertiva",
    wcgwid: "ID do WCGW",
    controlID: "ID do controle"
}

export const crtlistcontrolTypeName = {
    'IT Application Control': "Controle de aplicativos de TI",
    'IT Dependent Manual Control': "Controle Manual Dependente de TI",
    'Manual Prevent': "Prevenção manual",
    'Manual Detect': "Detecção manual"
}

export const controlFrequencyNameTypes = {
    'Many times per day': "Muitas vezes por dia",
    'Daily': "Diário",
    'Weekly': "Semanal",
    'Monthly': "Mensal",
    'Quarterly': "Trimestral",
    'Annually': "Anual",
    'IT Application Control': "Controle de aplicativos de TI",
    'Other': "Outro"
};

// Folder types
export const archiveFolderTypeNameTypes = {
    'Working Papers': "Papéis de trabalho",
    'Perm File Active': "Arquivo Permanente Ativo",
    'Perm File Superseded': "Arquivo Permanente Substituído",
    'Working Papers - CD/DVD': "Papéis de trabalho - CD/DVD",
    'Perm File Active - CD/DVD': "Arquivo Permanente Ativo - CD/DVD",
    'Perm File Superseded - CD/DVD': "Arquivo Permanente Substituído - CD/DVD",
    'Data Storage Devices': "Dispositivos de armazenamento de dados"
};

export const operatingEvaluationType = {
    'Effective': "Eficaz",
    'Ineffective': "Ineficaz",
    'Not Selected': "Não selecionado"
};

export const CRTSCOTCountSummaryHeaders = {
    scotname: "SCOT",
    strategyTypeName: "Estratégia da SCOT",
    wcgwName: "WCGWs relacionados",
    controlName: "Controles relacionados",
    operatingEvaluation: "Avaliação operacional",
    itApplicationName: "Aplicativo de TI / SO relacionado",
    assertions: "Assertivas",
    controlTypeName: "Tipo de controle",
    testing: "Seleção de teste",
    controlFrequencyTypeName: "Frequência",
    itApplications: "Aplicativos de TI",
    itAppType: "Tipo de aplicativo de TI",
    scotTypeName: "Tipo de SCOT",
    soctisLowerRisk: "Controle de risco menor",
    engagementID: "ID do Engagement",
    workspaceID: "ID da Área de trabalho",
    scotID: "ID da SCOT",
    scottypeid: "ID do tipo de SCOT",
    wcgwid: "ID do WCGW",
    controlID: "ID do controle"
};

export const projectInsightCanvasFormExportHeaders = {
    EngagementID: "ID do Engagement",
    DocumentID: "ID do documento",
    ControlID: "ID do controle"
};

export const projectInsightSCOTToWCGWToControlHeaders = {
    engagementID: "ID do engagement",
    scotName: "Nome da SCOT",
    strategyTypeName: "Nome do Tipo de Estratégia",
    wcgwName: "Nome do WCGW",
    controlID: "ID do Controle",
    controlName: "Nome do Controle",
    controlFrequencyTypeName: "Nome do Tipo de Frequência do Controle",
    controlTypeName: "Nome do Tipo de Controle",
    isLowerRiskHeader: "É Risco Mais Baixo",
    hasControlTestingHeader: "Tem Teste de Controle",
    operativeEffectiveness: "Efetividade Operacional"
};

export const ComponentTeamGroupAccountInfoControlHeaders = {
    engagementId: "ID do engagement",
    accountId: "ID da conta",
    accountName: "Nome da conta",
    accountTypeId: "ID do tipo de conta",
    accountDesignation: "Designação de conta",
    pspIndexTitle: "Índice PSP",
    knowledgeAssertion: "Abreviatura de assertiva",
    inherentRiskType: "Avaliação de risco inerente",
    controlRiskType: "Avaliação de risco de controle",
    craValue: "CRA",
    riskId: "ID do risco",
    riskTypeId: "ID do tipo de risco",
    riskTypeEnum: "Tipo de risco",
    riskName: "Nome do risco",
    isHigherRiskText: "É um risco mais alto",
    rejectedTaskId: "ID da tarefa",
    rejectedTaskName: "PSP rejeitado",
    rejectedTaskRationale: "Justificativa de PSP rejeitada"
};

export const projectInsightControlToITApplicationHeaders = {
    engagementID: "ID do Engagement",
    controlID: "ID do Controle",
    itApplicationID: "ID de Aplicativo de TI",
    controlITApplication: "Aplicativo de Controle de TI"
};

export const projectInsightControlToAssertionHeaders = {
    engagementID: "ID do Engagement",
    controlID: "ID do Controle",
    Accountname: "Nome da Conta",
    AssertionAbbreviation: "Abreviatura de assertiva"
};

export const projectInsightRisksToWCGWsHeaders = {
    engagementId: "ID do Engagement",
    accountName: "Nome da Conta",
    accountId: "ID da Conta",
    knowledgeAssertion: "Assertiva",
    CRA: "CRA",
    RelatedRisk: "Risco relacionado",
    riskId: "ID do risco",
    riskType: "Tipo de risco",
    WCGW: "WCGW",
    wcgwId: "ID do WCGW",
    RelatedSCOT: "SCOT relacionada",
    scotId: "ID da SCOT"
};

export const ipeControlsHeaders = {
    EngagementID: "ID do Engagement",
    DocumentID: "ID do Documento"
};

export const ipeSubstantiveHeaders = {
    EngagementID: "ID do Engagement",
    DocumentID: "ID do Documento"
};

export const ipeITGCHeaders = {
    EngagementID: "ID do Engagement",
    DocumentID: "ID do Documento"
};

export const iTAppSOReport = {
    relatedITSO: "Aplicativo de TI / SO relacionado",
    iTAppType: "Tipo de aplicativo de TI",
    iTAppControl: "Controle de aplicativos de TI",
    testingSelection: "Seleção de teste",
    relatedSCOTs: "SCOTs relacionadas",
    relatedSCOTStrategy: "Estratégia de SCOT Relacionada",
    itdm: "ITDM",
    manualPrevent: "Prevenção manual",
    manualDetect: "Detecção manual",
    noRelatedControls: "Nenhum controle relacionado",
    controlsStatistics: "Controles por tipo",
    relatedSCOTType: "Tipo de SCOT relacionada",
    controlType: "Tipo de controle",
    grandTotal: "Total",
    yes: "Sim",
    no: "Não",
    notSelected: "Não selecionado",
    controls: "Controles",
    substantive: "Substantivo",
    routine: "Rotineiro",
    nonRoutine: "Não rotineiro",
    estimation: "Estimativa"
};

export const IndependenceSummaryReport = {
    id: "ID",
    userName: "Nome de usuário",
    order: "Ordem",
    questionFormatted: "Pergunta",
    answer: "Resposta",
    actionTypeID: "ID do tipo de ação",
    independenceStatusID: "ID do status de independência",
    EngagementUserStatusName: "Status do usuário do engagement",
    engagementUserStatusID: "ID de status do usuário do engagement",
    IndependenceStatusName: "status da independência",
    requiresExecutiveClearance: "Requer autorização executiva"
};

export const additionalInfoBasedOnValidationTypeId = {
	1: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
    2: "A equipe não está usando a versão mais atualizada do 109 - Formulário de independência dos membros da equipe",
    3: "Um membro da equipe mudou sua função de PPEDD após conceder acesso a outro membro da equipe com um assunto de independência",
    4: "Um membro da equipe mudou sua função de PPEDD após conceder acesso a outro membro da equipe com um assunto de independência",
    5: "Clique no link de validação, identifique a SCOT que não possui número ao lado. Relacionar a SCOT a uma conta",
	6: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
    7: "Identifique a SCOT onde a contagem de WCGWs relacionada está em branco. Navegue até a respectiva tarefa de construção. Expanda a SCOT e adicione WCGWs conforme apropriado",
    8: "Identifique a SCOT onde a contagem de Controles relacionada está em branco. Navegue até a respectiva tarefa de construção. Expanda a SCOT e adicione um Controle aos WCGWs",
    9: "Identifique a SCOT com a validação, expanda os detalhes da SCOT e verifique se pelo menos um controle por WCGW tem Sim selecionado para teste",
    10: "Identifique a SCOT com a validação, expanda os detalhes da SCOT. Verifique se pelo menos um controle por WCGW tem Sim selecionado para teste",
    11: "Clique no link de validação, identifique o Risco que não possui número ao lado. Relacione a assertiva apropriada ao risco",
    12: "Identifique a assertiva que não possui um risco inerente e/ou de controle. Preencha o campo que falta",
    13: "Clique no link de validação e abra a gaveta Adicionar WCGW. Selecione uma SCOT por vez e identifique os WCGWs que não possuem número ao lado. Relacione o WCGW com a assertiva apropriada",
    14: "Identifique a conta que não possui um número ao lado. Navegue até o fluxo de criação das SCOTs e relacione a SCOT a uma conta",
    15: "Identifique a conta/assertiva com a validação, clique no botão Adicionar WCGWs e relacione o WCGW para a assertiva",
    16: "Esta verificação de validação verifica se todos os WCGWs relacionados a uma assertiva com uma estratégia de Controles estão cobertos por um controle que será testado. Identifique a assertiva com a validação, clique no botão Adicionar WCGWs e relacione o WCGW com a assertiva",
    17: "Revise cada WCGW associado a uma assertiva e verifique se ele é coberto por pelo menos um controle que tenha uma estratégia de teste Sim",
    18: "Todos os WCGWs para uma assertiva com uma estratégia de Confiança devem ser cobertos por um controle com um valor de teste definido como Sim.",
    19: "Um TI/SO tem uma Estratégia de confiança que não é excluída nem relacionada a um processo de TI/SO",
    20: "Um controle de TI/SO /procedimento substantivo de TI não está relacionado a um risco de TI/SO",
    21: "Uma mudança na estratégia de Confiar para Não Confiar após a criação do processo de TI/SO",
    22: "Um risco não está relacionado a uma assertiva",
    23: "Um controle de TI/SO /procedimento substantivo de TI não está relacionado a um risco de TI/SO",
    24: "Um controle/procedimento substantivos de TI/SO relacionado a um risco de TI/SO não está selecionado para teste",
    25: "Um controle de TI/SO /procedimento substantivo de TI não está relacionado a um risco de TI/SO",
    26: "Identifique a conta de risco limitado que não possui nenhuma tarefa. Adicione um ou mais OSPs",
    27: "Verifique se você importou os PSPs. Se os PSPs não foram importados, clique em importar PSPs. Se não houver PSPs para a assertiva, crie um OSP",
    28: "Navegue até o fluxo de criação das SCOTs, abra a gaveta Adicionar Teste de Controle, identifique a tarefa do TOC que não possui um número próximo a ela. Relacione a tarefa do TOC ao controle",
    29: "O engagement contém pelo menos uma tarefa de walkthrough que ainda não foi associada a uma SCOT",
    30: "Uma SCOT não tem pelo menos uma tarefa de walkthrough associada a ela",
    31: "Navegue até o fluxo de criação das SCOTs, abra a gaveta Adicionar Teste de Controle, identifique a tarefa do TOC que não possui um número próximo a ela. Relacione a tarefa do TOC ao controle",
    32: "Um walkthrough de TI/SO não está relacionado a pelo menos um processo de TI/SO",
    33: "Um teste de controle de TI/SO não está relacionado a pelo menos um procedimento de controle/substantivo de TI/SO com um valor de teste definido como Sim",
    34: "Um outro procedimento substantivo de TI/SO não está relacionado a pelo menos um controle/procedimento substantivo de TI/SO com um valor de teste definido como Sim",
    35: "Um processo de TI/SO não tem pelo menos uma tarefa de walkthrough associada a ele",
    36: "Um controle com um valor de teste definido como Sim não tem nenhuma tarefa de teste de controle associada a ele",
    37: "Um outro procedimento substantivo de TI/SO não está relacionado a pelo menos um controle/procedimento substantivo de TI/SO com um valor de teste definido como Sim",
    38: "Clique no link de validação, na lista de evidências clique no ícone de conflito para resolver o conflito",
	39: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
    40: "Clique no link de validação, na assinatura da lista de evidências nos documentos que faltam a aprovação do preparador ou do revisor. Assine apenas os arquivos que você preparou ou revisou",
    41: "Clique no link de validação, na lista de tarefas filtrada revise cada tarefa e associe os arquivos de evidência apropriados",
	42: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	43: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
    44: "Clique no link de validação, na lista de evidências renomeie os documentos com nomes duplicados",
    45: "A avaliação do processo de TI não foi selecionada ou é inconsistente com as avaliações de eficácia operacional do ITCG/ITSP.",
	46: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
    47: "A avaliação agregada de TI não foi selecionada para um ou mais dos controles de aplicativo/ITDM",
    48: "O formulário do Canvas tem pelo menos um campo que não foi preenchido",
    49: "Clique no link de validação e depois clique em Adicionar Assertiva para relacionar a assertiva ou conta de risco limitado",
    50: "Tarefa que não tem nenhuma assertiva ou conta de risco limitada associada. Clique em Adicionar Assertiva para associar uma assertiva ou conta de risco limitado",
    51: "Um WCGW não foi relacionado a uma tarefa substantiva",
    52: "Engagement tem pelo menos um risco inerente, significativo ou de fraude que não está associado a pelo menos um WCGW",
    53: "Conta de estimativa que não está no índice de estimativas contábeis EST. Adicione-o da lista de índices do PSP.",
    54: "Identifique a(s) conta(s) que tem uma estimativa e abra a conta para ver se ela tem uma SCOT de estimativa  relacionada a ela. Depois de identificar as contas que não possuem a SCOT de estimativa, você precisará relacionar a SCOT de estimativa.",
    55: "Identifique a SCOT de estimativa que não está relacionada a uma conta de estimativa. Depois de identificar a SCOT da estimativa que está faltando na conta da estimativa, você precisará relacionar a SCOT da estimativa à conta da estimativa.",
    56: "Um risco significativo ou de fraude deve ter pelo menos um procedimento substantivo, um controle e uma tarefa de teste de controle (se aplicável)",
    57: "Um risco significativo ou de fraude deve ter pelo menos um procedimento substantivo, um controle e uma tarefa de teste de controle (se aplicável)",
    58: "Clique no risco com a validação e expanda a assertiva. Verifique se pelo menos uma tarefa tem Sim selecionado",
    59: "Clique no risco com a validação e expanda a assertiva. Verifique se pelo menos um controle tem Sim selecionado. A efetividade do projeto também precisa ser concluída para o controle",
    60: "Clique no link de validação Resolver comentários do formulário do Canvas. Abra cada formulário do Canvas e selecione mostrar comentários não resolvidos. Todos os comentários devem ser limpos ou fechados",
    61: "Clique no link de validação Finalizar respostas incompletas do formulário do Canvas. Abra cada formulário do Canvas e selecione mostrar respostas incompletas. Todas as perguntas do Formulário do Canvas precisam ser respondidas",
    62: "Clique no link de validação, revise os comentários abertos e limpe ou feche todos os comentários abertos.",
	63: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
    64: "Clique no link de validação, na lista de tarefas filtradas, revise cada tarefa e marque as tarefas abertas como concluídas",
    65: "Clique no botão desvincular tudo para desvincular todas as evidências compartilhadas",
    66: "O formulário 440 tem pelo menos um documento sem um motivo para alteração selecionado",
	67: 'O formulário 440 tem pelo menos um documento com um motivo “não administrativo"para alteração selecionado que não tem a justificativa preenchida',
	68: 'O formulário 440 tem pelo menos um documento com um motivo "não administrativo " para alteração selecionado e que não foi aprovado por um gerente ou superior',
    69: "O formulário 440 não foi assinado pelo sócio do engagement ou pelo sócio responsável",
    70: "Clique no botão desvincular do grupo no checklist do archive",
    71: "Um formulário do Canvas não tem cabeçalhos ou conteúdo padrão",
	72: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
    73: "Clique no ícone de check de validação no formulário do Canvas para ver o número de respostas incompletas.",
    74: "Clique no link e envie a versão atualizada do Perfil de engagement.smt",
	75: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	76: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	77: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	78: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	79: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	80: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
    81: "Identifique processos de TI e relacione-os com aplicativos de TI",
	82: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	83: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	84: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	85: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	86: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	87: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	88: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
    89: "A avaliação do processo de TI não foi selecionada ou é inconsistente com as avaliações de eficácia operacional do ITCG/ITSP.",
    90: "Está faltando uma seleção de eficácia do desenho do controle",
    91: "Visualize as SCOTs e aplicativos de TI relacionados relevantes para a auditoria",
	92: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	93: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	94: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
    95: "Um engagement não tem membro específico da equipe identificado como a pessoa responsável em Gerenciar Equipe",
	96: 'Um fator de risco não está relacionado a um risco ou não marcado como "Não é um ROMM "',
    97: "Um risco não está relacionado a uma assertiva",
    98: "Um valor precisa ser inserido na Base da Projeção",
    99: "Um racional precisa ser inserido para a base da projeção",
    100: "Um valor precisa ser inserido na Base Ajustada",
    101: "A porcentagem de materialidade planejada não foi selecionada",
    102: "A porcentagem de materialidade do planejada está fora da faixa permitida",
    103: "Um racional precisa ser inserido para a porcentagem de Materialidade Planejada selecionada",
    104: "O erro tolerável não foi inserido",
    105: "A porcentagem de erro tolerável está fora da faixa permitida",
    106: "Um racional precisa ser inserido para a porcentagem de erro tolerável selecionada",
    107: "A porcentagem do SAD não foi selecionada",
    108: "A porcentagem do SAD está fora da faixa permitida",
    109: "Um racional precisa ser inserido para a porcentagem do SAD selecionada",
	110: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	111: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	112: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	113: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	114: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	115: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	116: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	117: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	118: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	119: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	120: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	121: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	123: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	124: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
    125: "Documentos protegidos não devem ser retidos nos arquivos do trabalho, a menos que seja necessário",
    126: "Excluir documento e fazer upload novamente",
	127: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	128: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	129: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	130: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	132: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	133: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	134: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	135: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	136: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	137: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	138: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	139: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	140: 'Use o passo a passo no enabler "How to clear validation checks in EY Canvas " para resolver essa validação',
	141: 'Use a orientação passo a passo na guia de "Como limpar verificações de validação no EY Canvas " para resolver essa validação',
	142: 'Use a orientação passo a passo na guia de "Como limpar verificações de validação no EY Canvas " para resolver essa validação',
	143: 'Use a orientação passo a passo na guia de "Como limpar verificações de validação no EY Canvas " para resolver essa validação',
	144: 'Use a orientação passo a passo na guia de "Como limpar verificações de validação no EY Canvas " para resolver essa validação',
	145: 'Use a orientação passo a passo na guia de "Como limpar verificações de validação no EY Canvas " para resolver essa validação',
	146: 'Use a orientação passo a passo na guia de "Como limpar verificações de validação no EY Canvas " para resolver essa validação',
	147: 'Use a orientação passo a passo na guia de "Como limpar verificações de validação no EY Canvas " para resolver essa validação',
	148: 'Use a orientação passo a passo na guia de "Como limpar verificações de validação no EY Canvas " para resolver essa validação',
    149: "Clique no link de validação Finalizar respostas incompletas do formulário do  Canvas. Abra cada formulário do Canvas e verifique se todos os documentos necessários associados aos requisitos possuem assinaturas de PIC/EQR relacionadas. Somente assine os arquivos que você preparou ou revisou.",
    150: "Clique no link de validação Finalizar respostas incompletas do formulário do Canvas. Abra cada formulário do Canvas e verifique se todos os documentos necessários associados aos requisitos têm o requisito de assinatura de PIC/EQR relacionado nos documentos.",
    151: "Verifique se todas as contas e divulgações significativas têm pelo menos uma assertiva.",
    152: "Abra cada formulário do Canvas e verifique se todos os documentos necessários associados aos requisitos têm as assinaturas de Preparador e Revisor. Somente assine os arquivos que você preparou ou revisou.",
    153: 'Navegue até o ajuste e use a opção "Adicionar evidência" para associar a evidência apropriada',
    154: "Navegue até o documento de estimativa e verifique se as estimativas de risco mais alto/mais baixo têm uma conta de estimativa relacionada. As estimativas de risco muito baixo devem ter pelo menos uma conta relacionada.",
    155: "Navegue até o documento de estimativa e verifique as contas relacionadas. Com base na documentação de auditoria, desrelacione a conta não estimada ou modifique-a para uma conta estimada.",
    156: "Navegue até o documento de estimativa e verifique as respostas lá.",
    157: "Navegue até o documento de estimativa e verifique se as estimativas de risco mais alto/mais baixo têm uma SCOT de estimativa relacionada. As estimativas de risco muito baixo devem ter pelo menos uma SCOT relacionada.",
    158: "Navegue até o documento da conta e verifique se há pelo menos uma estimativa de risco mais alto ou mais baixo relacionada.",
    159: "Navegue até o documento da conta e verifique se há pelo menos uma estimativa de risco mais alto ou mais baixo relacionada.",
    160: "Navegue até a planilha de estimativa para identificar SCOTs de estimativa que não tenham nenhuma estimativa relacionada. Com base na documentação de auditoria, modifique essas SCOTs para não estimar ou relacione as estimativas com esses SCOTs",
    161: "Navegue até o ajuste e verifique se a soma dos lançamentos de débito é igual à soma dos lançamentos de crédito.",
    162: "Navegue até o documento de estimativa ec e verifique se há pelo menos um risco significativo ou de fraude relacionado.",
    163: 'Use o passo a passo do ativador "Como limpar verificações de validação no EY Canvas" para resolver esta validação',
    164: 'Use o passo a passo do ativador "Como limpar verificações de validação no EY Canvas" para resolver esta validação',
    165: 'Use o passo a passo do ativador "Como limpar verificações de validação no EY Canvas" para resolver esta validação',
    166: "Navegue até o documento de estimativa e verifique os riscos relacionados. Com base na documentação de auditoria, desrelacione o risco significativo/de fraude ou atualize a categoria da estimativa para Risco mais alto."
};

export const validationChecksReportHeaderLabels = {
    validationType: "Tipo de validação",
    validationDescription: "Descrição da validação",
    itemName: "Nome do item",
    auditPhase: "Fase de Auditoria",
    additionalInformation: "Informação adicional",
    localization: "Localização",
    itemType: "Tipo de item",
    location: labels.location,
    count: "Contagem",
    validationCount: "Contagem de validações",
    itemID: "ID do item",
    validationTypeID: "ID do tipo de validação",
    category: "Categoria",
    auditPhaseID: "ID da Fase de Auditoria",
    entity: labels.filterEntitiesLabel
};


export const ReviewNotesReportHeaderLabel = {
    annotationID: "ID da anotação",
    assignToUserID: "Atribuído ao ID do usuário",
    assignedtoUser: labels.assignedTo,
    createUserID: "ID do autor",
    createdBy: "Autor",
    createdDate: "Criado em",
    dueDateLabel: "Data de vencimento",
    relatedEvidence: "Evidência Relacionada",
    reviewNote: labels.reviewNotesLabel,
    lastModifiedBy: "Última modificação por",
    modifyUserID: "Modificado por ID de usuário",
    lastModifiedOnLabel: "Última modificação em",
    priorityType: labels.priorityLabel,
    annotationParentID: "ID da anotação principal",
    referenceNumber: "Referência",
    relatedTasks: "Tarefa Relacionada",
    replies: labels.reply,
    reviewNoteStatus: labels.status,
    statusChangedByUserID: "Status alterado por ID de usuário",
    statusChangedBy: "Status alterado por",
    statusChangedDateLabel: "Status alterado por",
    startDateLabel: "Criado pela primeira vez (em UTC)",
    clearedDateLabel: "Última liberação (em UTC)",
    closedDateLabel: "Último fechamento (em UTC)",
    documentTypeID: "Data de alteração do status",
    childAnnotationID: "ID do tipo de documento"
};

export const taskDueDateCategoryIdLabels = {
    0: "Semanas anteriores",
    1: "Semana corrente",
    2: "Semana que vem",
    3: "Semanas futuras"
};

export const taskSummaryReportHeaderLabels = {
    engagementID: "ID do Engagement",
    taskID: "ID da tarefa",
    displayedTaskName: labels.TaskName,
    taskNamePrefix: "Prefixo da tarefa",
    taskNameSuffix: "Sufixo da tarefa",
    dueDateColumn: labels.taskDueDateHeader,
    dueDateWeek: labels.dueLabel,
    assignmentType: labels.assignmentType,
    assignmentTypeID: "ID do tipo de atribuição",
    assignmentName: labels.assignmentName,
    assignmentStatus: labels.taskAssigmentStatusHeader,
    reviewNoteAssignedOpen: "Notas de revisão atribuídas abertas",
    reviewNoteAssignedCleared: "Notas de revisão atribuídas limpas",
    reviewNoteAuthoredOpen: "Notas de revisão de autoria abertas",
    reviewNoteAuthoredCleared: "Notas de revisão de autoria limpas",
    taskStatus: labels.taskStatusLabel,
    taskStatusID: "ID do status da tarefa",
    taskType: labels.taskType,
    taskTypeID: "ID do tipo de tarefa",
    milestone: labels.filterMilestoneLabel,
    milestoneID: "ID do Milestone",
    isOverdueColumn: labels.Overdue,
    timephaseName: labels.timephase,
    relatedObjectName: "Objeto relacionado",
    relatedEntityID: "ID do objeto relacionado",
    openAssignmentsOverdue: "Abrir atribuições-atrasadas",
    openAssignmentsThisWeek: "Abrir atribuições-esta semana",
    openAssignmentsNextWeek: "Abrir atribuições-próxima semana",
    openAssignmentsTotal: "Abrir atribuições-total",
    inProgressAssignmentsOverdue: "Atribuições em andamento-atrasadas",
    inProgressAssignmentsThisWeek: "Atribuições em andamento-esta semana",
    inProgressAssignmentsNextWeek: "Atribuições em andamento-próxima semana",
    inProgressAssignmentsTotal: "Atribuições em andamento-total"
};

export const crtControlSummaryReportHeaderLabels = {
    scotID: "ID da SCOT",
    scotName: "SCOT",
    strategyTypeName: "Tipo de estratégia",
    wcgwID: "ID do WCGW",
    wcgwName: "WCGW",
    controlID: "ID do controle",
    controlName: "Controle",
    operatingEvaluation: "Avaliação operacional",
    assertions: "Assertivas",
    controlTypeName: "Tipo de controle",
    testingFormatted: "Seleção de teste",
    scotStrategy: "Estratégia da SCOT",
    itApplicationName: "Aplicativo de TI / SO relacionado",
    controlFrequencyTypeName: "Frequência",
    scotTypeID: "ID do tipo de SCOT",
    scotTypeName: "Tipo de SCOT",
    itAppType: "Aplicativo de TI/SO",
    lowerRiskControl: "Controle de risco menor "
};

export const trialBalanceReportHeaderLabels = {
    engagementID: "ID do engagement",
    trialBalanceID: "ID do balancete",
    trialBalanceTypeID: "ID do tipo de balancete",
    trialBalanceTypeName: "Nome do tipo de balancete",
    financialStatementID: "ID da demonstração financeira",
    financialStatementName: "Nome da demonstração financeira",
    financialStatementTypeID: "ID do tipo da demonstração financeira",
    financialStatementTypeName: "Nome do tipo da demonstração financeira",
    financialStatementSubTypeID: "ID do subtipo da demonstração financeira",
    financialStatementSubTypeName: "Nome do subtipo da demonstração financeira",
    analysisPeriodBalance: "Saldo da data de análise",
    comparativePeriodBalance: "Saldo de data comparativo",
    analysisComparativeBalanceChange: "Análise comparativa de mudança de saldo",
    analysisComparativeBalanceChangePercent: "Análise percentual de alteração comparativa do saldo",
    secondComparativePeriodBalance: "Saldo da segunda data comparativa",
    analysisSecondComparativeBalanceChange: "Análise da segunda mudança de saldo comparativo",
    analysisSecondComparativeBalanceChangePercent: "Análise da segunda porcentagem de alteração comparativa do saldo",
    parentFinancialStatementID: "ID do demonstrativo financeiro principal",
    displayOrder: "Ordem de exibição",
    eyCanvasAccountName: "Nome da conta do EY Canvas",
    relatedEntities: "Entidades relacionadas"
};

export const taskSourceTypes = {
    1: labels.internal,
    2: labels.external
};

export const taskNatureTypes = {
    1: labels.testOfDetail,
    2: labels.substantiveAnalyticalProcedure,
    3: labels.testOfControl
};

export const priorityTypesCollaboration = [{
        value: 1,
        label: "Normal"
    },
    {
        value: 3,
        label: "Alto"
    },
    {
        value: 4,
        label: "Crítico"
    }
];

export const StatementType = [{
    id: 1,
    value: "Demonstração do resultado"
}, {
    id: 2,
    value: "Balanço patrimonial"
}, {
    id: 3,
    value: "Ambos"
}];

export const AccountTypes = [{
        id: 1,
        accountTypeName: "Significante"
    },
    {
        id: 2,
        accountTypeName: "Risco limitado"
    },
    {
        id: 3,
        accountTypeName: "Insignificante"
    },
    {
        id: 4,
        accountTypeName: "Outro"
    },
    {
        id: 5,
        accountTypeName: "Divulgações significativas"
    }
];

export const ITAppSOAttributes = [{
    id: 1,
    value: "Seleção de teste"
}, {
    id: 2,
    value: "Aplicativo de TI / SO relacionado"
}, {
    id: 3,
    value: "SCOTs relacionadas"
}, {
    id: 4,
    value: "Estratégia de SCOT Relacionada"
}, {
    id: 5,
    value: "Tipo de SCOT relacionada"
}];

export const notesEditorLabels = {
    addNoteButtonLabel: reviewNoteModalLabels?.addNewReviewNoteButtonText,
    saveNoteButtonLabel: labels.saveLabel,
    messagePlaceholder: labels.addNewNoteModalTitle,
    messagePlaceholderReply: reviewNoteModalLabels?.replyInputPlaceholder,
    messagePlaceholderEdit: reviewNoteModalLabels?.noteInputPlaceholderEdit,
    messagePlaceholderReplyEdit: reviewNoteModalLabels?.replyInputPlaceholderEdit,
    addReplyButtonLabel: reviewNoteModalLabels?.reply,
    characters: labels.characters,
    of: labels.of,
    formRequired: labels.required,
    formMaxLength: labels.formMaxLength,
    toFieldLabel: labels.assignedTo,
    priorityFieldLabel: labels.rnhPriority,
    dueDateFieldLabel: labels.dueDate,
    voiceNoteButtonLabel: labels.voiceNoteButtonLabel,
    stopRecordingButtonLabel: labels.stopRecordingButtonLabel,
    cancelButtonLabel: labels.cancelButtonLabel,
    noResultsFound: labels.noResultsFound,
    microphoneBlockedMessage: labels.microphoneBlockedMessage,
    microphoneBlockedOnVideoMessage: labels.microphoneBlockedOnVideoMessage,
    notInMainWindowVoice: labels.notInMainWindowVoice,
    notInMainWindowScreen: labels.notInMainWindowScreen,
    voiceNoteNotAvailable: "Nota de voz e gravação de tela não estão disponíveis na visualização de gaveta. Mude para a visualização em tela inteira para usar esses recursos.",
    deleteButtonTitle: labels.voiceNoteCommentDeleteLabel,
    playButtonTitle: labels.voiceNoteCommentPlayLabel,
    pauseButtonTitle: labels.voiceNoteCommentStopLabel,
    screenRecord: labels.screenRecord,
    playbackReview: labels.playbackReview,
    close: labels.reviewNotesModalClose
};


export const noteModalLabels = {
    ...notesEditorLabels,
    closeButton: labels.reviewNotesModalClose,
    closed: labels.closed,
    open: labels.open,
    cleared: labels.cleared,
    allNotes: labels.allNotes,
    myNotes: labels.myNotes,
    assignedToMe: labels.assignedToMe,
    noNotesFound: reviewNoteModalLabels?.noNotesFound,
    noNotesFoundInstructional: reviewNoteModalLabels?.noNotesAssociatedWithDocumentLabel,
    assignedTo: labels.assignedTo,
    dueDate: labels.dueDate,
    edit: labels.edit,
    delete: labels.delete,
    clear: labels.clear,
    reopen: labels.reopen,
    close: labels.closeTitle,
    reply: labels.reply,
    confirm: labels.confirm,
    cancel: labels.cancelButtonLabel,
    deleteModalHeaderNote: reviewNoteModalLabels?.deleteIconModalTitleLabel,
    deleteModalHeaderReply: reviewNoteModalLabels?.deleteReplyIconModalTitle,
    deleteModalTextNote: reviewNoteModalLabels?.deleteIconModalConfirmMessageParent,
    deleteModalTextReply: reviewNoteModalLabels?.deleteIconModalConfirmMessage,
    showMore: reviewNoteModalLabels?.showMore,
    showLess: reviewNoteModalLabels?.showLess,
    view: labels.view,
    notSelected: labels.notSelectedText,
    deleteButtonTitle: labels.voiceNoteCommentDeleteLabel,
    playButtonTitle: labels.voiceNoteCommentPlayLabel,
    pauseButtonTitle: labels.voiceNoteCommentStopLabel
};

export const EntitiesLabels = {
    close: "Fechar",
    cancel: "Cancelar",
    repNoRecordMessage: "Nenhum resultado encontrado",
    edit: "Editar",
    delete: "Excluir",
    actions: "Ações",
    show: "Mostrar",
    first: "Primeira página",
    last: "Última página",
    prev: "Página anterior",
    next: "Próxima página",

    [Entity.Account]: {
        manageEntity: "Gerenciar contas e divulgações",
        searchEntity: "Pesquisar contas",
        createEntity: "Nova conta",
        entityName: "conta",
        entityNameCaps: "Conta",
        entityNamePlural: "Contas",
        placeholderText: "Crie novas contas e divulgações ou edite e exclua contas e divulgações existentes abaixo.",
        deleteConfirmLabel: "Tem certeza de que deseja excluir esta conta? Todos os relacionamentos existentes serão removidos. Esta ação não pode ser desfeita."
    },
    [Entity.Estimate]: {
        manageEntity: "Gerenciar estimativa",
        searchEntity: "Estimativa de pesquisa",
        createEntity: "Nova estimativa",
        entityName: "estimativa",
        entityNameCaps: "Estimativa",
        entityNamePlural: "Estimativas",
        placeholderText: "Crie novas estimativas ou edite e exclua as estimativas existentes abaixo.",
        deleteConfirmLabel: "Tem certeza de que deseja excluir esta estimativa? Todos os relacionamentos existentes serão removidos. Esta ação não pode ser desfeita."
    },
    [Entity.Risk]: {
        manageEntity: "Gerenciar riscos",
        searchEntity: "Pesquisar riscos",
        createEntity: "Novo risco",
        entityName: "risco",
        entityNameCaps: "Risco",
        entityNamePlural: "Riscos",
        placeholderText: "Criar novos riscos ou editar e excluir os riscos existentes abaixo.",
        deleteConfirmLabel: "Tem certeza de que deseja excluir este risco? Todos os relacionamentos existentes serão removidos. Esta ação não pode ser desfeita."
    },
    [Entity.STEntity]: {
        manageEntity: "Gerenciar entidades",
        searchEntity: "Pesquisar entidades",
        createEntity: "Nova entidade",
        entityName: "entidade",
        entityNameCaps: "Entidade",
        entityNamePlural: "Entidades",
        placeholderText: "Crie novas entidades ou edite e exclua as entidades existentes abaixo.",
        deleteEntity: "Excluir entidade",
        deleteConfirmLabel: "Tem certeza de que deseja excluir esta entidade? Todos os relacionamentos existentes serão removidos. Esta ação não pode ser desfeita."
    },
    [Entity.Control]: {
        manageEntity: "Gerenciar controles",
        searchEntity: "Pesquisar controles",
        createEntity: "Novo controle",
        entityName: "controle",
        entityNameCaps: "Controle",
        entityNamePlural: "Controles",
        placeholderText: "Crie novos controles ou edite e exclua os controles existentes abaixo.",
        deleteEntity: "Excluir controle",
        deleteConfirmLabel: "Tem certeza de que deseja excluir este controle? Todos os relacionamentos existentes serão removidos. Esta ação não pode ser desfeita."
    },
    [Entity.SCOT]: {
        manageEntity: "Gerenciar SCOTs",
        searchEntity: "Pesquisar SCOTs",
        createEntity: "Nova SCOT",
        entityName: "SCOT",
        entityNameCaps: "SCOT",
        entityNamePlural: "SCOTs",
        placeholderText: "Crie novas SCOTs ou edite e exclua as SCOTs existentes abaixo.",
        deleteEntity: "Excluir SCOT",
        deleteConfirmLabel: "Tem certeza de que deseja excluir esta SCOT? Todos os relacionamentos existentes serão removidos. Esta ação não pode ser desfeita."
    },
    [Entity.ITApplication]: {
        manageEntity: "Gerenciar aplicativos de TI",
        searchEntity: "Procurar",
        createEntity: "Novo aplicativo de TI",
        entityName: "Aplicativo de TI",
        entityNameCaps: "Aplicativo de TI",
        entityNamePlural: "Aplicativos de TI",
        placeholderText: "Crie novos aplicativos de TI ou edite e exclua os aplicativos de TI existentes abaixo.,",
        deleteEntity: "Excluir aplicativo de TI",
        deleteConfirmLabel: "Tem certeza de que deseja excluir este aplicativo de TI? Todos os relacionamentos existentes serão removidos. Esta ação não pode ser desfeita."
    },
    [Entity.TaskSection]: {
        manageEntity: "Gerenciar grupos de tarefas",
        searchEntity: "Grupo de tarefas de pesquisa",
        createEntity: "Novo grupo de tarefas",
        entityName: "grupo de tarefas",
        entityNameCaps: "Grupo de tarefas",
        entityNamePlural: "Grupos de tarefas",
        placeholderText: "Crie um novo grupo de tarefas ou edite e exclua o grupo de tarefas existente abaixo.",
        deleteEntity: "Excluir grupo de tarefas",
        deleteConfirmLabel: "Tem certeza de que deseja excluir o ajuste selecionado? Esta ação não pode ser desfeita. "
    },
    [Entity.WCGW]: {
        manageEntity: "Gerenciar WCGWs",
        searchEntity: "Pesquisar WCGWs",
        createEntity: "Novos WCGWs",
        entityName: "WCGW",
        entityNameCaps: "WCGW",
        entityNamePlural: "WCGWs",
        placeholderText: "Crie um novo WCGW ou edite e exclua o WCGW existente abaixo.",
        deleteEntity: "Deletar WCGWs",
        deleteConfirmLabel: "Tem certeza de que deseja excluir este WCGW? Todos os relacionamentos existentes serão removidos. Esta ação não pode ser desfeita."
    },
    [Entity.Misstatement]: {
        manageEntity: "Gerenciar ajustes",
        searchEntity: "Ajustes de pesquisa",
        createEntity: "Novo ajuste",
        entityName: "ajuste",
        entityNameCaps: "Ajuste",
        entityNamePlural: "Ajustes",
        placeholderText: "Crie novos ajustes ou edite e exclua ajustes existentes abaixo.",
        deleteConfirmLabel: "Tem certeza de que deseja excluir o ajuste selecionado? Esta ação não pode ser desfeita. "
    },
    [Entity.AdjustmentValidation]: {
        manageEntity: "Gerencie ajustes com verificações de validações",
        searchEntity: "Procurar",
        entityName: "ajustes",
        entityNameCaps: "Ajustes",
        entityNamePlural: "Ajustes",
		placeholderText: 'Cada ajuste deve ter pelo menos uma evidência relacionada e para cada ajuste a soma dos lançamentos à débito deve ser igual à soma dos lançamentos à crédito. Os ajustes a seguir apresentam um ou mais problemas de validação. Clique em <b>"Editar"</b> para abordá-los.',
        deleteConfirmLabel: "Tem certeza de que deseja excluir o ajuste selecionado? Esta ação não pode ser desfeita.",
        adjustmentHeader: "Ajuste",
        validationTyeHeader: "Tipo de validação",
        validationTypeAmtMissmatch: "A soma das entradas à débito não é igual à soma das entradas à crédito",
        validationTypeNoEvidence: "Nenhuma evidência relacionada"
    },
    [Entity.SampleItem]: {
        manageEntity: "Gerenciar tags de amostra",
        searchEntity: "Pesquisar tags",
        createEntity: "Nova tag",
        createManageTagEntity: "Gerenciar grupos de tags",
        entityName: "Tag",
        entityNamePlural: "Tags",
        entityNameForTagGroupPlural: "Grupos de tags",
        placeholderText: "Crie novas tags ou edite e exclua as tags existentes abaixo."
    },
    [Entity.SampleTagGroups]: {
        manageEntity: "Gerenciar grupos de tags de amostra",
        searchEntity: "Procurar",
        createEntity: "Novo grupo de tags",
        entityName: "Grupo de tags",
        entityNameCaps: "Grupo de tags",
        entityNamePlural: "Grupos de tags",
        placeholderText: "Crie novos grupos de tags de amostra ou edite e exclua os grupos de tags de amostra existentes abaixo."
    }
};

export const executionType = [{
        id: 1,
        label: '',
        toolTip: '',
        value: "Neste engagement"
    },
    {
        id: 2,
        label: 'CT',
        toolTip: "Procedimentos em outro(s) engagement(s) [somente PT]",
        value: "Em outro(s) engagement(s) [somente PT]"
    },
    {
        id: 3,
        label: 'PT/CT',
        toolTip: "Procedimentos neste e em outro(s) engagement(s) [somente PT]",
        value: "Neste e em outro(s) engagement(s) [apenas PT]"
    }
];

export const AccountType = [{
        id: 1,
        accounttypename: "Conta significativa"
    },
    {
        id: 2,
        accounttypename: "Conta de risco limitado"
    },
    {
        id: 3,
        accounttypename: "Conta insignificante"
    },
    {
        id: 4,
        accounttypename: "Outra conta"
    },
    {
        id: 5,
        accounttypename: "Divulgação significativa"
    }
];

export const statementTypes = [{
        id: 1,
        name: "Demonstração do resultado"
    },
    {
        id: 2,
        name: "Balanço patrimonial"
    },
    {
        id: 3,
        name: "Ambos"
    }
];

export const CreateEditAccountLabels = {
    createModalDescription: "Insira os detalhes da nova conta abaixo e selecione '<b>{0}</b>' para finalizar. Para criar outra conta, selecione '<b>{1}</b>'.",
    editModalDescription: "Edite os detalhes da conta abaixo e selecione '<b>{0}</b>' para finalizar.",
    close: "Fechar",
    cancel: "Cancelar",
    yes: "Sim",
    no: "Não",
    createAccount: "Nova conta",
    editAccount: "Editar conta",
    delete: "Excluir",
    save: "Salvar",
    saveAndCloseLabel: "Salvar e fechar",
    saveAndCreateLabel: "Salvar e criar outro",
    accountNameLabel: "Nome da conta (obrigatório)",
    accountDesignationLabel: "Designação",
    accountExecutionTypeLabel: "Em qual engagement do Canvas os procedimentos para esta conta serão realizados e documentados?",
    accountEstimateLabel: "Esta conta foi afetada por uma estimativa?",
    accountStatementTypeLabel: "Tipo de divulgação",
    pspIndexDropdownLabel: "Índice PSP (obrigatório, selecione até 5)",
    removePSPIndexLabel: "Remover índice PSP",
    assertionsLabel: "Selecione assertivas relevantes",
    assertionOptions: assertions,
    executionTypeOptions: executionType,
    accountTypeOptions: AccountType,
    statementTypeOptions: statementTypes,
    confirm: "Confirmar",
    pspIndexErrorMsg: "Obrigatório",
    assertionWarningMessage: "Você não pode fazer alterações em assertivas que tenham um risco significativo, ou risco de fraude, ou risco de distorção relevante ou uma estimativa relacionada. Você precisa remover essas relações primeiro.",
    confirmChanges: "Confirmar alterações",
    executionTypeWarningMessage: "As alterações que você salvar nesta conta afetarão as assertivas e PSPs existentes, os links serão quebrados. Tem certeza de que deseja prosseguir? Essa ação não pode ser desfeita.",
    contentUpdateToastMessage: "A atualização de conteúdo está disponível para {0}. Inicie a atualização de conteúdo na página Atualização de conteúdo.",
    assertionsRequired: "Pelo menos uma assertiva deve ser selecionada",
    pspIndexDisabledLabel: "Selecione até cinco índices PSP. Desmarque uma ou mais opções para continuar.",
    newSignificantDisclosure: "Nova divulgação significativa",
    noOptionsMessage: "Nenhum resultado encontrado",
    accountNameErrorMsg: "Obrigatório"
};

export const CreateMestLabels = {
    createModalTitle: "Nova entidade",
    createModalDescription: "Insira a entidade abaixo e selecione '<b>{0}</b>' para finalizar. Para criar outra entidade, selecione '<b>{1}</b>'. As entidades são a forma como planejamos a abordagem de auditoria e podem não ser entidades legais mas sim unidades de negócio ou outras combinações.",
    close: "Fechar",
    cancel: "Cancelar",
    save: "Salvar",
    saveAndCloseLabel: "Salvar e fechar",
    saveAndCreateLabel: "Salvar e criar outro",
    entityNameLabel: "Nome da entidade",
    entityStandardIndexLabel: "Índice padrão da entidade",
    entityDescriptionLabel: "Descrição da entidade (opcional)",
    entityNameErrorMsg: "Obrigatório",
    entityStandardIndexErrorMsg: "Obrigatório"
}

export const CreateEditSCOTLabels = {
    createModalTitle: "Nova SCOT",
    editModalTitle: "Editar SCOT",
    createModalDescription: "Insira os novos detalhes da SCOT abaixo e selecione '<b>{0}</b>' para finalizar. Para criar outro SCOT, selecione '<b>{1}</b>'.",
    editModalDescription: "Edite os detalhes da SCOT abaixo e selecione '<b>{0}</b>' para finalizar.",
    close: "Fechar",
    cancel: "Cancelar",
    save: "Salvar",
    saveAndCloseLabel: "Salvar e fechar",
    saveAndCreateLabel: "Salvar e criar outro",
    scotNameLabel: "Nome da SCOT (obrigatório)",
    scotStrategyLabel: "Estratégia da SCOT",
    scotTypeLabel: "Tipo da SCOT",
    scotTypeOptions: scotTypes,
    hasEstimateLabel: "Esta SCOT foi impactada por uma estimativa?",
    itAPPUsedLabel: "Nenhum aplicativo de TI usado",
    routine: "Rotineira",
    nonRoutine: "Não rotineira",
    controls: "Controles",
    substantive: "Substantivo",
    yes: "Sim",
    scotNameErrorMsg: "Obrigatório",
    remove: "Remover",
    noOptionsMessage: "Nenhum resultado encontrado",
    wtDetailPrefix: "<p>Para todos as SCOTs rotineiras e não rotineiras e processos de divulgação significativos, confirmamos nosso entendimento a cada período, realizando procedimentos de Walkthrough. Além disso, para auditorias do PCAOB, realizamos procedimentos Walkthrough para as SCOTs de estimativa.<br/>Para todas as SCOTs, quando adotamos uma estratégia de confiança em controles, e para controles que abordam riscos significativos, confirmamos que os controles relevantes foram adequadamente projetados e implementados. Confirmamos que nossa decisão de adotar uma estratégia de confiança em controles ainda é apropriada.<br/><br/>Concluímos que nossa documentação descreve com precisão a operação da SCOT e identificamos todos os WCGWs apropriados, incluindo os riscos que surgem do uso de TI e controles relevantes (quando aplicável).<br/><br/> Para SCOT de estimativas, quando usamos uma estratégia apenas substantiva, determinamos se nosso entendimento da SCOT de estimativas é apropriado com base em nossos procedimentos substantivos.</p>",
	disabledTabTooltipMessage: 'Desmarque "Nenhum aplicativo de TI usado" para relacionar aplicativos de TI',
    itAppLabels: {
        tabLabel: "Aplicativos de TI",
        dropdownLabel: "Relacionar Aplicativos de TI",
        noRelatedItems: "Nenhum aplicativo de TI relacionado",
        itApplications: "Aplicativos de TI"
    },
    soLabels: {
        tabLabel: "SOs",
        dropdownLabel: "Relacionar serviços de organizações",
        noRelatedItems: "Nenhum serviços de organizações relacionados",
        serviceOrganizations: "Serviços de organização "
    }
};

export const CreateEditWCGWLabels = {
    wcgwName: "Nome do WCGW (obrigatório)",
    editWCGW: "Editar WCGW",
    editTheWCGW: "Edite os detalhes do WCGW abaixo e selecione '<b>{0}</b>' para finalizar.",
    createNewWCGW: "Insira os novos detalhes do WCGW abaixo e selecione '<b>{0}</b>' para finalizar. Para criar outro WCGW, selecione '<b>{1}</b>'.",
    createEditWCGWModelScot: "SCOT",
    newWCGWTitel: "New WCGW",
    editWCGWSave: "Salvar",
    editWCGWClose: "Cancelar",
    closeTitle: "Fechar",
    wcgwNameIsRequired: "Obrigatório",
    saveAndCloseLabel: "Salvar e fechar",
    saveAndCreateLabel: "Salvar e criar outro"
};

export const controlFrequencyTypes = [{
        value: 1,
        label: "Muitas vezes por dia"
    },
    {
        value: 2,
        label: "Diariamente"
    },
    {
        value: 3,
        label: "Semanalmente"
    },
    {
        value: 4,
        label: "Mensalmente"
    },
    {
        value: 5,
        label: "Trimestralmente"
    },
    {
        value: 6,
        label: "Anualmente"
    },
    {
        value: 8,
        label: "Outro"
    }
];

export const controlTypes = [{
        value: 1,
        label: "Controle de aplicativos de TI"
    },
    {
        value: 2,
        label: "Controle manual dependente de TI"
    },
    {
        value: 3,
        label: "Prevenção manual"
    },
    {
        value: 4,
        label: "Detecção manual"
    }
];

export const CreateEditControlLabels = {
    createModalTitle: "Novo controle",
    editModalTitle: "Editar controle",
    close: "Fechar",
    cancel: "Cancelar",
    save: "Salvar",
    saveAndCloseLabel: "Salvar e fechar",
    saveAndCreateLabel: "Salvar e criar outro",
    controlNameLabel: "Nome do controle (obrigatório)",
    frequency: "Frequência",
    controlType: "Tipo de controle",
    frequencyTypeOptions: controlFrequencyTypes,
    controlTypeOptions: controlTypes,
    designEffectiveness: "Efetividade do desenho",
    operatingEffectiveness: "Efetividade operacional",
    testingLabel: "Teste",
    lowerRiskLabel: "O controle é de risco mais baixo?",
    ITDMControlSubstantiveTestingOptionLabel: "A parte automatizada deste controle ITDM é apenas o uso de relatório(s) gerado(s) pelo sistema que são testados substantivamente",
    effective: "Efetivo",
    ineffective: "Inefetivo",
    yes: "Sim",
    no: "Não",
    required: "Obrigatório",
    remove: "Remover",
    noOptionsMessage: "Nenhum resultado encontrado",
	disabledTabTooltipMessage: 'Selecione "Tipo de controle" como "Controle de aplicativos de TI" ou "Controle manual dependente de TI" para relacionar aplicativos de TI',
    itAppLabels: {
        tabLabel: "Aplicativos de TI",
        dropdownLabel: "Relacionar Aplicativos de TI",
        noRelatedItems: "Nenhum aplicativo de TI relacionado",
        itApplications: "Aplicativos de TI"
    },
    soLabels: {
        tabLabel: "SOs",
        dropdownLabel: "Relacionar serviços de organizações",
        noRelatedItems: "Nenhum serviços de organizações relacionados",
        serviceOrganizations: "Serviços de organização "
    },
    controlNameErrorMsg: "Obrigatório",
    createModalDescriptionLabel: "Insira os detalhes do novo controle abaixo e selecione '<b>{0}</b>' para finalizar. Para criar outro controle, selecione '<b>{1}</b>'.",
    editModalDescriptionLabel: "Edite os detalhes do controle abaixo e selecione '<b>{0}</b>' para finalizar.",
    wcgwLabel: "WCGW"
};

export const CreateEditITApplicationLabels = {
    close: "Fechar",
    cancel: "Cancelar",
    yes: "Sim",
    no: "Não",
    delete: "Excluir",
    save: "Salvar",
    closeTitle: "Fechar",
    saveAndCloseLabel: "Salvar e fechar",
    saveAndCreateLabel: "Salvar e criar outro",
    iTApplicationNameLabel: "Nome da aplicação de TI (obrigatório)",
    iTSOApplicationNameLabel: "Nome da organização de serviço",
    newITApplicationLabel: "Novo aplicativo de TI",
    newITSOApplicationLabel: "Nova organização de serviços",
    editITApplicationLabel: "Editar aplicativo de TI",
    confirm: "Confirmar",
    confirmChanges: "Confirmar alterações",
    noOptionsMessage: "Nenhum resultado encontrado",
    iTAppNameErrorMsg: "Obrigatório",
    iTSOAppNameErrorMsg: "Obrigatório",
    controls: "Controles",
    substantive: "Substantivo",
    remove: "Remover",
    iTApplicationStrategyLabel: "Estratégia do aplicativo de TI",
    SCOTsLabel: "Nomes das SCOTs",
    StrategyLabel: "Estratégia",
    ControlsLabel: "Controlar nomes",
    ControlTypeLabel: "Tipo",
    addDescriptionLabel: "Insira os detalhes do novo aplicativo de TI abaixo e selecione '<b>{0}</b>' para finalizar. Para criar outro aplicativo de TI, selecione '<b>{1}</b>'.",

    editDescriptionLabel: "Edite os detalhes do aplicativo de TI abaixo e selecione '<b>{0}</b>' para finalizar.",

    addSODescriptionLabel: "Insira os detalhes da nova organização de serviço abaixo e selecione '<b>Salvar e fechar</b>' para finalizar. Para criar outra organização de serviços, selecione '<b>Salvar e criar outra</b>'.",

    scotErrorMessage: "A SCOT pode não ser independente do aplicativo de TI, uma vez que existem controles relacionados.",
    SCOTsLabels: {
        tabLabel: "SCOTs",
        dropdownLabel: "Relacionar SCOTs",
        noRelatedItems: "Nenhuma SCOT relacionada"
    },
    ControlsLabels: {
        tabLabel: "Controles",
        dropdownLabel: "Relacionar controles",
        noRelatedItems: "Nenhum controle relacionado"
    },
    strategyType: {
        1: "Controles",
        2: "Substantivo",
        3: "Confiar",
        4: "Não Confiar"
    },
    controlType: {
        1: "Aplicativo de TI",
        2: "Manual Dependente de TI",
        3: "Prevenção manual",
        4: "Detecção manual"
    }
};

export const groupComponentAccountReportHeaderLabels = {
    primaryEngagementId: "ID do engagement",
    gaScopeName: "Escopo",
    gaComponentId: "Id co Componente GA",
    shortName: "Nome do componente",
    pocText: "Ponto de contato",
    accountId: "ID da conta",
    accountName: "Nome da conta",
    accountType: "Designação de conta",
    knowledgeAssertion: "Assertiva",
    inherentRiskType: "Risco inerente",
    riskId: "ID de risco",
    riskType: "Tipo de risco",
    riskName: "Nome do risco",
    isHigherRiskText: "É um risco mais alto"
};

export const AccountTypeIDs = {
    1: "Conta significativa",
    2: "Conta de risco limitado",
    3: "Conta insignificante",
    4: "Conta - Outra",
    5: "Divulgação Significativa"
};

export const InherentRiskTypeIDs = {
    1: "Mais alto",
    2: "Mais baixo",
    3: "Muito baixo"
};

export const riskTypeIDs = {
    1: "Riscos significativos",
    2: "Riscos de fraude",
    3: "Riscos de distorção material"
};

export const riskTypeIDsShortForm = {
    1: "RS",
    2: "RF",
    3: "RDM"
};

export const ControlRiskTypeIDs = {
    1: "Confiar",
    2: "Não confiar",
    3: "Testar MP"
};

export const knowledgeAssertions = {
    1: "Completude",
    2: "Existência",
    3: "Valorização",
    4: "Direitos e obrigações",
    5: "Apresentação e Divulgação",
    6: "Completude",
    7: "Ocorrência",
    8: "Mensuração",
    9: "Apresentação e Divulgação",
    10: "Completude",
    11: "Existência/Ocorrência",
    12: "Mensuração/Valorização",
    13: "Direitos e obrigações",
    14: "Apresentação e Divulgação"
};

export const gaInstructionStatuslabels = {
    0: "Indefinido",
    [instructionStatus.notSent]: "Não enviado",
    [instructionStatus.pending]: "Pendente",
    [instructionStatus.accepted]: "Aceito",
    [instructionStatus.rejected]: "Devolvido",
    [instructionStatus.systemError]: "Erro no sistema",
    [instructionStatus.expired]: "Expirado",
    [instructionStatus.sent]: "Enviado",
    [instructionStatus.unlinked]: "Desvinculado",
    [instructionStatus.queued]: "Enfileirados"
};

export const financialStatementTypeLabels = {
    [financialStatementType.Asset]: "Ativo",
    [financialStatementType.CurrentAsset]: "Ativo Circulante",
    [financialStatementType.NonCurrentAsset]: "Ativo Não Circulante",
    [financialStatementType.Liability]: "Passivo",
    [financialStatementType.CurrentLiability]: "Passivo Circulante",
    [financialStatementType.NonCurrentLiability]: "Passivo não circulante",
    [financialStatementType.Equity]: "Patrimônio líquido",
    [financialStatementType.Revenue]: "Receita",
    [financialStatementType.Expense]: "Despesa",
    [financialStatementType.NonOperatingIncome]: "Receitas/(despesas) não operacionais",
    [financialStatementType.OtherComprehensiveIncome]: "Outros resultados abrangentes",
    [financialStatementType.Other]: "Outro",
    [financialStatementType.AccountType]: "tipo da conta",
    [financialStatementType.AccountSubType]: "Subtipo da conta",
    [financialStatementType.AccountClass]: "Classe da conta",
    [financialStatementType.AccountSubClass]: "Subclasse da conta",
    [financialStatementType.NetIncomeExpense]: "(Receita)/despesa líquida",
    18: "Conta GL"
};

export const trialBalanceTypeLabels = {
    [trialBalanceType.Planning]: "Planejamento"
};

export const createEditRiskModalLabels = {
    createModalDescription: "Insira os novos detalhes do risco abaixo e selecione '<b>{0}</b>' para finalizar. Para criar outro risco, selecione '<b>{1}</b>'.",
    editModalDescription: "Edite os detalhes do risco abaixo e selecione <b>{0}</b> para finalizar.",
    close: "Fechar",
    cancel: "Cancelar",
    createRisk: "Novo risco",
    editRisk: "Editar risco",
    riskType: "Tipo de risco (obrigatório)",

    riskTypeOptions: [{
            value: 1,
            label: "Risco significativo"
        },
        {
            value: 2,
            label: "Risco de fraude"
        },
        {
            value: 3,
            label: "Risco de distorção relevante"
        }
    ],
    save: "Salvar",
    saveAndCloseLabel: "Salvar e fechar",
    saveAndCreateLabel: "Salvar e criar outro",
    riskNameLabel: "Nome do risco (obrigatório)",
    relatedAccountsAssertionsLabel: "Contas e assertivas relacionadas (opcional)",
    relateAccounts: "Relacionar contas e assertivas (opcional)",
    assertionsLabel: "Selecione assertivas relevantes",
    riskNameErrorMsg: "Obrigatório",
    riskTypeErrorMsg: "Obrigatório",
    assertionOptions: assertions,
    removeAccountLabel: "Remover conta",
    required: "Obrigatório",
    assertionsRequired: "Pelo menos uma assertiva deve ser selecionada"
};

export const activityTypeLabels = {
    104: "Adicionado",
    105: "Removido"
};

export const superModalNavigationLabels = {
    identifyAccountsAndDisclosures: "Identificar contas e divulgações",
    identifySCOTs: "Identificar SCOTs e relacionar com as contas",
    determineSCOTStrategy: "Determinar a estratégia da SCOT",
    identifyWCGWAndControls: "Identifique WCGWs e controles",
    selectControlToTest: "Selecione os controles para testar",
    identifyRisks: "Identifique os riscos",
    relateWCGWsToAssertions: "Relacionar WCGWs a assertivas",
    relateRisksToWCGWs: "Relacionar riscos aos WCGWs",
    determineCRA: "Determinar o CRA",
    timephase: "Fase de tempo",
    SCOTWT: "Criar WT",
    controlTOC: "Criar TOC",
    ITProcessUDP: "Criar UDP",
    ITGC_ITSP_TOC_OSP: "Criar TI TOC/OSP",
    accountPSP: "Criar PSP",
    accountOSP: "Criar OSP",
    relateWCGWTo: "WCGW relacionado a",
    relatedWCGWToTask: "Relacionar WCGW com a tarefa",
    respondToSignificant_fraudRisks: "Responder a riscos significativos/de fraude",
    OST: "OST",
    accountSummary: "Resumo da conta",
    SCOTSummary: "Resumo da SCOT",
    ITSummary: "Resumo de TI",
    understandITProcesses: "Entenda os processos de TI",
    evaluateIT: "Avaliação do TI",
    CRASummary: "Resumo do CRA",
    auditPlan: "Plano de auditoria",
    workplanSummary: "Resumo do plano de trabalho",
    buildSteps: "Etapas de construção",
    ITApplicationsAndITProcesses: "Aplicativos de TI e processos de TI",
    workPlan: "Plano de trabalho",
    accounts: "Contas",
    scots: "SCOTs",
    cra: "CRA",
    openInNewTab: "Abrir em nova aba"
}

export const auditPlanITProcessLabels = {
    itProcess: "Processo de TI",
    itProcesses: "Processos de TI",
    tasks: "Tarefas",
    sectionHeading: "Processo de TI e tarefas relacionadas de compreensão do processo (UDP)",
    subHeader: "Entenda o processo de TI",
    visualDistinctMessage: "Cada processo de TI deve ter pelo menos um UDP relacionado. Crie {0} ou {1}.",
    addUdp: "Novo UDP",
    relatedUdp: "Relacionar UDPs",
    toggleFilter: "Mostrar apenas processos de TI sem qualquer UDP relacionado",
    noResultsFound: "Nenhum resultado encontrado",
    taskTitle: "Entenda e documente o processo de TI: {0}",
    taskDescription: "Documente nosso entendimento do processo de TI. Anexe o formulário relevante como suporte para apoiar a nossa compreensão do processo de TI. Quando os ITGCs aparecerem na seção Atributos da Tarefa, execute procedimentos de walkthrough para confirmar nosso entendimento dos ITGCs e avaliar seu desenho e implementação. Anexe evidências de nossos procedimentos.",
    noRecordsAvailable: "Nenhum processo de TI disponível",
    unrelatedLabel: "Ver UDPs não relacionados",
    unrelatedModalHeader: "Tarefas UDP não relacionadas",
    noUnrelatedTaskPlaceholder: "Nenhuma tarefa UDP não relacionada disponível",
    noTaskselectedLabel: "Pelo menos uma tarefa deve ser selecionada para exclusão",
    relateITProcessTaskTitle: "Relacionar UDPs ao processo de TI",
    understandITProcesses: "Entenda os processos de TI",
    unrelatedTasksMustBeAssociated: "As tarefas não relacionadas devem ser associadas a uma processo de TI ou excluídas."
}

export const noEvidenceReferencedReasonsLabels = {
    immaterialReason: "Imaterial: Saldo/atividade não atende ao escopo de teste - investigação adicional dispensada",
    strikethroughMText: "m",
    waivedReason: "Dispensado: Valor abaixo do SAD - investigação adicional dispensada",
    strikethroughWText: "w"
}

export const auditPlanScotListLabels = {
    scot: "SCOT",
    scots: "SCOTs",
    tasks: "Tarefas",
    sectionHeading: "SCOTs e tarefas de walkthrough relacionados",
    subHeader: "Tarefas de walkthrough",
    visualDistinctMessage: "Cada SCOT deve ter pelo menos um passo a passo relacionado. Crie {0} ou {1}.",
    newWT: "Novo WT",
    relatedWT: "Relacionar WTs",
    toggleFilter: "Mostrar apenas SCOTs sem qualquer WT relacionado",
    noResultsFound: "Nenhum resultado encontrado",
    noRecordsAvailable: "Nenhuma SCOTs disponível",
    relateScotTaskTitle: "Relacionar WTs com a SCOT",
    taskTitle: "Walkthrough: {0}",
    taskDescription: "<p>Para todos as SCOTs rotineiras e não rotineiras e processos de divulgação significativos, confirmamos nosso entendimento a cada período, realizando procedimentos de Walkthrough. Além disso, para auditorias do PCAOB, realizamos procedimentos Walkthrough para as SCOTs de estimativa.<br/>Para todas as SCOTs, quando adotamos uma estratégia de confiança em controles, e para controles que abordam riscos significativos, confirmamos que os controles relevantes foram adequadamente projetados e implementados. Confirmamos que nossa decisão de adotar uma estratégia de confiança em controles ainda é apropriada.<br/><br/>Concluímos que nossa documentação descreve com precisão a operação da SCOT e identificamos todos os WCGWs apropriados, incluindo os riscos que surgem do uso de TI e controles relevantes (quando aplicável).<br/><br/> Para SCOT de estimativas, quando usamos uma estratégia apenas substantiva, determinamos se nosso entendimento da SCOT de estimativas é apropriado com base em nossos procedimentos substantivos.</p>",
    unrelatedLabel: "Ver WTs não relacionados",
    unrelatedModalHeader: "Tarefas de WT não relacionadas",
    noUnrelatedTaskPlaceholder: "Nenhuma tarefa de WT não relacionada disponível",
    noTaskselectedLabel: "Pelo menos uma tarefa deve ser selecionada para exclusão.",
    manageScots: "Gerenciar SCOTs",
    unrelatedTasksMustBeAssociated: "As tarefas não relacionadas devem ser associadas a uma SCOT ou excluídas."
}

export const auditPlanControlsLabels = {
    control: "Controle",
    controls: "Controles selecionados para teste",
    tasks: "Tarefas",
    sectionHeading: "Controles e testes de controles relacionados",
    subHeader: "Tarefas de teste de controle",
    visualDistinctMessage: "Cada controle deve ter pelo menos um teste de controle relacionado. Crie {0} ou {1}.",
    addToc: "Novo TOC",
    relatedToc: "Relacionar TOCs",
    toggleFilter: "Mostrar apenas controles sem nenhum TOC relacionado",
    noResultsFound: "Nenhum resultado encontrado",
    noRecordsAvailable: "Nenhum controle selecionado para teste",
    unrelatedLabel: "Ver sumários não relacionados",
    unrelatedModalHeader: "Tarefas de TOC não relacionadas",
    noUnrelatedTaskPlaceholder: "Nenhuma tarefa de sumário não relacionada disponível",
    noTaskselectedLabel: "Pelo menos uma tarefa deve ser selecionada para exclusão.",
    relateControlTaskTitle: "Relacionar TOCs com controle",
    manageControl: "Gerenciar controles",
    taskTitleTOC: "Teste de controle: {0}",
    taskDescriptionTOC: "Projetar a natureza, a época e a extensão de nossos testes de controles para obter evidência de auditoria suficiente e apropriada de que o controle opera de forma efetiva conforme projetado ao longo do período de confiança para prevenir ou detectar e corrigir distorções relevantes no nível da assertiva.<br/>Concluir sobre a efetividade operacional dos controles, avaliando os resultados de nossos testes de controles, inclusive quando ampliamos o tamanho da nossa amostra e realizamos testes de controles compensatórios.",
    manageControls: "Gerenciar controles",
    unrelatedTasksMustBeAssociated: "As tarefas não relacionadas devem ser associadas a um controle ou excluídas."
}

export const industrySelectionGroupLabels = {
    1: "Indústrias selecionadas",
    2: "Outras indústrias"
}

export const knowledgeDataLabels = {
    industry: "Indústria",
    showSelected: "Mostrar apenas selecionados",
    noContent: "Nenhum conteúdo está disponível no Conhecimento para o setor selecionado",
    importFromKnowledge: "Importar do Conhecimento",
    importAccounts: "Contas de importação",
    importAccountsAndDisclosures: "Importar contas e divulgações",
    accountBuild1: "Etapa 1 de criação de conta",
    import: "Importar",
    close: "Fechar",
    cancel: "Cancelar",
    selected: "selecionar",
    scotTitle: "SCOT de construção 1",
    importScots: "Importar SCOTs",
    noKnowledgeDataResult: "Nenhum conteúdo está disponível para a seleção",
    showOnlySelectedLabel: "Mostrar apenas selecionados",
    scot: "SCOT",
    scotDropdownLabel: "SCOT para a indústria selecionada",
    importWcgw: "Importar WCGW",
    importFailedLabel: "Falha na importação. Tente importar novamente.",
    wtDetailPrefix: "<p>Para todos as SCOTs rotineiras e não rotineiras e processos de divulgação significativos, confirmamos nosso entendimento a cada período, realizando procedimentos de Walkthrough. Além disso, para auditorias do PCAOB, realizamos procedimentos Walkthrough para as SCOTs de estimativa.<br/>Para todas as SCOTs, quando adotamos uma estratégia de confiança em controles, e para controles que abordam riscos significativos, confirmamos que os controles relevantes foram adequadamente projetados e implementados. Confirmamos que nossa decisão de adotar uma estratégia de confiança em controles ainda é apropriada.<br/><br/>Concluímos que nossa documentação descreve com precisão a operação da SCOT e identificamos todos os WCGWs apropriados, incluindo os riscos que surgem do uso de TI e controles relevantes (quando aplicável).<br/><br/> Para SCOT de estimativas, quando usamos uma estratégia apenas substantiva, determinamos se nosso entendimento da SCOT de estimativas é apropriado com base em nossos procedimentos substantivos.</p>",
    importOSP: "Importar OSPs",
    auditPlanBuild7: "Plano de Auditoria Costrução 7",
    account: "Conta",
    accountName: "Índices PSP",
    wcgwName: "WCGWs",
    selectScot: "Selecionar SCOT",
    wcgwTitle: "SCOT de construção 3",
    noResultFound: "Nenhum resultado encontrado",
    importValidationMessage: "É necessária uma seleção",
    searchIconHoverLabel: "Procurar",
    scotsHeader: "SCOTs",
    controlsHeader: "Controles",
    ospsHeader: "OSPs",
    wcgw: "WCGW",
    importControls: "Importar Controles",
    accountAssertionsValidationMessage: "Tarefas de assertivas estão faltando",
    accountsAndDisclosures: "Contas e divulgações",
}

export const auditPlanITControlsLabels = {
    itcontrol: "Controle de TI",
    itcontrols: "Controles de TI selecionados para teste",
    tasks: "Tarefas",
    type: "Tipo",
    sectionHeading: "ITGCs ITSPs e testes relacionados de controles e tarefas substantivas",
    subHeader: "Tarefaa de TOC/OSP",
    visualTOCDistinctMessage: "Cada ITGC deve ter pelo menos um teste de controle relacionado. Crie {0} ou {2}.",
    visualOSPDistinctMessage: "Cada ITSP deve ter pelo menos um procedimento substantivo relacionado. Crie {1} ou {3}.",
    addTOC: "Novo TOC",
    addOSP: "Novo OSP",
    relatedTOCOSP: "Relacionar TOCs/OSPs",
    relatedTOC: "Relacionar TOCs",
    relatedOSP: "Relacionar OSPs",
    toggleFilter: "Mostrar apenas controles de TI sem nenhum TOC/OSP relacionado",
    noResultsFound: "Nenhum resultado encontrado",
    noRecordsAvailable: "Nenhum ITGC selecionado para teste",
    taskTitleTOC: "Teste de controle: {0}",
    taskDescriptionTOC: "Realizar nossos testes desenhados de ITGCs para obter evidência de auditoria suficiente e apropriada de sua eficácia operacional durante todo o período de confiança.",
    taskTitleOSP: "Outro procedimento substantivo: {0}",
    taskDescriptionOSP: "Personalize esta descrição de tarefa para projetar a natureza, a época e a extensão dos procedimentos substantivos de TI para obter evidência de auditoria suficiente e apropriada de que os riscos de TI são tratados de forma eficaz durante todo o período de confiança.<br>Quando o procedimento substantivo de TI é executado a partir de um data intermediária, projetamos e executamos procedimentos para obter evidências adicionais de que os riscos de TI são abordados durante o período coberto por nossos procedimentos intermediários até o final do período.<br>Concluímos com os resultados de nossos procedimentos substantivos de TI.",
    relateITControlTaskTitle: "Relacionar TOCs/OSPs ao controle de TI",
    relateITControlTOCTaskTitle: "Relacionar TOCs ao ITGC",
    relateITControlOSPTaskTitle: "Relacionar OSPs ao ITSP",
    unrelatedModalHeader: "Tarefas de TOC/OSP não relacionadas",
    noUnrelatedTaskPlaceholder: "Nenhuma tarefa TOC/OSP não relacionada disponível",
    noTaskselectedLabel: "Pelo menos uma tarefa deve ser selecionada para exclusão.",
    unrelatedLabel: "Ver TOCs/OSPs não relacionados",
    understandITProcesses: "Entenda os processos de TI",
    unrelatedTasksMustBeAssociated: "As tarefas não relacionadas devem ser associadas a um controle de TI ou excluídas."
}

export const generalLabelsForMobile = {
    noRecordsFound: "Nenhum resultado encontrado nesta categoria de tarefa",
    taskListTitle: "Minhas tarefas",
    taskEvidenceTitle: "Evidência",
    cameraPagesTitle: "Páginas",
    cameraTitle: "Câmera",
    taskDetailsTitle: "Detalhes da tarefa",
    invalidPage: "Nenhuma página encontrada",
    combinedTaskLabel: "PIC/EQR",
    picTaskLabel: "PIC",
    eqrTaskLabel: "EQR",
    pageLabel: "Página",
    ofLabel: "de",
    noTasksAvailable: "Nenhuma tarefa disponível",
    searchLabel: "Procurar...",
    noDescriptionAvailable: 'No description available.',
    knowledge: 'Knowledge',
    description: 'Description',
    knowledgeDescription: 'Knowledge description',
    customized: 'Customized',
    taskDetailsTitle: "Detalhes da tarefa",
    unassigned: "Não atribuído",
    assignTo: "Atribuído a",
    signOffLabel: "Assinaturas",
    evidenceNoteLabel: "Notas da evidência",
    attributeLabel: "Atributos",
    addNoteLabel: "Nova nota",
    addCommentLabel: "Adicionar comentário",
    editCommentLabel: "Atualizar comentário",
    addReplyNoteLabel: "Responder a esta nota",
    replyNoteLabel: "Responder",
    replyEditNoteLabel: "Editar resposta",
    enterReplyPlaceholder: "Inserir resposta",
    editNoteLabel: "Editar",
    deleteNoteLabel: "Excluir",
    reopenNoteLabel: "Reabrir",
    closeNoteLabel: "Fechar",
    clearNoteLabel: "Limpar",
    preparerAbbrv: "P",
    reviewerAbbrv: "R",
    uploadPhoto: "Carregar foto",
    noEvidenceFound: "Nenhuma evidência está associada à tarefa",
    noRegionComponentFound: "Nenhum documento recebido da equipe regional ou componente",
    noEvidenceMessage: "Clique em Carregar foto para fazer upload de evidências",
    noNotesFound: "Nenhuma nota encontrada",
    noNotesStatement: "Deixe uma nota usando as entradas abaixo. Atribua a nota a um usuário e especifique a prioridade e a data de vencimento.",
    regionComponentEvidence: "Evidência de região e componente",
    documentWarning: "O documento baixado será somente leitura. Descarte o arquivo quando terminar.",
    preparerTitle: "Assinaturas do preparador",
    reviewerTitle: "Assinaturas do revisor",
    teamLabel: "Equipe",
    saveEvidenceTitle: "Salvar evidências",
    saveButton: "Salvar",
    cancelButton: "Cancelar",
    confirmButtonLabel: "Confirmar",
    previewButton: "Visualizar",
    evidenceLable: "Nome da evidência",
    mergingTitleLable: "imagens mescladas em PDF.",
    showErrFileExistMsg: "O nome do arquivo já existe. Por favor, renomeie o arquivo.",
    showErrForNoImgExist: "Não há imagens disponíveis para geração de PDF.",
    showErrBlankFileNameMsg: "O nome do arquivo não pode ficar em branco.",
    showIsCompletedMessage: "Arquivo carregado com sucesso.",
    uploadingTitle: "Processamento",
	showErrImgContext: '"Usar Imagens" deve ser usado dentro de um "Provedor de Imagens"',
    PagePreviewTitle: "Página",
    regionComponentEvidenceLabel: "Evidência de regional e componente",
    downloadProcessLabel: "Baixando...",
    downloadCompleteLabel: "Download completo",
    taskNotes: "Notas da tarefa",
    documentNotes: "Notas do documento",
    dueDateLabel: "Data de vencimento",
    view: "Visualizar:",
    documentNotes: "Notas do documento",
    newNote: "Adicionar nota",
    editNote: "Editar nota",
    assignedTo: "Atribuído a",
    priority: "Prioridade",
    select: "Selecionar",
    dueDate: "Data de vencimento",
    addNewNote: "Adicionar uma nova nota",
    addNote: "Adicionar nota",
    updateNote: "Atualizar nota",
    enterDescription: "Insirir uma descrição...",
    allnotes: "Todas as notas",
    mynotes: "Minhas notas",
    assignedToMe: "Atribuído a mim",
    hashValue: "#",
    showLessToggle: "Mostrar menos",
    showMoreToggle: "Mostrar mais",
    delete: "Excluir",
    deleteNoteModalTitle: "Excluir mensagem",
    deleteReplyModalTitle: "Excluir resposta",
    confirmDeleteNoteLabel: "Tem certeza de que deseja excluir a nota selecionada?",
    confirmDeleteReplyLabel: "Tem certeza de que deseja excluir sua resposta a esta nota?",
    downloadInfo: "Não é permitido baixar um arquivo contendo caracteres #",
	evidenceFileValidationInfo: 'O nome do arquivo não pode incluir caracteres */ : <>\?| "',
    previewPageTitle: "Visualização",
    redirecting: "Redirecionando para a página de destino em poucos segundos...",
    redirectingToTask: "Redirecionando para a página \'Minhas tarefas\' em alguns segundos...",
    errorApplyingConstraints: "Erro ao aplicar restrições:",
    zoomIsNotSupported: "O zoom não é compatível neste dispositivo.",
    errorCheckingCameraCapability: "Erro ao verificar os recursos da câmera:",
    previous: "anterior",
    next: "próximo",
    after: "depois",
    redirectingToTaskDetails: "Redirecionando para detalhes da tarefa em alguns segundos",
    mobileURL: '/mobile'
};

export const RNHNoteMobileStatusOptions = [{
        value: 1,
        label: "Abrir"
    },
    {
        value: 2,
        label: "Limpar"
    },
    {
        value: 3,
        label: "Fechar"
    }
];

export const auditPhaseTypes = [{
        value: 1,
        label: "Escopo & Estratégia"
    },
    {
        value: 2,
        label: "Execução"
    },
    {
        value: 3,
        label: "Conclusão"
    },
];

export const CreateEditTaskSectionLabels = {
    createModalTitle: "Novo grupo de tarefas",
    editModalTitle: "Editar grupo de tarefas",
    createModalDescription: "Insira os detalhes do grupo de tarefas abaixo e selecione '<b>{0}</b>' para finalizar. Para criar outro grupo de tarefas, selecione '<b>{1}</b>'.",
    editModalDescription: "Edite os detalhes do grupo de tarefas abaixo e selecione '<b>{0}</b>' para finalizar.",
    close: "Fechar",
    cancel: "Cancelar",
    save: "Salvar",
    saveAndCloseLabel: "Salvar e fechar",
    saveAndCreateLabel: "Salvar e criar outro",
    taskSectionNameLabel: "Nome do grupo de tarefas (obrigatório)",
    taskSectionNameErrorMsg: "Obrigatório",
    engagementPhaseOptions: auditPhaseTypes,
    engagementPhaseLabel: "Fase de engagement (obrigatório)",
    engagementPhaseErrorMsg: "Obrigatório",
};

export const auditPhaseLabels = {
    1: "Escopo & estratégia",
    2: "Execução",
    3: "Conclusão",
    4: "Realize atividades preliminares do engagement",
    5: "Identifique e avalie os riscos",
    6: "Responder aos riscos",
    7: "Concluir e reportar"
};

export const ITApproachType = {
    1: "ITGC",
    2: "ITSP"
};

// taskbuildmilestoneid labels
export const taskBuildMilestoneId = [{
        id: 1,
        label: superModalNavigationLabels.identifyAccountsAndDisclosures
    },
    {
        id: 31,
        label: superModalNavigationLabels.identifyAccountsAndDisclosures
    },
    {
        id: 5,
        label: superModalNavigationLabels.identifySCOTs
    },
    {
        id: 32,
        label: superModalNavigationLabels.identifySCOTs
    },
    {
        id: 6,
        label: superModalNavigationLabels.determineSCOTStrategy
    },
    {
        id: 7,
        label: superModalNavigationLabels.identifyWCGWAndControls
    },
    {
        id: 38,
        label: superModalNavigationLabels.identifyWCGWAndControls
    },
    {
        id: 8,
        label: superModalNavigationLabels.selectControlToTest
    },
    {
        id: 2,
        label: superModalNavigationLabels.identifyRisks
    },
    {
        id: 15,
        label: superModalNavigationLabels.relateWCGWsToAssertions
    },
    {
        id: 30,
        label: superModalNavigationLabels.relateRisksToWCGWs
    },
    {
        id: 3,
        label: superModalNavigationLabels.determineCRA
    },
    {
        id: 18,
        label: superModalNavigationLabels.SCOTWT
    },
    {
        id: 19,
        label: superModalNavigationLabels.controlTOC
    },
    {
        id: 20,
        label: superModalNavigationLabels.ITProcessUDP
    },
    {
        id: 21,
        label: superModalNavigationLabels.ITGC_ITSP_TOC_OSP
    },
    {
        id: 25,
        label: superModalNavigationLabels.accountPSP
    },
    {
        id: 26,
        label: superModalNavigationLabels.accountOSP,
    },
    {
        id: 27,
        label: superModalNavigationLabels.respondToSignificant_fraudRisks
    },
    {
        id: 56,
        label: superModalNavigationLabels.respondToSignificant_fraudRisks
    },
    {
        id: 29,
        label: superModalNavigationLabels.relatedWCGWToTask
    },
    {
        id: 39,
        label: superModalNavigationLabels.respondToSignificant_fraudRisks
    },
    {
        id: 50,
        label: superModalNavigationLabels.OST
    }
];

export const noEvidenceReferencedReasons = [{
        id: 1,
        reason: noEvidenceReferencedReasonsLabels.immaterialReason,
        glAccountTypeId: 12,
        strikethroughText: noEvidenceReferencedReasonsLabels.strikethroughMText
    },
    {
        id: 2,
        reason: noEvidenceReferencedReasonsLabels.waivedReason,
        glAccountTypeId: 13,
        strikethroughText: noEvidenceReferencedReasonsLabels.strikethroughWText
    }
];


export const createEditAdjustmentLabels = {
    createModalTitle: "Novo ajuste",
    editModalTitle: "Editar ajuste",
    createModalDescription: "Insira os detalhes do ajuste abaixo e selecione '<b>{0}</b>' para finalizar. Para criar outro ajuste, selecione '<b>{1}</b>'.",
    editModalDescription: "Edite os detalhes do ajuste abaixo e selecione '<b>{0}</b>' para finalizar. Para excluir o ajuste, clique em '<b>{1}</b>'.",
    close: "Fechar",
    cancel: "Cancelar",
    save: "Salvar",
    saveAndCloseLabel: "Salvar e fechar",
    saveAndCreateLabel: "Salvar e criar outro",
    delete: "Excluir",
    adjustmentNameLabel: "Índice de ajuste (obrigatório)",
    adjustmentDescriptionLabel: "Descrição do ajuste (obrigatório)",
    adjustmentDescriptionPlaceholder: "Descrição do ajuste (obrigatório)",
    required: "Obrigatório",
    editDescriptionModal: "Editar descrição do ajuste",
    descriptionRequired: "A descrição do ajuste é obrigatória",
    uploadDocumentPlaceholder: "O ajuste deve ser salvo antes de poder ser relacionado à evidência.",
    generalLedgerAccount: "Contas GL (obrigatório)",
    documentHeader: "Documentos (obrigatório)",
    addDocumentButton: "Adicionar evidências",
    glAccountPlaceholder: 'GL account is not available. To add the account click {0}.',
    adjustmentIndex: "Índice de ajuste",
    addglaccountbutton: "Adicionar conta contábil",
    descriptionMaxLengthError: "A resposta excede o máximo permitido.",
    glaccountTotalError: "O total de entradas de débito deve ser igual ao total de entradas de crédito",
    glaccountIdDuplicate: "Cada conta GL deve ser usada somente uma vez no ajuste",
    placeholderText: 'No related documents. To relate a document click <a>Add evidence<a>',
    editAdjustmentDescriptionHeader: "Editar descrição do ajuste",
    editAdjustmentDescriptionSubHead: "Edite os detalhes da descrição do ajuste abaixo e selecione \'<b>Salvar</b>\' para concluir."
};

export const addUpdateGlAccountLabels = {
    addGLaccountTitle: "Adicionar conta GL",
    glaccountDescription: "Insira os detalhes da conta GL abaixo e selecione '<b>{0}</b>' para concluir. Para adicionar outra conta GL, selecione '<b>{1}</b>'.",
    addAndClose: "Adicionar e fechar",
    addAnother: "Adicionar outro",
    accountSubClassPlaceholder: "Subclasse da conta",
    glAccountsPlaceholder: "Selecione a subclasse da conta para ver as contas GL disponíveis.",
    glAccountListHeaderColumn: "Conta GL",
    amountLabel: "Valor (obrigatório)",
    debitCreditOptions: [{
            id: 1,
            label: "Débito"
        },
        {
            id: 2,
            label: "Crédito"
        }
    ],
    searchPlaceholder: "Procurar",
    newGlAccount: "Nova conta de reconciliação",
    noResultsFound: "Nenhum resultado encontrado",
    noRecordsPlaceholder: "Nenhuma conta de reconciliação encontrada para a subclasse de conta selecionada. Selecione uma subclasse diferente ou clique em {0} para adicionar a conta de reconciliação à subclasse de conta selecionada.",
    editTitleTip: "Editar conta de reconciliação",
    removeTitleTip: "Excluir conta de reconciliação",
    custom: "Personalizado",
    duplicateGLAccount: "Cada conta GL deve ser usada somente uma vez no ajuste",
    updateModalTitle: "Atualizar conta de reconciliação",
    updateModalDescription: `Update GL account amount and debit/credit details below and select '<b>{0}</b>' to finish.`,
    accountClassLabel: "Account class",
    glAccountLabel: "GL account",
    updateLabel: "Atualizar",
    updateGlAccountModalTitle: "Atualizar conta GL",
}

export const deleteGLAccountLabels = {
    deleteConfirmationModallHeader: "Excluir conta de reconciliação",
    deleteConfirmationModalBodyHeader: "Tem certeza de que deseja excluir a conta de reconciliação selecionada? Esta ação não pode ser desfeita.",
    deleteConfirmationModalAccountSubClass: "Subclasse da conta:",
    deleteConfirmationModalAccountName: "Nome da conta:",
    deleteConfirmationModalGLAccountName: "Nome da conta de reconciliação:",
    closeButtonTitle: "Cancelar",
    confirmBtnTitle: "Excluir"
}

export const glAccountListLabel = {
    accountClass: "Classe da conta",
    accountSubClass: "Subclasse da conta",
    glAccount: "Conta GL",
    debit: "Débito",
    credit: "Crédito",
    actions: "Ações",
    editTitleTip: "Editar conta GL",
    removeTitleTip: "Remover conta GL"
}

export const EngagementMapLabels = {
    objectivePreviewMessage: 'Hover over a map item to preview',
    noMapAvailableMessage: "Nenhum mapa disponível.",
    takeContentUpdateMessage: "Faça uma atualização de conteúdo para obter o mapa mais recente.",
    noRecordsLabel: "Nenhum registro encontrado.",
    auditTopic: "Tópico de auditoria",
    auditTopicPlaceholder: "Selecione o tópico para visualizar",
    numberSelected: "{0} tópicos selecionados",
    refreshMapTitletip: "Clique aqui para iniciar a atualização do mapa de engagement",
    mapUpdateInProgress: "Atualização em andamento. Pode levar até dez minutos para que a atualização seja concluída.",
    refreshMapsLabel: "Refresh maps"
}

export const createEditGLAccountLabels = {
    createModalTitle: "Nova conta de reconciliação",
    editModalTitle: "Editar conta de reconciliação",
    createModalDescription: "Insira os detalhes da conta de reconciliação abaixo e selecione '<b>{0}</b>' para finalizar. Para adicionar outra conta de reconciliação, selecione '<b>{1}</b>'.",
    editModalDescription: "Edite os detalhes da conta de reconciliação abaixo e selecione '<b>{0}</b>' para finalizar.",
    accountSubClass: "Subclasse da conta",
    accountName: "Nome da conta (obrigatório)",
    glAccountName: "Nome da conta de reconciliação (obrigatório)",
    cancelbtn: "Cancelar",
    saveAndAddbtn: "Salvar e adicionar outro",
    saveAndClosebtn: "Salvar e fechar",
    save: "Salvar",
    required: "Obrigatório",
}

//Receive instructions switcher
export const receiveInstructionSwitcherLabels = {

    [receiveInstructionSwitcherIds.groupInstructions]: "Instruções para grupo",
    [receiveInstructionSwitcherIds.groupRiskAssessment]: "Avaliação de risco de grupo",
    [receiveInstructionSwitcherIds.documents]: "Documentos"
};

export const misstatementEvidenceLabels = {
    placeholderText: "Nenhuma evidência relacionada. Pelo menos uma evidência de apoio deve estar associada. Para relacionar uma evidência, clique em {0}.",
    addEvidenceBtn: "Adicionar evidências",
};

export const misstatementTempLabels = {
    placeholderText: "Nenhum documento temporário relacionado. Para relacionar um documento temporário, clique em {0}.",
    addEvidenceBtn: "Adicionar arquivo temporário",
};

export const inherentRiskFactorTypes = [{
        id: 1,
        label: "Complexidade",
        displayOrder: 1
    },
    {
        id: 2,
        label: "Incerteza da subjetividade",
        displayOrder: 2
    },
    {
        id: 3,
        label: "Fraude ou erro",
        displayOrder: 3
    },
    {
        id: 4,
        label: "Mudar",
        displayOrder: 4
    },
    {
        id: 5,
        label: "Natureza da conta",
        displayOrder: 5
    },
    {
        id: 6,
        label: "Partes relacionadas",
        displayOrder: 6
    }
];

export const helixSettingsStepLabels = {
    title: "Definir configurações de conexão",
    subTitle: "Selecione as configurações para sua conexão de analyzer.",
    connectionNameLabel: "Nome da conexão",
    connectionNamePlaceholder: "Nome da conexão (obrigatório)",
    connetionTypesLabel: "Tipos de conexão",
    connectionTypeScopeAndStrategy: "Escopo & Estratégia",
    connectionTypeFinancionStatement: "Demonstrações Financeiras",
    includeAllBusinessUnitsField: "Você quer incluir todas as unidades de negócios?",
    yes: "Sim",
    no: "Não",
    businessUnitsLabel: "Unidade(s) de negócios",
    businessUnitsPlaceholder: "Unidade(s) de negócios",
    analysisPeriodLabel: "Data de análise",
    analysisPeriodPlaceholder: "Data de análise",
    comparativePeriod1Label: "Data comparativa 1",
    comparativePeriod1Placeholder: "Data comparativa 1 (opcional)",
    comparativePeriod2Label: "Data comparativa 2",
    comparativePeriod2Placeholder: "Data comparativa 2 (opcional)",
    currencyTypeField: "Tipo de moeda",
    reporting: "Relatório",
    functional: "Funcional",
    currencyCodeField: "Código da moeda",
    currencyCodePlaceholder: "Código da moeda (obrigatório)",
    scopeAndStrategyLabel: "Escopo & estratégia",
    financialStatementLabel: "Demonstração financeira",

    required: "Obrigatório",
    comparativePeriodError: "Data inválida. Selecione uma data anterior à data de análise.",

    dataConnectionLink: 'How to manage data connections',
    helixfiscalDropDownLabel: "Data {0} - {1}",

    helixError: 'Could not connect to the selected analyzer. Refresh the page and try again. If the issue persists, contact the Help Desk.',
    businessUnitsSelectedCount: "{0} selecionado",
    allBusinessUnitsLabel: "Todas as unidades de negócios"
};

export const importDataModalLabels = ({
    title,
    description,
    buttonLabel
}) => {
    return {
        title: title,
        description: description,
        entity: "Entidade",
        trialBalanceName: "Nome do balancete",
        reporting: "Moeda de Apresentação",
        functional: "Moeda Funcional",
        analysisPeriod: "Data de análise",
        comparativePeriod: "Data comparativa",
        secondComparativePeriod: "Segunda data comparativa (opcional)",
        includeFinancialStatements: "Incluir demonstrações financeiras",
        carryForwardReferencesAndAdjustments: "Transportar referências e ajustes à nova importação?",
        import: buttonLabel,
        businessUnitSelectedCount: "{0} unidade de negócios",
        businessUnitsSelectedCount: "{0} unidades de negócios",
        allBusinessUnitsLabel: "Todas as unidades de negócios",
        businessUnitsPlaceholder: "Unidade(s) de negócios",
        required: "Obrigatório",
        comparativePeriodError: "Data inválida. Selecione uma data anterior à data de análise.",
        secondComparativePeriodError: "Segunda data comparativa maior ou igual à data comparativa.",
        equalComparativePeriodError: "As datas não podem ser iguais.",
        analysisDateMustBeLaterError: 'Analysis date must be later than both comparative dates.'
    };
};

export const AnalyzerHelixErrors = {
    400: "O projeto do EY Helix para a conexão selecionada não está mais disponível. Entre em contato com um administrador do EY Helix para mais detalhes. Para remover permanentemente a conexão, primeiro remova todas as importações associadas à conexão. Em seguida, clique em 'Desconectar analyzer' no menu mais. Considere se outro analyzer deve ser conectado.",
    403: "Você não é um membro autorizado da equipe do analyzer conectado. Entre em contato com o administrador do projeto EY Helix para obter acesso.",
    405: "As análises não estão disponíveis na conexão vinculada. Acesse EY Helix e conclua as etapas de processamento de dados e análises para continuar.",
    406: "O analyzer do EY Helix para a conexão selecionada não está mais disponível. Entre em contato com um administrador do EY Helix para mais detalhes. Para remover permanentemente a conexão, primeiro remova todas as importações associadas à conexão. Em seguida, clique em 'Desconectar analyzer' no menu mais. Considere se outro analyzer deve ser conectado.",
    408: "O projeto do EY Helix para a conexão selecionada não está mais disponível. Entre em contato com um administrador do EY Helix para mais detalhes. Para remover permanentemente a conexão, primeiro remova todas as importações associadas à conexão. Em seguida, clique em 'Desconectar analyzer' no menu mais. Considere se outro analyzer deve ser conectado.",
    411: "O analyzer selecionado não possui todos os parâmetros necessários. Entre em contato com um administrador do EY Helix para mais detalhes.",
    430: "O analyzer selecionado não possui todos os parâmetros necessários. Entre em contato com um administrador do EY Helix para mais detalhes. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    800: "Parece que você não acessou o EY Helix antes. Vá para o EY Helix, faça login e siga as instruções para configurar sua conta.",
    801: "Você não é um membro autorizado da equipe do projeto vinculado. Entre em contato com o administrador do projeto EY Helix para obter acesso.",
    901: "O projeto EY Helix para a conexão selecionada não está mais disponível. Entre em contato com um administrador do EY Helix para mais detalhes. Para excluir permanentemente a conexão, clique em 'Excluir' abaixo no menu mais. Por favor, considere se outro analyzer deve ser conectado.",
    902: "O projeto EY Helix para a conexão selecionada está marcado para exclusão. Entre em contato com um administrador do EY Helix para mais detalhes. Para excluir permanentemente a conexão, clique em 'Excluir' abaixo no menu mais. Considere se outro analyzer deve ser conectado.",
    903: "O projeto EY Helix para a conexão selecionada está marcado para armazenamento. Entre em contato com um administrador do EY Helix para mais detalhes. Para excluir permanentemente a conexão, clique em 'Excluir' abaixo no menu mais. Considere se outro analyzer deve ser conectado.",
    926: "O analyzer selecionado não está disponível no EY Helix. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    927: "As análises não estão disponíveis no projeto vinculado. Vá para o EY Helix e complete as etapas de processamento de dados & análises para continuar.",
    928: "Analyzer inválido ou ausente no EY Helix. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    929: "Ocorreu um erro relacionado ao projeto EY Helix vinculado. Os dados não podem ser importados."
};

export const validationLabels = {
    viewAdjustmentWithValidations: "Visualizar ajustes com validações {0}",
    validationTypeAmtMissmatch: "A soma das entradas à débito não é igual à soma das entradas à crédito",
    validationTypeNoEvidence: "Nenhuma evidência relacionada",
};

export const canavsImportErrors = {
    400: "Falha na importação. O projeto do EY Helix para a conexão selecionada não está mais disponível. Entre em contato com um administrador do EY Helix para mais detalhes. Para remover permanentemente a conexão, primeiro remova todas as importações associadas à conexão. Em seguida, clique em 'Desconectar analyzer' no menu mais. Considere se outro analyzer deve ser conectado.",
    403: "Falha na importação. Você não é um membro autorizado da equipe do analyzer conectado. Entre em contato com o administrador do projeto EY Helix para obter acesso, atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    405: "Falha na importação. As análises não estão disponíveis na conexão vinculada. Acesse EY Helix e conclua as etapas de processamento de dados e análises para continuar. Em seguida, atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    406: "Falha na importação. O analyzer do EY Helix para a conexão selecionada não está mais disponível. Entre em contato com um administrador do EY Helix para mais detalhes. Para remover permanentemente a conexão, primeiro remova todas as importações associadas à conexão. Em seguida, clique em 'Desconectar analyzer' no menu mais. Considere se outro analyzer deve ser conectado.",
    408: "Falha na importação. O projeto do EY Helix para a conexão selecionada não está mais disponível. Entre em contato com um administrador do EY Helix para mais detalhes. Para remover permanentemente a conexão, primeiro remova todas as importações associadas à conexão. Em seguida, clique em 'Desconectar analyzer' no menu mais. Considere se outro analyzer deve ser conectado.",
    411: "Falha na importação. O analyzer selecionado não possui todos os parâmetros necessários. Entre em contato com um administrador do EY Helix para obter mais detalhes, atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    430: "Falha na importação. O analyzer selecionado não possui todos os parâmetros necessários. Entre em contato com um administrador do EY Helix para mais detalhes. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
    113082: "O período de análise não deve estar vazio."
};
